import { api } from './baseApi';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  File: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AdminFeatureFlag = {
  __typename?: 'AdminFeatureFlag';
  constraints: Array<AdminFeatureFlagConstraint>;
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
};

export type AdminFeatureFlagConstraint = {
  __typename?: 'AdminFeatureFlagConstraint';
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type AdminFeatureFlagConstraintInput = {
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type AdminFeatureFlagInput = {
  constraints?: InputMaybe<Array<AdminFeatureFlagConstraintInput>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};

export enum AggregateFunction {
  Avg = 'avg',
  Count = 'count',
  Max = 'max',
  Min = 'min',
  P10 = 'p10',
  P25 = 'p25',
  P50 = 'p50',
  P75 = 'p75',
  P90 = 'p90',
  Sum = 'sum'
}

export type AuthError = Error & {
  __typename?: 'AuthError';
  /** The error code */
  code: AuthErrorCode;
  message: Scalars['String'];
};

export enum AuthErrorCode {
  IdentityNotFound = 'IdentityNotFound',
  IncorrectPassword = 'IncorrectPassword',
  InvalidEmailDomain = 'InvalidEmailDomain',
  InvalidInvite = 'InvalidInvite',
  InvalidPassword = 'InvalidPassword',
  InviteEmailMismatch = 'InviteEmailMismatch',
  LocalPasswordNotSet = 'LocalPasswordNotSet',
  UserAlreadyExists = 'UserAlreadyExists',
  UserNotFound = 'UserNotFound'
}

export type AvailableThirdPartyDataset = {
  __typename?: 'AvailableThirdPartyDataset';
  available_intervals: Array<Scalars['Int']>;
  available_years: Scalars['JSON'];
  dataset_name: Scalars['String'];
  display_name: Scalars['String'];
  source: Scalars['String'];
};

export type BaseError = Error & {
  __typename?: 'BaseError';
  message: Scalars['String'];
};

export type Block = {
  __typename?: 'Block';
  block_layers?: Maybe<Array<BlockLayer>>;
  cleaning_interval_days?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  date_of_most_recent_cleaning?: Maybe<Scalars['String']>;
  enviro_dataset?: Maybe<EnviroDataset>;
  enviro_dataset_id?: Maybe<Scalars['String']>;
  follow_slope?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  num_inverters?: Maybe<Scalars['Float']>;
  power_factor?: Maybe<Scalars['Float']>;
  project?: Maybe<Project>;
  project_id: Scalars['String'];
  pv_ac_wire_id?: Maybe<Scalars['String']>;
  pv_dc_wire_id?: Maybe<Scalars['String']>;
  pv_inverter?: Maybe<PvInverter>;
  pv_inverter_id?: Maybe<Scalars['String']>;
  pv_panel?: Maybe<PvPanel>;
  pv_panel_id?: Maybe<Scalars['String']>;
  pv_soiling_algorithm?: Maybe<Scalars['String']>;
  pv_system_start_date?: Maybe<Scalars['String']>;
  pv_table?: Maybe<PvTable>;
  pv_table_id?: Maybe<Scalars['String']>;
  pv_transformer?: Maybe<PvTransformer>;
  pv_transformer_id?: Maybe<Scalars['String']>;
  slope_aware_tracking?: Maybe<Scalars['Boolean']>;
  slope_azimuth?: Maybe<Scalars['Float']>;
  slope_tilt?: Maybe<Scalars['Float']>;
  soiling_rate?: Maybe<Scalars['Float']>;
  soiling_rates_percentage?: Maybe<Scalars['JSON']>;
  terrain_type: TerrainType;
  updated_at: Scalars['DateTime'];
};

export type BlockInput = {
  cleaning_interval_days?: InputMaybe<Scalars['Float']>;
  date_of_most_recent_cleaning?: InputMaybe<Scalars['String']>;
  enviro_dataset_id?: InputMaybe<Scalars['String']>;
  follow_slope?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  num_inverters?: InputMaybe<Scalars['Float']>;
  power_factor?: InputMaybe<Scalars['Float']>;
  project_id: Scalars['String'];
  pv_ac_wire_id?: InputMaybe<Scalars['String']>;
  pv_dc_wire_id?: InputMaybe<Scalars['String']>;
  pv_inverter_id?: InputMaybe<Scalars['String']>;
  pv_panel_id?: InputMaybe<Scalars['String']>;
  pv_soiling_algorithm?: InputMaybe<Scalars['String']>;
  pv_system_start_date?: InputMaybe<Scalars['String']>;
  pv_table_id?: InputMaybe<Scalars['String']>;
  pv_transformer_id?: InputMaybe<Scalars['String']>;
  slope_aware_tracking?: InputMaybe<Scalars['Boolean']>;
  slope_azimuth?: InputMaybe<Scalars['Float']>;
  slope_tilt?: InputMaybe<Scalars['Float']>;
  soiling_rate?: InputMaybe<Scalars['Float']>;
  soiling_rates_percentage?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  terrain_type?: InputMaybe<TerrainType>;
};

export type BlockLayer = {
  __typename?: 'BlockLayer';
  block_id?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  geojson: Scalars['JSON'];
  id: Scalars['String'];
  name: Scalars['String'];
  project_id: Scalars['String'];
  source_filename?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
  source_url?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type BlockLayerInput = {
  block_id?: InputMaybe<Scalars['String']>;
  geojson?: InputMaybe<Scalars['JSON']>;
  id: Scalars['String'];
  name: Scalars['String'];
  source_filename?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type BlockSimulationErrors = {
  __typename?: 'BlockSimulationErrors';
  block_id: Scalars['String'];
  messages: Array<Scalars['String']>;
};

export type BlockSimulationInput = {
  id: Scalars['String'];
  num_rows: Scalars['Int'];
  num_total_tables: Scalars['Int'];
  scaling_factor?: InputMaybe<Scalars['Float']>;
};

export type CecInverter = {
  __typename?: 'CecInverter';
  id: Scalars['ID'];
  manufacturer: Scalars['String'];
  /** Maximum input DC current */
  maximum_dc_current: Scalars['Float'];
  /** Maximum input DC voltage required for MPPT operation */
  maximum_dc_voltage: Scalars['Float'];
  /** Minimum input DC voltage required for MPPT operation */
  minimum_dc_voltage: Scalars['Float'];
  model: Scalars['String'];
  /** Inverter power consumption at night (or when in OFF-state) */
  night_tare_power: Scalars['Float'];
  /** Nominal AC voltage at the output of the inverter */
  output_ac_voltage: Scalars['Float'];
  /** Rated output AC power (both nominal and maximum) rating of the inverter */
  rated_output_ac_power: Scalars['Float'];
  /** Input DC power that results in rated_output_ac_power at the reference DC voltage (reference_dc_voltage) */
  reference_dc_power: Scalars['Float'];
  /** Nominal AC voltage at the output of the inverter */
  reference_dc_voltage: Scalars['Float'];
  /** Parameter defining the curvature (parabolic) of the relationship between AC power and DC power at the refernce operating condition */
  sandia_model_c0: Scalars['Float'];
  /** Empirical coefficient allowing reference_dc_power to vary linearly with DC voltage input */
  sandia_model_c1: Scalars['Float'];
  /** Empirical coefficient allowing self_consumption_power to vary linearly with DC input */
  sandia_model_c2: Scalars['Float'];
  /** Empirical coefficient allowing sandia_model_c0 to vary linearly with DC voltage input */
  sandia_model_c3: Scalars['Float'];
  /** DC input power required to start the inversion process */
  self_consumption_power: Scalars['Float'];
};

export type CecInverterFilter = {
  id?: InputMaybe<Array<Scalars['String']>>;
  manufacturer?: InputMaybe<Array<Scalars['String']>>;
  maximum_dc_current?: InputMaybe<MinMaxInput>;
  maximum_dc_voltage?: InputMaybe<MinMaxInput>;
  model?: InputMaybe<Scalars['String']>;
  output_ac_voltage?: InputMaybe<MinMaxInput>;
};

export type CecInverterFilterOptions = {
  __typename?: 'CecInverterFilterOptions';
  manufacturers: Array<Scalars['String']>;
  maximum_dc_current: MinMax;
  maximum_dc_voltage: MinMax;
  output_ac_voltage: MinMax;
};

export type CecInverterSort = {
  direction: SortDirection;
  field: InvertSortField;
};

export enum CellShapeEnum {
  Oct = 'oct',
  Rect = 'rect'
}

export enum CellType {
  Full = 'full',
  Half = 'half'
}

export type CompareWorkbook = {
  __typename?: 'CompareWorkbook';
  created_at: Scalars['DateTime'];
  data: Scalars['JSON'];
  dataset_a?: Maybe<CompareWorkbookDataset>;
  dataset_b?: Maybe<CompareWorkbookDataset>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type CompareWorkbookDataset = {
  __typename?: 'CompareWorkbookDataset';
  id: Scalars['String'];
  label: Scalars['String'];
  source: Scalars['String'];
};

export type CompareWorkbookDatasetInput = {
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type ComponentSummary = {
  __typename?: 'ComponentSummary';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreateCecInverterInput = {
  manufacturer: Scalars['String'];
  maximum_dc_current: Scalars['Float'];
  maximum_dc_voltage: Scalars['Float'];
  minimum_dc_voltage: Scalars['Float'];
  model: Scalars['String'];
  night_tare_power: Scalars['Float'];
  output_ac_voltage: Scalars['Float'];
  rated_output_ac_power: Scalars['Float'];
  reference_dc_power: Scalars['Float'];
  reference_dc_voltage: Scalars['Float'];
  sandia_model_c0: Scalars['Float'];
  sandia_model_c1: Scalars['Float'];
  sandia_model_c2: Scalars['Float'];
  sandia_model_c3: Scalars['Float'];
  self_consumption_power: Scalars['Float'];
};

export type CreateEnviroDataInput = {
  /** Albedo */
  albedo: Scalars['Float'];
  /** Day of the data point */
  day: Scalars['Int'];
  /** Diffuse Horizontal Irradiance in W/m^2 */
  dhi_wm2: Scalars['Float'];
  /** Direct Normal Irradiance in W/m^2 */
  dni_wm2: Scalars['Float'];
  /** Global Horizontal Irradiance in W/m^2 */
  ghi_wm2: Scalars['Float'];
  /** Hour of the data point */
  hour: Scalars['Int'];
  /** Minute of the data point */
  minute?: Scalars['Int'];
  /** Month of the data point */
  month: Scalars['Int'];
  /** Relative humidity */
  rh?: InputMaybe<Scalars['Float']>;
  /** Temperature in degrees celsius */
  temp_c: Scalars['Float'];
  /** Tracker angle in degrees */
  tracker_angle?: InputMaybe<Scalars['Float']>;
  /** Windspeed in m/s */
  windspeed?: InputMaybe<Scalars['Float']>;
  /** Year of the data point */
  year: Scalars['Int'];
};

export type CreateEnviroDatasetFromCsvFileInput = {
  dst_shifts?: Array<DstShiftInput>;
  /** Filename of the dataset */
  filename: Scalars['String'];
  interval_alignment: IntervalAlignmentType;
  last_modified: Scalars['DateTime'];
  /** Latitude of the meteo data */
  latitude?: InputMaybe<Scalars['Float']>;
  /** UTC offset of the location that the dataset was recorded at */
  local_time_zone: Scalars['Float'];
  /** Longitude of the meteo data */
  longitude?: InputMaybe<Scalars['Float']>;
  /** Name of the dataset */
  name: Scalars['String'];
  /** Number of rows in the dataset */
  row_count: Scalars['Int'];
  size: Scalars['Int'];
  time_interval: Scalars['Float'];
  time_zone?: InputMaybe<Scalars['Float']>;
  /** TMY or Sequential */
  type: EnviroDatasetType;
};

export type CreateEnviroDatasetFromMetFileInput = {
  dst_shifts?: Array<DstShiftInput>;
  /** Filename of the dataset */
  filename: Scalars['String'];
  last_modified: Scalars['DateTime'];
  /** UTC offset of the location that the dataset was recorded at */
  local_time_zone: Scalars['Float'];
  /** Monthly albedo */
  monthly_albedo: Array<Scalars['Float']>;
  /** Name of the dataset */
  name: Scalars['String'];
  size: Scalars['Int'];
  /** TMY or Sequential */
  type: EnviroDatasetType;
};

export type CreateEnviroDatasetInput = {
  /** Data points in the dataset */
  enviro_data: Array<CreateEnviroDataInput>;
  /** Filename of the dataset */
  filename?: InputMaybe<Scalars['String']>;
  interval_alignment: IntervalAlignmentType;
  last_modified: Scalars['DateTime'];
  /** Latitude of the meteo data */
  latitude?: InputMaybe<Scalars['Float']>;
  /** UTC offset of the location that the dataset was recorded at */
  local_time_zone: Scalars['Float'];
  /** Longitude of the meteo data */
  longitude?: InputMaybe<Scalars['Float']>;
  /** Name of the dataset */
  name: Scalars['String'];
  /** Number of rows in the dataset */
  row_count: Scalars['Int'];
  size: Scalars['Int'];
  time_interval: Scalars['Float'];
  /** TMY or Sequential */
  type: EnviroDatasetType;
};

export type CreateOrganizationInput = {
  allow_domain: Scalars['Boolean'];
  name: Scalars['String'];
};

export enum DataExportFormat {
  Csv = 'csv',
  Parquet = 'parquet'
}

export enum DataExportScope {
  Block = 'block',
  System = 'system'
}

export type DateArgsInput = {
  interval: DateBinInterval;
  range?: InputMaybe<DateRangeArgs>;
  sort?: InputMaybe<DateSortArgs>;
  trunc?: InputMaybe<DateTruncArgs>;
};

export enum DateBinInterval {
  FifteenMinutes = 'FifteenMinutes',
  FiveMinutes = 'FiveMinutes',
  OneDay = 'OneDay',
  OneHour = 'OneHour',
  OneMinute = 'OneMinute',
  OneMonth = 'OneMonth',
  OneWeek = 'OneWeek',
  OneYear = 'OneYear',
  TenMinutes = 'TenMinutes',
  ThirtyMinutes = 'ThirtyMinutes'
}

export type DateRangeArgs = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type DateSortArgs = {
  direction: SortDirection;
  excludeYear?: InputMaybe<Scalars['Boolean']>;
};

export type DateTimeObject = {
  __typename?: 'DateTimeObject';
  day: Scalars['Int'];
  hour: Scalars['Int'];
  minute?: Maybe<Scalars['Int']>;
  month: Scalars['Int'];
  year?: Maybe<Scalars['Int']>;
};

export type DateTimeObjectInput = {
  day: Scalars['Int'];
  hour: Scalars['Int'];
  minute?: InputMaybe<Scalars['Int']>;
  month: Scalars['Int'];
  year?: InputMaybe<Scalars['Int']>;
};

export type DateTruncArgs = {
  part: DateTruncPart;
  withTime?: InputMaybe<Scalars['Boolean']>;
};

export enum DateTruncPart {
  Day = 'day',
  Month = 'month'
}

export type DecompositionParametersInput = {
  /** DHI not present in dataset */
  ignore_dhi: Scalars['Boolean'];
  /** DNI not present in dataset */
  ignore_dni: Scalars['Boolean'];
  /** GHI not present in dataset */
  ignore_ghi: Scalars['Boolean'];
};

export type DescribeRow = {
  __typename?: 'DescribeRow';
  file_name: Scalars['String'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type DstShiftInput = {
  shift_backward_at: Scalars['DateTime'];
  shift_forward_at: Scalars['DateTime'];
  year: Scalars['Int'];
};

export type DuetJob = {
  __typename?: 'DuetJob';
  completed_at?: Maybe<Scalars['DateTime']>;
  completed_tasks?: Maybe<Scalars['Int']>;
  config_meta: Scalars['JSON'];
  created_at: Scalars['DateTime'];
  id: Scalars['String'];
  running_at?: Maybe<Scalars['DateTime']>;
  stage?: Maybe<Scalars['String']>;
  /** The status of the job */
  status: Scalars['String'];
  submitted_at?: Maybe<Scalars['DateTime']>;
  time_interval?: Maybe<Scalars['Int']>;
  total_tasks?: Maybe<Scalars['Int']>;
};

export type DuetJobInput = {
  completed_at?: InputMaybe<Scalars['DateTime']>;
  completed_tasks?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['DateTime']>;
  running_at?: InputMaybe<Scalars['DateTime']>;
  stage?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['DateTime']>;
  time_interval?: InputMaybe<Scalars['Int']>;
  total_tasks?: InputMaybe<Scalars['Int']>;
};

export type DuetSimulation = {
  __typename?: 'DuetSimulation';
  created_at: Scalars['DateTime'];
  duet_job: DuetJob;
  duet_job_id: Scalars['String'];
  duet_simulation_blocks: Array<DuetSimulationBlock>;
  enviro_dataset_name?: Maybe<Scalars['String']>;
  enviro_dataset_type: Scalars['String'];
  hv_ac_wire_parameters: PvAcWire;
  hv_transformer_parameters: PvTransformer;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  local_time_zone?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  project: Project;
  project_id: Scalars['String'];
  sentinel_deployment_id?: Maybe<Scalars['String']>;
  time_range?: Maybe<TimeRange>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']>;
};

export type DuetSimulationBlock = {
  __typename?: 'DuetSimulationBlock';
  ac_wire_parameters: PvAcWire;
  block_id: Scalars['String'];
  cleaning_interval_days?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  csv_export_progress_pct?: Maybe<Scalars['Float']>;
  date_of_most_recent_cleaning?: Maybe<Scalars['String']>;
  dc_wire_parameters: PvDcWire;
  duet_job_id: Scalars['String'];
  duet_job_input_id: Scalars['String'];
  duet_simulation_id: Scalars['String'];
  id: Scalars['ID'];
  inverter_parameters: PvInverter;
  name: Scalars['String'];
  num_inverters?: Maybe<Scalars['Int']>;
  num_rows?: Maybe<Scalars['Int']>;
  num_total_tables?: Maybe<Scalars['Int']>;
  panel_parameters: PvPanel;
  power_factor?: Maybe<Scalars['Float']>;
  pv_soiling_algorithm?: Maybe<Scalars['String']>;
  pv_system_start_date?: Maybe<Scalars['String']>;
  slope_aware_tracking?: Maybe<Scalars['Boolean']>;
  slope_azimuth?: Maybe<Scalars['Float']>;
  slope_tilt?: Maybe<Scalars['Float']>;
  soiling_rate?: Maybe<Scalars['Float']>;
  soiling_rates_percentage?: Maybe<Array<Maybe<Scalars['Float']>>>;
  table_parameters: PvTable;
  terrain_type?: Maybe<Scalars['String']>;
  time_range: TimeRange;
  transformer_parameters: PvTransformer;
};

export type EnviroData = {
  __typename?: 'EnviroData';
  /** Albedo */
  albedo: Scalars['Float'];
  created_at: Scalars['DateTime'];
  /** Day of the data point */
  day: Scalars['Int'];
  /** Diffuse Horizontal Irradiance in W/m^2 */
  dhi_wm2: Scalars['Float'];
  /** Direct Normal Irradiance in W/m^2 */
  dni_wm2: Scalars['Float'];
  enviro_dataset_id: Scalars['String'];
  /** Global Horizontal Irradiance in W/m^2 */
  ghi_wm2: Scalars['Float'];
  /** Hour of the data point */
  hour: Scalars['Int'];
  id: Scalars['ID'];
  /** Minute of the data point */
  minute: Scalars['Int'];
  /** Month of the data point */
  month: Scalars['Int'];
  /** Relative humidity */
  rh?: Maybe<Scalars['Float']>;
  /** Temperature in degrees celsius */
  temp_c: Scalars['Float'];
  /** Tracker angle in degrees */
  tracker_angle?: Maybe<Scalars['Float']>;
  /** Windspeed in m/s */
  windspeed?: Maybe<Scalars['Float']>;
  /** Year of the data point */
  year: Scalars['Int'];
};

export type EnviroDataRollup = {
  __typename?: 'EnviroDataRollup';
  avg__albedo: Scalars['Float'];
  avg__dhi_wm2: Scalars['Float'];
  avg__dni_wm2: Scalars['Float'];
  avg__ghi_wm2: Scalars['Float'];
  avg__temp_c: Scalars['Float'];
  dt_timestamp: Scalars['DateTime'];
  max__albedo: Scalars['Float'];
  max__dhi_wm2: Scalars['Float'];
  max__dni_wm2: Scalars['Float'];
  max__ghi_wm2: Scalars['Float'];
  max__temp_c: Scalars['Float'];
  min__albedo: Scalars['Float'];
  min__dhi_wm2: Scalars['Float'];
  min__dni_wm2: Scalars['Float'];
  min__ghi_wm2: Scalars['Float'];
  min__temp_c: Scalars['Float'];
  p10__albedo: Scalars['Float'];
  p10__dhi_wm2: Scalars['Float'];
  p10__dni_wm2: Scalars['Float'];
  p10__ghi_wm2: Scalars['Float'];
  p10__temp_c: Scalars['Float'];
  p25__albedo: Scalars['Float'];
  p25__dhi_wm2: Scalars['Float'];
  p25__dni_wm2: Scalars['Float'];
  p25__ghi_wm2: Scalars['Float'];
  p25__temp_c: Scalars['Float'];
  p50__albedo: Scalars['Float'];
  p50__dhi_wm2: Scalars['Float'];
  p50__dni_wm2: Scalars['Float'];
  p50__ghi_wm2: Scalars['Float'];
  p50__temp_c: Scalars['Float'];
  p75__albedo: Scalars['Float'];
  p75__dhi_wm2: Scalars['Float'];
  p75__dni_wm2: Scalars['Float'];
  p75__ghi_wm2: Scalars['Float'];
  p75__temp_c: Scalars['Float'];
  p90__albedo: Scalars['Float'];
  p90__dhi_wm2: Scalars['Float'];
  p90__dni_wm2: Scalars['Float'];
  p90__ghi_wm2: Scalars['Float'];
  p90__temp_c: Scalars['Float'];
};

export type EnviroDataset = {
  __typename?: 'EnviroDataset';
  created_at: Scalars['DateTime'];
  dst_shifts: Scalars['JSON'];
  end_time: Scalars['DateTime'];
  enviro_data: Array<EnviroData>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interval_alignment: Scalars['String'];
  last_modified: Scalars['DateTime'];
  latitude?: Maybe<Scalars['Float']>;
  local_time_zone: Scalars['Float'];
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  row_count: Scalars['Int'];
  size: Scalars['Int'];
  source?: Maybe<Scalars['String']>;
  start_time: Scalars['DateTime'];
  time_interval?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
};


export type EnviroDatasetEnviro_DataArgs = {
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};

export type EnviroDatasetOwner = {
  __typename?: 'EnviroDatasetOwner';
  created_at: Scalars['DateTime'];
  enviro_dataset: EnviroDataset;
  enviro_dataset_id: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['String']>;
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['String']>;
  user: User;
  user_id: Scalars['String'];
};

export enum EnviroDatasetType {
  Sequential = 'Sequential',
  Tmy = 'TMY'
}

export type Error = {
  message: Scalars['String'];
};

export type ExpandedUserInvite = {
  __typename?: 'ExpandedUserInvite';
  email: Scalars['String'];
  id: Scalars['String'];
  organization_slug?: Maybe<Scalars['String']>;
  user_registered: Scalars['Boolean'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  constraint?: Maybe<FeatureFlagConstraint>;
  id: Scalars['String'];
};

export type FeatureFlagConstraint = {
  __typename?: 'FeatureFlagConstraint';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type FieldError = {
  __typename?: 'FieldError';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type GetFileStorageSignedUrlPayload = {
  __typename?: 'GetFileStorageSignedUrlPayload';
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type GetPanelIvInput = {
  cells: Array<Scalars['Float']>;
  id: Scalars['String'];
  ideality_factor: Scalars['Float'];
  open_circuit_voltage: Scalars['Float'];
  parallel_string_per_diode: Array<Scalars['Float']>;
  series_resistance: Scalars['Float'];
  short_circuit_current: Scalars['Float'];
  shunt_resistance: Scalars['Float'];
};

export type GetPanelIvPayload = {
  __typename?: 'GetPanelIvPayload';
  cell_iv_curve?: Maybe<Array<IvCurvePoint>>;
  ideality_factor?: Maybe<Scalars['Float']>;
  iv_params_invalid: Scalars['Boolean'];
  maximum_dc_power?: Maybe<Scalars['Float']>;
  maximum_power_current?: Maybe<Scalars['Float']>;
  maximum_power_voltage?: Maybe<Scalars['Float']>;
  module_iv_curve?: Maybe<Array<IvCurvePoint>>;
  open_circuit_voltage?: Maybe<Scalars['Float']>;
  panel_id: Scalars['String'];
  saturation_current?: Maybe<Scalars['Float']>;
  series_resistance?: Maybe<Scalars['Float']>;
  short_circuit_current?: Maybe<Scalars['Float']>;
  shunt_resistance?: Maybe<Scalars['Float']>;
};

export type IvCurvePoint = {
  __typename?: 'IVCurvePoint';
  current: Scalars['Float'];
  voltage: Scalars['Float'];
};

export enum IntervalAlignmentType {
  Beginning = 'beginning',
  Center = 'center',
  Ending = 'ending'
}

export enum InvertSortField {
  Manufacturer = 'manufacturer',
  MaximumDcCurrent = 'maximum_dc_current',
  MaximumDcVoltage = 'maximum_dc_voltage',
  MinimumDcVoltage = 'minimum_dc_voltage',
  Model = 'model',
  NightTarePower = 'night_tare_power',
  OutputAcVoltage = 'output_ac_voltage',
  RatedOutputAcPower = 'rated_output_ac_power',
  ReferenceDcPower = 'reference_dc_power',
  ReferenceDcVoltage = 'reference_dc_voltage',
  SelfConsumptionPower = 'self_consumption_power'
}

export type IssueEvent = {
  __typename?: 'IssueEvent';
  dt_timestamp: Scalars['String'];
  duet_block_id?: Maybe<Scalars['String']>;
  event_id: Scalars['String'];
  loss: Scalars['Float'];
  organization_id: Scalars['String'];
  project_id: Scalars['String'];
  source: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type IssueSummary = {
  __typename?: 'IssueSummary';
  count: Scalars['Int'];
  dt_timestamp: Scalars['String'];
  duet_block_id?: Maybe<Scalars['String']>;
  hierarchy_component: Scalars['String'];
  hierarchy_ids: Array<Scalars['String']>;
  loss: Scalars['Float'];
  organization_id: Scalars['String'];
  project_id: Scalars['String'];
  source: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type LabelledEvent = {
  __typename?: 'LabelledEvent';
  component: Scalars['String'];
  delta?: Maybe<Scalars['Float']>;
  duet_block_id?: Maybe<Scalars['String']>;
  event_type: Scalars['String'];
  hierarchy_id?: Maybe<Scalars['String']>;
  measurable?: Maybe<Scalars['Int']>;
  model_value?: Maybe<Scalars['Float']>;
  sensor_value?: Maybe<Scalars['Float']>;
  ts: Scalars['String'];
};

export enum LineMetalType {
  Al = 'Al',
  Cu = 'Cu'
}

export type LocalEmail = {
  __typename?: 'LocalEmail';
  html: Scalars['String'];
  id: Scalars['String'];
  subject: Scalars['String'];
  to: Scalars['String'];
};

export type LocalLoginInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export enum Measure {
  AboveMaxTemperatureLossWBi = 'above_max_temperature_loss_w_bi',
  AboveMaxTemperatureLossWMono = 'above_max_temperature_loss_w_mono',
  AboveMaxTemperatureLossWhBi = 'above_max_temperature_loss_wh_bi',
  AboveMaxTemperatureLossWhMono = 'above_max_temperature_loss_wh_mono',
  AcPowerClippingLossWBi = 'ac_power_clipping_loss_w_bi',
  AcPowerClippingLossWMono = 'ac_power_clipping_loss_w_mono',
  AcPowerClippingLossWhBi = 'ac_power_clipping_loss_wh_bi',
  AcPowerClippingLossWhMono = 'ac_power_clipping_loss_wh_mono',
  AirMass = 'air_mass',
  Albedo = 'albedo',
  ArrayCellEnergyBi = 'array_cell_energy_bi',
  ArrayCellEnergyMono = 'array_cell_energy_mono',
  ArrayCellMaxEnergyTStcBi = 'array_cell_max_energy_t_stc_bi',
  ArrayCellMaxEnergyTStcMono = 'array_cell_max_energy_t_stc_mono',
  ArrayCenterPanelCellEnergyBi = 'array_center_panel_cell_energy_bi',
  ArrayCenterPanelCellEnergyMono = 'array_center_panel_cell_energy_mono',
  ArrayStringEnergyBi = 'array_string_energy_bi',
  ArrayStringEnergyMono = 'array_string_energy_mono',
  AvailableEnergyWhBi = 'available_energy_wh_bi',
  AvailableEnergyWhMono = 'available_energy_wh_mono',
  AvailablePowerWBi = 'available_power_w_bi',
  AvailablePowerWMono = 'available_power_w_mono',
  AveBiCellTempC = 'ave_bi_cell_temp_c',
  AveMonoCellTempC = 'ave_mono_cell_temp_c',
  BelowMinTemperatureLossWBi = 'below_min_temperature_loss_w_bi',
  BelowMinTemperatureLossWMono = 'below_min_temperature_loss_w_mono',
  BelowMinTemperatureLossWhBi = 'below_min_temperature_loss_wh_bi',
  BelowMinTemperatureLossWhMono = 'below_min_temperature_loss_wh_mono',
  BifacialityCurrentRatio = 'bifaciality_current_ratio',
  CenterModuleInclinedIrradiance = 'center_module_inclined_irradiance',
  CenterModuleRearInclinedIrradiance = 'center_module_rear_inclined_irradiance',
  DegradationLossFirstYearWBi = 'degradation_loss_first_year_w_bi',
  DegradationLossFirstYearWMono = 'degradation_loss_first_year_w_mono',
  DegradationLossFirstYearWhBi = 'degradation_loss_first_year_wh_bi',
  DegradationLossFirstYearWhMono = 'degradation_loss_first_year_wh_mono',
  DegradationLossRemainingYearsWBi = 'degradation_loss_remaining_years_w_bi',
  DegradationLossRemainingYearsWMono = 'degradation_loss_remaining_years_w_mono',
  DegradationLossRemainingYearsWhBi = 'degradation_loss_remaining_years_wh_bi',
  DegradationLossRemainingYearsWhMono = 'degradation_loss_remaining_years_wh_mono',
  DhiWhm2 = 'dhi_whm2',
  DhiWm2 = 'dhi_wm2',
  DniWhm2 = 'dni_whm2',
  DniWm2 = 'dni_wm2',
  EnergyBi = 'energy_bi',
  EnergyMono = 'energy_mono',
  GhiGroundReflectedWhm2 = 'ghi_ground_reflected_whm2',
  GhiWhm2 = 'ghi_whm2',
  GhiWm2 = 'ghi_wm2',
  GridInjectionEnergyWhBi = 'grid_injection_energy_wh_bi',
  GridInjectionEnergyWhMono = 'grid_injection_energy_wh_mono',
  GridInjectionPowerWBi = 'grid_injection_power_w_bi',
  GridInjectionPowerWMono = 'grid_injection_power_w_mono',
  GtiFPvsystNoLossWhm2 = 'gti_f_pvsyst_no_loss_whm2',
  GtiFPvsystWithFarShadingWhm2 = 'gti_f_pvsyst_with_far_shading_whm2',
  GtiFPvsystWithIamWhm2 = 'gti_f_pvsyst_with_iam_whm2',
  GtiFPvsystWithNearShadingWhm2 = 'gti_f_pvsyst_with_near_shading_whm2',
  GtiRPvsystGroundReflectedWhm2 = 'gti_r_pvsyst_ground_reflected_whm2',
  GtiRPvsystWithDiffuseWhm2 = 'gti_r_pvsyst_with_diffuse_whm2',
  GtiRPvsystWithDirectWhm2 = 'gti_r_pvsyst_with_direct_whm2',
  GtiRPvsystWithStructureWhm2 = 'gti_r_pvsyst_with_structure_whm2',
  HvTransformerCopperLossWBi = 'hv_transformer_copper_loss_w_bi',
  HvTransformerCopperLossWMono = 'hv_transformer_copper_loss_w_mono',
  HvTransformerCopperLossWhBi = 'hv_transformer_copper_loss_wh_bi',
  HvTransformerCopperLossWhMono = 'hv_transformer_copper_loss_wh_mono',
  HvTransformerEfficiencyPercentageBi = 'hv_transformer_efficiency_percentage_bi',
  HvTransformerEfficiencyPercentageMono = 'hv_transformer_efficiency_percentage_mono',
  HvTransformerEnergyLossWhBi = 'hv_transformer_energy_loss_wh_bi',
  HvTransformerEnergyLossWhMono = 'hv_transformer_energy_loss_wh_mono',
  HvTransformerInputEnergyWhBi = 'hv_transformer_input_energy_wh_bi',
  HvTransformerInputEnergyWhMono = 'hv_transformer_input_energy_wh_mono',
  HvTransformerInputPowerWBi = 'hv_transformer_input_power_w_bi',
  HvTransformerInputPowerWMono = 'hv_transformer_input_power_w_mono',
  HvTransformerIronCoreLossWBi = 'hv_transformer_iron_core_loss_w_bi',
  HvTransformerIronCoreLossWMono = 'hv_transformer_iron_core_loss_w_mono',
  HvTransformerIronCoreLossWhBi = 'hv_transformer_iron_core_loss_wh_bi',
  HvTransformerIronCoreLossWhMono = 'hv_transformer_iron_core_loss_wh_mono',
  HvTransformerOutputEnergyWhBi = 'hv_transformer_output_energy_wh_bi',
  HvTransformerOutputEnergyWhMono = 'hv_transformer_output_energy_wh_mono',
  HvTransformerOutputPowerWBi = 'hv_transformer_output_power_w_bi',
  HvTransformerOutputPowerWMono = 'hv_transformer_output_power_w_mono',
  HvTransformerPowerLossWBi = 'hv_transformer_power_loss_w_bi',
  HvTransformerPowerLossWMono = 'hv_transformer_power_loss_w_mono',
  HvTransmissionLineEnergyLossWhBi = 'hv_transmission_line_energy_loss_wh_bi',
  HvTransmissionLineEnergyLossWhMono = 'hv_transmission_line_energy_loss_wh_mono',
  HvTransmissionLinePowerLossWBi = 'hv_transmission_line_power_loss_w_bi',
  HvTransmissionLinePowerLossWMono = 'hv_transmission_line_power_loss_w_mono',
  HvTransmissionLineReceivingEndEnergyWhBi = 'hv_transmission_line_receiving_end_energy_wh_bi',
  HvTransmissionLineReceivingEndEnergyWhMono = 'hv_transmission_line_receiving_end_energy_wh_mono',
  HvTransmissionLineReceivingEndPowerWBi = 'hv_transmission_line_receiving_end_power_w_bi',
  HvTransmissionLineReceivingEndPowerWMono = 'hv_transmission_line_receiving_end_power_w_mono',
  HvTransmissionLineSendingEndEnergyWhBi = 'hv_transmission_line_sending_end_energy_wh_bi',
  HvTransmissionLineSendingEndEnergyWhMono = 'hv_transmission_line_sending_end_energy_wh_mono',
  HvTransmissionLineSendingEndPowerWBi = 'hv_transmission_line_sending_end_power_w_bi',
  HvTransmissionLineSendingEndPowerWMono = 'hv_transmission_line_sending_end_power_w_mono',
  InverterDcOvercurrentLossWBi = 'inverter_dc_overcurrent_loss_w_bi',
  InverterDcOvercurrentLossWMono = 'inverter_dc_overcurrent_loss_w_mono',
  InverterDcOvercurrentLossWhBi = 'inverter_dc_overcurrent_loss_wh_bi',
  InverterDcOvercurrentLossWhMono = 'inverter_dc_overcurrent_loss_wh_mono',
  InverterDcOverpowerLossWBi = 'inverter_dc_overpower_loss_w_bi',
  InverterDcOverpowerLossWMono = 'inverter_dc_overpower_loss_w_mono',
  InverterDcOverpowerLossWhBi = 'inverter_dc_overpower_loss_wh_bi',
  InverterDcOverpowerLossWhMono = 'inverter_dc_overpower_loss_wh_mono',
  InverterDcOvervoltageLossWBi = 'inverter_dc_overvoltage_loss_w_bi',
  InverterDcOvervoltageLossWMono = 'inverter_dc_overvoltage_loss_w_mono',
  InverterDcOvervoltageLossWhBi = 'inverter_dc_overvoltage_loss_wh_bi',
  InverterDcOvervoltageLossWhMono = 'inverter_dc_overvoltage_loss_wh_mono',
  InverterDcUnderpowerLossWBi = 'inverter_dc_underpower_loss_w_bi',
  InverterDcUnderpowerLossWMono = 'inverter_dc_underpower_loss_w_mono',
  InverterDcUnderpowerLossWhBi = 'inverter_dc_underpower_loss_wh_bi',
  InverterDcUnderpowerLossWhMono = 'inverter_dc_underpower_loss_wh_mono',
  InverterDcUndervoltageLossWBi = 'inverter_dc_undervoltage_loss_w_bi',
  InverterDcUndervoltageLossWMono = 'inverter_dc_undervoltage_loss_w_mono',
  InverterDcUndervoltageLossWhBi = 'inverter_dc_undervoltage_loss_wh_bi',
  InverterDcUndervoltageLossWhMono = 'inverter_dc_undervoltage_loss_wh_mono',
  InverterNightTareLossWBi = 'inverter_night_tare_loss_w_bi',
  InverterNightTareLossWMono = 'inverter_night_tare_loss_w_mono',
  InverterNightTareLossWhBi = 'inverter_night_tare_loss_wh_bi',
  InverterNightTareLossWhMono = 'inverter_night_tare_loss_wh_mono',
  InverterOutputEnergyStcWhBi = 'inverter_output_energy_stc_wh_bi',
  InverterOutputEnergyStcWhMono = 'inverter_output_energy_stc_wh_mono',
  InverterOutputEnergyWhBi = 'inverter_output_energy_wh_bi',
  InverterOutputEnergyWhMono = 'inverter_output_energy_wh_mono',
  InverterOutputPowerStcWBi = 'inverter_output_power_stc_w_bi',
  InverterOutputPowerStcWMono = 'inverter_output_power_stc_w_mono',
  InverterOutputPowerWBi = 'inverter_output_power_w_bi',
  InverterOutputPowerWMono = 'inverter_output_power_w_mono',
  LineEnergyLossWhBi = 'line_energy_loss_wh_bi',
  LineEnergyLossWhMono = 'line_energy_loss_wh_mono',
  LinePowerLossWBi = 'line_power_loss_w_bi',
  LinePowerLossWMono = 'line_power_loss_w_mono',
  LineReceivingEndEnergyWhBi = 'line_receiving_end_energy_wh_bi',
  LineReceivingEndEnergyWhMono = 'line_receiving_end_energy_wh_mono',
  LineReceivingEndPowerWBi = 'line_receiving_end_power_w_bi',
  LineReceivingEndPowerWMono = 'line_receiving_end_power_w_mono',
  LineSendingEndEnergyWhBi = 'line_sending_end_energy_wh_bi',
  LineSendingEndEnergyWhMono = 'line_sending_end_energy_wh_mono',
  LineSendingEndPowerWBi = 'line_sending_end_power_w_bi',
  LineSendingEndPowerWMono = 'line_sending_end_power_w_mono',
  NumPanelsInArray = 'num_panels_in_array',
  PerformanceRatioBi = 'performance_ratio_bi',
  PerformanceRatioMono = 'performance_ratio_mono',
  PowerFactorDerateLossWBi = 'power_factor_derate_loss_w_bi',
  PowerFactorDerateLossWMono = 'power_factor_derate_loss_w_mono',
  PowerFactorDerateLossWhBi = 'power_factor_derate_loss_wh_bi',
  PowerFactorDerateLossWhMono = 'power_factor_derate_loss_wh_mono',
  PvPowerNoDegradationWBi = 'pv_power_no_degradation_w_bi',
  PvPowerNoDegradationWMono = 'pv_power_no_degradation_w_mono',
  PvPowerNoDegradationWhBi = 'pv_power_no_degradation_wh_bi',
  PvPowerNoDegradationWhMono = 'pv_power_no_degradation_wh_mono',
  PvPowerNoSoilingWBi = 'pv_power_no_soiling_w_bi',
  PvPowerNoSoilingWMono = 'pv_power_no_soiling_w_mono',
  PvPowerNoSoilingWhBi = 'pv_power_no_soiling_wh_bi',
  PvPowerNoSoilingWhMono = 'pv_power_no_soiling_wh_mono',
  PvPowerWithDegradationWBi = 'pv_power_with_degradation_w_bi',
  PvPowerWithDegradationWMono = 'pv_power_with_degradation_w_mono',
  PvPowerWithDegradationWhBi = 'pv_power_with_degradation_wh_bi',
  PvPowerWithDegradationWhMono = 'pv_power_with_degradation_wh_mono',
  PvPowerWithSoilingWBi = 'pv_power_with_soiling_w_bi',
  PvPowerWithSoilingWMono = 'pv_power_with_soiling_w_mono',
  PvPowerWithSoilingWhBi = 'pv_power_with_soiling_wh_bi',
  PvPowerWithSoilingWhMono = 'pv_power_with_soiling_wh_mono',
  SelfConsumptionLossWBi = 'self_consumption_loss_w_bi',
  SelfConsumptionLossWMono = 'self_consumption_loss_w_mono',
  SelfConsumptionLossWhBi = 'self_consumption_loss_wh_bi',
  SelfConsumptionLossWhMono = 'self_consumption_loss_wh_mono',
  SoilingLossWBi = 'soiling_loss_w_bi',
  SoilingLossWMono = 'soiling_loss_w_mono',
  SoilingLossWhBi = 'soiling_loss_wh_bi',
  SoilingLossWhMono = 'soiling_loss_wh_mono',
  StcPvPower = 'stc_pv_power',
  SunAzimuthDeg = 'sun_azimuth_deg',
  SunZenithDeg = 'sun_zenith_deg',
  TemperatureC = 'temperature_c',
  TemperatureDeratingLossWBi = 'temperature_derating_loss_w_bi',
  TemperatureDeratingLossWMono = 'temperature_derating_loss_w_mono',
  TemperatureDeratingLossWhBi = 'temperature_derating_loss_wh_bi',
  TemperatureDeratingLossWhMono = 'temperature_derating_loss_wh_mono',
  TotalDegradationLossWBi = 'total_degradation_loss_w_bi',
  TotalDegradationLossWMono = 'total_degradation_loss_w_mono',
  TotalDegradationLossWhBi = 'total_degradation_loss_wh_bi',
  TotalDegradationLossWhMono = 'total_degradation_loss_wh_mono',
  TotalInverterLossWBi = 'total_inverter_loss_w_bi',
  TotalInverterLossWMono = 'total_inverter_loss_w_mono',
  TotalInverterLossWhBi = 'total_inverter_loss_wh_bi',
  TotalInverterLossWhMono = 'total_inverter_loss_wh_mono',
  TransformerCopperLossWBi = 'transformer_copper_loss_w_bi',
  TransformerCopperLossWMono = 'transformer_copper_loss_w_mono',
  TransformerCopperLossWhBi = 'transformer_copper_loss_wh_bi',
  TransformerCopperLossWhMono = 'transformer_copper_loss_wh_mono',
  TransformerEnergyLossWhBi = 'transformer_energy_loss_wh_bi',
  TransformerEnergyLossWhMono = 'transformer_energy_loss_wh_mono',
  TransformerInputEnergyWhBi = 'transformer_input_energy_wh_bi',
  TransformerInputEnergyWhMono = 'transformer_input_energy_wh_mono',
  TransformerInputPowerWBi = 'transformer_input_power_w_bi',
  TransformerInputPowerWMono = 'transformer_input_power_w_mono',
  TransformerIronCoreLossWBi = 'transformer_iron_core_loss_w_bi',
  TransformerIronCoreLossWMono = 'transformer_iron_core_loss_w_mono',
  TransformerIronCoreLossWhBi = 'transformer_iron_core_loss_wh_bi',
  TransformerIronCoreLossWhMono = 'transformer_iron_core_loss_wh_mono',
  TransformerOutputEnergyWhBi = 'transformer_output_energy_wh_bi',
  TransformerOutputEnergyWhMono = 'transformer_output_energy_wh_mono',
  TransformerOutputPowerWBi = 'transformer_output_power_w_bi',
  TransformerOutputPowerWMono = 'transformer_output_power_w_mono',
  TransformerPowerLossWBi = 'transformer_power_loss_w_bi',
  TransformerPowerLossWMono = 'transformer_power_loss_w_mono',
  TransmissionLineEnergyLossWhBi = 'transmission_line_energy_loss_wh_bi',
  TransmissionLineEnergyLossWhMono = 'transmission_line_energy_loss_wh_mono',
  TransmissionLinePowerLossWBi = 'transmission_line_power_loss_w_bi',
  TransmissionLinePowerLossWMono = 'transmission_line_power_loss_w_mono',
  TransmissionLineReceivingEndEnergyWhBi = 'transmission_line_receiving_end_energy_wh_bi',
  TransmissionLineReceivingEndEnergyWhMono = 'transmission_line_receiving_end_energy_wh_mono',
  TransmissionLineReceivingEndPowerWBi = 'transmission_line_receiving_end_power_w_bi',
  TransmissionLineReceivingEndPowerWMono = 'transmission_line_receiving_end_power_w_mono',
  TransmissionLineSendingEndEnergyWhBi = 'transmission_line_sending_end_energy_wh_bi',
  TransmissionLineSendingEndEnergyWhMono = 'transmission_line_sending_end_energy_wh_mono',
  TransmissionLineSendingEndPowerWBi = 'transmission_line_sending_end_power_w_bi',
  TransmissionLineSendingEndPowerWMono = 'transmission_line_sending_end_power_w_mono'
}

export enum MechanicalShapeEnum {
  Rect = 'rect',
  Round = 'round'
}

export type MinMax = {
  __typename?: 'MinMax';
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type MinMaxInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type ModuleIrradianceProfile = {
  __typename?: 'ModuleIrradianceProfile';
  dt_time_index: Scalars['Int'];
  dt_timestamp: Scalars['String'];
  duet_job_id: Scalars['String'];
  duet_job_input_id: Scalars['String'];
  front_exterior: Array<Array<Scalars['Float']>>;
  front_interior: Array<Array<Scalars['Float']>>;
  id: Scalars['String'];
  pui_id: Scalars['String'];
  rear_exterior: Array<Array<Scalars['Float']>>;
  rear_interior: Array<Array<Scalars['Float']>>;
};

export type ModuleIrradianceProfileIndex = {
  __typename?: 'ModuleIrradianceProfileIndex';
  column: Scalars['Int'];
  dt_time_index: Scalars['Int'];
  dt_timestamp: Scalars['DateTime'];
  duet_job_id: Scalars['String'];
  duet_job_input_id: Scalars['String'];
  profile_group: Scalars['String'];
  pui_id: Scalars['String'];
  row: Scalars['Int'];
  table: Scalars['Int'];
  tier: Scalars['Int'];
};

export type ModuleIrradianceProfileTableMeta = {
  __typename?: 'ModuleIrradianceProfileTableMeta';
  dt_timestamp: Scalars['DateTime'];
  duet_job_input_id: Scalars['String'];
  table_id: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptUserInvite?: Maybe<ExpandedUserInvite>;
  addMeteoDataset: Scalars['Boolean'];
  addProjectUsers: Array<ProjectUser>;
  adminCopyProjectToSelf: Project;
  adminDeleteOrganizationIntegrationServer: Scalars['Boolean'];
  adminDeleteOrganizationIntegrationServerSchedule: OrganizationIntegrationServerSchedule;
  adminMakeOrganizationIntegrationServerRequest: Scalars['JSON'];
  adminUpsertOrganizationIntegrationServer: Scalars['String'];
  adminUpsertOrganizationIntegrationServerSchedule: OrganizationIntegrationServerSchedule;
  approveUserRequest: UserRequest;
  assignProjectRole: ProjectUser;
  changePassword: MutationChangePasswordResult;
  copyProject: Project;
  createAcWire: PvAcWire;
  createApiToken: UserApiToken;
  createCompareWorkbook: CompareWorkbook;
  createDcWire: PvDcWire;
  createInverter: PvInverter;
  createOrganization: Organization;
  createPanel: PvPanel;
  createProject: Project;
  createProjectEnviroDatasetFromCsvFile: EnviroDatasetOwner;
  createProjectEnviroDatasetFromMetFile: EnviroDatasetOwner;
  createRasterLayer: RasterLayer;
  createTable: PvTable;
  createTransformer: PvTransformer;
  createUserRequest: UserRequest;
  deleteAcWire: PvAcWire;
  deleteApiToken: UserApiToken;
  deleteBlockLayers: Scalars['Boolean'];
  deleteBlocks: Scalars['Boolean'];
  deleteCompareWorkbook: CompareWorkbook;
  deleteDcWire: PvDcWire;
  deleteDuetSimulation: DuetSimulation;
  deleteInverter: PvInverter;
  deleteOrganizationUser: Scalars['Boolean'];
  deletePanel: PvPanel;
  deleteProject: Project;
  deleteProjectEnviroDataset: EnviroDatasetOwner;
  deleteProjectUser: ProjectUser;
  deleteRasterLayer: Scalars['String'];
  deleteTable: PvTable;
  deleteTransformer: PvTransformer;
  deleteUserInvite: UserInvite;
  deleteUserRequest: UserRequest;
  duetJobStatusNotifier: Scalars['Boolean'];
  editDuetJobStatus: DuetJob;
  editDuetSimulation: DuetSimulation;
  endImpersonate: Scalars['JSON'];
  executePvSystImport: PvSystImportResult;
  firebaseEmailVerificationSuccess: MutationFirebaseEmailVerificationSuccessResult;
  firebaseLogin: MutationFirebaseLoginResult;
  firebaseRegister: MutationFirebaseRegisterResult;
  firebaseSendEmailVerification: MutationFirebaseSendEmailVerificationResult;
  firebaseSyncUserIdentity: MutationFirebaseSyncUserIdentityResult;
  impersonateUser: TokenPayload;
  inviteOrganizationUser: UserInvite;
  inviteUser: UserInvite;
  localLogin: MutationLocalLoginResult;
  organizationIntegrationServerEvent: Scalars['Boolean'];
  rejectUserRequest: UserRequest;
  runProjectBlockSimulation: RunSimulationResult;
  runSentinelSimulation: RunSimulationResult;
  simDataExport: Scalars['Boolean'];
  stopProjectSimulation: DuetSimulation;
  updateAcWire: PvAcWire;
  updateAcWireName: PvAcWire;
  updateCompareWorkbook: CompareWorkbook;
  updateDcWire: PvDcWire;
  updateDcWireName: PvDcWire;
  updateFeatureFlag: Scalars['Boolean'];
  updateInverter: PvInverter;
  updateInverterName: PvInverter;
  updateOrganization: UpdateOrganizationResult;
  updatePanel: PvPanel;
  updatePanelName: PvPanel;
  updateProject: Project;
  updateProjectEnviroDataset: EnviroDatasetOwner;
  updateRasterLayer: RasterLayer;
  updateSystemParameters: SystemParameters;
  updateTable: PvTable;
  updateTableName: PvTable;
  updateTransformer: PvTransformer;
  updateTransformerName: PvTransformer;
  updateUser: User;
  updateUserIntakeForm: UserLeadIntakeForm;
  upsertBlockLayers: Array<BlockLayer>;
  upsertBlocks: Array<Block>;
  upsertCecInverters: Scalars['Int'];
  upsertOrganizationUser: UserOrganization;
  userDataPrivacyRequest: Scalars['Boolean'];
};


export type MutationAcceptUserInviteArgs = {
  id: Scalars['String'];
};


export type MutationAddMeteoDatasetArgs = {
  dataset_name: Scalars['String'];
  display_name?: InputMaybe<Scalars['String']>;
  intervals: Array<Scalars['Int']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  nsrdb_tmy_years?: InputMaybe<Array<Scalars['String']>>;
  project_id: Scalars['String'];
  source: Scalars['String'];
  years?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationAddProjectUsersArgs = {
  project_id: Scalars['String'];
  role_id: Scalars['String'];
  user_ids: Array<Scalars['String']>;
};


export type MutationAdminCopyProjectToSelfArgs = {
  copyProjectName: Scalars['String'];
  sourceProjectId: Scalars['String'];
};


export type MutationAdminDeleteOrganizationIntegrationServerArgs = {
  id: Scalars['String'];
};


export type MutationAdminDeleteOrganizationIntegrationServerScheduleArgs = {
  integration_server_id: Scalars['String'];
  schedule_id: Scalars['String'];
};


export type MutationAdminMakeOrganizationIntegrationServerRequestArgs = {
  body?: InputMaybe<Scalars['JSON']>;
  endpoint: Scalars['String'];
  id: Scalars['String'];
  method: Scalars['String'];
};


export type MutationAdminUpsertOrganizationIntegrationServerArgs = {
  organizationIntegrationServerInput: OrganizationIntegrationServerInput;
  skipTokenGeneration?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAdminUpsertOrganizationIntegrationServerScheduleArgs = {
  organizationIntegrationServerScheduleInput: OrganizationIntegrationServerScheduleInput;
};


export type MutationApproveUserRequestArgs = {
  id: Scalars['String'];
};


export type MutationAssignProjectRoleArgs = {
  project_id: Scalars['String'];
  role_id: Scalars['String'];
  user_id: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationCopyProjectArgs = {
  copyProjectName: Scalars['String'];
  sourceProjectId: Scalars['String'];
};


export type MutationCreateAcWireArgs = {
  data?: InputMaybe<PvAcWireUpdateInput>;
  name: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationCreateCompareWorkbookArgs = {
  name: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationCreateDcWireArgs = {
  data?: InputMaybe<PvDcWireUpdateInput>;
  name: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationCreateInverterArgs = {
  data?: InputMaybe<PvInverterUpdateInput>;
  name: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePanelArgs = {
  data?: InputMaybe<PvPanelUpdateInput>;
  name: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationCreateProjectArgs = {
  blocks_bounding_box?: InputMaybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  organization_id: Scalars['String'];
  pvsyst_import_in_progress?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateProjectEnviroDatasetFromCsvFileArgs = {
  decomposition_parameters?: InputMaybe<DecompositionParametersInput>;
  enviro_dataset: CreateEnviroDatasetFromCsvFileInput;
  project_id: Scalars['String'];
};


export type MutationCreateProjectEnviroDatasetFromMetFileArgs = {
  enviro_dataset: CreateEnviroDatasetFromMetFileInput;
  project_id: Scalars['String'];
};


export type MutationCreateRasterLayerArgs = {
  project_id: Scalars['String'];
  raster_layer: RasterLayerInput;
};


export type MutationCreateTableArgs = {
  data?: InputMaybe<PvTableUpdateInput>;
  name: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationCreateTransformerArgs = {
  data?: InputMaybe<PvTransformerUpdateInput>;
  name: Scalars['String'];
  project_id: Scalars['String'];
  type: Scalars['String'];
};


export type MutationCreateUserRequestArgs = {
  organization_id: Scalars['String'];
};


export type MutationDeleteAcWireArgs = {
  id: Scalars['String'];
};


export type MutationDeleteApiTokenArgs = {
  token: Scalars['String'];
};


export type MutationDeleteBlockLayersArgs = {
  block_layer_ids?: InputMaybe<Array<Scalars['String']>>;
  project_id: Scalars['String'];
};


export type MutationDeleteBlocksArgs = {
  block_ids?: InputMaybe<Array<Scalars['String']>>;
  project_id: Scalars['String'];
};


export type MutationDeleteCompareWorkbookArgs = {
  id: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationDeleteDcWireArgs = {
  id: Scalars['String'];
};


export type MutationDeleteDuetSimulationArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInverterArgs = {
  id: Scalars['String'];
};


export type MutationDeleteOrganizationUserArgs = {
  user_id: Scalars['String'];
};


export type MutationDeletePanelArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectEnviroDatasetArgs = {
  id: Scalars['String'];
};


export type MutationDeleteProjectUserArgs = {
  project_id: Scalars['String'];
  user_id: Scalars['String'];
};


export type MutationDeleteRasterLayerArgs = {
  project_id: Scalars['String'];
  raster_layer_id: Scalars['String'];
};


export type MutationDeleteTableArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTransformerArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserInviteArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserRequestArgs = {
  id: Scalars['String'];
};


export type MutationDuetJobStatusNotifierArgs = {
  duet_job_id: Scalars['String'];
};


export type MutationEditDuetJobStatusArgs = {
  id: Scalars['String'];
  status: Scalars['String'];
};


export type MutationEditDuetSimulationArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationExecutePvSystImportArgs = {
  apply_starter_defaults?: InputMaybe<Scalars['Boolean']>;
  project_id: Scalars['String'];
  variant_file_name: Scalars['String'];
};


export type MutationFirebaseEmailVerificationSuccessArgs = {
  token: Scalars['String'];
};


export type MutationFirebaseLoginArgs = {
  credential: Scalars['JSON'];
  invite_id?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type MutationFirebaseRegisterArgs = {
  credential: Scalars['JSON'];
  invite_id?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type MutationImpersonateUserArgs = {
  email: Scalars['String'];
  reason: Scalars['String'];
  remarks?: InputMaybe<Scalars['String']>;
};


export type MutationInviteOrganizationUserArgs = {
  email: Scalars['String'];
  organization_id: Scalars['String'];
};


export type MutationInviteUserArgs = {
  email: Scalars['String'];
};


export type MutationLocalLoginArgs = {
  input: LocalLoginInput;
};


export type MutationOrganizationIntegrationServerEventArgs = {
  event_data: Scalars['JSON'];
  event_type: Scalars['String'];
  job: Scalars['JSON'];
};


export type MutationRejectUserRequestArgs = {
  id: Scalars['String'];
};


export type MutationRunProjectBlockSimulationArgs = {
  blocks: Array<BlockSimulationInput>;
  enviro_dataset_id: Scalars['String'];
  name: Scalars['String'];
  project_id: Scalars['String'];
  simulated_year_for_tmy?: InputMaybe<Scalars['Int']>;
  time_range: TimeSelectionRangeInput;
};


export type MutationRunSentinelSimulationArgs = {
  concurrency?: InputMaybe<Scalars['Int']>;
  dt_end: Scalars['String'];
  dt_start: Scalars['String'];
  project_id: Scalars['String'];
  sentinel_tag?: InputMaybe<Scalars['String']>;
};


export type MutationSimDataExportArgs = {
  format: DataExportFormat;
  scope: DataExportScope;
  simulation_id: Scalars['String'];
};


export type MutationStopProjectSimulationArgs = {
  id: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationUpdateAcWireArgs = {
  data: PvAcWireUpdateInput;
  id: Scalars['String'];
};


export type MutationUpdateAcWireNameArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateCompareWorkbookArgs = {
  data?: InputMaybe<UpdateCompareWorkbookInput>;
  id: Scalars['String'];
  project_id: Scalars['String'];
};


export type MutationUpdateDcWireArgs = {
  data: PvDcWireUpdateInput;
  id: Scalars['String'];
};


export type MutationUpdateDcWireNameArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateFeatureFlagArgs = {
  flag_input: AdminFeatureFlagInput;
};


export type MutationUpdateInverterArgs = {
  data: PvInverterUpdateInput;
  id: Scalars['String'];
};


export type MutationUpdateInverterNameArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateOrganizationArgs = {
  data: UpdateOrganizationInput;
  id: Scalars['String'];
};


export type MutationUpdatePanelArgs = {
  data: PvPanelUpdateInput;
  id: Scalars['String'];
};


export type MutationUpdatePanelNameArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateProjectArgs = {
  data: ProjectUpdateData;
  id: Scalars['String'];
};


export type MutationUpdateProjectEnviroDatasetArgs = {
  data: UpdateEnviroDatasetInput;
  id: Scalars['String'];
};


export type MutationUpdateRasterLayerArgs = {
  project_id: Scalars['String'];
  raster_layer: UpdateRasterLayerInput;
  raster_layer_id: Scalars['String'];
};


export type MutationUpdateSystemParametersArgs = {
  system_parameters: SystemParametersInput;
};


export type MutationUpdateTableArgs = {
  data: PvTableUpdateInput;
  id: Scalars['String'];
};


export type MutationUpdateTableNameArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateTransformerArgs = {
  data: PvTransformerUpdateInput;
  id: Scalars['String'];
};


export type MutationUpdateTransformerNameArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserIntakeFormArgs = {
  input: UserLeadIntakeFormInput;
};


export type MutationUpsertBlockLayersArgs = {
  block_layers?: InputMaybe<Array<BlockLayerInput>>;
  project_id: Scalars['String'];
};


export type MutationUpsertBlocksArgs = {
  blocks?: InputMaybe<Array<BlockInput>>;
  project_id: Scalars['String'];
};


export type MutationUpsertCecInvertersArgs = {
  data: Array<CreateCecInverterInput>;
};


export type MutationUpsertOrganizationUserArgs = {
  role_id: Scalars['String'];
  user_id: Scalars['String'];
};


export type MutationUserDataPrivacyRequestArgs = {
  request_type: Scalars['String'];
};

export type MutationChangePasswordResult = AuthError | TokenPayload;

export type MutationFirebaseEmailVerificationSuccessResult = AuthError | MutationFirebaseEmailVerificationSuccessSuccess;

export type MutationFirebaseEmailVerificationSuccessSuccess = {
  __typename?: 'MutationFirebaseEmailVerificationSuccessSuccess';
  data: Scalars['Boolean'];
};

export type MutationFirebaseLoginResult = AuthError | TokenPayload;

export type MutationFirebaseRegisterResult = AuthError | TokenPayload;

export type MutationFirebaseSendEmailVerificationResult = AuthError | MutationFirebaseSendEmailVerificationSuccess;

export type MutationFirebaseSendEmailVerificationSuccess = {
  __typename?: 'MutationFirebaseSendEmailVerificationSuccess';
  data: Scalars['Boolean'];
};

export type MutationFirebaseSyncUserIdentityResult = AuthError | MutationFirebaseSyncUserIdentitySuccess;

export type MutationFirebaseSyncUserIdentitySuccess = {
  __typename?: 'MutationFirebaseSyncUserIdentitySuccess';
  data: Scalars['Boolean'];
};

export type MutationLocalLoginResult = AuthError | TokenPayload;

export type Organization = {
  __typename?: 'Organization';
  allowed_domains: Array<Scalars['String']>;
  created_at: Scalars['DateTime'];
  created_by_user_id: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  sentinel_deployments: Array<SentinelDeployment>;
  slug: Scalars['String'];
  updated_at: Scalars['DateTime'];
  user_organization: Array<UserOrganization>;
  user_request: Array<UserRequest>;
};

export type OrganizationIntegrationServer = {
  __typename?: 'OrganizationIntegrationServer';
  api_spec?: Maybe<Scalars['JSON']>;
  bearer_token: Scalars['String'];
  id: Scalars['String'];
  organization: Organization;
  organization_id: Scalars['String'];
  ping: Scalars['Boolean'];
  registered_schedulers?: Maybe<Scalars['JSON']>;
  schedules: Array<OrganizationIntegrationServerSchedule>;
  sentinelDeployments: Array<SentinelDeployment>;
  url: Scalars['String'];
};

export type OrganizationIntegrationServerInput = {
  bearer_token: Scalars['String'];
  organization_id: Scalars['String'];
  url: Scalars['String'];
};

export type OrganizationIntegrationServerJob = {
  __typename?: 'OrganizationIntegrationServerJob';
  created_at: Scalars['DateTime'];
  id: Scalars['String'];
  integration_server: OrganizationIntegrationServer;
  integration_server_id: Scalars['String'];
  job_events: Array<OrganizationIntegrationServerJobEvent>;
  job_name: Scalars['String'];
  parent_job_id?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type OrganizationIntegrationServerJobEvent = {
  __typename?: 'OrganizationIntegrationServerJobEvent';
  created_at: Scalars['DateTime'];
  event_data: Scalars['JSON'];
  event_type: Scalars['String'];
  job_data: Scalars['JSON'];
  updated_at: Scalars['DateTime'];
};

export type OrganizationIntegrationServerSchedule = {
  __typename?: 'OrganizationIntegrationServerSchedule';
  created_at: Scalars['DateTime'];
  crontab: Scalars['String'];
  job_data: Scalars['JSON'];
  job_name: Scalars['String'];
  job_type: Scalars['String'];
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['String']>;
  schedule_id: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type OrganizationIntegrationServerScheduleInput = {
  crontab: Scalars['String'];
  integration_server_id: Scalars['String'];
  job_data?: InputMaybe<Scalars['JSON']>;
  job_name: Scalars['String'];
  job_type: Scalars['String'];
  project_id?: InputMaybe<Scalars['String']>;
  schedule_id: Scalars['String'];
};

export enum PanelOrientationEnum {
  Landscape = 'landscape',
  Portrait = 'portrait'
}

export type PlantPlaybackData = {
  __typename?: 'PlantPlaybackData';
  columns: Array<Scalars['String']>;
  rows: Array<Scalars['JSON']>;
};

export type Project = {
  __typename?: 'Project';
  blocks_bounding_box?: Maybe<Array<Scalars['Float']>>;
  created_at: Scalars['DateTime'];
  duet_simulations: Array<DuetSimulation>;
  enviro_dataset_owner: Array<EnviroDatasetOwner>;
  id: Scalars['ID'];
  last_activity_at: Scalars['DateTime'];
  layers_mutated_at?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  org_general_access: Scalars['Boolean'];
  organization: Organization;
  organization_id: Scalars['String'];
  owner: User;
  owner_id: Scalars['ID'];
  project_users: Array<ProjectUser>;
  pvsyst_import_in_progress?: Maybe<Scalars['Boolean']>;
  raster_layers: Array<RasterLayer>;
  recent_simulations: Array<DuetSimulation>;
  sentinel_deployment?: Maybe<SentinelDeployment>;
  system_parameters: SystemParameters;
  updated_at: Scalars['DateTime'];
};

export type ProjectUpdateData = {
  blocks_bounding_box?: InputMaybe<Array<Scalars['Float']>>;
  name?: InputMaybe<Scalars['String']>;
  org_general_access?: InputMaybe<Scalars['Boolean']>;
  organization_id?: InputMaybe<Scalars['String']>;
  pvsyst_import_in_progress?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectUser = {
  __typename?: 'ProjectUser';
  id: Scalars['ID'];
  project: Project;
  project_id: Scalars['ID'];
  role_id: Scalars['ID'];
  user: User;
  user_id: Scalars['ID'];
};

export type PvAcWire = {
  __typename?: 'PvAcWire';
  ac_line_calculation_method?: Maybe<Scalars['String']>;
  ac_line_cross_section?: Maybe<Scalars['Float']>;
  ac_line_length?: Maybe<Scalars['Float']>;
  ac_line_loss_percentage?: Maybe<Scalars['Float']>;
  ac_line_metal_type?: Maybe<Scalars['String']>;
  ac_per_km_resistance?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  default_state_fields?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  name: Scalars['String'];
  total_ac_resistance_override?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
};

export type PvAcWireUpdateInput = {
  ac_line_calculation_method?: InputMaybe<Scalars['String']>;
  ac_line_cross_section?: InputMaybe<Scalars['Float']>;
  ac_line_length?: InputMaybe<Scalars['Float']>;
  ac_line_loss_percentage?: InputMaybe<Scalars['Float']>;
  ac_line_metal_type?: InputMaybe<Scalars['String']>;
  ac_per_km_resistance?: InputMaybe<Scalars['Float']>;
  default_state_fields?: InputMaybe<Scalars['JSON']>;
  total_ac_resistance_override?: InputMaybe<Scalars['Float']>;
};

export type PvDcWire = {
  __typename?: 'PvDcWire';
  created_at: Scalars['DateTime'];
  dc_line_calculation_method?: Maybe<Scalars['String']>;
  dc_line_cross_section?: Maybe<Scalars['Float']>;
  dc_line_length?: Maybe<Scalars['Float']>;
  dc_line_loss_percentage?: Maybe<Scalars['Float']>;
  dc_line_metal_type?: Maybe<Scalars['String']>;
  dc_per_km_resistance?: Maybe<Scalars['Float']>;
  default_state_fields?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  name: Scalars['String'];
  total_dc_resistance_override?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
};

export type PvDcWireUpdateInput = {
  dc_line_calculation_method?: InputMaybe<Scalars['String']>;
  dc_line_cross_section?: InputMaybe<Scalars['Float']>;
  dc_line_length?: InputMaybe<Scalars['Float']>;
  dc_line_loss_percentage?: InputMaybe<Scalars['Float']>;
  dc_line_metal_type?: InputMaybe<Scalars['String']>;
  dc_per_km_resistance?: InputMaybe<Scalars['Float']>;
  default_state_fields?: InputMaybe<Scalars['JSON']>;
  total_dc_resistance_override?: InputMaybe<Scalars['Float']>;
};

export type PvElectrical = {
  __typename?: 'PvElectrical';
  ac_line_calculation_method?: Maybe<Scalars['String']>;
  ac_line_cross_section?: Maybe<Scalars['Float']>;
  ac_line_length?: Maybe<Scalars['Float']>;
  ac_line_loss_percentage?: Maybe<Scalars['Float']>;
  ac_line_metal_type?: Maybe<Scalars['String']>;
  ac_per_km_resistance?: Maybe<Scalars['Float']>;
  copper_power_loss_data_source?: Maybe<Scalars['String']>;
  copper_power_loss_percentage?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  dc_line_calculation_method?: Maybe<Scalars['String']>;
  dc_line_cross_section?: Maybe<Scalars['Float']>;
  dc_line_length?: Maybe<Scalars['Float']>;
  dc_line_loss_percentage?: Maybe<Scalars['Float']>;
  dc_line_metal_type?: Maybe<Scalars['String']>;
  dc_per_km_resistance?: Maybe<Scalars['Float']>;
  default_state_fields?: Maybe<Scalars['JSON']>;
  high_voltage_winding_resistance?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  iron_power_loss?: Maybe<Scalars['Float']>;
  iron_power_loss_data_source?: Maybe<Scalars['String']>;
  iron_power_loss_percentage?: Maybe<Scalars['Float']>;
  low_voltage_winding_resistance?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  night_disconnect?: Maybe<Scalars['Boolean']>;
  nominal_high_side_voltage?: Maybe<Scalars['Float']>;
  nominal_low_side_voltage?: Maybe<Scalars['Float']>;
  total_ac_resistance_override?: Maybe<Scalars['Float']>;
  total_dc_resistance_override?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
};

export type PvInverter = {
  __typename?: 'PvInverter';
  cec_efficiency_curves?: Maybe<Scalars['JSON']>;
  created_at: Scalars['DateTime'];
  default_state_fields?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  inverter_data_source?: Maybe<Scalars['String']>;
  inverter_id?: Maybe<Scalars['String']>;
  maximum_ac_power?: Maybe<Scalars['Float']>;
  maximum_dc_current?: Maybe<Scalars['Float']>;
  maximum_dc_power?: Maybe<Scalars['Float']>;
  maximum_dc_voltage?: Maybe<Scalars['Float']>;
  maximum_operating_temperature?: Maybe<Scalars['Float']>;
  minimum_dc_voltage?: Maybe<Scalars['Float']>;
  minimum_operating_temperature?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  night_tare_power?: Maybe<Scalars['Float']>;
  ond_file_import?: Maybe<Scalars['JSON']>;
  output_ac_voltage?: Maybe<Scalars['Float']>;
  rated_output_ac_power?: Maybe<Scalars['Float']>;
  reference_dc_power?: Maybe<Scalars['Float']>;
  reference_dc_voltage?: Maybe<Scalars['Float']>;
  self_consumption_power?: Maybe<Scalars['Float']>;
  temp_derate_curves?: Maybe<Scalars['JSON']>;
  updated_at: Scalars['DateTime'];
};

export type PvInverterUpdateInput = {
  cec_efficiency_curves?: InputMaybe<Scalars['JSON']>;
  default_state_fields?: InputMaybe<Scalars['JSON']>;
  inverter_data_source?: InputMaybe<Scalars['String']>;
  inverter_id?: InputMaybe<Scalars['String']>;
  maximum_ac_power?: InputMaybe<Scalars['Float']>;
  maximum_dc_current?: InputMaybe<Scalars['Float']>;
  maximum_dc_power?: InputMaybe<Scalars['Float']>;
  maximum_dc_voltage?: InputMaybe<Scalars['Float']>;
  maximum_operating_temperature?: InputMaybe<Scalars['Float']>;
  minimum_dc_voltage?: InputMaybe<Scalars['Float']>;
  minimum_operating_temperature?: InputMaybe<Scalars['Float']>;
  night_tare_power?: InputMaybe<Scalars['Float']>;
  ond_file_import?: InputMaybe<Scalars['JSON']>;
  output_ac_voltage?: InputMaybe<Scalars['Float']>;
  rated_output_ac_power?: InputMaybe<Scalars['Float']>;
  reference_dc_power?: InputMaybe<Scalars['Float']>;
  reference_dc_voltage?: InputMaybe<Scalars['Float']>;
  self_consumption_power?: InputMaybe<Scalars['Float']>;
  temp_derate_curves?: InputMaybe<Scalars['JSON']>;
};

export type PvPanel = {
  __typename?: 'PvPanel';
  bifaciality_current_ratio?: Maybe<Scalars['Float']>;
  bypass_diode_max_neg_v?: Maybe<Scalars['Float']>;
  bypass_diodes?: Maybe<Array<Maybe<Scalars['Float']>>>;
  cell_length?: Maybe<Scalars['Float']>;
  cell_shape?: Maybe<Scalars['String']>;
  cell_spacing_lr?: Maybe<Scalars['Float']>;
  cell_spacing_tb?: Maybe<Scalars['Float']>;
  cell_type?: Maybe<Scalars['String']>;
  cell_width?: Maybe<Scalars['Float']>;
  cells?: Maybe<Array<Maybe<Scalars['Float']>>>;
  corner_cut_off?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  default_state_fields?: Maybe<Scalars['JSON']>;
  first_year_degradation_rate?: Maybe<Scalars['Float']>;
  frame?: Maybe<Scalars['Boolean']>;
  frame_dimensions?: Maybe<Array<Maybe<Scalars['Float']>>>;
  half_cut_center_space?: Maybe<Scalars['Float']>;
  iam_profile?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  ideality_factor?: Maybe<Scalars['Float']>;
  irradiance_coefficients_temp?: Maybe<Array<Maybe<Scalars['Float']>>>;
  name: Scalars['String'];
  nominal_operating_cell_temp?: Maybe<Scalars['Float']>;
  open_circuit_voltage?: Maybe<Scalars['Float']>;
  pan_file_import?: Maybe<Scalars['JSON']>;
  panel_edge_b?: Maybe<Scalars['Float']>;
  panel_edge_lr?: Maybe<Scalars['Float']>;
  panel_edge_t?: Maybe<Scalars['Float']>;
  panel_technology?: Maybe<Scalars['String']>;
  panel_type?: Maybe<Scalars['String']>;
  parallel_string_per_diode?: Maybe<Array<Maybe<Scalars['Float']>>>;
  remaining_years_degradation_rate?: Maybe<Scalars['Float']>;
  series_resistance?: Maybe<Scalars['Float']>;
  short_circuit_current?: Maybe<Scalars['Float']>;
  shunt_resistance?: Maybe<Scalars['Float']>;
  temperature_coefficient_isc?: Maybe<Scalars['Float']>;
  temperature_coefficient_voc?: Maybe<Scalars['Float']>;
  updated_at: Scalars['DateTime'];
};

export type PvPanelUpdateInput = {
  bifaciality_current_ratio?: InputMaybe<Scalars['Float']>;
  bypass_diode_max_neg_v?: InputMaybe<Scalars['Float']>;
  bypass_diodes?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  cell_length?: InputMaybe<Scalars['Float']>;
  cell_shape?: InputMaybe<Scalars['String']>;
  cell_spacing_lr?: InputMaybe<Scalars['Float']>;
  cell_spacing_tb?: InputMaybe<Scalars['Float']>;
  cell_type?: InputMaybe<Scalars['String']>;
  cell_width?: InputMaybe<Scalars['Float']>;
  cells?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  corner_cut_off?: InputMaybe<Scalars['Float']>;
  default_state_fields?: InputMaybe<Scalars['JSON']>;
  first_year_degradation_rate?: InputMaybe<Scalars['Float']>;
  frame?: InputMaybe<Scalars['Boolean']>;
  frame_dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  half_cut_center_space?: InputMaybe<Scalars['Float']>;
  iam_profile?: InputMaybe<Array<Array<InputMaybe<Scalars['Float']>>>>;
  ideality_factor?: InputMaybe<Scalars['Float']>;
  irradiance_coefficients_temp?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nominal_operating_cell_temp?: InputMaybe<Scalars['Float']>;
  open_circuit_voltage?: InputMaybe<Scalars['Float']>;
  pan_file_import?: InputMaybe<Scalars['JSON']>;
  panel_edge_b?: InputMaybe<Scalars['Float']>;
  panel_edge_lr?: InputMaybe<Scalars['Float']>;
  panel_edge_t?: InputMaybe<Scalars['Float']>;
  panel_technology?: InputMaybe<Scalars['String']>;
  panel_type?: InputMaybe<Scalars['String']>;
  parallel_string_per_diode?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  remaining_years_degradation_rate?: InputMaybe<Scalars['Float']>;
  series_resistance?: InputMaybe<Scalars['Float']>;
  short_circuit_current?: InputMaybe<Scalars['Float']>;
  shunt_resistance?: InputMaybe<Scalars['Float']>;
  temperature_coefficient_isc?: InputMaybe<Scalars['Float']>;
  temperature_coefficient_voc?: InputMaybe<Scalars['Float']>;
};

export type PvSystImportBlock = {
  __typename?: 'PvSystImportBlock';
  id: Scalars['String'];
  name: Scalars['String'];
  num_inverters?: Maybe<Scalars['Float']>;
  power_factor?: Maybe<Scalars['Float']>;
  pv_ac_wire_id?: Maybe<Scalars['String']>;
  pv_dc_wire_id?: Maybe<Scalars['String']>;
  pv_inverter_id?: Maybe<Scalars['String']>;
  pv_panel_id?: Maybe<Scalars['String']>;
  pv_table_id?: Maybe<Scalars['String']>;
  pv_transformer_id?: Maybe<Scalars['String']>;
};

export type PvSystImportData = {
  __typename?: 'PvSystImportData';
  data?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
};

export type PvSystImportEnviroDataset = {
  __typename?: 'PvSystImportEnviroDataset';
  id: Scalars['String'];
  local_time_zone: Scalars['Float'];
  name: Scalars['String'];
  time_interval: Scalars['Float'];
  time_range?: Maybe<TimeRange>;
  type: Scalars['String'];
};

export type PvSystImportPreview = {
  __typename?: 'PvSystImportPreview';
  acWires: Array<ComponentSummary>;
  blocks: Array<PvSystImportBlock>;
  dcWires: Array<ComponentSummary>;
  enviro_dataset?: Maybe<PvSystImportEnviroDataset>;
  inverters: Array<ComponentSummary>;
  panels: Array<ComponentSummary>;
  tables: Array<ComponentSummary>;
  transformers: Array<ComponentSummary>;
};

export type PvSystImportResult = {
  __typename?: 'PvSystImportResult';
  acWires: Array<PvAcWire>;
  blocks: Array<Block>;
  dcWires: Array<PvDcWire>;
  enviro_dataset?: Maybe<EnviroDataset>;
  inverters: Array<PvInverter>;
  panels: Array<PvPanel>;
  tables: Array<PvTable>;
  transformers: Array<PvTransformer>;
};

export type PvTable = {
  __typename?: 'PvTable';
  azimuth?: Maybe<Scalars['Float']>;
  backtracking_enabled?: Maybe<Scalars['Boolean']>;
  column_gap?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  default_state_fields?: Maybe<Scalars['JSON']>;
  ground_clearance?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  in_plane_racking_dimensions?: Maybe<Scalars['JSON']>;
  in_plane_racking_enabled?: Maybe<Scalars['Boolean']>;
  in_plane_racking_shape?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  num_cols?: Maybe<Scalars['JSON']>;
  num_post_cols?: Maybe<Scalars['Float']>;
  num_post_tiers?: Maybe<Scalars['Float']>;
  num_tiers?: Maybe<Scalars['Float']>;
  orientation_str?: Maybe<Scalars['String']>;
  rotation_radius?: Maybe<Scalars['Float']>;
  row_offset?: Maybe<Scalars['JSON']>;
  row_spacing?: Maybe<Scalars['Float']>;
  stow_angle?: Maybe<Scalars['Float']>;
  table_gap?: Maybe<Scalars['JSON']>;
  tier_gap?: Maybe<Scalars['JSON']>;
  tilt?: Maybe<Scalars['Float']>;
  torque_tube_enabled?: Maybe<Scalars['Boolean']>;
  torque_tube_height?: Maybe<Scalars['Float']>;
  torque_tube_radius?: Maybe<Scalars['Float']>;
  torque_tube_rect_dimensions?: Maybe<Scalars['JSON']>;
  torque_tube_shape?: Maybe<Scalars['String']>;
  track_angle_bounds?: Maybe<Array<Maybe<Scalars['Float']>>>;
  tracking_type?: Maybe<Scalars['Int']>;
  updated_at: Scalars['DateTime'];
  vertical_post_dimensions?: Maybe<Scalars['JSON']>;
  vertical_post_distance?: Maybe<Array<Maybe<Scalars['Float']>>>;
  vertical_post_enabled?: Maybe<Scalars['Boolean']>;
  vertical_post_radius?: Maybe<Scalars['Float']>;
  vertical_post_shape?: Maybe<Scalars['String']>;
};

export type PvTableUpdateInput = {
  azimuth?: InputMaybe<Scalars['Float']>;
  backtracking_enabled?: InputMaybe<Scalars['Boolean']>;
  column_gap?: InputMaybe<Scalars['Float']>;
  default_state_fields?: InputMaybe<Scalars['JSON']>;
  ground_clearance?: InputMaybe<Scalars['Float']>;
  in_plane_racking_dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  in_plane_racking_enabled?: InputMaybe<Scalars['Boolean']>;
  in_plane_racking_shape?: InputMaybe<Scalars['String']>;
  num_cols?: InputMaybe<Scalars['Float']>;
  num_post_cols?: InputMaybe<Scalars['Float']>;
  num_post_tiers?: InputMaybe<Scalars['Float']>;
  num_tiers?: InputMaybe<Scalars['Float']>;
  orientation_str?: InputMaybe<Scalars['String']>;
  rotation_radius?: InputMaybe<Scalars['Float']>;
  row_offset?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  row_spacing?: InputMaybe<Scalars['Float']>;
  stow_angle?: InputMaybe<Scalars['Float']>;
  table_gap?: InputMaybe<Scalars['Float']>;
  tier_gap?: InputMaybe<Scalars['Float']>;
  tilt?: InputMaybe<Scalars['Float']>;
  torque_tube_enabled?: InputMaybe<Scalars['Boolean']>;
  torque_tube_height?: InputMaybe<Scalars['Float']>;
  torque_tube_radius?: InputMaybe<Scalars['Float']>;
  torque_tube_rect_dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  torque_tube_shape?: InputMaybe<Scalars['String']>;
  track_angle_bounds?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  tracking_type?: InputMaybe<Scalars['Int']>;
  vertical_post_dimensions?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  vertical_post_distance?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  vertical_post_enabled?: InputMaybe<Scalars['Boolean']>;
  vertical_post_radius?: InputMaybe<Scalars['Float']>;
  vertical_post_shape?: InputMaybe<Scalars['String']>;
};

export type PvTransformer = {
  __typename?: 'PvTransformer';
  copper_power_loss_data_source?: Maybe<Scalars['String']>;
  copper_power_loss_percentage?: Maybe<Scalars['Float']>;
  created_at: Scalars['DateTime'];
  default_state_fields?: Maybe<Scalars['JSON']>;
  high_voltage_winding_resistance?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  iron_power_loss?: Maybe<Scalars['Float']>;
  iron_power_loss_data_source?: Maybe<Scalars['String']>;
  iron_power_loss_percentage?: Maybe<Scalars['Float']>;
  low_voltage_winding_resistance?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  night_disconnect?: Maybe<Scalars['Boolean']>;
  nominal_high_side_voltage?: Maybe<Scalars['Float']>;
  nominal_low_side_voltage?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type PvTransformerUpdateInput = {
  copper_power_loss_data_source?: InputMaybe<Scalars['String']>;
  copper_power_loss_percentage?: InputMaybe<Scalars['Float']>;
  default_state_fields?: InputMaybe<Scalars['JSON']>;
  high_voltage_winding_resistance?: InputMaybe<Scalars['Float']>;
  iron_power_loss?: InputMaybe<Scalars['Float']>;
  iron_power_loss_data_source?: InputMaybe<Scalars['String']>;
  iron_power_loss_percentage?: InputMaybe<Scalars['Float']>;
  low_voltage_winding_resistance?: InputMaybe<Scalars['Float']>;
  night_disconnect?: InputMaybe<Scalars['Boolean']>;
  nominal_high_side_voltage?: InputMaybe<Scalars['Float']>;
  nominal_low_side_voltage?: InputMaybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  acWire: PvAcWire;
  acWires: Array<PvAcWire>;
  adminMe: User;
  adminOrganizationIntegrationServerJobEvents: Array<OrganizationIntegrationServerJob>;
  adminOrganizationIntegrationServerSchedules: Array<OrganizationIntegrationServerSchedule>;
  adminOrganizationIntegrationServers: Array<OrganizationIntegrationServer>;
  adminProjectExport: Scalars['JSON'];
  adminUpsertOrganizationIntegrationServerTryFetch: Scalars['JSON'];
  allFeatureFlags: Array<AdminFeatureFlag>;
  apiToken?: Maybe<UserApiToken>;
  blockLayers: Array<BlockLayer>;
  blocks: Array<Block>;
  cecInverter: CecInverter;
  cecInverterFilterParams: CecInverterFilterOptions;
  cecInverters: Array<CecInverter>;
  cecInvertersCount: Scalars['Int'];
  compareWorkbooks: Array<CompareWorkbook>;
  customDatasetDescribe: Array<DescribeRow>;
  customDatasetQuery: Scalars['JSON'];
  dataExports: Array<SimDataExport>;
  dcWire: PvDcWire;
  dcWires: Array<PvDcWire>;
  domainMatchingOrganizations: Array<Organization>;
  duetSimulation: DuetSimulation;
  enviroData: Array<EnviroData>;
  enviroDataCount: Scalars['Int'];
  enviroDataRollup: Array<EnviroDataRollup>;
  featureFlags: Array<FeatureFlag>;
  getDataExportUrls: Array<SimDataUrlPayload>;
  getPanelIv: Array<GetPanelIvPayload>;
  inverter: PvInverter;
  inverters: Array<PvInverter>;
  invitation?: Maybe<ExpandedUserInvite>;
  labelledEvents: Array<LabelledEvent>;
  localEmails: Array<LocalEmail>;
  me: User;
  numDaylightTimestamps?: Maybe<Scalars['Int']>;
  organization: Organization;
  organizationIntegrationServer: OrganizationIntegrationServer;
  organizationIntegrationServerSchedules: Array<OrganizationIntegrationServerSchedule>;
  organizationProjects: Array<Project>;
  organizations: Array<Organization>;
  panel: PvPanel;
  panels: Array<PvPanel>;
  plantPlayback: PlantPlaybackData;
  plantPlaybackGeoJson: Scalars['JSON'];
  project: Project;
  projectDuetSim: Array<DuetSimulation>;
  projectDuetSimBlock: Array<DuetSimulationBlock>;
  projectEnviroDatasets: Array<EnviroDatasetOwner>;
  projectFileStorage: Array<StorageFile>;
  projectFileStorageSignedUrl: GetFileStorageSignedUrlPayload;
  projects: Array<Project>;
  pvSystImportData: Array<PvSystImportData>;
  pvSystImportPreview: PvSystImportPreview;
  rasterLayers: Array<RasterLayer>;
  refreshToken: QueryRefreshTokenResult;
  root: Scalars['String'];
  searchMeteoDatasets: Array<AvailableThirdPartyDataset>;
  sensorDataHierarchy: Array<SensorDataHierarchy>;
  sensorDataModelled: Array<SensorDataModelled>;
  sensorDataModelledSystem: Array<SensorDataModelled>;
  sentinelDeployment: SentinelDeployment;
  sentinelIssueSummary: Array<IssueSummary>;
  sentinelPortfolios: Array<Scalars['String']>;
  sentinelSimulation: DuetSimulation;
  sentinelSimulationSummary: Array<SimulationSummary>;
  sentinelSimulationTimeSeriesSummary: Array<SimulationTimeSeriesSummary>;
  sentinelTimestamps: Timestamps;
  simPdfExportData: SimulationPdfExportData;
  simulationDailySunRiseSet: Array<SunRiseSet>;
  simulationExtendedSummary: SimulationExtendedSummary;
  simulationModuleIrradianceProfileIndex: Array<ModuleIrradianceProfileIndex>;
  simulationModuleIrradianceProfileTableData: Array<ModuleIrradianceProfile>;
  simulationModuleIrradianceProfileTablesMeta: Array<ModuleIrradianceProfileTableMeta>;
  simulationSummary: Array<SimulationSummary>;
  simulationTimeSeriesDrillDown: Array<SimulationTimeSeriesDrillDown>;
  simulationTimeSeriesSummary: Array<SimulationTimeSeriesSummary>;
  simulationTimestamps: Array<SimulationTimestamp>;
  systemParameters: SystemParameters;
  table: PvTable;
  tables: Array<PvTable>;
  transformer: PvTransformer;
  transformers: Array<PvTransformer>;
  userInvites?: Maybe<Array<UserInvite>>;
  userRequests?: Maybe<Array<UserRequest>>;
  users: Array<User>;
  usersCount: Scalars['Int'];
};


export type QueryAcWireArgs = {
  id: Scalars['String'];
};


export type QueryAcWiresArgs = {
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminOrganizationIntegrationServerJobEventsArgs = {
  integration_server_id?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminOrganizationIntegrationServerSchedulesArgs = {
  integration_server_id: Scalars['String'];
};


export type QueryAdminOrganizationIntegrationServersArgs = {
  id?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['String']>;
};


export type QueryAdminProjectExportArgs = {
  projectId: Scalars['String'];
};


export type QueryAdminUpsertOrganizationIntegrationServerTryFetchArgs = {
  bearer_token: Scalars['String'];
  url: Scalars['String'];
};


export type QueryBlockLayersArgs = {
  project_id: Scalars['String'];
  updated_after?: InputMaybe<Scalars['DateTime']>;
};


export type QueryBlocksArgs = {
  project_id: Scalars['String'];
  updated_after?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCecInverterArgs = {
  id: Scalars['String'];
};


export type QueryCecInvertersArgs = {
  filter: CecInverterFilter;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CecInverterSort>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCecInvertersCountArgs = {
  filter: CecInverterFilter;
};


export type QueryCompareWorkbooksArgs = {
  id?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomDatasetDescribeArgs = {
  path: Scalars['String'];
  project_id: Scalars['String'];
};


export type QueryCustomDatasetQueryArgs = {
  date_args: DateArgsInput;
  measures: Array<Scalars['String']>;
  path: Scalars['String'];
  project_id: Scalars['String'];
};


export type QueryDataExportsArgs = {
  format?: InputMaybe<DataExportFormat>;
  scope?: InputMaybe<DataExportScope>;
  simulation_id: Scalars['String'];
};


export type QueryDcWireArgs = {
  id: Scalars['String'];
};


export type QueryDcWiresArgs = {
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDomainMatchingOrganizationsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDuetSimulationArgs = {
  id: Scalars['String'];
};


export type QueryEnviroDataArgs = {
  enviro_dataset_owner_id: Scalars['String'];
  restore_dst_shifts?: InputMaybe<Scalars['Boolean']>;
  restore_interval_alignment?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  time_range?: InputMaybe<TimeRangeInput>;
};


export type QueryEnviroDataCountArgs = {
  enviro_dataset_owner_id: Scalars['String'];
  time_range?: InputMaybe<TimeRangeInput>;
};


export type QueryEnviroDataRollupArgs = {
  date_args: DateArgsInput;
  enviro_dataset_owner_id: Scalars['String'];
};


export type QueryFeatureFlagsArgs = {
  project_id?: InputMaybe<Scalars['String']>;
};


export type QueryGetDataExportUrlsArgs = {
  simulation_id: Scalars['String'];
};


export type QueryGetPanelIvArgs = {
  panels: Array<GetPanelIvInput>;
};


export type QueryInverterArgs = {
  id: Scalars['String'];
};


export type QueryInvertersArgs = {
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryInvitationArgs = {
  token: Scalars['String'];
};


export type QueryLabelledEventsArgs = {
  date_range: DateRangeArgs;
  interval: TimestampInterval;
  project_id: Scalars['String'];
  sentinel_tag?: InputMaybe<Scalars['String']>;
};


export type QueryNumDaylightTimestampsArgs = {
  enviro_dataset_owner_id: Scalars['String'];
  selectedTimeRange: TimeRangeInput;
};


export type QueryOrganizationArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationProjectsArgs = {
  organization_id: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrganizationsArgs = {
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPanelArgs = {
  id: Scalars['String'];
};


export type QueryPanelsArgs = {
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPlantPlaybackArgs = {
  plant_playback_id: Scalars['String'];
  project_id: Scalars['String'];
};


export type QueryPlantPlaybackGeoJsonArgs = {
  plant_playback_id: Scalars['String'];
  project_id: Scalars['String'];
};


export type QueryProjectArgs = {
  id: Scalars['String'];
};


export type QueryProjectDuetSimArgs = {
  id?: InputMaybe<Array<Scalars['String']>>;
  not_status?: InputMaybe<Array<Scalars['String']>>;
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryProjectDuetSimBlockArgs = {
  duet_job_input_id?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['String']>>;
  project_id: Scalars['String'];
  simulation_id?: InputMaybe<Array<Scalars['String']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryProjectEnviroDatasetsArgs = {
  id?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<Array<Scalars['String']>>;
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryProjectFileStorageArgs = {
  includes?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
};


export type QueryProjectFileStorageSignedUrlArgs = {
  allowOverwrite?: InputMaybe<Scalars['Boolean']>;
  dir: Scalars['String'];
  filename: Scalars['String'];
  project_id: Scalars['String'];
};


export type QueryProjectsArgs = {
  collection: Scalars['String'];
  order_by?: InputMaybe<Array<Scalars['String']>>;
  org_id?: InputMaybe<Scalars['String']>;
  portfolio?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryPvSystImportDataArgs = {
  files: Array<Scalars['String']>;
  project_id: Scalars['String'];
};


export type QueryPvSystImportPreviewArgs = {
  project_id: Scalars['String'];
  variant_file_name: Scalars['String'];
};


export type QueryRasterLayersArgs = {
  project_id: Scalars['String'];
};


export type QuerySearchMeteoDatasetsArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  sources: Array<Scalars['String']>;
};


export type QuerySensorDataHierarchyArgs = {
  project_id: Scalars['String'];
};


export type QuerySensorDataModelledArgs = {
  block_id?: InputMaybe<Scalars['String']>;
  component: SensorHierarchyComponent;
  component_measure: SensorHierarchyComponentMeasure;
  date_range: DateRangeArgs;
  hierarchy_id?: InputMaybe<Scalars['String']>;
  interval: TimestampInterval;
  power_to_energy?: InputMaybe<Scalars['Boolean']>;
  project_id: Scalars['String'];
  sentinel_tag?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type QuerySensorDataModelledSystemArgs = {
  component: SensorHierarchyComponent;
  component_measure: SensorHierarchyComponentMeasure;
  date_range: DateRangeArgs;
  interval: TimestampInterval;
  power_to_energy?: InputMaybe<Scalars['Boolean']>;
  project_id: Scalars['String'];
  sentinel_tag?: InputMaybe<Scalars['String']>;
};


export type QuerySentinelDeploymentArgs = {
  project_id: Scalars['String'];
};


export type QuerySentinelIssueSummaryArgs = {
  block_id?: InputMaybe<Scalars['String']>;
  date_range: DateRangeArgs;
  hierarchy_component?: InputMaybe<SensorHierarchyComponent>;
  interval?: InputMaybe<TimestampInterval>;
  project_id: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};


export type QuerySentinelPortfoliosArgs = {
  org_id: Scalars['String'];
};


export type QuerySentinelSimulationArgs = {
  id: Scalars['String'];
  project_id: Scalars['String'];
};


export type QuerySentinelSimulationSummaryArgs = {
  block_id?: InputMaybe<Scalars['String']>;
  date_range?: InputMaybe<DateRangeArgs>;
  project_id: Scalars['String'];
  sentinel_tag?: InputMaybe<Scalars['String']>;
};


export type QuerySentinelSimulationTimeSeriesSummaryArgs = {
  date_args: DateArgsInput;
  project_id: Scalars['String'];
  sentinel_tag?: InputMaybe<Scalars['String']>;
};


export type QuerySentinelTimestampsArgs = {
  interval?: InputMaybe<TimestampInterval>;
  project_id: Scalars['String'];
};


export type QuerySimPdfExportDataArgs = {
  simulation_id: Scalars['String'];
};


export type QuerySimulationDailySunRiseSetArgs = {
  project_id: Scalars['String'];
  simulation_id: Scalars['String'];
};


export type QuerySimulationExtendedSummaryArgs = {
  project_id: Scalars['String'];
  simulation_id: Scalars['String'];
};


export type QuerySimulationModuleIrradianceProfileIndexArgs = {
  simulation_id: Scalars['String'];
};


export type QuerySimulationModuleIrradianceProfileTableDataArgs = {
  dt_timestamp: Scalars['String'];
  duet_job_input_id: Scalars['String'];
  simulation_id: Scalars['String'];
  table_id: Scalars['String'];
};


export type QuerySimulationModuleIrradianceProfileTablesMetaArgs = {
  simulation_id: Scalars['String'];
};


export type QuerySimulationSummaryArgs = {
  duet_job_input_id?: InputMaybe<Array<Scalars['String']>>;
  project_id: Scalars['String'];
  simulation_id: Scalars['String'];
};


export type QuerySimulationTimeSeriesDrillDownArgs = {
  date_args: DateArgsInput;
  duet_job_input_id?: InputMaybe<Scalars['String']>;
  measure: Measure;
  project_id: Scalars['String'];
  simulation_id: Scalars['String'];
};


export type QuerySimulationTimeSeriesSummaryArgs = {
  date_args: DateArgsInput;
  duet_job_input_id?: InputMaybe<Array<Scalars['String']>>;
  project_id: Scalars['String'];
  simulation_id: Scalars['String'];
};


export type QuerySimulationTimestampsArgs = {
  interval: DateBinInterval;
  project_id: Scalars['String'];
  simulation_id: Scalars['String'];
};


export type QuerySystemParametersArgs = {
  project_id: Scalars['String'];
};


export type QueryTableArgs = {
  id: Scalars['String'];
};


export type QueryTablesArgs = {
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTransformerArgs = {
  id: Scalars['String'];
};


export type QueryTransformersArgs = {
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserInvitesArgs = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserRequestsArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  organization_id: Scalars['String'];
  rejected?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersArgs = {
  organization_id?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUsersCountArgs = {
  organization_id?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};

export type QueryRefreshTokenResult = AuthError | TokenPayload;

export type RasterLayer = {
  __typename?: 'RasterLayer';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  opacity: Scalars['Float'];
  origin: Scalars['JSON'];
  pixel_ratio: Scalars['Float'];
  project_id: Scalars['String'];
  storage_url: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export type RasterLayerInput = {
  name: Scalars['String'];
  opacity: Scalars['Float'];
  origin: Scalars['JSON'];
  pixel_ratio: Scalars['Float'];
  storage_url: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type RunSimulationResult = {
  __typename?: 'RunSimulationResult';
  duetSimulation?: Maybe<DuetSimulation>;
  errors?: Maybe<Array<BlockSimulationErrors>>;
  success: Scalars['Boolean'];
};

export type SensorDataHierarchy = {
  __typename?: 'SensorDataHierarchy';
  component: Scalars['String'];
  component_measure?: Maybe<Scalars['String']>;
  duet_block_id?: Maybe<Scalars['String']>;
  duet_measure?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inverter_dc_capacity?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  organization_id: Scalars['String'];
  parent_id?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
  sensor_tag: Scalars['String'];
  sensor_time_interval?: Maybe<Scalars['Float']>;
  sentinel_tag?: Maybe<Scalars['String']>;
};

export type SensorDataModelled = {
  __typename?: 'SensorDataModelled';
  duet_block_id?: Maybe<Scalars['String']>;
  hierarchy_id?: Maybe<Scalars['String']>;
  model_value: Scalars['Float'];
  performance_index?: Maybe<Scalars['Float']>;
  sensor_value?: Maybe<Scalars['Float']>;
  ts: Scalars['String'];
};

export enum SensorHierarchyComponent {
  Block = 'block',
  Inverter = 'inverter',
  Met = 'met',
  Meter = 'meter',
  System = 'system'
}

export enum SensorHierarchyComponentMeasure {
  ActivePower = 'active_power',
  Ghi = 'ghi',
  PoaFront = 'poa_front',
  Temp = 'temp'
}

export type SentinelDeployment = {
  __typename?: 'SentinelDeployment';
  albedo: Scalars['JSON'];
  id: Scalars['ID'];
  portfolio?: Maybe<Scalars['String']>;
  project: Project;
  project_id: Scalars['String'];
  time_interval: Scalars['Float'];
  time_zone_offset: Scalars['Float'];
};

export type SimDataExport = {
  __typename?: 'SimDataExport';
  createdOn?: Maybe<Scalars['DateTime']>;
  format: DataExportFormat;
  inProgress: Scalars['Boolean'];
  scope: DataExportScope;
  urls: Array<SimDataExportUrl>;
};

export type SimDataExportUrl = {
  __typename?: 'SimDataExportUrl';
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type SimDataUrlPayload = {
  __typename?: 'SimDataUrlPayload';
  expires_at: Scalars['Float'];
  full_sim_detail_url: Scalars['String'];
  system_sim_detail_url: Scalars['String'];
};

export type SimulationAggregatedMeasures = {
  avg__above_max_temperature_loss_w_bi: Scalars['Float'];
  avg__above_max_temperature_loss_w_mono: Scalars['Float'];
  avg__above_max_temperature_loss_wh_bi: Scalars['Float'];
  avg__above_max_temperature_loss_wh_mono: Scalars['Float'];
  avg__ac_power_clipping_loss_w_bi: Scalars['Float'];
  avg__ac_power_clipping_loss_w_mono: Scalars['Float'];
  avg__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  avg__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  avg__air_mass: Scalars['Float'];
  avg__albedo?: Maybe<Scalars['Float']>;
  avg__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  avg__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  avg__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  avg__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  avg__array_string_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_string_energy_mono?: Maybe<Scalars['Float']>;
  avg__available_energy_wh_bi: Scalars['Float'];
  avg__available_energy_wh_mono: Scalars['Float'];
  avg__available_power_w_bi: Scalars['Float'];
  avg__available_power_w_mono: Scalars['Float'];
  avg__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  avg__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  avg__below_min_temperature_loss_w_bi: Scalars['Float'];
  avg__below_min_temperature_loss_w_mono: Scalars['Float'];
  avg__below_min_temperature_loss_wh_bi: Scalars['Float'];
  avg__below_min_temperature_loss_wh_mono: Scalars['Float'];
  avg__bifaciality_current_ratio: Scalars['Float'];
  avg__center_module_inclined_irradiance: Scalars['Float'];
  avg__center_module_rear_inclined_irradiance: Scalars['Float'];
  avg__degradation_loss_first_year_w_bi: Scalars['Float'];
  avg__degradation_loss_first_year_w_mono: Scalars['Float'];
  avg__degradation_loss_first_year_wh_bi: Scalars['Float'];
  avg__degradation_loss_first_year_wh_mono: Scalars['Float'];
  avg__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  avg__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  avg__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  avg__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  avg__dhi_whm2: Scalars['Float'];
  avg__dhi_wm2: Scalars['Float'];
  avg__dni_whm2: Scalars['Float'];
  avg__dni_wm2: Scalars['Float'];
  avg__energy_bi: Scalars['Float'];
  avg__energy_mono: Scalars['Float'];
  avg__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  avg__ghi_whm2: Scalars['Float'];
  avg__ghi_wm2: Scalars['Float'];
  avg__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  avg__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  avg__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  avg__inverter_night_tare_loss_w_bi: Scalars['Float'];
  avg__inverter_night_tare_loss_w_mono: Scalars['Float'];
  avg__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  avg__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  avg__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  avg__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  avg__inverter_output_energy_wh_bi: Scalars['Float'];
  avg__inverter_output_energy_wh_mono: Scalars['Float'];
  avg__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  avg__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  avg__inverter_output_power_w_bi: Scalars['Float'];
  avg__inverter_output_power_w_mono: Scalars['Float'];
  avg__line_energy_loss_wh_bi: Scalars['Float'];
  avg__line_energy_loss_wh_mono: Scalars['Float'];
  avg__line_power_loss_w_bi: Scalars['Float'];
  avg__line_power_loss_w_mono: Scalars['Float'];
  avg__line_receiving_end_energy_wh_bi: Scalars['Float'];
  avg__line_receiving_end_energy_wh_mono: Scalars['Float'];
  avg__line_receiving_end_power_w_bi: Scalars['Float'];
  avg__line_receiving_end_power_w_mono: Scalars['Float'];
  avg__line_sending_end_energy_wh_bi: Scalars['Float'];
  avg__line_sending_end_energy_wh_mono: Scalars['Float'];
  avg__line_sending_end_power_w_bi: Scalars['Float'];
  avg__line_sending_end_power_w_mono: Scalars['Float'];
  avg__num_panels_in_array: Scalars['Float'];
  avg__performance_ratio_bi: Scalars['Float'];
  avg__performance_ratio_mono: Scalars['Float'];
  avg__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__pv_power_no_degradation_w_bi: Scalars['Float'];
  avg__pv_power_no_degradation_w_mono: Scalars['Float'];
  avg__pv_power_no_degradation_wh_bi: Scalars['Float'];
  avg__pv_power_no_degradation_wh_mono: Scalars['Float'];
  avg__pv_power_no_soiling_w_bi: Scalars['Float'];
  avg__pv_power_no_soiling_w_mono: Scalars['Float'];
  avg__pv_power_no_soiling_wh_bi: Scalars['Float'];
  avg__pv_power_no_soiling_wh_mono: Scalars['Float'];
  avg__pv_power_with_degradation_w_bi: Scalars['Float'];
  avg__pv_power_with_degradation_w_mono: Scalars['Float'];
  avg__pv_power_with_degradation_wh_bi: Scalars['Float'];
  avg__pv_power_with_degradation_wh_mono: Scalars['Float'];
  avg__pv_power_with_soiling_w_bi: Scalars['Float'];
  avg__pv_power_with_soiling_w_mono: Scalars['Float'];
  avg__pv_power_with_soiling_wh_bi: Scalars['Float'];
  avg__pv_power_with_soiling_wh_mono: Scalars['Float'];
  avg__self_consumption_loss_w_bi: Scalars['Float'];
  avg__self_consumption_loss_w_mono: Scalars['Float'];
  avg__self_consumption_loss_wh_bi: Scalars['Float'];
  avg__self_consumption_loss_wh_mono: Scalars['Float'];
  avg__soiling_loss_w_bi: Scalars['Float'];
  avg__soiling_loss_w_mono: Scalars['Float'];
  avg__soiling_loss_wh_bi: Scalars['Float'];
  avg__soiling_loss_wh_mono: Scalars['Float'];
  avg__stc_pv_power: Scalars['Float'];
  avg__sun_azimuth_deg: Scalars['Float'];
  avg__sun_zenith_deg: Scalars['Float'];
  avg__temperature_c: Scalars['Float'];
  avg__temperature_derating_loss_w_bi: Scalars['Float'];
  avg__temperature_derating_loss_w_mono: Scalars['Float'];
  avg__temperature_derating_loss_wh_bi: Scalars['Float'];
  avg__temperature_derating_loss_wh_mono: Scalars['Float'];
  avg__total_degradation_loss_w_bi: Scalars['Float'];
  avg__total_degradation_loss_w_mono: Scalars['Float'];
  avg__total_degradation_loss_wh_bi: Scalars['Float'];
  avg__total_degradation_loss_wh_mono: Scalars['Float'];
  avg__total_inverter_loss_w_bi: Scalars['Float'];
  avg__total_inverter_loss_w_mono: Scalars['Float'];
  avg__total_inverter_loss_wh_bi: Scalars['Float'];
  avg__total_inverter_loss_wh_mono: Scalars['Float'];
  avg__transformer_copper_loss_w_bi: Scalars['Float'];
  avg__transformer_copper_loss_w_mono: Scalars['Float'];
  avg__transformer_copper_loss_wh_bi: Scalars['Float'];
  avg__transformer_copper_loss_wh_mono: Scalars['Float'];
  avg__transformer_energy_loss_wh_bi: Scalars['Float'];
  avg__transformer_energy_loss_wh_mono: Scalars['Float'];
  avg__transformer_input_energy_wh_bi: Scalars['Float'];
  avg__transformer_input_energy_wh_mono: Scalars['Float'];
  avg__transformer_input_power_w_bi: Scalars['Float'];
  avg__transformer_input_power_w_mono: Scalars['Float'];
  avg__transformer_iron_core_loss_w_bi: Scalars['Float'];
  avg__transformer_iron_core_loss_w_mono: Scalars['Float'];
  avg__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  avg__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  avg__transformer_output_energy_wh_bi: Scalars['Float'];
  avg__transformer_output_energy_wh_mono: Scalars['Float'];
  avg__transformer_output_power_w_bi: Scalars['Float'];
  avg__transformer_output_power_w_mono: Scalars['Float'];
  avg__transformer_power_loss_w_bi: Scalars['Float'];
  avg__transformer_power_loss_w_mono: Scalars['Float'];
  avg__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  avg__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  avg__transmission_line_power_loss_w_bi: Scalars['Float'];
  avg__transmission_line_power_loss_w_mono: Scalars['Float'];
  avg__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  avg__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  avg__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  avg__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  avg__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  avg__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  avg__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  avg__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  count__above_max_temperature_loss_w_bi: Scalars['Float'];
  count__above_max_temperature_loss_w_mono: Scalars['Float'];
  count__above_max_temperature_loss_wh_bi: Scalars['Float'];
  count__above_max_temperature_loss_wh_mono: Scalars['Float'];
  count__ac_power_clipping_loss_w_bi: Scalars['Float'];
  count__ac_power_clipping_loss_w_mono: Scalars['Float'];
  count__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  count__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  count__air_mass: Scalars['Float'];
  count__albedo?: Maybe<Scalars['Float']>;
  count__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  count__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  count__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  count__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  count__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  count__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  count__array_string_energy_bi?: Maybe<Scalars['Float']>;
  count__array_string_energy_mono?: Maybe<Scalars['Float']>;
  count__available_energy_wh_bi: Scalars['Float'];
  count__available_energy_wh_mono: Scalars['Float'];
  count__available_power_w_bi: Scalars['Float'];
  count__available_power_w_mono: Scalars['Float'];
  count__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  count__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  count__below_min_temperature_loss_w_bi: Scalars['Float'];
  count__below_min_temperature_loss_w_mono: Scalars['Float'];
  count__below_min_temperature_loss_wh_bi: Scalars['Float'];
  count__below_min_temperature_loss_wh_mono: Scalars['Float'];
  count__bifaciality_current_ratio: Scalars['Float'];
  count__center_module_inclined_irradiance: Scalars['Float'];
  count__center_module_rear_inclined_irradiance: Scalars['Float'];
  count__degradation_loss_first_year_w_bi: Scalars['Float'];
  count__degradation_loss_first_year_w_mono: Scalars['Float'];
  count__degradation_loss_first_year_wh_bi: Scalars['Float'];
  count__degradation_loss_first_year_wh_mono: Scalars['Float'];
  count__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  count__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  count__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  count__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  count__dhi_whm2: Scalars['Float'];
  count__dhi_wm2: Scalars['Float'];
  count__dni_whm2: Scalars['Float'];
  count__dni_wm2: Scalars['Float'];
  count__energy_bi: Scalars['Float'];
  count__energy_mono: Scalars['Float'];
  count__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  count__ghi_whm2: Scalars['Float'];
  count__ghi_wm2: Scalars['Float'];
  count__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  count__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  count__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  count__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  count__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  count__inverter_night_tare_loss_w_bi: Scalars['Float'];
  count__inverter_night_tare_loss_w_mono: Scalars['Float'];
  count__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  count__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  count__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  count__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  count__inverter_output_energy_wh_bi: Scalars['Float'];
  count__inverter_output_energy_wh_mono: Scalars['Float'];
  count__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  count__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  count__inverter_output_power_w_bi: Scalars['Float'];
  count__inverter_output_power_w_mono: Scalars['Float'];
  count__line_energy_loss_wh_bi: Scalars['Float'];
  count__line_energy_loss_wh_mono: Scalars['Float'];
  count__line_power_loss_w_bi: Scalars['Float'];
  count__line_power_loss_w_mono: Scalars['Float'];
  count__line_receiving_end_energy_wh_bi: Scalars['Float'];
  count__line_receiving_end_energy_wh_mono: Scalars['Float'];
  count__line_receiving_end_power_w_bi: Scalars['Float'];
  count__line_receiving_end_power_w_mono: Scalars['Float'];
  count__line_sending_end_energy_wh_bi: Scalars['Float'];
  count__line_sending_end_energy_wh_mono: Scalars['Float'];
  count__line_sending_end_power_w_bi: Scalars['Float'];
  count__line_sending_end_power_w_mono: Scalars['Float'];
  count__num_panels_in_array: Scalars['Float'];
  count__performance_ratio_bi: Scalars['Float'];
  count__performance_ratio_mono: Scalars['Float'];
  count__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__pv_power_no_degradation_w_bi: Scalars['Float'];
  count__pv_power_no_degradation_w_mono: Scalars['Float'];
  count__pv_power_no_degradation_wh_bi: Scalars['Float'];
  count__pv_power_no_degradation_wh_mono: Scalars['Float'];
  count__pv_power_no_soiling_w_bi: Scalars['Float'];
  count__pv_power_no_soiling_w_mono: Scalars['Float'];
  count__pv_power_no_soiling_wh_bi: Scalars['Float'];
  count__pv_power_no_soiling_wh_mono: Scalars['Float'];
  count__pv_power_with_degradation_w_bi: Scalars['Float'];
  count__pv_power_with_degradation_w_mono: Scalars['Float'];
  count__pv_power_with_degradation_wh_bi: Scalars['Float'];
  count__pv_power_with_degradation_wh_mono: Scalars['Float'];
  count__pv_power_with_soiling_w_bi: Scalars['Float'];
  count__pv_power_with_soiling_w_mono: Scalars['Float'];
  count__pv_power_with_soiling_wh_bi: Scalars['Float'];
  count__pv_power_with_soiling_wh_mono: Scalars['Float'];
  count__self_consumption_loss_w_bi: Scalars['Float'];
  count__self_consumption_loss_w_mono: Scalars['Float'];
  count__self_consumption_loss_wh_bi: Scalars['Float'];
  count__self_consumption_loss_wh_mono: Scalars['Float'];
  count__soiling_loss_w_bi: Scalars['Float'];
  count__soiling_loss_w_mono: Scalars['Float'];
  count__soiling_loss_wh_bi: Scalars['Float'];
  count__soiling_loss_wh_mono: Scalars['Float'];
  count__stc_pv_power: Scalars['Float'];
  count__sun_azimuth_deg: Scalars['Float'];
  count__sun_zenith_deg: Scalars['Float'];
  count__temperature_c: Scalars['Float'];
  count__temperature_derating_loss_w_bi: Scalars['Float'];
  count__temperature_derating_loss_w_mono: Scalars['Float'];
  count__temperature_derating_loss_wh_bi: Scalars['Float'];
  count__temperature_derating_loss_wh_mono: Scalars['Float'];
  count__total_degradation_loss_w_bi: Scalars['Float'];
  count__total_degradation_loss_w_mono: Scalars['Float'];
  count__total_degradation_loss_wh_bi: Scalars['Float'];
  count__total_degradation_loss_wh_mono: Scalars['Float'];
  count__total_inverter_loss_w_bi: Scalars['Float'];
  count__total_inverter_loss_w_mono: Scalars['Float'];
  count__total_inverter_loss_wh_bi: Scalars['Float'];
  count__total_inverter_loss_wh_mono: Scalars['Float'];
  count__transformer_copper_loss_w_bi: Scalars['Float'];
  count__transformer_copper_loss_w_mono: Scalars['Float'];
  count__transformer_copper_loss_wh_bi: Scalars['Float'];
  count__transformer_copper_loss_wh_mono: Scalars['Float'];
  count__transformer_energy_loss_wh_bi: Scalars['Float'];
  count__transformer_energy_loss_wh_mono: Scalars['Float'];
  count__transformer_input_energy_wh_bi: Scalars['Float'];
  count__transformer_input_energy_wh_mono: Scalars['Float'];
  count__transformer_input_power_w_bi: Scalars['Float'];
  count__transformer_input_power_w_mono: Scalars['Float'];
  count__transformer_iron_core_loss_w_bi: Scalars['Float'];
  count__transformer_iron_core_loss_w_mono: Scalars['Float'];
  count__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  count__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  count__transformer_output_energy_wh_bi: Scalars['Float'];
  count__transformer_output_energy_wh_mono: Scalars['Float'];
  count__transformer_output_power_w_bi: Scalars['Float'];
  count__transformer_output_power_w_mono: Scalars['Float'];
  count__transformer_power_loss_w_bi: Scalars['Float'];
  count__transformer_power_loss_w_mono: Scalars['Float'];
  count__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  count__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  count__transmission_line_power_loss_w_bi: Scalars['Float'];
  count__transmission_line_power_loss_w_mono: Scalars['Float'];
  count__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  count__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  count__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  count__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  count__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  count__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  count__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  count__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  max__above_max_temperature_loss_w_bi: Scalars['Float'];
  max__above_max_temperature_loss_w_mono: Scalars['Float'];
  max__above_max_temperature_loss_wh_bi: Scalars['Float'];
  max__above_max_temperature_loss_wh_mono: Scalars['Float'];
  max__ac_power_clipping_loss_w_bi: Scalars['Float'];
  max__ac_power_clipping_loss_w_mono: Scalars['Float'];
  max__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  max__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  max__air_mass: Scalars['Float'];
  max__albedo?: Maybe<Scalars['Float']>;
  max__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  max__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  max__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  max__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  max__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  max__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  max__array_string_energy_bi?: Maybe<Scalars['Float']>;
  max__array_string_energy_mono?: Maybe<Scalars['Float']>;
  max__available_energy_wh_bi: Scalars['Float'];
  max__available_energy_wh_mono: Scalars['Float'];
  max__available_power_w_bi: Scalars['Float'];
  max__available_power_w_mono: Scalars['Float'];
  max__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  max__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  max__below_min_temperature_loss_w_bi: Scalars['Float'];
  max__below_min_temperature_loss_w_mono: Scalars['Float'];
  max__below_min_temperature_loss_wh_bi: Scalars['Float'];
  max__below_min_temperature_loss_wh_mono: Scalars['Float'];
  max__bifaciality_current_ratio: Scalars['Float'];
  max__center_module_inclined_irradiance: Scalars['Float'];
  max__center_module_rear_inclined_irradiance: Scalars['Float'];
  max__degradation_loss_first_year_w_bi: Scalars['Float'];
  max__degradation_loss_first_year_w_mono: Scalars['Float'];
  max__degradation_loss_first_year_wh_bi: Scalars['Float'];
  max__degradation_loss_first_year_wh_mono: Scalars['Float'];
  max__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  max__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  max__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  max__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  max__dhi_whm2: Scalars['Float'];
  max__dhi_wm2: Scalars['Float'];
  max__dni_whm2: Scalars['Float'];
  max__dni_wm2: Scalars['Float'];
  max__energy_bi: Scalars['Float'];
  max__energy_mono: Scalars['Float'];
  max__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  max__ghi_whm2: Scalars['Float'];
  max__ghi_wm2: Scalars['Float'];
  max__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  max__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  max__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  max__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  max__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  max__inverter_night_tare_loss_w_bi: Scalars['Float'];
  max__inverter_night_tare_loss_w_mono: Scalars['Float'];
  max__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  max__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  max__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  max__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  max__inverter_output_energy_wh_bi: Scalars['Float'];
  max__inverter_output_energy_wh_mono: Scalars['Float'];
  max__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  max__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  max__inverter_output_power_w_bi: Scalars['Float'];
  max__inverter_output_power_w_mono: Scalars['Float'];
  max__line_energy_loss_wh_bi: Scalars['Float'];
  max__line_energy_loss_wh_mono: Scalars['Float'];
  max__line_power_loss_w_bi: Scalars['Float'];
  max__line_power_loss_w_mono: Scalars['Float'];
  max__line_receiving_end_energy_wh_bi: Scalars['Float'];
  max__line_receiving_end_energy_wh_mono: Scalars['Float'];
  max__line_receiving_end_power_w_bi: Scalars['Float'];
  max__line_receiving_end_power_w_mono: Scalars['Float'];
  max__line_sending_end_energy_wh_bi: Scalars['Float'];
  max__line_sending_end_energy_wh_mono: Scalars['Float'];
  max__line_sending_end_power_w_bi: Scalars['Float'];
  max__line_sending_end_power_w_mono: Scalars['Float'];
  max__num_panels_in_array: Scalars['Float'];
  max__performance_ratio_bi: Scalars['Float'];
  max__performance_ratio_mono: Scalars['Float'];
  max__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__pv_power_no_degradation_w_bi: Scalars['Float'];
  max__pv_power_no_degradation_w_mono: Scalars['Float'];
  max__pv_power_no_degradation_wh_bi: Scalars['Float'];
  max__pv_power_no_degradation_wh_mono: Scalars['Float'];
  max__pv_power_no_soiling_w_bi: Scalars['Float'];
  max__pv_power_no_soiling_w_mono: Scalars['Float'];
  max__pv_power_no_soiling_wh_bi: Scalars['Float'];
  max__pv_power_no_soiling_wh_mono: Scalars['Float'];
  max__pv_power_with_degradation_w_bi: Scalars['Float'];
  max__pv_power_with_degradation_w_mono: Scalars['Float'];
  max__pv_power_with_degradation_wh_bi: Scalars['Float'];
  max__pv_power_with_degradation_wh_mono: Scalars['Float'];
  max__pv_power_with_soiling_w_bi: Scalars['Float'];
  max__pv_power_with_soiling_w_mono: Scalars['Float'];
  max__pv_power_with_soiling_wh_bi: Scalars['Float'];
  max__pv_power_with_soiling_wh_mono: Scalars['Float'];
  max__self_consumption_loss_w_bi: Scalars['Float'];
  max__self_consumption_loss_w_mono: Scalars['Float'];
  max__self_consumption_loss_wh_bi: Scalars['Float'];
  max__self_consumption_loss_wh_mono: Scalars['Float'];
  max__soiling_loss_w_bi: Scalars['Float'];
  max__soiling_loss_w_mono: Scalars['Float'];
  max__soiling_loss_wh_bi: Scalars['Float'];
  max__soiling_loss_wh_mono: Scalars['Float'];
  max__stc_pv_power: Scalars['Float'];
  max__sun_azimuth_deg: Scalars['Float'];
  max__sun_zenith_deg: Scalars['Float'];
  max__temperature_c: Scalars['Float'];
  max__temperature_derating_loss_w_bi: Scalars['Float'];
  max__temperature_derating_loss_w_mono: Scalars['Float'];
  max__temperature_derating_loss_wh_bi: Scalars['Float'];
  max__temperature_derating_loss_wh_mono: Scalars['Float'];
  max__total_degradation_loss_w_bi: Scalars['Float'];
  max__total_degradation_loss_w_mono: Scalars['Float'];
  max__total_degradation_loss_wh_bi: Scalars['Float'];
  max__total_degradation_loss_wh_mono: Scalars['Float'];
  max__total_inverter_loss_w_bi: Scalars['Float'];
  max__total_inverter_loss_w_mono: Scalars['Float'];
  max__total_inverter_loss_wh_bi: Scalars['Float'];
  max__total_inverter_loss_wh_mono: Scalars['Float'];
  max__transformer_copper_loss_w_bi: Scalars['Float'];
  max__transformer_copper_loss_w_mono: Scalars['Float'];
  max__transformer_copper_loss_wh_bi: Scalars['Float'];
  max__transformer_copper_loss_wh_mono: Scalars['Float'];
  max__transformer_energy_loss_wh_bi: Scalars['Float'];
  max__transformer_energy_loss_wh_mono: Scalars['Float'];
  max__transformer_input_energy_wh_bi: Scalars['Float'];
  max__transformer_input_energy_wh_mono: Scalars['Float'];
  max__transformer_input_power_w_bi: Scalars['Float'];
  max__transformer_input_power_w_mono: Scalars['Float'];
  max__transformer_iron_core_loss_w_bi: Scalars['Float'];
  max__transformer_iron_core_loss_w_mono: Scalars['Float'];
  max__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  max__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  max__transformer_output_energy_wh_bi: Scalars['Float'];
  max__transformer_output_energy_wh_mono: Scalars['Float'];
  max__transformer_output_power_w_bi: Scalars['Float'];
  max__transformer_output_power_w_mono: Scalars['Float'];
  max__transformer_power_loss_w_bi: Scalars['Float'];
  max__transformer_power_loss_w_mono: Scalars['Float'];
  max__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  max__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  max__transmission_line_power_loss_w_bi: Scalars['Float'];
  max__transmission_line_power_loss_w_mono: Scalars['Float'];
  max__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  max__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  max__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  max__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  max__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  max__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  max__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  max__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  min__above_max_temperature_loss_w_bi: Scalars['Float'];
  min__above_max_temperature_loss_w_mono: Scalars['Float'];
  min__above_max_temperature_loss_wh_bi: Scalars['Float'];
  min__above_max_temperature_loss_wh_mono: Scalars['Float'];
  min__ac_power_clipping_loss_w_bi: Scalars['Float'];
  min__ac_power_clipping_loss_w_mono: Scalars['Float'];
  min__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  min__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  min__air_mass: Scalars['Float'];
  min__albedo?: Maybe<Scalars['Float']>;
  min__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  min__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  min__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  min__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  min__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  min__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  min__array_string_energy_bi?: Maybe<Scalars['Float']>;
  min__array_string_energy_mono?: Maybe<Scalars['Float']>;
  min__available_energy_wh_bi: Scalars['Float'];
  min__available_energy_wh_mono: Scalars['Float'];
  min__available_power_w_bi: Scalars['Float'];
  min__available_power_w_mono: Scalars['Float'];
  min__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  min__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  min__below_min_temperature_loss_w_bi: Scalars['Float'];
  min__below_min_temperature_loss_w_mono: Scalars['Float'];
  min__below_min_temperature_loss_wh_bi: Scalars['Float'];
  min__below_min_temperature_loss_wh_mono: Scalars['Float'];
  min__bifaciality_current_ratio: Scalars['Float'];
  min__center_module_inclined_irradiance: Scalars['Float'];
  min__center_module_rear_inclined_irradiance: Scalars['Float'];
  min__degradation_loss_first_year_w_bi: Scalars['Float'];
  min__degradation_loss_first_year_w_mono: Scalars['Float'];
  min__degradation_loss_first_year_wh_bi: Scalars['Float'];
  min__degradation_loss_first_year_wh_mono: Scalars['Float'];
  min__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  min__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  min__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  min__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  min__dhi_whm2: Scalars['Float'];
  min__dhi_wm2: Scalars['Float'];
  min__dni_whm2: Scalars['Float'];
  min__dni_wm2: Scalars['Float'];
  min__energy_bi: Scalars['Float'];
  min__energy_mono: Scalars['Float'];
  min__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  min__ghi_whm2: Scalars['Float'];
  min__ghi_wm2: Scalars['Float'];
  min__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  min__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  min__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  min__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  min__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  min__inverter_night_tare_loss_w_bi: Scalars['Float'];
  min__inverter_night_tare_loss_w_mono: Scalars['Float'];
  min__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  min__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  min__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  min__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  min__inverter_output_energy_wh_bi: Scalars['Float'];
  min__inverter_output_energy_wh_mono: Scalars['Float'];
  min__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  min__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  min__inverter_output_power_w_bi: Scalars['Float'];
  min__inverter_output_power_w_mono: Scalars['Float'];
  min__line_energy_loss_wh_bi: Scalars['Float'];
  min__line_energy_loss_wh_mono: Scalars['Float'];
  min__line_power_loss_w_bi: Scalars['Float'];
  min__line_power_loss_w_mono: Scalars['Float'];
  min__line_receiving_end_energy_wh_bi: Scalars['Float'];
  min__line_receiving_end_energy_wh_mono: Scalars['Float'];
  min__line_receiving_end_power_w_bi: Scalars['Float'];
  min__line_receiving_end_power_w_mono: Scalars['Float'];
  min__line_sending_end_energy_wh_bi: Scalars['Float'];
  min__line_sending_end_energy_wh_mono: Scalars['Float'];
  min__line_sending_end_power_w_bi: Scalars['Float'];
  min__line_sending_end_power_w_mono: Scalars['Float'];
  min__num_panels_in_array: Scalars['Float'];
  min__performance_ratio_bi: Scalars['Float'];
  min__performance_ratio_mono: Scalars['Float'];
  min__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__pv_power_no_degradation_w_bi: Scalars['Float'];
  min__pv_power_no_degradation_w_mono: Scalars['Float'];
  min__pv_power_no_degradation_wh_bi: Scalars['Float'];
  min__pv_power_no_degradation_wh_mono: Scalars['Float'];
  min__pv_power_no_soiling_w_bi: Scalars['Float'];
  min__pv_power_no_soiling_w_mono: Scalars['Float'];
  min__pv_power_no_soiling_wh_bi: Scalars['Float'];
  min__pv_power_no_soiling_wh_mono: Scalars['Float'];
  min__pv_power_with_degradation_w_bi: Scalars['Float'];
  min__pv_power_with_degradation_w_mono: Scalars['Float'];
  min__pv_power_with_degradation_wh_bi: Scalars['Float'];
  min__pv_power_with_degradation_wh_mono: Scalars['Float'];
  min__pv_power_with_soiling_w_bi: Scalars['Float'];
  min__pv_power_with_soiling_w_mono: Scalars['Float'];
  min__pv_power_with_soiling_wh_bi: Scalars['Float'];
  min__pv_power_with_soiling_wh_mono: Scalars['Float'];
  min__self_consumption_loss_w_bi: Scalars['Float'];
  min__self_consumption_loss_w_mono: Scalars['Float'];
  min__self_consumption_loss_wh_bi: Scalars['Float'];
  min__self_consumption_loss_wh_mono: Scalars['Float'];
  min__soiling_loss_w_bi: Scalars['Float'];
  min__soiling_loss_w_mono: Scalars['Float'];
  min__soiling_loss_wh_bi: Scalars['Float'];
  min__soiling_loss_wh_mono: Scalars['Float'];
  min__stc_pv_power: Scalars['Float'];
  min__sun_azimuth_deg: Scalars['Float'];
  min__sun_zenith_deg: Scalars['Float'];
  min__temperature_c: Scalars['Float'];
  min__temperature_derating_loss_w_bi: Scalars['Float'];
  min__temperature_derating_loss_w_mono: Scalars['Float'];
  min__temperature_derating_loss_wh_bi: Scalars['Float'];
  min__temperature_derating_loss_wh_mono: Scalars['Float'];
  min__total_degradation_loss_w_bi: Scalars['Float'];
  min__total_degradation_loss_w_mono: Scalars['Float'];
  min__total_degradation_loss_wh_bi: Scalars['Float'];
  min__total_degradation_loss_wh_mono: Scalars['Float'];
  min__total_inverter_loss_w_bi: Scalars['Float'];
  min__total_inverter_loss_w_mono: Scalars['Float'];
  min__total_inverter_loss_wh_bi: Scalars['Float'];
  min__total_inverter_loss_wh_mono: Scalars['Float'];
  min__transformer_copper_loss_w_bi: Scalars['Float'];
  min__transformer_copper_loss_w_mono: Scalars['Float'];
  min__transformer_copper_loss_wh_bi: Scalars['Float'];
  min__transformer_copper_loss_wh_mono: Scalars['Float'];
  min__transformer_energy_loss_wh_bi: Scalars['Float'];
  min__transformer_energy_loss_wh_mono: Scalars['Float'];
  min__transformer_input_energy_wh_bi: Scalars['Float'];
  min__transformer_input_energy_wh_mono: Scalars['Float'];
  min__transformer_input_power_w_bi: Scalars['Float'];
  min__transformer_input_power_w_mono: Scalars['Float'];
  min__transformer_iron_core_loss_w_bi: Scalars['Float'];
  min__transformer_iron_core_loss_w_mono: Scalars['Float'];
  min__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  min__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  min__transformer_output_energy_wh_bi: Scalars['Float'];
  min__transformer_output_energy_wh_mono: Scalars['Float'];
  min__transformer_output_power_w_bi: Scalars['Float'];
  min__transformer_output_power_w_mono: Scalars['Float'];
  min__transformer_power_loss_w_bi: Scalars['Float'];
  min__transformer_power_loss_w_mono: Scalars['Float'];
  min__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  min__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  min__transmission_line_power_loss_w_bi: Scalars['Float'];
  min__transmission_line_power_loss_w_mono: Scalars['Float'];
  min__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  min__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  min__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  min__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  min__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  min__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  min__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  min__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p10__above_max_temperature_loss_w_bi: Scalars['Float'];
  p10__above_max_temperature_loss_w_mono: Scalars['Float'];
  p10__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p10__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p10__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p10__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p10__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p10__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p10__air_mass: Scalars['Float'];
  p10__albedo?: Maybe<Scalars['Float']>;
  p10__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p10__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p10__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p10__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p10__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p10__available_energy_wh_bi: Scalars['Float'];
  p10__available_energy_wh_mono: Scalars['Float'];
  p10__available_power_w_bi: Scalars['Float'];
  p10__available_power_w_mono: Scalars['Float'];
  p10__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p10__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p10__below_min_temperature_loss_w_bi: Scalars['Float'];
  p10__below_min_temperature_loss_w_mono: Scalars['Float'];
  p10__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p10__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p10__bifaciality_current_ratio: Scalars['Float'];
  p10__center_module_inclined_irradiance: Scalars['Float'];
  p10__center_module_rear_inclined_irradiance: Scalars['Float'];
  p10__degradation_loss_first_year_w_bi: Scalars['Float'];
  p10__degradation_loss_first_year_w_mono: Scalars['Float'];
  p10__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p10__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p10__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p10__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p10__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p10__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p10__dhi_whm2: Scalars['Float'];
  p10__dhi_wm2: Scalars['Float'];
  p10__dni_whm2: Scalars['Float'];
  p10__dni_wm2: Scalars['Float'];
  p10__energy_bi: Scalars['Float'];
  p10__energy_mono: Scalars['Float'];
  p10__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p10__ghi_whm2: Scalars['Float'];
  p10__ghi_wm2: Scalars['Float'];
  p10__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p10__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p10__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p10__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p10__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p10__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p10__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p10__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p10__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p10__inverter_output_energy_wh_bi: Scalars['Float'];
  p10__inverter_output_energy_wh_mono: Scalars['Float'];
  p10__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p10__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p10__inverter_output_power_w_bi: Scalars['Float'];
  p10__inverter_output_power_w_mono: Scalars['Float'];
  p10__line_energy_loss_wh_bi: Scalars['Float'];
  p10__line_energy_loss_wh_mono: Scalars['Float'];
  p10__line_power_loss_w_bi: Scalars['Float'];
  p10__line_power_loss_w_mono: Scalars['Float'];
  p10__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p10__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p10__line_receiving_end_power_w_bi: Scalars['Float'];
  p10__line_receiving_end_power_w_mono: Scalars['Float'];
  p10__line_sending_end_energy_wh_bi: Scalars['Float'];
  p10__line_sending_end_energy_wh_mono: Scalars['Float'];
  p10__line_sending_end_power_w_bi: Scalars['Float'];
  p10__line_sending_end_power_w_mono: Scalars['Float'];
  p10__num_panels_in_array: Scalars['Float'];
  p10__performance_ratio_bi: Scalars['Float'];
  p10__performance_ratio_mono: Scalars['Float'];
  p10__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__pv_power_no_degradation_w_bi: Scalars['Float'];
  p10__pv_power_no_degradation_w_mono: Scalars['Float'];
  p10__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p10__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p10__pv_power_no_soiling_w_bi: Scalars['Float'];
  p10__pv_power_no_soiling_w_mono: Scalars['Float'];
  p10__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p10__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p10__pv_power_with_degradation_w_bi: Scalars['Float'];
  p10__pv_power_with_degradation_w_mono: Scalars['Float'];
  p10__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p10__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p10__pv_power_with_soiling_w_bi: Scalars['Float'];
  p10__pv_power_with_soiling_w_mono: Scalars['Float'];
  p10__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p10__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p10__self_consumption_loss_w_bi: Scalars['Float'];
  p10__self_consumption_loss_w_mono: Scalars['Float'];
  p10__self_consumption_loss_wh_bi: Scalars['Float'];
  p10__self_consumption_loss_wh_mono: Scalars['Float'];
  p10__soiling_loss_w_bi: Scalars['Float'];
  p10__soiling_loss_w_mono: Scalars['Float'];
  p10__soiling_loss_wh_bi: Scalars['Float'];
  p10__soiling_loss_wh_mono: Scalars['Float'];
  p10__stc_pv_power: Scalars['Float'];
  p10__sun_azimuth_deg: Scalars['Float'];
  p10__sun_zenith_deg: Scalars['Float'];
  p10__temperature_c: Scalars['Float'];
  p10__temperature_derating_loss_w_bi: Scalars['Float'];
  p10__temperature_derating_loss_w_mono: Scalars['Float'];
  p10__temperature_derating_loss_wh_bi: Scalars['Float'];
  p10__temperature_derating_loss_wh_mono: Scalars['Float'];
  p10__total_degradation_loss_w_bi: Scalars['Float'];
  p10__total_degradation_loss_w_mono: Scalars['Float'];
  p10__total_degradation_loss_wh_bi: Scalars['Float'];
  p10__total_degradation_loss_wh_mono: Scalars['Float'];
  p10__total_inverter_loss_w_bi: Scalars['Float'];
  p10__total_inverter_loss_w_mono: Scalars['Float'];
  p10__total_inverter_loss_wh_bi: Scalars['Float'];
  p10__total_inverter_loss_wh_mono: Scalars['Float'];
  p10__transformer_copper_loss_w_bi: Scalars['Float'];
  p10__transformer_copper_loss_w_mono: Scalars['Float'];
  p10__transformer_copper_loss_wh_bi: Scalars['Float'];
  p10__transformer_copper_loss_wh_mono: Scalars['Float'];
  p10__transformer_energy_loss_wh_bi: Scalars['Float'];
  p10__transformer_energy_loss_wh_mono: Scalars['Float'];
  p10__transformer_input_energy_wh_bi: Scalars['Float'];
  p10__transformer_input_energy_wh_mono: Scalars['Float'];
  p10__transformer_input_power_w_bi: Scalars['Float'];
  p10__transformer_input_power_w_mono: Scalars['Float'];
  p10__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p10__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p10__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p10__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p10__transformer_output_energy_wh_bi: Scalars['Float'];
  p10__transformer_output_energy_wh_mono: Scalars['Float'];
  p10__transformer_output_power_w_bi: Scalars['Float'];
  p10__transformer_output_power_w_mono: Scalars['Float'];
  p10__transformer_power_loss_w_bi: Scalars['Float'];
  p10__transformer_power_loss_w_mono: Scalars['Float'];
  p10__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p10__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p10__transmission_line_power_loss_w_bi: Scalars['Float'];
  p10__transmission_line_power_loss_w_mono: Scalars['Float'];
  p10__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p10__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p10__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p10__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p10__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p10__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p10__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p10__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p25__above_max_temperature_loss_w_bi: Scalars['Float'];
  p25__above_max_temperature_loss_w_mono: Scalars['Float'];
  p25__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p25__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p25__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p25__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p25__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p25__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p25__air_mass: Scalars['Float'];
  p25__albedo?: Maybe<Scalars['Float']>;
  p25__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p25__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p25__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p25__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p25__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p25__available_energy_wh_bi: Scalars['Float'];
  p25__available_energy_wh_mono: Scalars['Float'];
  p25__available_power_w_bi: Scalars['Float'];
  p25__available_power_w_mono: Scalars['Float'];
  p25__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p25__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p25__below_min_temperature_loss_w_bi: Scalars['Float'];
  p25__below_min_temperature_loss_w_mono: Scalars['Float'];
  p25__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p25__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p25__bifaciality_current_ratio: Scalars['Float'];
  p25__center_module_inclined_irradiance: Scalars['Float'];
  p25__center_module_rear_inclined_irradiance: Scalars['Float'];
  p25__degradation_loss_first_year_w_bi: Scalars['Float'];
  p25__degradation_loss_first_year_w_mono: Scalars['Float'];
  p25__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p25__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p25__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p25__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p25__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p25__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p25__dhi_whm2: Scalars['Float'];
  p25__dhi_wm2: Scalars['Float'];
  p25__dni_whm2: Scalars['Float'];
  p25__dni_wm2: Scalars['Float'];
  p25__energy_bi: Scalars['Float'];
  p25__energy_mono: Scalars['Float'];
  p25__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p25__ghi_whm2: Scalars['Float'];
  p25__ghi_wm2: Scalars['Float'];
  p25__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p25__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p25__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p25__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p25__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p25__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p25__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p25__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p25__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p25__inverter_output_energy_wh_bi: Scalars['Float'];
  p25__inverter_output_energy_wh_mono: Scalars['Float'];
  p25__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p25__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p25__inverter_output_power_w_bi: Scalars['Float'];
  p25__inverter_output_power_w_mono: Scalars['Float'];
  p25__line_energy_loss_wh_bi: Scalars['Float'];
  p25__line_energy_loss_wh_mono: Scalars['Float'];
  p25__line_power_loss_w_bi: Scalars['Float'];
  p25__line_power_loss_w_mono: Scalars['Float'];
  p25__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p25__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p25__line_receiving_end_power_w_bi: Scalars['Float'];
  p25__line_receiving_end_power_w_mono: Scalars['Float'];
  p25__line_sending_end_energy_wh_bi: Scalars['Float'];
  p25__line_sending_end_energy_wh_mono: Scalars['Float'];
  p25__line_sending_end_power_w_bi: Scalars['Float'];
  p25__line_sending_end_power_w_mono: Scalars['Float'];
  p25__num_panels_in_array: Scalars['Float'];
  p25__performance_ratio_bi: Scalars['Float'];
  p25__performance_ratio_mono: Scalars['Float'];
  p25__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__pv_power_no_degradation_w_bi: Scalars['Float'];
  p25__pv_power_no_degradation_w_mono: Scalars['Float'];
  p25__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p25__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p25__pv_power_no_soiling_w_bi: Scalars['Float'];
  p25__pv_power_no_soiling_w_mono: Scalars['Float'];
  p25__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p25__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p25__pv_power_with_degradation_w_bi: Scalars['Float'];
  p25__pv_power_with_degradation_w_mono: Scalars['Float'];
  p25__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p25__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p25__pv_power_with_soiling_w_bi: Scalars['Float'];
  p25__pv_power_with_soiling_w_mono: Scalars['Float'];
  p25__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p25__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p25__self_consumption_loss_w_bi: Scalars['Float'];
  p25__self_consumption_loss_w_mono: Scalars['Float'];
  p25__self_consumption_loss_wh_bi: Scalars['Float'];
  p25__self_consumption_loss_wh_mono: Scalars['Float'];
  p25__soiling_loss_w_bi: Scalars['Float'];
  p25__soiling_loss_w_mono: Scalars['Float'];
  p25__soiling_loss_wh_bi: Scalars['Float'];
  p25__soiling_loss_wh_mono: Scalars['Float'];
  p25__stc_pv_power: Scalars['Float'];
  p25__sun_azimuth_deg: Scalars['Float'];
  p25__sun_zenith_deg: Scalars['Float'];
  p25__temperature_c: Scalars['Float'];
  p25__temperature_derating_loss_w_bi: Scalars['Float'];
  p25__temperature_derating_loss_w_mono: Scalars['Float'];
  p25__temperature_derating_loss_wh_bi: Scalars['Float'];
  p25__temperature_derating_loss_wh_mono: Scalars['Float'];
  p25__total_degradation_loss_w_bi: Scalars['Float'];
  p25__total_degradation_loss_w_mono: Scalars['Float'];
  p25__total_degradation_loss_wh_bi: Scalars['Float'];
  p25__total_degradation_loss_wh_mono: Scalars['Float'];
  p25__total_inverter_loss_w_bi: Scalars['Float'];
  p25__total_inverter_loss_w_mono: Scalars['Float'];
  p25__total_inverter_loss_wh_bi: Scalars['Float'];
  p25__total_inverter_loss_wh_mono: Scalars['Float'];
  p25__transformer_copper_loss_w_bi: Scalars['Float'];
  p25__transformer_copper_loss_w_mono: Scalars['Float'];
  p25__transformer_copper_loss_wh_bi: Scalars['Float'];
  p25__transformer_copper_loss_wh_mono: Scalars['Float'];
  p25__transformer_energy_loss_wh_bi: Scalars['Float'];
  p25__transformer_energy_loss_wh_mono: Scalars['Float'];
  p25__transformer_input_energy_wh_bi: Scalars['Float'];
  p25__transformer_input_energy_wh_mono: Scalars['Float'];
  p25__transformer_input_power_w_bi: Scalars['Float'];
  p25__transformer_input_power_w_mono: Scalars['Float'];
  p25__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p25__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p25__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p25__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p25__transformer_output_energy_wh_bi: Scalars['Float'];
  p25__transformer_output_energy_wh_mono: Scalars['Float'];
  p25__transformer_output_power_w_bi: Scalars['Float'];
  p25__transformer_output_power_w_mono: Scalars['Float'];
  p25__transformer_power_loss_w_bi: Scalars['Float'];
  p25__transformer_power_loss_w_mono: Scalars['Float'];
  p25__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p25__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p25__transmission_line_power_loss_w_bi: Scalars['Float'];
  p25__transmission_line_power_loss_w_mono: Scalars['Float'];
  p25__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p25__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p25__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p25__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p25__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p25__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p25__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p25__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p50__above_max_temperature_loss_w_bi: Scalars['Float'];
  p50__above_max_temperature_loss_w_mono: Scalars['Float'];
  p50__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p50__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p50__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p50__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p50__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p50__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p50__air_mass: Scalars['Float'];
  p50__albedo?: Maybe<Scalars['Float']>;
  p50__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p50__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p50__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p50__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p50__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p50__available_energy_wh_bi: Scalars['Float'];
  p50__available_energy_wh_mono: Scalars['Float'];
  p50__available_power_w_bi: Scalars['Float'];
  p50__available_power_w_mono: Scalars['Float'];
  p50__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p50__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p50__below_min_temperature_loss_w_bi: Scalars['Float'];
  p50__below_min_temperature_loss_w_mono: Scalars['Float'];
  p50__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p50__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p50__bifaciality_current_ratio: Scalars['Float'];
  p50__center_module_inclined_irradiance: Scalars['Float'];
  p50__center_module_rear_inclined_irradiance: Scalars['Float'];
  p50__degradation_loss_first_year_w_bi: Scalars['Float'];
  p50__degradation_loss_first_year_w_mono: Scalars['Float'];
  p50__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p50__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p50__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p50__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p50__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p50__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p50__dhi_whm2: Scalars['Float'];
  p50__dhi_wm2: Scalars['Float'];
  p50__dni_whm2: Scalars['Float'];
  p50__dni_wm2: Scalars['Float'];
  p50__energy_bi: Scalars['Float'];
  p50__energy_mono: Scalars['Float'];
  p50__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p50__ghi_whm2: Scalars['Float'];
  p50__ghi_wm2: Scalars['Float'];
  p50__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p50__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p50__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p50__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p50__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p50__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p50__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p50__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p50__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p50__inverter_output_energy_wh_bi: Scalars['Float'];
  p50__inverter_output_energy_wh_mono: Scalars['Float'];
  p50__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p50__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p50__inverter_output_power_w_bi: Scalars['Float'];
  p50__inverter_output_power_w_mono: Scalars['Float'];
  p50__line_energy_loss_wh_bi: Scalars['Float'];
  p50__line_energy_loss_wh_mono: Scalars['Float'];
  p50__line_power_loss_w_bi: Scalars['Float'];
  p50__line_power_loss_w_mono: Scalars['Float'];
  p50__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p50__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p50__line_receiving_end_power_w_bi: Scalars['Float'];
  p50__line_receiving_end_power_w_mono: Scalars['Float'];
  p50__line_sending_end_energy_wh_bi: Scalars['Float'];
  p50__line_sending_end_energy_wh_mono: Scalars['Float'];
  p50__line_sending_end_power_w_bi: Scalars['Float'];
  p50__line_sending_end_power_w_mono: Scalars['Float'];
  p50__num_panels_in_array: Scalars['Float'];
  p50__performance_ratio_bi: Scalars['Float'];
  p50__performance_ratio_mono: Scalars['Float'];
  p50__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__pv_power_no_degradation_w_bi: Scalars['Float'];
  p50__pv_power_no_degradation_w_mono: Scalars['Float'];
  p50__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p50__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p50__pv_power_no_soiling_w_bi: Scalars['Float'];
  p50__pv_power_no_soiling_w_mono: Scalars['Float'];
  p50__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p50__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p50__pv_power_with_degradation_w_bi: Scalars['Float'];
  p50__pv_power_with_degradation_w_mono: Scalars['Float'];
  p50__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p50__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p50__pv_power_with_soiling_w_bi: Scalars['Float'];
  p50__pv_power_with_soiling_w_mono: Scalars['Float'];
  p50__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p50__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p50__self_consumption_loss_w_bi: Scalars['Float'];
  p50__self_consumption_loss_w_mono: Scalars['Float'];
  p50__self_consumption_loss_wh_bi: Scalars['Float'];
  p50__self_consumption_loss_wh_mono: Scalars['Float'];
  p50__soiling_loss_w_bi: Scalars['Float'];
  p50__soiling_loss_w_mono: Scalars['Float'];
  p50__soiling_loss_wh_bi: Scalars['Float'];
  p50__soiling_loss_wh_mono: Scalars['Float'];
  p50__stc_pv_power: Scalars['Float'];
  p50__sun_azimuth_deg: Scalars['Float'];
  p50__sun_zenith_deg: Scalars['Float'];
  p50__temperature_c: Scalars['Float'];
  p50__temperature_derating_loss_w_bi: Scalars['Float'];
  p50__temperature_derating_loss_w_mono: Scalars['Float'];
  p50__temperature_derating_loss_wh_bi: Scalars['Float'];
  p50__temperature_derating_loss_wh_mono: Scalars['Float'];
  p50__total_degradation_loss_w_bi: Scalars['Float'];
  p50__total_degradation_loss_w_mono: Scalars['Float'];
  p50__total_degradation_loss_wh_bi: Scalars['Float'];
  p50__total_degradation_loss_wh_mono: Scalars['Float'];
  p50__total_inverter_loss_w_bi: Scalars['Float'];
  p50__total_inverter_loss_w_mono: Scalars['Float'];
  p50__total_inverter_loss_wh_bi: Scalars['Float'];
  p50__total_inverter_loss_wh_mono: Scalars['Float'];
  p50__transformer_copper_loss_w_bi: Scalars['Float'];
  p50__transformer_copper_loss_w_mono: Scalars['Float'];
  p50__transformer_copper_loss_wh_bi: Scalars['Float'];
  p50__transformer_copper_loss_wh_mono: Scalars['Float'];
  p50__transformer_energy_loss_wh_bi: Scalars['Float'];
  p50__transformer_energy_loss_wh_mono: Scalars['Float'];
  p50__transformer_input_energy_wh_bi: Scalars['Float'];
  p50__transformer_input_energy_wh_mono: Scalars['Float'];
  p50__transformer_input_power_w_bi: Scalars['Float'];
  p50__transformer_input_power_w_mono: Scalars['Float'];
  p50__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p50__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p50__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p50__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p50__transformer_output_energy_wh_bi: Scalars['Float'];
  p50__transformer_output_energy_wh_mono: Scalars['Float'];
  p50__transformer_output_power_w_bi: Scalars['Float'];
  p50__transformer_output_power_w_mono: Scalars['Float'];
  p50__transformer_power_loss_w_bi: Scalars['Float'];
  p50__transformer_power_loss_w_mono: Scalars['Float'];
  p50__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p50__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p50__transmission_line_power_loss_w_bi: Scalars['Float'];
  p50__transmission_line_power_loss_w_mono: Scalars['Float'];
  p50__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p50__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p50__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p50__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p50__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p50__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p50__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p50__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p75__above_max_temperature_loss_w_bi: Scalars['Float'];
  p75__above_max_temperature_loss_w_mono: Scalars['Float'];
  p75__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p75__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p75__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p75__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p75__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p75__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p75__air_mass: Scalars['Float'];
  p75__albedo?: Maybe<Scalars['Float']>;
  p75__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p75__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p75__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p75__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p75__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p75__available_energy_wh_bi: Scalars['Float'];
  p75__available_energy_wh_mono: Scalars['Float'];
  p75__available_power_w_bi: Scalars['Float'];
  p75__available_power_w_mono: Scalars['Float'];
  p75__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p75__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p75__below_min_temperature_loss_w_bi: Scalars['Float'];
  p75__below_min_temperature_loss_w_mono: Scalars['Float'];
  p75__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p75__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p75__bifaciality_current_ratio: Scalars['Float'];
  p75__center_module_inclined_irradiance: Scalars['Float'];
  p75__center_module_rear_inclined_irradiance: Scalars['Float'];
  p75__degradation_loss_first_year_w_bi: Scalars['Float'];
  p75__degradation_loss_first_year_w_mono: Scalars['Float'];
  p75__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p75__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p75__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p75__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p75__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p75__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p75__dhi_whm2: Scalars['Float'];
  p75__dhi_wm2: Scalars['Float'];
  p75__dni_whm2: Scalars['Float'];
  p75__dni_wm2: Scalars['Float'];
  p75__energy_bi: Scalars['Float'];
  p75__energy_mono: Scalars['Float'];
  p75__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p75__ghi_whm2: Scalars['Float'];
  p75__ghi_wm2: Scalars['Float'];
  p75__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p75__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p75__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p75__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p75__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p75__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p75__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p75__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p75__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p75__inverter_output_energy_wh_bi: Scalars['Float'];
  p75__inverter_output_energy_wh_mono: Scalars['Float'];
  p75__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p75__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p75__inverter_output_power_w_bi: Scalars['Float'];
  p75__inverter_output_power_w_mono: Scalars['Float'];
  p75__line_energy_loss_wh_bi: Scalars['Float'];
  p75__line_energy_loss_wh_mono: Scalars['Float'];
  p75__line_power_loss_w_bi: Scalars['Float'];
  p75__line_power_loss_w_mono: Scalars['Float'];
  p75__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p75__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p75__line_receiving_end_power_w_bi: Scalars['Float'];
  p75__line_receiving_end_power_w_mono: Scalars['Float'];
  p75__line_sending_end_energy_wh_bi: Scalars['Float'];
  p75__line_sending_end_energy_wh_mono: Scalars['Float'];
  p75__line_sending_end_power_w_bi: Scalars['Float'];
  p75__line_sending_end_power_w_mono: Scalars['Float'];
  p75__num_panels_in_array: Scalars['Float'];
  p75__performance_ratio_bi: Scalars['Float'];
  p75__performance_ratio_mono: Scalars['Float'];
  p75__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__pv_power_no_degradation_w_bi: Scalars['Float'];
  p75__pv_power_no_degradation_w_mono: Scalars['Float'];
  p75__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p75__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p75__pv_power_no_soiling_w_bi: Scalars['Float'];
  p75__pv_power_no_soiling_w_mono: Scalars['Float'];
  p75__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p75__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p75__pv_power_with_degradation_w_bi: Scalars['Float'];
  p75__pv_power_with_degradation_w_mono: Scalars['Float'];
  p75__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p75__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p75__pv_power_with_soiling_w_bi: Scalars['Float'];
  p75__pv_power_with_soiling_w_mono: Scalars['Float'];
  p75__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p75__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p75__self_consumption_loss_w_bi: Scalars['Float'];
  p75__self_consumption_loss_w_mono: Scalars['Float'];
  p75__self_consumption_loss_wh_bi: Scalars['Float'];
  p75__self_consumption_loss_wh_mono: Scalars['Float'];
  p75__soiling_loss_w_bi: Scalars['Float'];
  p75__soiling_loss_w_mono: Scalars['Float'];
  p75__soiling_loss_wh_bi: Scalars['Float'];
  p75__soiling_loss_wh_mono: Scalars['Float'];
  p75__stc_pv_power: Scalars['Float'];
  p75__sun_azimuth_deg: Scalars['Float'];
  p75__sun_zenith_deg: Scalars['Float'];
  p75__temperature_c: Scalars['Float'];
  p75__temperature_derating_loss_w_bi: Scalars['Float'];
  p75__temperature_derating_loss_w_mono: Scalars['Float'];
  p75__temperature_derating_loss_wh_bi: Scalars['Float'];
  p75__temperature_derating_loss_wh_mono: Scalars['Float'];
  p75__total_degradation_loss_w_bi: Scalars['Float'];
  p75__total_degradation_loss_w_mono: Scalars['Float'];
  p75__total_degradation_loss_wh_bi: Scalars['Float'];
  p75__total_degradation_loss_wh_mono: Scalars['Float'];
  p75__total_inverter_loss_w_bi: Scalars['Float'];
  p75__total_inverter_loss_w_mono: Scalars['Float'];
  p75__total_inverter_loss_wh_bi: Scalars['Float'];
  p75__total_inverter_loss_wh_mono: Scalars['Float'];
  p75__transformer_copper_loss_w_bi: Scalars['Float'];
  p75__transformer_copper_loss_w_mono: Scalars['Float'];
  p75__transformer_copper_loss_wh_bi: Scalars['Float'];
  p75__transformer_copper_loss_wh_mono: Scalars['Float'];
  p75__transformer_energy_loss_wh_bi: Scalars['Float'];
  p75__transformer_energy_loss_wh_mono: Scalars['Float'];
  p75__transformer_input_energy_wh_bi: Scalars['Float'];
  p75__transformer_input_energy_wh_mono: Scalars['Float'];
  p75__transformer_input_power_w_bi: Scalars['Float'];
  p75__transformer_input_power_w_mono: Scalars['Float'];
  p75__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p75__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p75__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p75__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p75__transformer_output_energy_wh_bi: Scalars['Float'];
  p75__transformer_output_energy_wh_mono: Scalars['Float'];
  p75__transformer_output_power_w_bi: Scalars['Float'];
  p75__transformer_output_power_w_mono: Scalars['Float'];
  p75__transformer_power_loss_w_bi: Scalars['Float'];
  p75__transformer_power_loss_w_mono: Scalars['Float'];
  p75__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p75__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p75__transmission_line_power_loss_w_bi: Scalars['Float'];
  p75__transmission_line_power_loss_w_mono: Scalars['Float'];
  p75__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p75__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p75__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p75__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p75__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p75__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p75__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p75__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p90__above_max_temperature_loss_w_bi: Scalars['Float'];
  p90__above_max_temperature_loss_w_mono: Scalars['Float'];
  p90__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p90__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p90__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p90__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p90__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p90__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p90__air_mass: Scalars['Float'];
  p90__albedo?: Maybe<Scalars['Float']>;
  p90__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p90__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p90__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p90__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p90__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p90__available_energy_wh_bi: Scalars['Float'];
  p90__available_energy_wh_mono: Scalars['Float'];
  p90__available_power_w_bi: Scalars['Float'];
  p90__available_power_w_mono: Scalars['Float'];
  p90__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p90__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p90__below_min_temperature_loss_w_bi: Scalars['Float'];
  p90__below_min_temperature_loss_w_mono: Scalars['Float'];
  p90__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p90__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p90__bifaciality_current_ratio: Scalars['Float'];
  p90__center_module_inclined_irradiance: Scalars['Float'];
  p90__center_module_rear_inclined_irradiance: Scalars['Float'];
  p90__degradation_loss_first_year_w_bi: Scalars['Float'];
  p90__degradation_loss_first_year_w_mono: Scalars['Float'];
  p90__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p90__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p90__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p90__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p90__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p90__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p90__dhi_whm2: Scalars['Float'];
  p90__dhi_wm2: Scalars['Float'];
  p90__dni_whm2: Scalars['Float'];
  p90__dni_wm2: Scalars['Float'];
  p90__energy_bi: Scalars['Float'];
  p90__energy_mono: Scalars['Float'];
  p90__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p90__ghi_whm2: Scalars['Float'];
  p90__ghi_wm2: Scalars['Float'];
  p90__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p90__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p90__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p90__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p90__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p90__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p90__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p90__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p90__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p90__inverter_output_energy_wh_bi: Scalars['Float'];
  p90__inverter_output_energy_wh_mono: Scalars['Float'];
  p90__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p90__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p90__inverter_output_power_w_bi: Scalars['Float'];
  p90__inverter_output_power_w_mono: Scalars['Float'];
  p90__line_energy_loss_wh_bi: Scalars['Float'];
  p90__line_energy_loss_wh_mono: Scalars['Float'];
  p90__line_power_loss_w_bi: Scalars['Float'];
  p90__line_power_loss_w_mono: Scalars['Float'];
  p90__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p90__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p90__line_receiving_end_power_w_bi: Scalars['Float'];
  p90__line_receiving_end_power_w_mono: Scalars['Float'];
  p90__line_sending_end_energy_wh_bi: Scalars['Float'];
  p90__line_sending_end_energy_wh_mono: Scalars['Float'];
  p90__line_sending_end_power_w_bi: Scalars['Float'];
  p90__line_sending_end_power_w_mono: Scalars['Float'];
  p90__num_panels_in_array: Scalars['Float'];
  p90__performance_ratio_bi: Scalars['Float'];
  p90__performance_ratio_mono: Scalars['Float'];
  p90__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__pv_power_no_degradation_w_bi: Scalars['Float'];
  p90__pv_power_no_degradation_w_mono: Scalars['Float'];
  p90__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p90__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p90__pv_power_no_soiling_w_bi: Scalars['Float'];
  p90__pv_power_no_soiling_w_mono: Scalars['Float'];
  p90__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p90__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p90__pv_power_with_degradation_w_bi: Scalars['Float'];
  p90__pv_power_with_degradation_w_mono: Scalars['Float'];
  p90__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p90__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p90__pv_power_with_soiling_w_bi: Scalars['Float'];
  p90__pv_power_with_soiling_w_mono: Scalars['Float'];
  p90__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p90__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p90__self_consumption_loss_w_bi: Scalars['Float'];
  p90__self_consumption_loss_w_mono: Scalars['Float'];
  p90__self_consumption_loss_wh_bi: Scalars['Float'];
  p90__self_consumption_loss_wh_mono: Scalars['Float'];
  p90__soiling_loss_w_bi: Scalars['Float'];
  p90__soiling_loss_w_mono: Scalars['Float'];
  p90__soiling_loss_wh_bi: Scalars['Float'];
  p90__soiling_loss_wh_mono: Scalars['Float'];
  p90__stc_pv_power: Scalars['Float'];
  p90__sun_azimuth_deg: Scalars['Float'];
  p90__sun_zenith_deg: Scalars['Float'];
  p90__temperature_c: Scalars['Float'];
  p90__temperature_derating_loss_w_bi: Scalars['Float'];
  p90__temperature_derating_loss_w_mono: Scalars['Float'];
  p90__temperature_derating_loss_wh_bi: Scalars['Float'];
  p90__temperature_derating_loss_wh_mono: Scalars['Float'];
  p90__total_degradation_loss_w_bi: Scalars['Float'];
  p90__total_degradation_loss_w_mono: Scalars['Float'];
  p90__total_degradation_loss_wh_bi: Scalars['Float'];
  p90__total_degradation_loss_wh_mono: Scalars['Float'];
  p90__total_inverter_loss_w_bi: Scalars['Float'];
  p90__total_inverter_loss_w_mono: Scalars['Float'];
  p90__total_inverter_loss_wh_bi: Scalars['Float'];
  p90__total_inverter_loss_wh_mono: Scalars['Float'];
  p90__transformer_copper_loss_w_bi: Scalars['Float'];
  p90__transformer_copper_loss_w_mono: Scalars['Float'];
  p90__transformer_copper_loss_wh_bi: Scalars['Float'];
  p90__transformer_copper_loss_wh_mono: Scalars['Float'];
  p90__transformer_energy_loss_wh_bi: Scalars['Float'];
  p90__transformer_energy_loss_wh_mono: Scalars['Float'];
  p90__transformer_input_energy_wh_bi: Scalars['Float'];
  p90__transformer_input_energy_wh_mono: Scalars['Float'];
  p90__transformer_input_power_w_bi: Scalars['Float'];
  p90__transformer_input_power_w_mono: Scalars['Float'];
  p90__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p90__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p90__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p90__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p90__transformer_output_energy_wh_bi: Scalars['Float'];
  p90__transformer_output_energy_wh_mono: Scalars['Float'];
  p90__transformer_output_power_w_bi: Scalars['Float'];
  p90__transformer_output_power_w_mono: Scalars['Float'];
  p90__transformer_power_loss_w_bi: Scalars['Float'];
  p90__transformer_power_loss_w_mono: Scalars['Float'];
  p90__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p90__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p90__transmission_line_power_loss_w_bi: Scalars['Float'];
  p90__transmission_line_power_loss_w_mono: Scalars['Float'];
  p90__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p90__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p90__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p90__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p90__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p90__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p90__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p90__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  sum__above_max_temperature_loss_w_bi: Scalars['Float'];
  sum__above_max_temperature_loss_w_mono: Scalars['Float'];
  sum__above_max_temperature_loss_wh_bi: Scalars['Float'];
  sum__above_max_temperature_loss_wh_mono: Scalars['Float'];
  sum__ac_power_clipping_loss_w_bi: Scalars['Float'];
  sum__ac_power_clipping_loss_w_mono: Scalars['Float'];
  sum__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  sum__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  sum__air_mass: Scalars['Float'];
  sum__albedo?: Maybe<Scalars['Float']>;
  sum__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  sum__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  sum__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  sum__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  sum__array_string_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_string_energy_mono?: Maybe<Scalars['Float']>;
  sum__available_energy_wh_bi: Scalars['Float'];
  sum__available_energy_wh_mono: Scalars['Float'];
  sum__available_power_w_bi: Scalars['Float'];
  sum__available_power_w_mono: Scalars['Float'];
  sum__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  sum__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  sum__below_min_temperature_loss_w_bi: Scalars['Float'];
  sum__below_min_temperature_loss_w_mono: Scalars['Float'];
  sum__below_min_temperature_loss_wh_bi: Scalars['Float'];
  sum__below_min_temperature_loss_wh_mono: Scalars['Float'];
  sum__bifaciality_current_ratio: Scalars['Float'];
  sum__center_module_inclined_irradiance: Scalars['Float'];
  sum__center_module_rear_inclined_irradiance: Scalars['Float'];
  sum__degradation_loss_first_year_w_bi: Scalars['Float'];
  sum__degradation_loss_first_year_w_mono: Scalars['Float'];
  sum__degradation_loss_first_year_wh_bi: Scalars['Float'];
  sum__degradation_loss_first_year_wh_mono: Scalars['Float'];
  sum__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  sum__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  sum__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  sum__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  sum__dhi_whm2: Scalars['Float'];
  sum__dhi_wm2: Scalars['Float'];
  sum__dni_whm2: Scalars['Float'];
  sum__dni_wm2: Scalars['Float'];
  sum__energy_bi: Scalars['Float'];
  sum__energy_mono: Scalars['Float'];
  sum__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  sum__ghi_whm2: Scalars['Float'];
  sum__ghi_wm2: Scalars['Float'];
  sum__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  sum__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  sum__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  sum__inverter_night_tare_loss_w_bi: Scalars['Float'];
  sum__inverter_night_tare_loss_w_mono: Scalars['Float'];
  sum__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  sum__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  sum__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  sum__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  sum__inverter_output_energy_wh_bi: Scalars['Float'];
  sum__inverter_output_energy_wh_mono: Scalars['Float'];
  sum__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  sum__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  sum__inverter_output_power_w_bi: Scalars['Float'];
  sum__inverter_output_power_w_mono: Scalars['Float'];
  sum__line_energy_loss_wh_bi: Scalars['Float'];
  sum__line_energy_loss_wh_mono: Scalars['Float'];
  sum__line_power_loss_w_bi: Scalars['Float'];
  sum__line_power_loss_w_mono: Scalars['Float'];
  sum__line_receiving_end_energy_wh_bi: Scalars['Float'];
  sum__line_receiving_end_energy_wh_mono: Scalars['Float'];
  sum__line_receiving_end_power_w_bi: Scalars['Float'];
  sum__line_receiving_end_power_w_mono: Scalars['Float'];
  sum__line_sending_end_energy_wh_bi: Scalars['Float'];
  sum__line_sending_end_energy_wh_mono: Scalars['Float'];
  sum__line_sending_end_power_w_bi: Scalars['Float'];
  sum__line_sending_end_power_w_mono: Scalars['Float'];
  sum__num_panels_in_array: Scalars['Float'];
  sum__performance_ratio_bi: Scalars['Float'];
  sum__performance_ratio_mono: Scalars['Float'];
  sum__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__pv_power_no_degradation_w_bi: Scalars['Float'];
  sum__pv_power_no_degradation_w_mono: Scalars['Float'];
  sum__pv_power_no_degradation_wh_bi: Scalars['Float'];
  sum__pv_power_no_degradation_wh_mono: Scalars['Float'];
  sum__pv_power_no_soiling_w_bi: Scalars['Float'];
  sum__pv_power_no_soiling_w_mono: Scalars['Float'];
  sum__pv_power_no_soiling_wh_bi: Scalars['Float'];
  sum__pv_power_no_soiling_wh_mono: Scalars['Float'];
  sum__pv_power_with_degradation_w_bi: Scalars['Float'];
  sum__pv_power_with_degradation_w_mono: Scalars['Float'];
  sum__pv_power_with_degradation_wh_bi: Scalars['Float'];
  sum__pv_power_with_degradation_wh_mono: Scalars['Float'];
  sum__pv_power_with_soiling_w_bi: Scalars['Float'];
  sum__pv_power_with_soiling_w_mono: Scalars['Float'];
  sum__pv_power_with_soiling_wh_bi: Scalars['Float'];
  sum__pv_power_with_soiling_wh_mono: Scalars['Float'];
  sum__self_consumption_loss_w_bi: Scalars['Float'];
  sum__self_consumption_loss_w_mono: Scalars['Float'];
  sum__self_consumption_loss_wh_bi: Scalars['Float'];
  sum__self_consumption_loss_wh_mono: Scalars['Float'];
  sum__soiling_loss_w_bi: Scalars['Float'];
  sum__soiling_loss_w_mono: Scalars['Float'];
  sum__soiling_loss_wh_bi: Scalars['Float'];
  sum__soiling_loss_wh_mono: Scalars['Float'];
  sum__stc_pv_power: Scalars['Float'];
  sum__sun_azimuth_deg: Scalars['Float'];
  sum__sun_zenith_deg: Scalars['Float'];
  sum__temperature_c: Scalars['Float'];
  sum__temperature_derating_loss_w_bi: Scalars['Float'];
  sum__temperature_derating_loss_w_mono: Scalars['Float'];
  sum__temperature_derating_loss_wh_bi: Scalars['Float'];
  sum__temperature_derating_loss_wh_mono: Scalars['Float'];
  sum__total_degradation_loss_w_bi: Scalars['Float'];
  sum__total_degradation_loss_w_mono: Scalars['Float'];
  sum__total_degradation_loss_wh_bi: Scalars['Float'];
  sum__total_degradation_loss_wh_mono: Scalars['Float'];
  sum__total_inverter_loss_w_bi: Scalars['Float'];
  sum__total_inverter_loss_w_mono: Scalars['Float'];
  sum__total_inverter_loss_wh_bi: Scalars['Float'];
  sum__total_inverter_loss_wh_mono: Scalars['Float'];
  sum__transformer_copper_loss_w_bi: Scalars['Float'];
  sum__transformer_copper_loss_w_mono: Scalars['Float'];
  sum__transformer_copper_loss_wh_bi: Scalars['Float'];
  sum__transformer_copper_loss_wh_mono: Scalars['Float'];
  sum__transformer_energy_loss_wh_bi: Scalars['Float'];
  sum__transformer_energy_loss_wh_mono: Scalars['Float'];
  sum__transformer_input_energy_wh_bi: Scalars['Float'];
  sum__transformer_input_energy_wh_mono: Scalars['Float'];
  sum__transformer_input_power_w_bi: Scalars['Float'];
  sum__transformer_input_power_w_mono: Scalars['Float'];
  sum__transformer_iron_core_loss_w_bi: Scalars['Float'];
  sum__transformer_iron_core_loss_w_mono: Scalars['Float'];
  sum__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  sum__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  sum__transformer_output_energy_wh_bi: Scalars['Float'];
  sum__transformer_output_energy_wh_mono: Scalars['Float'];
  sum__transformer_output_power_w_bi: Scalars['Float'];
  sum__transformer_output_power_w_mono: Scalars['Float'];
  sum__transformer_power_loss_w_bi: Scalars['Float'];
  sum__transformer_power_loss_w_mono: Scalars['Float'];
  sum__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  sum__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  sum__transmission_line_power_loss_w_bi: Scalars['Float'];
  sum__transmission_line_power_loss_w_mono: Scalars['Float'];
  sum__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  sum__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  sum__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  sum__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  sum__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  sum__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  sum__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  sum__transmission_line_sending_end_power_w_mono: Scalars['Float'];
};

export type SimulationExtendedSummary = {
  __typename?: 'SimulationExtendedSummary';
  cellTemperatureSupported?: Maybe<Scalars['Boolean']>;
  inverterNightTarePower?: Maybe<Scalars['Float']>;
  inverter_ac_power?: Maybe<Scalars['Float']>;
  nominal_dc_power?: Maybe<Scalars['Float']>;
};

export type SimulationPdfExportBlockData = {
  __typename?: 'SimulationPdfExportBlockData';
  block_id: Scalars['String'];
  block_name: Scalars['String'];
  collector_width?: Maybe<Scalars['Float']>;
  dc_wiring_loss_fraction?: Maybe<Scalars['Float']>;
  global_array_resistance?: Maybe<Scalars['Float']>;
  inverter_ac_power?: Maybe<Scalars['Float']>;
  inverter_manufacturer?: Maybe<Scalars['String']>;
  inverter_maximum_voltage?: Maybe<Scalars['Float']>;
  inverter_minimum_voltage?: Maybe<Scalars['Float']>;
  inverter_model?: Maybe<Scalars['String']>;
  inverter_night_tare_power?: Maybe<Scalars['Float']>;
  monthly_soiling_pct_ghi_weighted?: Maybe<Array<Maybe<Scalars['Float']>>>;
  nominal_dc_power?: Maybe<Scalars['Float']>;
  num_inverters?: Maybe<Scalars['Float']>;
  num_panels_per_string?: Maybe<Scalars['Float']>;
  num_strings?: Maybe<Scalars['Float']>;
  num_total_panels?: Maybe<Scalars['Float']>;
  single_panel_dc_power?: Maybe<Scalars['Float']>;
  stc_efficiency?: Maybe<Scalars['Float']>;
};

export type SimulationPdfExportData = {
  __typename?: 'SimulationPdfExportData';
  albedo?: Maybe<Scalars['Float']>;
  albedo_ghi_weighted?: Maybe<Scalars['Float']>;
  author?: Maybe<User>;
  block_data: Array<SimulationPdfExportBlockData>;
  has_hv_stage: Scalars['Boolean'];
  monthly_albedo: Array<Maybe<Scalars['Float']>>;
  monthly_albedo_ghi_weighted: Array<Maybe<Scalars['Float']>>;
  num_total_panels?: Maybe<Scalars['Float']>;
  num_total_strings?: Maybe<Scalars['Float']>;
  system_collector_width?: Maybe<Scalars['Float']>;
  system_inverter_ac_power?: Maybe<Scalars['Float']>;
  system_nominal_dc_power?: Maybe<Scalars['Float']>;
  system_stc_efficiency?: Maybe<Scalars['Float']>;
  system_tracker_spacing?: Maybe<Scalars['Float']>;
  windspeed_available: Scalars['Boolean'];
};

export type SimulationSummary = SimulationAggregatedMeasures & {
  __typename?: 'SimulationSummary';
  avg__above_max_temperature_loss_w_bi: Scalars['Float'];
  avg__above_max_temperature_loss_w_mono: Scalars['Float'];
  avg__above_max_temperature_loss_wh_bi: Scalars['Float'];
  avg__above_max_temperature_loss_wh_mono: Scalars['Float'];
  avg__ac_power_clipping_loss_w_bi: Scalars['Float'];
  avg__ac_power_clipping_loss_w_mono: Scalars['Float'];
  avg__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  avg__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  avg__air_mass: Scalars['Float'];
  avg__albedo?: Maybe<Scalars['Float']>;
  avg__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  avg__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  avg__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  avg__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  avg__array_string_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_string_energy_mono?: Maybe<Scalars['Float']>;
  avg__available_energy_wh_bi: Scalars['Float'];
  avg__available_energy_wh_mono: Scalars['Float'];
  avg__available_power_w_bi: Scalars['Float'];
  avg__available_power_w_mono: Scalars['Float'];
  avg__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  avg__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  avg__below_min_temperature_loss_w_bi: Scalars['Float'];
  avg__below_min_temperature_loss_w_mono: Scalars['Float'];
  avg__below_min_temperature_loss_wh_bi: Scalars['Float'];
  avg__below_min_temperature_loss_wh_mono: Scalars['Float'];
  avg__bifaciality_current_ratio: Scalars['Float'];
  avg__center_module_inclined_irradiance: Scalars['Float'];
  avg__center_module_rear_inclined_irradiance: Scalars['Float'];
  avg__degradation_loss_first_year_w_bi: Scalars['Float'];
  avg__degradation_loss_first_year_w_mono: Scalars['Float'];
  avg__degradation_loss_first_year_wh_bi: Scalars['Float'];
  avg__degradation_loss_first_year_wh_mono: Scalars['Float'];
  avg__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  avg__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  avg__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  avg__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  avg__dhi_whm2: Scalars['Float'];
  avg__dhi_wm2: Scalars['Float'];
  avg__dni_whm2: Scalars['Float'];
  avg__dni_wm2: Scalars['Float'];
  avg__energy_bi: Scalars['Float'];
  avg__energy_mono: Scalars['Float'];
  avg__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  avg__ghi_whm2: Scalars['Float'];
  avg__ghi_wm2: Scalars['Float'];
  avg__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  avg__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  avg__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  avg__inverter_night_tare_loss_w_bi: Scalars['Float'];
  avg__inverter_night_tare_loss_w_mono: Scalars['Float'];
  avg__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  avg__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  avg__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  avg__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  avg__inverter_output_energy_wh_bi: Scalars['Float'];
  avg__inverter_output_energy_wh_mono: Scalars['Float'];
  avg__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  avg__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  avg__inverter_output_power_w_bi: Scalars['Float'];
  avg__inverter_output_power_w_mono: Scalars['Float'];
  avg__line_energy_loss_wh_bi: Scalars['Float'];
  avg__line_energy_loss_wh_mono: Scalars['Float'];
  avg__line_power_loss_w_bi: Scalars['Float'];
  avg__line_power_loss_w_mono: Scalars['Float'];
  avg__line_receiving_end_energy_wh_bi: Scalars['Float'];
  avg__line_receiving_end_energy_wh_mono: Scalars['Float'];
  avg__line_receiving_end_power_w_bi: Scalars['Float'];
  avg__line_receiving_end_power_w_mono: Scalars['Float'];
  avg__line_sending_end_energy_wh_bi: Scalars['Float'];
  avg__line_sending_end_energy_wh_mono: Scalars['Float'];
  avg__line_sending_end_power_w_bi: Scalars['Float'];
  avg__line_sending_end_power_w_mono: Scalars['Float'];
  avg__num_panels_in_array: Scalars['Float'];
  avg__performance_ratio_bi: Scalars['Float'];
  avg__performance_ratio_mono: Scalars['Float'];
  avg__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__pv_power_no_degradation_w_bi: Scalars['Float'];
  avg__pv_power_no_degradation_w_mono: Scalars['Float'];
  avg__pv_power_no_degradation_wh_bi: Scalars['Float'];
  avg__pv_power_no_degradation_wh_mono: Scalars['Float'];
  avg__pv_power_no_soiling_w_bi: Scalars['Float'];
  avg__pv_power_no_soiling_w_mono: Scalars['Float'];
  avg__pv_power_no_soiling_wh_bi: Scalars['Float'];
  avg__pv_power_no_soiling_wh_mono: Scalars['Float'];
  avg__pv_power_with_degradation_w_bi: Scalars['Float'];
  avg__pv_power_with_degradation_w_mono: Scalars['Float'];
  avg__pv_power_with_degradation_wh_bi: Scalars['Float'];
  avg__pv_power_with_degradation_wh_mono: Scalars['Float'];
  avg__pv_power_with_soiling_w_bi: Scalars['Float'];
  avg__pv_power_with_soiling_w_mono: Scalars['Float'];
  avg__pv_power_with_soiling_wh_bi: Scalars['Float'];
  avg__pv_power_with_soiling_wh_mono: Scalars['Float'];
  avg__self_consumption_loss_w_bi: Scalars['Float'];
  avg__self_consumption_loss_w_mono: Scalars['Float'];
  avg__self_consumption_loss_wh_bi: Scalars['Float'];
  avg__self_consumption_loss_wh_mono: Scalars['Float'];
  avg__soiling_loss_w_bi: Scalars['Float'];
  avg__soiling_loss_w_mono: Scalars['Float'];
  avg__soiling_loss_wh_bi: Scalars['Float'];
  avg__soiling_loss_wh_mono: Scalars['Float'];
  avg__stc_pv_power: Scalars['Float'];
  avg__sun_azimuth_deg: Scalars['Float'];
  avg__sun_zenith_deg: Scalars['Float'];
  avg__temperature_c: Scalars['Float'];
  avg__temperature_derating_loss_w_bi: Scalars['Float'];
  avg__temperature_derating_loss_w_mono: Scalars['Float'];
  avg__temperature_derating_loss_wh_bi: Scalars['Float'];
  avg__temperature_derating_loss_wh_mono: Scalars['Float'];
  avg__total_degradation_loss_w_bi: Scalars['Float'];
  avg__total_degradation_loss_w_mono: Scalars['Float'];
  avg__total_degradation_loss_wh_bi: Scalars['Float'];
  avg__total_degradation_loss_wh_mono: Scalars['Float'];
  avg__total_inverter_loss_w_bi: Scalars['Float'];
  avg__total_inverter_loss_w_mono: Scalars['Float'];
  avg__total_inverter_loss_wh_bi: Scalars['Float'];
  avg__total_inverter_loss_wh_mono: Scalars['Float'];
  avg__transformer_copper_loss_w_bi: Scalars['Float'];
  avg__transformer_copper_loss_w_mono: Scalars['Float'];
  avg__transformer_copper_loss_wh_bi: Scalars['Float'];
  avg__transformer_copper_loss_wh_mono: Scalars['Float'];
  avg__transformer_energy_loss_wh_bi: Scalars['Float'];
  avg__transformer_energy_loss_wh_mono: Scalars['Float'];
  avg__transformer_input_energy_wh_bi: Scalars['Float'];
  avg__transformer_input_energy_wh_mono: Scalars['Float'];
  avg__transformer_input_power_w_bi: Scalars['Float'];
  avg__transformer_input_power_w_mono: Scalars['Float'];
  avg__transformer_iron_core_loss_w_bi: Scalars['Float'];
  avg__transformer_iron_core_loss_w_mono: Scalars['Float'];
  avg__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  avg__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  avg__transformer_output_energy_wh_bi: Scalars['Float'];
  avg__transformer_output_energy_wh_mono: Scalars['Float'];
  avg__transformer_output_power_w_bi: Scalars['Float'];
  avg__transformer_output_power_w_mono: Scalars['Float'];
  avg__transformer_power_loss_w_bi: Scalars['Float'];
  avg__transformer_power_loss_w_mono: Scalars['Float'];
  avg__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  avg__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  avg__transmission_line_power_loss_w_bi: Scalars['Float'];
  avg__transmission_line_power_loss_w_mono: Scalars['Float'];
  avg__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  avg__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  avg__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  avg__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  avg__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  avg__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  avg__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  avg__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  count__above_max_temperature_loss_w_bi: Scalars['Float'];
  count__above_max_temperature_loss_w_mono: Scalars['Float'];
  count__above_max_temperature_loss_wh_bi: Scalars['Float'];
  count__above_max_temperature_loss_wh_mono: Scalars['Float'];
  count__ac_power_clipping_loss_w_bi: Scalars['Float'];
  count__ac_power_clipping_loss_w_mono: Scalars['Float'];
  count__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  count__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  count__air_mass: Scalars['Float'];
  count__albedo?: Maybe<Scalars['Float']>;
  count__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  count__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  count__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  count__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  count__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  count__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  count__array_string_energy_bi?: Maybe<Scalars['Float']>;
  count__array_string_energy_mono?: Maybe<Scalars['Float']>;
  count__available_energy_wh_bi: Scalars['Float'];
  count__available_energy_wh_mono: Scalars['Float'];
  count__available_power_w_bi: Scalars['Float'];
  count__available_power_w_mono: Scalars['Float'];
  count__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  count__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  count__below_min_temperature_loss_w_bi: Scalars['Float'];
  count__below_min_temperature_loss_w_mono: Scalars['Float'];
  count__below_min_temperature_loss_wh_bi: Scalars['Float'];
  count__below_min_temperature_loss_wh_mono: Scalars['Float'];
  count__bifaciality_current_ratio: Scalars['Float'];
  count__center_module_inclined_irradiance: Scalars['Float'];
  count__center_module_rear_inclined_irradiance: Scalars['Float'];
  count__degradation_loss_first_year_w_bi: Scalars['Float'];
  count__degradation_loss_first_year_w_mono: Scalars['Float'];
  count__degradation_loss_first_year_wh_bi: Scalars['Float'];
  count__degradation_loss_first_year_wh_mono: Scalars['Float'];
  count__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  count__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  count__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  count__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  count__dhi_whm2: Scalars['Float'];
  count__dhi_wm2: Scalars['Float'];
  count__dni_whm2: Scalars['Float'];
  count__dni_wm2: Scalars['Float'];
  count__energy_bi: Scalars['Float'];
  count__energy_mono: Scalars['Float'];
  count__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  count__ghi_whm2: Scalars['Float'];
  count__ghi_wm2: Scalars['Float'];
  count__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  count__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  count__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  count__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  count__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  count__inverter_night_tare_loss_w_bi: Scalars['Float'];
  count__inverter_night_tare_loss_w_mono: Scalars['Float'];
  count__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  count__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  count__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  count__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  count__inverter_output_energy_wh_bi: Scalars['Float'];
  count__inverter_output_energy_wh_mono: Scalars['Float'];
  count__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  count__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  count__inverter_output_power_w_bi: Scalars['Float'];
  count__inverter_output_power_w_mono: Scalars['Float'];
  count__line_energy_loss_wh_bi: Scalars['Float'];
  count__line_energy_loss_wh_mono: Scalars['Float'];
  count__line_power_loss_w_bi: Scalars['Float'];
  count__line_power_loss_w_mono: Scalars['Float'];
  count__line_receiving_end_energy_wh_bi: Scalars['Float'];
  count__line_receiving_end_energy_wh_mono: Scalars['Float'];
  count__line_receiving_end_power_w_bi: Scalars['Float'];
  count__line_receiving_end_power_w_mono: Scalars['Float'];
  count__line_sending_end_energy_wh_bi: Scalars['Float'];
  count__line_sending_end_energy_wh_mono: Scalars['Float'];
  count__line_sending_end_power_w_bi: Scalars['Float'];
  count__line_sending_end_power_w_mono: Scalars['Float'];
  count__num_panels_in_array: Scalars['Float'];
  count__performance_ratio_bi: Scalars['Float'];
  count__performance_ratio_mono: Scalars['Float'];
  count__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__pv_power_no_degradation_w_bi: Scalars['Float'];
  count__pv_power_no_degradation_w_mono: Scalars['Float'];
  count__pv_power_no_degradation_wh_bi: Scalars['Float'];
  count__pv_power_no_degradation_wh_mono: Scalars['Float'];
  count__pv_power_no_soiling_w_bi: Scalars['Float'];
  count__pv_power_no_soiling_w_mono: Scalars['Float'];
  count__pv_power_no_soiling_wh_bi: Scalars['Float'];
  count__pv_power_no_soiling_wh_mono: Scalars['Float'];
  count__pv_power_with_degradation_w_bi: Scalars['Float'];
  count__pv_power_with_degradation_w_mono: Scalars['Float'];
  count__pv_power_with_degradation_wh_bi: Scalars['Float'];
  count__pv_power_with_degradation_wh_mono: Scalars['Float'];
  count__pv_power_with_soiling_w_bi: Scalars['Float'];
  count__pv_power_with_soiling_w_mono: Scalars['Float'];
  count__pv_power_with_soiling_wh_bi: Scalars['Float'];
  count__pv_power_with_soiling_wh_mono: Scalars['Float'];
  count__self_consumption_loss_w_bi: Scalars['Float'];
  count__self_consumption_loss_w_mono: Scalars['Float'];
  count__self_consumption_loss_wh_bi: Scalars['Float'];
  count__self_consumption_loss_wh_mono: Scalars['Float'];
  count__soiling_loss_w_bi: Scalars['Float'];
  count__soiling_loss_w_mono: Scalars['Float'];
  count__soiling_loss_wh_bi: Scalars['Float'];
  count__soiling_loss_wh_mono: Scalars['Float'];
  count__stc_pv_power: Scalars['Float'];
  count__sun_azimuth_deg: Scalars['Float'];
  count__sun_zenith_deg: Scalars['Float'];
  count__temperature_c: Scalars['Float'];
  count__temperature_derating_loss_w_bi: Scalars['Float'];
  count__temperature_derating_loss_w_mono: Scalars['Float'];
  count__temperature_derating_loss_wh_bi: Scalars['Float'];
  count__temperature_derating_loss_wh_mono: Scalars['Float'];
  count__total_degradation_loss_w_bi: Scalars['Float'];
  count__total_degradation_loss_w_mono: Scalars['Float'];
  count__total_degradation_loss_wh_bi: Scalars['Float'];
  count__total_degradation_loss_wh_mono: Scalars['Float'];
  count__total_inverter_loss_w_bi: Scalars['Float'];
  count__total_inverter_loss_w_mono: Scalars['Float'];
  count__total_inverter_loss_wh_bi: Scalars['Float'];
  count__total_inverter_loss_wh_mono: Scalars['Float'];
  count__transformer_copper_loss_w_bi: Scalars['Float'];
  count__transformer_copper_loss_w_mono: Scalars['Float'];
  count__transformer_copper_loss_wh_bi: Scalars['Float'];
  count__transformer_copper_loss_wh_mono: Scalars['Float'];
  count__transformer_energy_loss_wh_bi: Scalars['Float'];
  count__transformer_energy_loss_wh_mono: Scalars['Float'];
  count__transformer_input_energy_wh_bi: Scalars['Float'];
  count__transformer_input_energy_wh_mono: Scalars['Float'];
  count__transformer_input_power_w_bi: Scalars['Float'];
  count__transformer_input_power_w_mono: Scalars['Float'];
  count__transformer_iron_core_loss_w_bi: Scalars['Float'];
  count__transformer_iron_core_loss_w_mono: Scalars['Float'];
  count__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  count__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  count__transformer_output_energy_wh_bi: Scalars['Float'];
  count__transformer_output_energy_wh_mono: Scalars['Float'];
  count__transformer_output_power_w_bi: Scalars['Float'];
  count__transformer_output_power_w_mono: Scalars['Float'];
  count__transformer_power_loss_w_bi: Scalars['Float'];
  count__transformer_power_loss_w_mono: Scalars['Float'];
  count__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  count__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  count__transmission_line_power_loss_w_bi: Scalars['Float'];
  count__transmission_line_power_loss_w_mono: Scalars['Float'];
  count__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  count__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  count__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  count__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  count__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  count__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  count__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  count__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  duet_job_input_id?: Maybe<Scalars['String']>;
  max__above_max_temperature_loss_w_bi: Scalars['Float'];
  max__above_max_temperature_loss_w_mono: Scalars['Float'];
  max__above_max_temperature_loss_wh_bi: Scalars['Float'];
  max__above_max_temperature_loss_wh_mono: Scalars['Float'];
  max__ac_power_clipping_loss_w_bi: Scalars['Float'];
  max__ac_power_clipping_loss_w_mono: Scalars['Float'];
  max__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  max__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  max__air_mass: Scalars['Float'];
  max__albedo?: Maybe<Scalars['Float']>;
  max__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  max__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  max__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  max__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  max__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  max__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  max__array_string_energy_bi?: Maybe<Scalars['Float']>;
  max__array_string_energy_mono?: Maybe<Scalars['Float']>;
  max__available_energy_wh_bi: Scalars['Float'];
  max__available_energy_wh_mono: Scalars['Float'];
  max__available_power_w_bi: Scalars['Float'];
  max__available_power_w_mono: Scalars['Float'];
  max__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  max__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  max__below_min_temperature_loss_w_bi: Scalars['Float'];
  max__below_min_temperature_loss_w_mono: Scalars['Float'];
  max__below_min_temperature_loss_wh_bi: Scalars['Float'];
  max__below_min_temperature_loss_wh_mono: Scalars['Float'];
  max__bifaciality_current_ratio: Scalars['Float'];
  max__center_module_inclined_irradiance: Scalars['Float'];
  max__center_module_rear_inclined_irradiance: Scalars['Float'];
  max__degradation_loss_first_year_w_bi: Scalars['Float'];
  max__degradation_loss_first_year_w_mono: Scalars['Float'];
  max__degradation_loss_first_year_wh_bi: Scalars['Float'];
  max__degradation_loss_first_year_wh_mono: Scalars['Float'];
  max__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  max__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  max__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  max__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  max__dhi_whm2: Scalars['Float'];
  max__dhi_wm2: Scalars['Float'];
  max__dni_whm2: Scalars['Float'];
  max__dni_wm2: Scalars['Float'];
  max__energy_bi: Scalars['Float'];
  max__energy_mono: Scalars['Float'];
  max__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  max__ghi_whm2: Scalars['Float'];
  max__ghi_wm2: Scalars['Float'];
  max__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  max__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  max__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  max__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  max__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  max__inverter_night_tare_loss_w_bi: Scalars['Float'];
  max__inverter_night_tare_loss_w_mono: Scalars['Float'];
  max__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  max__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  max__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  max__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  max__inverter_output_energy_wh_bi: Scalars['Float'];
  max__inverter_output_energy_wh_mono: Scalars['Float'];
  max__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  max__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  max__inverter_output_power_w_bi: Scalars['Float'];
  max__inverter_output_power_w_mono: Scalars['Float'];
  max__line_energy_loss_wh_bi: Scalars['Float'];
  max__line_energy_loss_wh_mono: Scalars['Float'];
  max__line_power_loss_w_bi: Scalars['Float'];
  max__line_power_loss_w_mono: Scalars['Float'];
  max__line_receiving_end_energy_wh_bi: Scalars['Float'];
  max__line_receiving_end_energy_wh_mono: Scalars['Float'];
  max__line_receiving_end_power_w_bi: Scalars['Float'];
  max__line_receiving_end_power_w_mono: Scalars['Float'];
  max__line_sending_end_energy_wh_bi: Scalars['Float'];
  max__line_sending_end_energy_wh_mono: Scalars['Float'];
  max__line_sending_end_power_w_bi: Scalars['Float'];
  max__line_sending_end_power_w_mono: Scalars['Float'];
  max__num_panels_in_array: Scalars['Float'];
  max__performance_ratio_bi: Scalars['Float'];
  max__performance_ratio_mono: Scalars['Float'];
  max__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__pv_power_no_degradation_w_bi: Scalars['Float'];
  max__pv_power_no_degradation_w_mono: Scalars['Float'];
  max__pv_power_no_degradation_wh_bi: Scalars['Float'];
  max__pv_power_no_degradation_wh_mono: Scalars['Float'];
  max__pv_power_no_soiling_w_bi: Scalars['Float'];
  max__pv_power_no_soiling_w_mono: Scalars['Float'];
  max__pv_power_no_soiling_wh_bi: Scalars['Float'];
  max__pv_power_no_soiling_wh_mono: Scalars['Float'];
  max__pv_power_with_degradation_w_bi: Scalars['Float'];
  max__pv_power_with_degradation_w_mono: Scalars['Float'];
  max__pv_power_with_degradation_wh_bi: Scalars['Float'];
  max__pv_power_with_degradation_wh_mono: Scalars['Float'];
  max__pv_power_with_soiling_w_bi: Scalars['Float'];
  max__pv_power_with_soiling_w_mono: Scalars['Float'];
  max__pv_power_with_soiling_wh_bi: Scalars['Float'];
  max__pv_power_with_soiling_wh_mono: Scalars['Float'];
  max__self_consumption_loss_w_bi: Scalars['Float'];
  max__self_consumption_loss_w_mono: Scalars['Float'];
  max__self_consumption_loss_wh_bi: Scalars['Float'];
  max__self_consumption_loss_wh_mono: Scalars['Float'];
  max__soiling_loss_w_bi: Scalars['Float'];
  max__soiling_loss_w_mono: Scalars['Float'];
  max__soiling_loss_wh_bi: Scalars['Float'];
  max__soiling_loss_wh_mono: Scalars['Float'];
  max__stc_pv_power: Scalars['Float'];
  max__sun_azimuth_deg: Scalars['Float'];
  max__sun_zenith_deg: Scalars['Float'];
  max__temperature_c: Scalars['Float'];
  max__temperature_derating_loss_w_bi: Scalars['Float'];
  max__temperature_derating_loss_w_mono: Scalars['Float'];
  max__temperature_derating_loss_wh_bi: Scalars['Float'];
  max__temperature_derating_loss_wh_mono: Scalars['Float'];
  max__total_degradation_loss_w_bi: Scalars['Float'];
  max__total_degradation_loss_w_mono: Scalars['Float'];
  max__total_degradation_loss_wh_bi: Scalars['Float'];
  max__total_degradation_loss_wh_mono: Scalars['Float'];
  max__total_inverter_loss_w_bi: Scalars['Float'];
  max__total_inverter_loss_w_mono: Scalars['Float'];
  max__total_inverter_loss_wh_bi: Scalars['Float'];
  max__total_inverter_loss_wh_mono: Scalars['Float'];
  max__transformer_copper_loss_w_bi: Scalars['Float'];
  max__transformer_copper_loss_w_mono: Scalars['Float'];
  max__transformer_copper_loss_wh_bi: Scalars['Float'];
  max__transformer_copper_loss_wh_mono: Scalars['Float'];
  max__transformer_energy_loss_wh_bi: Scalars['Float'];
  max__transformer_energy_loss_wh_mono: Scalars['Float'];
  max__transformer_input_energy_wh_bi: Scalars['Float'];
  max__transformer_input_energy_wh_mono: Scalars['Float'];
  max__transformer_input_power_w_bi: Scalars['Float'];
  max__transformer_input_power_w_mono: Scalars['Float'];
  max__transformer_iron_core_loss_w_bi: Scalars['Float'];
  max__transformer_iron_core_loss_w_mono: Scalars['Float'];
  max__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  max__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  max__transformer_output_energy_wh_bi: Scalars['Float'];
  max__transformer_output_energy_wh_mono: Scalars['Float'];
  max__transformer_output_power_w_bi: Scalars['Float'];
  max__transformer_output_power_w_mono: Scalars['Float'];
  max__transformer_power_loss_w_bi: Scalars['Float'];
  max__transformer_power_loss_w_mono: Scalars['Float'];
  max__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  max__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  max__transmission_line_power_loss_w_bi: Scalars['Float'];
  max__transmission_line_power_loss_w_mono: Scalars['Float'];
  max__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  max__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  max__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  max__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  max__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  max__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  max__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  max__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  min__above_max_temperature_loss_w_bi: Scalars['Float'];
  min__above_max_temperature_loss_w_mono: Scalars['Float'];
  min__above_max_temperature_loss_wh_bi: Scalars['Float'];
  min__above_max_temperature_loss_wh_mono: Scalars['Float'];
  min__ac_power_clipping_loss_w_bi: Scalars['Float'];
  min__ac_power_clipping_loss_w_mono: Scalars['Float'];
  min__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  min__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  min__air_mass: Scalars['Float'];
  min__albedo?: Maybe<Scalars['Float']>;
  min__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  min__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  min__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  min__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  min__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  min__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  min__array_string_energy_bi?: Maybe<Scalars['Float']>;
  min__array_string_energy_mono?: Maybe<Scalars['Float']>;
  min__available_energy_wh_bi: Scalars['Float'];
  min__available_energy_wh_mono: Scalars['Float'];
  min__available_power_w_bi: Scalars['Float'];
  min__available_power_w_mono: Scalars['Float'];
  min__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  min__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  min__below_min_temperature_loss_w_bi: Scalars['Float'];
  min__below_min_temperature_loss_w_mono: Scalars['Float'];
  min__below_min_temperature_loss_wh_bi: Scalars['Float'];
  min__below_min_temperature_loss_wh_mono: Scalars['Float'];
  min__bifaciality_current_ratio: Scalars['Float'];
  min__center_module_inclined_irradiance: Scalars['Float'];
  min__center_module_rear_inclined_irradiance: Scalars['Float'];
  min__degradation_loss_first_year_w_bi: Scalars['Float'];
  min__degradation_loss_first_year_w_mono: Scalars['Float'];
  min__degradation_loss_first_year_wh_bi: Scalars['Float'];
  min__degradation_loss_first_year_wh_mono: Scalars['Float'];
  min__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  min__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  min__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  min__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  min__dhi_whm2: Scalars['Float'];
  min__dhi_wm2: Scalars['Float'];
  min__dni_whm2: Scalars['Float'];
  min__dni_wm2: Scalars['Float'];
  min__energy_bi: Scalars['Float'];
  min__energy_mono: Scalars['Float'];
  min__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  min__ghi_whm2: Scalars['Float'];
  min__ghi_wm2: Scalars['Float'];
  min__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  min__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  min__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  min__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  min__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  min__inverter_night_tare_loss_w_bi: Scalars['Float'];
  min__inverter_night_tare_loss_w_mono: Scalars['Float'];
  min__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  min__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  min__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  min__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  min__inverter_output_energy_wh_bi: Scalars['Float'];
  min__inverter_output_energy_wh_mono: Scalars['Float'];
  min__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  min__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  min__inverter_output_power_w_bi: Scalars['Float'];
  min__inverter_output_power_w_mono: Scalars['Float'];
  min__line_energy_loss_wh_bi: Scalars['Float'];
  min__line_energy_loss_wh_mono: Scalars['Float'];
  min__line_power_loss_w_bi: Scalars['Float'];
  min__line_power_loss_w_mono: Scalars['Float'];
  min__line_receiving_end_energy_wh_bi: Scalars['Float'];
  min__line_receiving_end_energy_wh_mono: Scalars['Float'];
  min__line_receiving_end_power_w_bi: Scalars['Float'];
  min__line_receiving_end_power_w_mono: Scalars['Float'];
  min__line_sending_end_energy_wh_bi: Scalars['Float'];
  min__line_sending_end_energy_wh_mono: Scalars['Float'];
  min__line_sending_end_power_w_bi: Scalars['Float'];
  min__line_sending_end_power_w_mono: Scalars['Float'];
  min__num_panels_in_array: Scalars['Float'];
  min__performance_ratio_bi: Scalars['Float'];
  min__performance_ratio_mono: Scalars['Float'];
  min__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__pv_power_no_degradation_w_bi: Scalars['Float'];
  min__pv_power_no_degradation_w_mono: Scalars['Float'];
  min__pv_power_no_degradation_wh_bi: Scalars['Float'];
  min__pv_power_no_degradation_wh_mono: Scalars['Float'];
  min__pv_power_no_soiling_w_bi: Scalars['Float'];
  min__pv_power_no_soiling_w_mono: Scalars['Float'];
  min__pv_power_no_soiling_wh_bi: Scalars['Float'];
  min__pv_power_no_soiling_wh_mono: Scalars['Float'];
  min__pv_power_with_degradation_w_bi: Scalars['Float'];
  min__pv_power_with_degradation_w_mono: Scalars['Float'];
  min__pv_power_with_degradation_wh_bi: Scalars['Float'];
  min__pv_power_with_degradation_wh_mono: Scalars['Float'];
  min__pv_power_with_soiling_w_bi: Scalars['Float'];
  min__pv_power_with_soiling_w_mono: Scalars['Float'];
  min__pv_power_with_soiling_wh_bi: Scalars['Float'];
  min__pv_power_with_soiling_wh_mono: Scalars['Float'];
  min__self_consumption_loss_w_bi: Scalars['Float'];
  min__self_consumption_loss_w_mono: Scalars['Float'];
  min__self_consumption_loss_wh_bi: Scalars['Float'];
  min__self_consumption_loss_wh_mono: Scalars['Float'];
  min__soiling_loss_w_bi: Scalars['Float'];
  min__soiling_loss_w_mono: Scalars['Float'];
  min__soiling_loss_wh_bi: Scalars['Float'];
  min__soiling_loss_wh_mono: Scalars['Float'];
  min__stc_pv_power: Scalars['Float'];
  min__sun_azimuth_deg: Scalars['Float'];
  min__sun_zenith_deg: Scalars['Float'];
  min__temperature_c: Scalars['Float'];
  min__temperature_derating_loss_w_bi: Scalars['Float'];
  min__temperature_derating_loss_w_mono: Scalars['Float'];
  min__temperature_derating_loss_wh_bi: Scalars['Float'];
  min__temperature_derating_loss_wh_mono: Scalars['Float'];
  min__total_degradation_loss_w_bi: Scalars['Float'];
  min__total_degradation_loss_w_mono: Scalars['Float'];
  min__total_degradation_loss_wh_bi: Scalars['Float'];
  min__total_degradation_loss_wh_mono: Scalars['Float'];
  min__total_inverter_loss_w_bi: Scalars['Float'];
  min__total_inverter_loss_w_mono: Scalars['Float'];
  min__total_inverter_loss_wh_bi: Scalars['Float'];
  min__total_inverter_loss_wh_mono: Scalars['Float'];
  min__transformer_copper_loss_w_bi: Scalars['Float'];
  min__transformer_copper_loss_w_mono: Scalars['Float'];
  min__transformer_copper_loss_wh_bi: Scalars['Float'];
  min__transformer_copper_loss_wh_mono: Scalars['Float'];
  min__transformer_energy_loss_wh_bi: Scalars['Float'];
  min__transformer_energy_loss_wh_mono: Scalars['Float'];
  min__transformer_input_energy_wh_bi: Scalars['Float'];
  min__transformer_input_energy_wh_mono: Scalars['Float'];
  min__transformer_input_power_w_bi: Scalars['Float'];
  min__transformer_input_power_w_mono: Scalars['Float'];
  min__transformer_iron_core_loss_w_bi: Scalars['Float'];
  min__transformer_iron_core_loss_w_mono: Scalars['Float'];
  min__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  min__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  min__transformer_output_energy_wh_bi: Scalars['Float'];
  min__transformer_output_energy_wh_mono: Scalars['Float'];
  min__transformer_output_power_w_bi: Scalars['Float'];
  min__transformer_output_power_w_mono: Scalars['Float'];
  min__transformer_power_loss_w_bi: Scalars['Float'];
  min__transformer_power_loss_w_mono: Scalars['Float'];
  min__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  min__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  min__transmission_line_power_loss_w_bi: Scalars['Float'];
  min__transmission_line_power_loss_w_mono: Scalars['Float'];
  min__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  min__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  min__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  min__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  min__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  min__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  min__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  min__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p10__above_max_temperature_loss_w_bi: Scalars['Float'];
  p10__above_max_temperature_loss_w_mono: Scalars['Float'];
  p10__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p10__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p10__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p10__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p10__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p10__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p10__air_mass: Scalars['Float'];
  p10__albedo?: Maybe<Scalars['Float']>;
  p10__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p10__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p10__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p10__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p10__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p10__available_energy_wh_bi: Scalars['Float'];
  p10__available_energy_wh_mono: Scalars['Float'];
  p10__available_power_w_bi: Scalars['Float'];
  p10__available_power_w_mono: Scalars['Float'];
  p10__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p10__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p10__below_min_temperature_loss_w_bi: Scalars['Float'];
  p10__below_min_temperature_loss_w_mono: Scalars['Float'];
  p10__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p10__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p10__bifaciality_current_ratio: Scalars['Float'];
  p10__center_module_inclined_irradiance: Scalars['Float'];
  p10__center_module_rear_inclined_irradiance: Scalars['Float'];
  p10__degradation_loss_first_year_w_bi: Scalars['Float'];
  p10__degradation_loss_first_year_w_mono: Scalars['Float'];
  p10__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p10__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p10__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p10__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p10__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p10__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p10__dhi_whm2: Scalars['Float'];
  p10__dhi_wm2: Scalars['Float'];
  p10__dni_whm2: Scalars['Float'];
  p10__dni_wm2: Scalars['Float'];
  p10__energy_bi: Scalars['Float'];
  p10__energy_mono: Scalars['Float'];
  p10__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p10__ghi_whm2: Scalars['Float'];
  p10__ghi_wm2: Scalars['Float'];
  p10__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p10__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p10__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p10__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p10__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p10__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p10__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p10__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p10__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p10__inverter_output_energy_wh_bi: Scalars['Float'];
  p10__inverter_output_energy_wh_mono: Scalars['Float'];
  p10__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p10__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p10__inverter_output_power_w_bi: Scalars['Float'];
  p10__inverter_output_power_w_mono: Scalars['Float'];
  p10__line_energy_loss_wh_bi: Scalars['Float'];
  p10__line_energy_loss_wh_mono: Scalars['Float'];
  p10__line_power_loss_w_bi: Scalars['Float'];
  p10__line_power_loss_w_mono: Scalars['Float'];
  p10__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p10__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p10__line_receiving_end_power_w_bi: Scalars['Float'];
  p10__line_receiving_end_power_w_mono: Scalars['Float'];
  p10__line_sending_end_energy_wh_bi: Scalars['Float'];
  p10__line_sending_end_energy_wh_mono: Scalars['Float'];
  p10__line_sending_end_power_w_bi: Scalars['Float'];
  p10__line_sending_end_power_w_mono: Scalars['Float'];
  p10__num_panels_in_array: Scalars['Float'];
  p10__performance_ratio_bi: Scalars['Float'];
  p10__performance_ratio_mono: Scalars['Float'];
  p10__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__pv_power_no_degradation_w_bi: Scalars['Float'];
  p10__pv_power_no_degradation_w_mono: Scalars['Float'];
  p10__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p10__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p10__pv_power_no_soiling_w_bi: Scalars['Float'];
  p10__pv_power_no_soiling_w_mono: Scalars['Float'];
  p10__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p10__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p10__pv_power_with_degradation_w_bi: Scalars['Float'];
  p10__pv_power_with_degradation_w_mono: Scalars['Float'];
  p10__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p10__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p10__pv_power_with_soiling_w_bi: Scalars['Float'];
  p10__pv_power_with_soiling_w_mono: Scalars['Float'];
  p10__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p10__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p10__self_consumption_loss_w_bi: Scalars['Float'];
  p10__self_consumption_loss_w_mono: Scalars['Float'];
  p10__self_consumption_loss_wh_bi: Scalars['Float'];
  p10__self_consumption_loss_wh_mono: Scalars['Float'];
  p10__soiling_loss_w_bi: Scalars['Float'];
  p10__soiling_loss_w_mono: Scalars['Float'];
  p10__soiling_loss_wh_bi: Scalars['Float'];
  p10__soiling_loss_wh_mono: Scalars['Float'];
  p10__stc_pv_power: Scalars['Float'];
  p10__sun_azimuth_deg: Scalars['Float'];
  p10__sun_zenith_deg: Scalars['Float'];
  p10__temperature_c: Scalars['Float'];
  p10__temperature_derating_loss_w_bi: Scalars['Float'];
  p10__temperature_derating_loss_w_mono: Scalars['Float'];
  p10__temperature_derating_loss_wh_bi: Scalars['Float'];
  p10__temperature_derating_loss_wh_mono: Scalars['Float'];
  p10__total_degradation_loss_w_bi: Scalars['Float'];
  p10__total_degradation_loss_w_mono: Scalars['Float'];
  p10__total_degradation_loss_wh_bi: Scalars['Float'];
  p10__total_degradation_loss_wh_mono: Scalars['Float'];
  p10__total_inverter_loss_w_bi: Scalars['Float'];
  p10__total_inverter_loss_w_mono: Scalars['Float'];
  p10__total_inverter_loss_wh_bi: Scalars['Float'];
  p10__total_inverter_loss_wh_mono: Scalars['Float'];
  p10__transformer_copper_loss_w_bi: Scalars['Float'];
  p10__transformer_copper_loss_w_mono: Scalars['Float'];
  p10__transformer_copper_loss_wh_bi: Scalars['Float'];
  p10__transformer_copper_loss_wh_mono: Scalars['Float'];
  p10__transformer_energy_loss_wh_bi: Scalars['Float'];
  p10__transformer_energy_loss_wh_mono: Scalars['Float'];
  p10__transformer_input_energy_wh_bi: Scalars['Float'];
  p10__transformer_input_energy_wh_mono: Scalars['Float'];
  p10__transformer_input_power_w_bi: Scalars['Float'];
  p10__transformer_input_power_w_mono: Scalars['Float'];
  p10__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p10__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p10__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p10__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p10__transformer_output_energy_wh_bi: Scalars['Float'];
  p10__transformer_output_energy_wh_mono: Scalars['Float'];
  p10__transformer_output_power_w_bi: Scalars['Float'];
  p10__transformer_output_power_w_mono: Scalars['Float'];
  p10__transformer_power_loss_w_bi: Scalars['Float'];
  p10__transformer_power_loss_w_mono: Scalars['Float'];
  p10__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p10__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p10__transmission_line_power_loss_w_bi: Scalars['Float'];
  p10__transmission_line_power_loss_w_mono: Scalars['Float'];
  p10__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p10__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p10__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p10__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p10__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p10__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p10__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p10__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p25__above_max_temperature_loss_w_bi: Scalars['Float'];
  p25__above_max_temperature_loss_w_mono: Scalars['Float'];
  p25__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p25__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p25__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p25__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p25__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p25__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p25__air_mass: Scalars['Float'];
  p25__albedo?: Maybe<Scalars['Float']>;
  p25__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p25__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p25__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p25__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p25__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p25__available_energy_wh_bi: Scalars['Float'];
  p25__available_energy_wh_mono: Scalars['Float'];
  p25__available_power_w_bi: Scalars['Float'];
  p25__available_power_w_mono: Scalars['Float'];
  p25__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p25__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p25__below_min_temperature_loss_w_bi: Scalars['Float'];
  p25__below_min_temperature_loss_w_mono: Scalars['Float'];
  p25__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p25__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p25__bifaciality_current_ratio: Scalars['Float'];
  p25__center_module_inclined_irradiance: Scalars['Float'];
  p25__center_module_rear_inclined_irradiance: Scalars['Float'];
  p25__degradation_loss_first_year_w_bi: Scalars['Float'];
  p25__degradation_loss_first_year_w_mono: Scalars['Float'];
  p25__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p25__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p25__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p25__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p25__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p25__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p25__dhi_whm2: Scalars['Float'];
  p25__dhi_wm2: Scalars['Float'];
  p25__dni_whm2: Scalars['Float'];
  p25__dni_wm2: Scalars['Float'];
  p25__energy_bi: Scalars['Float'];
  p25__energy_mono: Scalars['Float'];
  p25__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p25__ghi_whm2: Scalars['Float'];
  p25__ghi_wm2: Scalars['Float'];
  p25__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p25__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p25__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p25__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p25__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p25__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p25__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p25__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p25__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p25__inverter_output_energy_wh_bi: Scalars['Float'];
  p25__inverter_output_energy_wh_mono: Scalars['Float'];
  p25__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p25__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p25__inverter_output_power_w_bi: Scalars['Float'];
  p25__inverter_output_power_w_mono: Scalars['Float'];
  p25__line_energy_loss_wh_bi: Scalars['Float'];
  p25__line_energy_loss_wh_mono: Scalars['Float'];
  p25__line_power_loss_w_bi: Scalars['Float'];
  p25__line_power_loss_w_mono: Scalars['Float'];
  p25__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p25__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p25__line_receiving_end_power_w_bi: Scalars['Float'];
  p25__line_receiving_end_power_w_mono: Scalars['Float'];
  p25__line_sending_end_energy_wh_bi: Scalars['Float'];
  p25__line_sending_end_energy_wh_mono: Scalars['Float'];
  p25__line_sending_end_power_w_bi: Scalars['Float'];
  p25__line_sending_end_power_w_mono: Scalars['Float'];
  p25__num_panels_in_array: Scalars['Float'];
  p25__performance_ratio_bi: Scalars['Float'];
  p25__performance_ratio_mono: Scalars['Float'];
  p25__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__pv_power_no_degradation_w_bi: Scalars['Float'];
  p25__pv_power_no_degradation_w_mono: Scalars['Float'];
  p25__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p25__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p25__pv_power_no_soiling_w_bi: Scalars['Float'];
  p25__pv_power_no_soiling_w_mono: Scalars['Float'];
  p25__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p25__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p25__pv_power_with_degradation_w_bi: Scalars['Float'];
  p25__pv_power_with_degradation_w_mono: Scalars['Float'];
  p25__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p25__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p25__pv_power_with_soiling_w_bi: Scalars['Float'];
  p25__pv_power_with_soiling_w_mono: Scalars['Float'];
  p25__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p25__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p25__self_consumption_loss_w_bi: Scalars['Float'];
  p25__self_consumption_loss_w_mono: Scalars['Float'];
  p25__self_consumption_loss_wh_bi: Scalars['Float'];
  p25__self_consumption_loss_wh_mono: Scalars['Float'];
  p25__soiling_loss_w_bi: Scalars['Float'];
  p25__soiling_loss_w_mono: Scalars['Float'];
  p25__soiling_loss_wh_bi: Scalars['Float'];
  p25__soiling_loss_wh_mono: Scalars['Float'];
  p25__stc_pv_power: Scalars['Float'];
  p25__sun_azimuth_deg: Scalars['Float'];
  p25__sun_zenith_deg: Scalars['Float'];
  p25__temperature_c: Scalars['Float'];
  p25__temperature_derating_loss_w_bi: Scalars['Float'];
  p25__temperature_derating_loss_w_mono: Scalars['Float'];
  p25__temperature_derating_loss_wh_bi: Scalars['Float'];
  p25__temperature_derating_loss_wh_mono: Scalars['Float'];
  p25__total_degradation_loss_w_bi: Scalars['Float'];
  p25__total_degradation_loss_w_mono: Scalars['Float'];
  p25__total_degradation_loss_wh_bi: Scalars['Float'];
  p25__total_degradation_loss_wh_mono: Scalars['Float'];
  p25__total_inverter_loss_w_bi: Scalars['Float'];
  p25__total_inverter_loss_w_mono: Scalars['Float'];
  p25__total_inverter_loss_wh_bi: Scalars['Float'];
  p25__total_inverter_loss_wh_mono: Scalars['Float'];
  p25__transformer_copper_loss_w_bi: Scalars['Float'];
  p25__transformer_copper_loss_w_mono: Scalars['Float'];
  p25__transformer_copper_loss_wh_bi: Scalars['Float'];
  p25__transformer_copper_loss_wh_mono: Scalars['Float'];
  p25__transformer_energy_loss_wh_bi: Scalars['Float'];
  p25__transformer_energy_loss_wh_mono: Scalars['Float'];
  p25__transformer_input_energy_wh_bi: Scalars['Float'];
  p25__transformer_input_energy_wh_mono: Scalars['Float'];
  p25__transformer_input_power_w_bi: Scalars['Float'];
  p25__transformer_input_power_w_mono: Scalars['Float'];
  p25__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p25__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p25__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p25__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p25__transformer_output_energy_wh_bi: Scalars['Float'];
  p25__transformer_output_energy_wh_mono: Scalars['Float'];
  p25__transformer_output_power_w_bi: Scalars['Float'];
  p25__transformer_output_power_w_mono: Scalars['Float'];
  p25__transformer_power_loss_w_bi: Scalars['Float'];
  p25__transformer_power_loss_w_mono: Scalars['Float'];
  p25__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p25__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p25__transmission_line_power_loss_w_bi: Scalars['Float'];
  p25__transmission_line_power_loss_w_mono: Scalars['Float'];
  p25__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p25__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p25__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p25__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p25__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p25__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p25__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p25__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p50__above_max_temperature_loss_w_bi: Scalars['Float'];
  p50__above_max_temperature_loss_w_mono: Scalars['Float'];
  p50__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p50__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p50__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p50__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p50__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p50__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p50__air_mass: Scalars['Float'];
  p50__albedo?: Maybe<Scalars['Float']>;
  p50__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p50__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p50__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p50__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p50__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p50__available_energy_wh_bi: Scalars['Float'];
  p50__available_energy_wh_mono: Scalars['Float'];
  p50__available_power_w_bi: Scalars['Float'];
  p50__available_power_w_mono: Scalars['Float'];
  p50__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p50__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p50__below_min_temperature_loss_w_bi: Scalars['Float'];
  p50__below_min_temperature_loss_w_mono: Scalars['Float'];
  p50__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p50__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p50__bifaciality_current_ratio: Scalars['Float'];
  p50__center_module_inclined_irradiance: Scalars['Float'];
  p50__center_module_rear_inclined_irradiance: Scalars['Float'];
  p50__degradation_loss_first_year_w_bi: Scalars['Float'];
  p50__degradation_loss_first_year_w_mono: Scalars['Float'];
  p50__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p50__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p50__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p50__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p50__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p50__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p50__dhi_whm2: Scalars['Float'];
  p50__dhi_wm2: Scalars['Float'];
  p50__dni_whm2: Scalars['Float'];
  p50__dni_wm2: Scalars['Float'];
  p50__energy_bi: Scalars['Float'];
  p50__energy_mono: Scalars['Float'];
  p50__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p50__ghi_whm2: Scalars['Float'];
  p50__ghi_wm2: Scalars['Float'];
  p50__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p50__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p50__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p50__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p50__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p50__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p50__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p50__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p50__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p50__inverter_output_energy_wh_bi: Scalars['Float'];
  p50__inverter_output_energy_wh_mono: Scalars['Float'];
  p50__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p50__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p50__inverter_output_power_w_bi: Scalars['Float'];
  p50__inverter_output_power_w_mono: Scalars['Float'];
  p50__line_energy_loss_wh_bi: Scalars['Float'];
  p50__line_energy_loss_wh_mono: Scalars['Float'];
  p50__line_power_loss_w_bi: Scalars['Float'];
  p50__line_power_loss_w_mono: Scalars['Float'];
  p50__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p50__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p50__line_receiving_end_power_w_bi: Scalars['Float'];
  p50__line_receiving_end_power_w_mono: Scalars['Float'];
  p50__line_sending_end_energy_wh_bi: Scalars['Float'];
  p50__line_sending_end_energy_wh_mono: Scalars['Float'];
  p50__line_sending_end_power_w_bi: Scalars['Float'];
  p50__line_sending_end_power_w_mono: Scalars['Float'];
  p50__num_panels_in_array: Scalars['Float'];
  p50__performance_ratio_bi: Scalars['Float'];
  p50__performance_ratio_mono: Scalars['Float'];
  p50__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__pv_power_no_degradation_w_bi: Scalars['Float'];
  p50__pv_power_no_degradation_w_mono: Scalars['Float'];
  p50__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p50__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p50__pv_power_no_soiling_w_bi: Scalars['Float'];
  p50__pv_power_no_soiling_w_mono: Scalars['Float'];
  p50__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p50__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p50__pv_power_with_degradation_w_bi: Scalars['Float'];
  p50__pv_power_with_degradation_w_mono: Scalars['Float'];
  p50__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p50__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p50__pv_power_with_soiling_w_bi: Scalars['Float'];
  p50__pv_power_with_soiling_w_mono: Scalars['Float'];
  p50__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p50__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p50__self_consumption_loss_w_bi: Scalars['Float'];
  p50__self_consumption_loss_w_mono: Scalars['Float'];
  p50__self_consumption_loss_wh_bi: Scalars['Float'];
  p50__self_consumption_loss_wh_mono: Scalars['Float'];
  p50__soiling_loss_w_bi: Scalars['Float'];
  p50__soiling_loss_w_mono: Scalars['Float'];
  p50__soiling_loss_wh_bi: Scalars['Float'];
  p50__soiling_loss_wh_mono: Scalars['Float'];
  p50__stc_pv_power: Scalars['Float'];
  p50__sun_azimuth_deg: Scalars['Float'];
  p50__sun_zenith_deg: Scalars['Float'];
  p50__temperature_c: Scalars['Float'];
  p50__temperature_derating_loss_w_bi: Scalars['Float'];
  p50__temperature_derating_loss_w_mono: Scalars['Float'];
  p50__temperature_derating_loss_wh_bi: Scalars['Float'];
  p50__temperature_derating_loss_wh_mono: Scalars['Float'];
  p50__total_degradation_loss_w_bi: Scalars['Float'];
  p50__total_degradation_loss_w_mono: Scalars['Float'];
  p50__total_degradation_loss_wh_bi: Scalars['Float'];
  p50__total_degradation_loss_wh_mono: Scalars['Float'];
  p50__total_inverter_loss_w_bi: Scalars['Float'];
  p50__total_inverter_loss_w_mono: Scalars['Float'];
  p50__total_inverter_loss_wh_bi: Scalars['Float'];
  p50__total_inverter_loss_wh_mono: Scalars['Float'];
  p50__transformer_copper_loss_w_bi: Scalars['Float'];
  p50__transformer_copper_loss_w_mono: Scalars['Float'];
  p50__transformer_copper_loss_wh_bi: Scalars['Float'];
  p50__transformer_copper_loss_wh_mono: Scalars['Float'];
  p50__transformer_energy_loss_wh_bi: Scalars['Float'];
  p50__transformer_energy_loss_wh_mono: Scalars['Float'];
  p50__transformer_input_energy_wh_bi: Scalars['Float'];
  p50__transformer_input_energy_wh_mono: Scalars['Float'];
  p50__transformer_input_power_w_bi: Scalars['Float'];
  p50__transformer_input_power_w_mono: Scalars['Float'];
  p50__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p50__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p50__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p50__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p50__transformer_output_energy_wh_bi: Scalars['Float'];
  p50__transformer_output_energy_wh_mono: Scalars['Float'];
  p50__transformer_output_power_w_bi: Scalars['Float'];
  p50__transformer_output_power_w_mono: Scalars['Float'];
  p50__transformer_power_loss_w_bi: Scalars['Float'];
  p50__transformer_power_loss_w_mono: Scalars['Float'];
  p50__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p50__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p50__transmission_line_power_loss_w_bi: Scalars['Float'];
  p50__transmission_line_power_loss_w_mono: Scalars['Float'];
  p50__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p50__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p50__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p50__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p50__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p50__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p50__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p50__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p75__above_max_temperature_loss_w_bi: Scalars['Float'];
  p75__above_max_temperature_loss_w_mono: Scalars['Float'];
  p75__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p75__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p75__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p75__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p75__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p75__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p75__air_mass: Scalars['Float'];
  p75__albedo?: Maybe<Scalars['Float']>;
  p75__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p75__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p75__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p75__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p75__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p75__available_energy_wh_bi: Scalars['Float'];
  p75__available_energy_wh_mono: Scalars['Float'];
  p75__available_power_w_bi: Scalars['Float'];
  p75__available_power_w_mono: Scalars['Float'];
  p75__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p75__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p75__below_min_temperature_loss_w_bi: Scalars['Float'];
  p75__below_min_temperature_loss_w_mono: Scalars['Float'];
  p75__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p75__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p75__bifaciality_current_ratio: Scalars['Float'];
  p75__center_module_inclined_irradiance: Scalars['Float'];
  p75__center_module_rear_inclined_irradiance: Scalars['Float'];
  p75__degradation_loss_first_year_w_bi: Scalars['Float'];
  p75__degradation_loss_first_year_w_mono: Scalars['Float'];
  p75__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p75__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p75__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p75__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p75__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p75__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p75__dhi_whm2: Scalars['Float'];
  p75__dhi_wm2: Scalars['Float'];
  p75__dni_whm2: Scalars['Float'];
  p75__dni_wm2: Scalars['Float'];
  p75__energy_bi: Scalars['Float'];
  p75__energy_mono: Scalars['Float'];
  p75__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p75__ghi_whm2: Scalars['Float'];
  p75__ghi_wm2: Scalars['Float'];
  p75__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p75__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p75__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p75__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p75__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p75__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p75__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p75__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p75__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p75__inverter_output_energy_wh_bi: Scalars['Float'];
  p75__inverter_output_energy_wh_mono: Scalars['Float'];
  p75__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p75__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p75__inverter_output_power_w_bi: Scalars['Float'];
  p75__inverter_output_power_w_mono: Scalars['Float'];
  p75__line_energy_loss_wh_bi: Scalars['Float'];
  p75__line_energy_loss_wh_mono: Scalars['Float'];
  p75__line_power_loss_w_bi: Scalars['Float'];
  p75__line_power_loss_w_mono: Scalars['Float'];
  p75__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p75__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p75__line_receiving_end_power_w_bi: Scalars['Float'];
  p75__line_receiving_end_power_w_mono: Scalars['Float'];
  p75__line_sending_end_energy_wh_bi: Scalars['Float'];
  p75__line_sending_end_energy_wh_mono: Scalars['Float'];
  p75__line_sending_end_power_w_bi: Scalars['Float'];
  p75__line_sending_end_power_w_mono: Scalars['Float'];
  p75__num_panels_in_array: Scalars['Float'];
  p75__performance_ratio_bi: Scalars['Float'];
  p75__performance_ratio_mono: Scalars['Float'];
  p75__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__pv_power_no_degradation_w_bi: Scalars['Float'];
  p75__pv_power_no_degradation_w_mono: Scalars['Float'];
  p75__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p75__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p75__pv_power_no_soiling_w_bi: Scalars['Float'];
  p75__pv_power_no_soiling_w_mono: Scalars['Float'];
  p75__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p75__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p75__pv_power_with_degradation_w_bi: Scalars['Float'];
  p75__pv_power_with_degradation_w_mono: Scalars['Float'];
  p75__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p75__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p75__pv_power_with_soiling_w_bi: Scalars['Float'];
  p75__pv_power_with_soiling_w_mono: Scalars['Float'];
  p75__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p75__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p75__self_consumption_loss_w_bi: Scalars['Float'];
  p75__self_consumption_loss_w_mono: Scalars['Float'];
  p75__self_consumption_loss_wh_bi: Scalars['Float'];
  p75__self_consumption_loss_wh_mono: Scalars['Float'];
  p75__soiling_loss_w_bi: Scalars['Float'];
  p75__soiling_loss_w_mono: Scalars['Float'];
  p75__soiling_loss_wh_bi: Scalars['Float'];
  p75__soiling_loss_wh_mono: Scalars['Float'];
  p75__stc_pv_power: Scalars['Float'];
  p75__sun_azimuth_deg: Scalars['Float'];
  p75__sun_zenith_deg: Scalars['Float'];
  p75__temperature_c: Scalars['Float'];
  p75__temperature_derating_loss_w_bi: Scalars['Float'];
  p75__temperature_derating_loss_w_mono: Scalars['Float'];
  p75__temperature_derating_loss_wh_bi: Scalars['Float'];
  p75__temperature_derating_loss_wh_mono: Scalars['Float'];
  p75__total_degradation_loss_w_bi: Scalars['Float'];
  p75__total_degradation_loss_w_mono: Scalars['Float'];
  p75__total_degradation_loss_wh_bi: Scalars['Float'];
  p75__total_degradation_loss_wh_mono: Scalars['Float'];
  p75__total_inverter_loss_w_bi: Scalars['Float'];
  p75__total_inverter_loss_w_mono: Scalars['Float'];
  p75__total_inverter_loss_wh_bi: Scalars['Float'];
  p75__total_inverter_loss_wh_mono: Scalars['Float'];
  p75__transformer_copper_loss_w_bi: Scalars['Float'];
  p75__transformer_copper_loss_w_mono: Scalars['Float'];
  p75__transformer_copper_loss_wh_bi: Scalars['Float'];
  p75__transformer_copper_loss_wh_mono: Scalars['Float'];
  p75__transformer_energy_loss_wh_bi: Scalars['Float'];
  p75__transformer_energy_loss_wh_mono: Scalars['Float'];
  p75__transformer_input_energy_wh_bi: Scalars['Float'];
  p75__transformer_input_energy_wh_mono: Scalars['Float'];
  p75__transformer_input_power_w_bi: Scalars['Float'];
  p75__transformer_input_power_w_mono: Scalars['Float'];
  p75__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p75__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p75__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p75__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p75__transformer_output_energy_wh_bi: Scalars['Float'];
  p75__transformer_output_energy_wh_mono: Scalars['Float'];
  p75__transformer_output_power_w_bi: Scalars['Float'];
  p75__transformer_output_power_w_mono: Scalars['Float'];
  p75__transformer_power_loss_w_bi: Scalars['Float'];
  p75__transformer_power_loss_w_mono: Scalars['Float'];
  p75__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p75__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p75__transmission_line_power_loss_w_bi: Scalars['Float'];
  p75__transmission_line_power_loss_w_mono: Scalars['Float'];
  p75__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p75__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p75__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p75__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p75__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p75__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p75__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p75__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p90__above_max_temperature_loss_w_bi: Scalars['Float'];
  p90__above_max_temperature_loss_w_mono: Scalars['Float'];
  p90__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p90__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p90__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p90__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p90__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p90__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p90__air_mass: Scalars['Float'];
  p90__albedo?: Maybe<Scalars['Float']>;
  p90__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p90__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p90__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p90__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p90__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p90__available_energy_wh_bi: Scalars['Float'];
  p90__available_energy_wh_mono: Scalars['Float'];
  p90__available_power_w_bi: Scalars['Float'];
  p90__available_power_w_mono: Scalars['Float'];
  p90__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p90__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p90__below_min_temperature_loss_w_bi: Scalars['Float'];
  p90__below_min_temperature_loss_w_mono: Scalars['Float'];
  p90__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p90__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p90__bifaciality_current_ratio: Scalars['Float'];
  p90__center_module_inclined_irradiance: Scalars['Float'];
  p90__center_module_rear_inclined_irradiance: Scalars['Float'];
  p90__degradation_loss_first_year_w_bi: Scalars['Float'];
  p90__degradation_loss_first_year_w_mono: Scalars['Float'];
  p90__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p90__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p90__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p90__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p90__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p90__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p90__dhi_whm2: Scalars['Float'];
  p90__dhi_wm2: Scalars['Float'];
  p90__dni_whm2: Scalars['Float'];
  p90__dni_wm2: Scalars['Float'];
  p90__energy_bi: Scalars['Float'];
  p90__energy_mono: Scalars['Float'];
  p90__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p90__ghi_whm2: Scalars['Float'];
  p90__ghi_wm2: Scalars['Float'];
  p90__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p90__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p90__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p90__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p90__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p90__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p90__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p90__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p90__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p90__inverter_output_energy_wh_bi: Scalars['Float'];
  p90__inverter_output_energy_wh_mono: Scalars['Float'];
  p90__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p90__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p90__inverter_output_power_w_bi: Scalars['Float'];
  p90__inverter_output_power_w_mono: Scalars['Float'];
  p90__line_energy_loss_wh_bi: Scalars['Float'];
  p90__line_energy_loss_wh_mono: Scalars['Float'];
  p90__line_power_loss_w_bi: Scalars['Float'];
  p90__line_power_loss_w_mono: Scalars['Float'];
  p90__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p90__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p90__line_receiving_end_power_w_bi: Scalars['Float'];
  p90__line_receiving_end_power_w_mono: Scalars['Float'];
  p90__line_sending_end_energy_wh_bi: Scalars['Float'];
  p90__line_sending_end_energy_wh_mono: Scalars['Float'];
  p90__line_sending_end_power_w_bi: Scalars['Float'];
  p90__line_sending_end_power_w_mono: Scalars['Float'];
  p90__num_panels_in_array: Scalars['Float'];
  p90__performance_ratio_bi: Scalars['Float'];
  p90__performance_ratio_mono: Scalars['Float'];
  p90__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__pv_power_no_degradation_w_bi: Scalars['Float'];
  p90__pv_power_no_degradation_w_mono: Scalars['Float'];
  p90__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p90__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p90__pv_power_no_soiling_w_bi: Scalars['Float'];
  p90__pv_power_no_soiling_w_mono: Scalars['Float'];
  p90__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p90__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p90__pv_power_with_degradation_w_bi: Scalars['Float'];
  p90__pv_power_with_degradation_w_mono: Scalars['Float'];
  p90__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p90__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p90__pv_power_with_soiling_w_bi: Scalars['Float'];
  p90__pv_power_with_soiling_w_mono: Scalars['Float'];
  p90__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p90__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p90__self_consumption_loss_w_bi: Scalars['Float'];
  p90__self_consumption_loss_w_mono: Scalars['Float'];
  p90__self_consumption_loss_wh_bi: Scalars['Float'];
  p90__self_consumption_loss_wh_mono: Scalars['Float'];
  p90__soiling_loss_w_bi: Scalars['Float'];
  p90__soiling_loss_w_mono: Scalars['Float'];
  p90__soiling_loss_wh_bi: Scalars['Float'];
  p90__soiling_loss_wh_mono: Scalars['Float'];
  p90__stc_pv_power: Scalars['Float'];
  p90__sun_azimuth_deg: Scalars['Float'];
  p90__sun_zenith_deg: Scalars['Float'];
  p90__temperature_c: Scalars['Float'];
  p90__temperature_derating_loss_w_bi: Scalars['Float'];
  p90__temperature_derating_loss_w_mono: Scalars['Float'];
  p90__temperature_derating_loss_wh_bi: Scalars['Float'];
  p90__temperature_derating_loss_wh_mono: Scalars['Float'];
  p90__total_degradation_loss_w_bi: Scalars['Float'];
  p90__total_degradation_loss_w_mono: Scalars['Float'];
  p90__total_degradation_loss_wh_bi: Scalars['Float'];
  p90__total_degradation_loss_wh_mono: Scalars['Float'];
  p90__total_inverter_loss_w_bi: Scalars['Float'];
  p90__total_inverter_loss_w_mono: Scalars['Float'];
  p90__total_inverter_loss_wh_bi: Scalars['Float'];
  p90__total_inverter_loss_wh_mono: Scalars['Float'];
  p90__transformer_copper_loss_w_bi: Scalars['Float'];
  p90__transformer_copper_loss_w_mono: Scalars['Float'];
  p90__transformer_copper_loss_wh_bi: Scalars['Float'];
  p90__transformer_copper_loss_wh_mono: Scalars['Float'];
  p90__transformer_energy_loss_wh_bi: Scalars['Float'];
  p90__transformer_energy_loss_wh_mono: Scalars['Float'];
  p90__transformer_input_energy_wh_bi: Scalars['Float'];
  p90__transformer_input_energy_wh_mono: Scalars['Float'];
  p90__transformer_input_power_w_bi: Scalars['Float'];
  p90__transformer_input_power_w_mono: Scalars['Float'];
  p90__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p90__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p90__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p90__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p90__transformer_output_energy_wh_bi: Scalars['Float'];
  p90__transformer_output_energy_wh_mono: Scalars['Float'];
  p90__transformer_output_power_w_bi: Scalars['Float'];
  p90__transformer_output_power_w_mono: Scalars['Float'];
  p90__transformer_power_loss_w_bi: Scalars['Float'];
  p90__transformer_power_loss_w_mono: Scalars['Float'];
  p90__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p90__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p90__transmission_line_power_loss_w_bi: Scalars['Float'];
  p90__transmission_line_power_loss_w_mono: Scalars['Float'];
  p90__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p90__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p90__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p90__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p90__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p90__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p90__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p90__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  sum__above_max_temperature_loss_w_bi: Scalars['Float'];
  sum__above_max_temperature_loss_w_mono: Scalars['Float'];
  sum__above_max_temperature_loss_wh_bi: Scalars['Float'];
  sum__above_max_temperature_loss_wh_mono: Scalars['Float'];
  sum__ac_power_clipping_loss_w_bi: Scalars['Float'];
  sum__ac_power_clipping_loss_w_mono: Scalars['Float'];
  sum__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  sum__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  sum__air_mass: Scalars['Float'];
  sum__albedo?: Maybe<Scalars['Float']>;
  sum__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  sum__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  sum__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  sum__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  sum__array_string_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_string_energy_mono?: Maybe<Scalars['Float']>;
  sum__available_energy_wh_bi: Scalars['Float'];
  sum__available_energy_wh_mono: Scalars['Float'];
  sum__available_power_w_bi: Scalars['Float'];
  sum__available_power_w_mono: Scalars['Float'];
  sum__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  sum__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  sum__below_min_temperature_loss_w_bi: Scalars['Float'];
  sum__below_min_temperature_loss_w_mono: Scalars['Float'];
  sum__below_min_temperature_loss_wh_bi: Scalars['Float'];
  sum__below_min_temperature_loss_wh_mono: Scalars['Float'];
  sum__bifaciality_current_ratio: Scalars['Float'];
  sum__center_module_inclined_irradiance: Scalars['Float'];
  sum__center_module_rear_inclined_irradiance: Scalars['Float'];
  sum__degradation_loss_first_year_w_bi: Scalars['Float'];
  sum__degradation_loss_first_year_w_mono: Scalars['Float'];
  sum__degradation_loss_first_year_wh_bi: Scalars['Float'];
  sum__degradation_loss_first_year_wh_mono: Scalars['Float'];
  sum__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  sum__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  sum__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  sum__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  sum__dhi_whm2: Scalars['Float'];
  sum__dhi_wm2: Scalars['Float'];
  sum__dni_whm2: Scalars['Float'];
  sum__dni_wm2: Scalars['Float'];
  sum__energy_bi: Scalars['Float'];
  sum__energy_mono: Scalars['Float'];
  sum__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  sum__ghi_whm2: Scalars['Float'];
  sum__ghi_wm2: Scalars['Float'];
  sum__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  sum__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  sum__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  sum__inverter_night_tare_loss_w_bi: Scalars['Float'];
  sum__inverter_night_tare_loss_w_mono: Scalars['Float'];
  sum__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  sum__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  sum__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  sum__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  sum__inverter_output_energy_wh_bi: Scalars['Float'];
  sum__inverter_output_energy_wh_mono: Scalars['Float'];
  sum__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  sum__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  sum__inverter_output_power_w_bi: Scalars['Float'];
  sum__inverter_output_power_w_mono: Scalars['Float'];
  sum__line_energy_loss_wh_bi: Scalars['Float'];
  sum__line_energy_loss_wh_mono: Scalars['Float'];
  sum__line_power_loss_w_bi: Scalars['Float'];
  sum__line_power_loss_w_mono: Scalars['Float'];
  sum__line_receiving_end_energy_wh_bi: Scalars['Float'];
  sum__line_receiving_end_energy_wh_mono: Scalars['Float'];
  sum__line_receiving_end_power_w_bi: Scalars['Float'];
  sum__line_receiving_end_power_w_mono: Scalars['Float'];
  sum__line_sending_end_energy_wh_bi: Scalars['Float'];
  sum__line_sending_end_energy_wh_mono: Scalars['Float'];
  sum__line_sending_end_power_w_bi: Scalars['Float'];
  sum__line_sending_end_power_w_mono: Scalars['Float'];
  sum__num_panels_in_array: Scalars['Float'];
  sum__performance_ratio_bi: Scalars['Float'];
  sum__performance_ratio_mono: Scalars['Float'];
  sum__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__pv_power_no_degradation_w_bi: Scalars['Float'];
  sum__pv_power_no_degradation_w_mono: Scalars['Float'];
  sum__pv_power_no_degradation_wh_bi: Scalars['Float'];
  sum__pv_power_no_degradation_wh_mono: Scalars['Float'];
  sum__pv_power_no_soiling_w_bi: Scalars['Float'];
  sum__pv_power_no_soiling_w_mono: Scalars['Float'];
  sum__pv_power_no_soiling_wh_bi: Scalars['Float'];
  sum__pv_power_no_soiling_wh_mono: Scalars['Float'];
  sum__pv_power_with_degradation_w_bi: Scalars['Float'];
  sum__pv_power_with_degradation_w_mono: Scalars['Float'];
  sum__pv_power_with_degradation_wh_bi: Scalars['Float'];
  sum__pv_power_with_degradation_wh_mono: Scalars['Float'];
  sum__pv_power_with_soiling_w_bi: Scalars['Float'];
  sum__pv_power_with_soiling_w_mono: Scalars['Float'];
  sum__pv_power_with_soiling_wh_bi: Scalars['Float'];
  sum__pv_power_with_soiling_wh_mono: Scalars['Float'];
  sum__self_consumption_loss_w_bi: Scalars['Float'];
  sum__self_consumption_loss_w_mono: Scalars['Float'];
  sum__self_consumption_loss_wh_bi: Scalars['Float'];
  sum__self_consumption_loss_wh_mono: Scalars['Float'];
  sum__soiling_loss_w_bi: Scalars['Float'];
  sum__soiling_loss_w_mono: Scalars['Float'];
  sum__soiling_loss_wh_bi: Scalars['Float'];
  sum__soiling_loss_wh_mono: Scalars['Float'];
  sum__stc_pv_power: Scalars['Float'];
  sum__sun_azimuth_deg: Scalars['Float'];
  sum__sun_zenith_deg: Scalars['Float'];
  sum__temperature_c: Scalars['Float'];
  sum__temperature_derating_loss_w_bi: Scalars['Float'];
  sum__temperature_derating_loss_w_mono: Scalars['Float'];
  sum__temperature_derating_loss_wh_bi: Scalars['Float'];
  sum__temperature_derating_loss_wh_mono: Scalars['Float'];
  sum__total_degradation_loss_w_bi: Scalars['Float'];
  sum__total_degradation_loss_w_mono: Scalars['Float'];
  sum__total_degradation_loss_wh_bi: Scalars['Float'];
  sum__total_degradation_loss_wh_mono: Scalars['Float'];
  sum__total_inverter_loss_w_bi: Scalars['Float'];
  sum__total_inverter_loss_w_mono: Scalars['Float'];
  sum__total_inverter_loss_wh_bi: Scalars['Float'];
  sum__total_inverter_loss_wh_mono: Scalars['Float'];
  sum__transformer_copper_loss_w_bi: Scalars['Float'];
  sum__transformer_copper_loss_w_mono: Scalars['Float'];
  sum__transformer_copper_loss_wh_bi: Scalars['Float'];
  sum__transformer_copper_loss_wh_mono: Scalars['Float'];
  sum__transformer_energy_loss_wh_bi: Scalars['Float'];
  sum__transformer_energy_loss_wh_mono: Scalars['Float'];
  sum__transformer_input_energy_wh_bi: Scalars['Float'];
  sum__transformer_input_energy_wh_mono: Scalars['Float'];
  sum__transformer_input_power_w_bi: Scalars['Float'];
  sum__transformer_input_power_w_mono: Scalars['Float'];
  sum__transformer_iron_core_loss_w_bi: Scalars['Float'];
  sum__transformer_iron_core_loss_w_mono: Scalars['Float'];
  sum__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  sum__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  sum__transformer_output_energy_wh_bi: Scalars['Float'];
  sum__transformer_output_energy_wh_mono: Scalars['Float'];
  sum__transformer_output_power_w_bi: Scalars['Float'];
  sum__transformer_output_power_w_mono: Scalars['Float'];
  sum__transformer_power_loss_w_bi: Scalars['Float'];
  sum__transformer_power_loss_w_mono: Scalars['Float'];
  sum__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  sum__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  sum__transmission_line_power_loss_w_bi: Scalars['Float'];
  sum__transmission_line_power_loss_w_mono: Scalars['Float'];
  sum__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  sum__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  sum__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  sum__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  sum__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  sum__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  sum__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  sum__transmission_line_sending_end_power_w_mono: Scalars['Float'];
};

export type SimulationTimeSeriesDrillDown = {
  __typename?: 'SimulationTimeSeriesDrillDown';
  avg: Scalars['Float'];
  count: Scalars['Float'];
  dt_timestamp: Scalars['DateTime'];
  max: Scalars['Float'];
  min: Scalars['Float'];
  p10: Scalars['Float'];
  p25: Scalars['Float'];
  p50: Scalars['Float'];
  p75: Scalars['Float'];
  p90: Scalars['Float'];
  sum: Scalars['Float'];
};

export type SimulationTimeSeriesSummary = SimulationAggregatedMeasures & {
  __typename?: 'SimulationTimeSeriesSummary';
  avg__above_max_temperature_loss_w_bi: Scalars['Float'];
  avg__above_max_temperature_loss_w_mono: Scalars['Float'];
  avg__above_max_temperature_loss_wh_bi: Scalars['Float'];
  avg__above_max_temperature_loss_wh_mono: Scalars['Float'];
  avg__ac_power_clipping_loss_w_bi: Scalars['Float'];
  avg__ac_power_clipping_loss_w_mono: Scalars['Float'];
  avg__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  avg__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  avg__air_mass: Scalars['Float'];
  avg__albedo?: Maybe<Scalars['Float']>;
  avg__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  avg__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  avg__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  avg__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  avg__array_string_energy_bi?: Maybe<Scalars['Float']>;
  avg__array_string_energy_mono?: Maybe<Scalars['Float']>;
  avg__available_energy_wh_bi: Scalars['Float'];
  avg__available_energy_wh_mono: Scalars['Float'];
  avg__available_power_w_bi: Scalars['Float'];
  avg__available_power_w_mono: Scalars['Float'];
  avg__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  avg__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  avg__below_min_temperature_loss_w_bi: Scalars['Float'];
  avg__below_min_temperature_loss_w_mono: Scalars['Float'];
  avg__below_min_temperature_loss_wh_bi: Scalars['Float'];
  avg__below_min_temperature_loss_wh_mono: Scalars['Float'];
  avg__bifaciality_current_ratio: Scalars['Float'];
  avg__center_module_inclined_irradiance: Scalars['Float'];
  avg__center_module_rear_inclined_irradiance: Scalars['Float'];
  avg__degradation_loss_first_year_w_bi: Scalars['Float'];
  avg__degradation_loss_first_year_w_mono: Scalars['Float'];
  avg__degradation_loss_first_year_wh_bi: Scalars['Float'];
  avg__degradation_loss_first_year_wh_mono: Scalars['Float'];
  avg__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  avg__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  avg__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  avg__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  avg__dhi_whm2: Scalars['Float'];
  avg__dhi_wm2: Scalars['Float'];
  avg__dni_whm2: Scalars['Float'];
  avg__dni_wm2: Scalars['Float'];
  avg__energy_bi: Scalars['Float'];
  avg__energy_mono: Scalars['Float'];
  avg__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  avg__ghi_whm2: Scalars['Float'];
  avg__ghi_wm2: Scalars['Float'];
  avg__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  avg__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  avg__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  avg__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  avg__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  avg__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  avg__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  avg__inverter_night_tare_loss_w_bi: Scalars['Float'];
  avg__inverter_night_tare_loss_w_mono: Scalars['Float'];
  avg__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  avg__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  avg__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  avg__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  avg__inverter_output_energy_wh_bi: Scalars['Float'];
  avg__inverter_output_energy_wh_mono: Scalars['Float'];
  avg__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  avg__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  avg__inverter_output_power_w_bi: Scalars['Float'];
  avg__inverter_output_power_w_mono: Scalars['Float'];
  avg__line_energy_loss_wh_bi: Scalars['Float'];
  avg__line_energy_loss_wh_mono: Scalars['Float'];
  avg__line_power_loss_w_bi: Scalars['Float'];
  avg__line_power_loss_w_mono: Scalars['Float'];
  avg__line_receiving_end_energy_wh_bi: Scalars['Float'];
  avg__line_receiving_end_energy_wh_mono: Scalars['Float'];
  avg__line_receiving_end_power_w_bi: Scalars['Float'];
  avg__line_receiving_end_power_w_mono: Scalars['Float'];
  avg__line_sending_end_energy_wh_bi: Scalars['Float'];
  avg__line_sending_end_energy_wh_mono: Scalars['Float'];
  avg__line_sending_end_power_w_bi: Scalars['Float'];
  avg__line_sending_end_power_w_mono: Scalars['Float'];
  avg__num_panels_in_array: Scalars['Float'];
  avg__performance_ratio_bi: Scalars['Float'];
  avg__performance_ratio_mono: Scalars['Float'];
  avg__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  avg__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  avg__pv_power_no_degradation_w_bi: Scalars['Float'];
  avg__pv_power_no_degradation_w_mono: Scalars['Float'];
  avg__pv_power_no_degradation_wh_bi: Scalars['Float'];
  avg__pv_power_no_degradation_wh_mono: Scalars['Float'];
  avg__pv_power_no_soiling_w_bi: Scalars['Float'];
  avg__pv_power_no_soiling_w_mono: Scalars['Float'];
  avg__pv_power_no_soiling_wh_bi: Scalars['Float'];
  avg__pv_power_no_soiling_wh_mono: Scalars['Float'];
  avg__pv_power_with_degradation_w_bi: Scalars['Float'];
  avg__pv_power_with_degradation_w_mono: Scalars['Float'];
  avg__pv_power_with_degradation_wh_bi: Scalars['Float'];
  avg__pv_power_with_degradation_wh_mono: Scalars['Float'];
  avg__pv_power_with_soiling_w_bi: Scalars['Float'];
  avg__pv_power_with_soiling_w_mono: Scalars['Float'];
  avg__pv_power_with_soiling_wh_bi: Scalars['Float'];
  avg__pv_power_with_soiling_wh_mono: Scalars['Float'];
  avg__self_consumption_loss_w_bi: Scalars['Float'];
  avg__self_consumption_loss_w_mono: Scalars['Float'];
  avg__self_consumption_loss_wh_bi: Scalars['Float'];
  avg__self_consumption_loss_wh_mono: Scalars['Float'];
  avg__soiling_loss_w_bi: Scalars['Float'];
  avg__soiling_loss_w_mono: Scalars['Float'];
  avg__soiling_loss_wh_bi: Scalars['Float'];
  avg__soiling_loss_wh_mono: Scalars['Float'];
  avg__stc_pv_power: Scalars['Float'];
  avg__sun_azimuth_deg: Scalars['Float'];
  avg__sun_zenith_deg: Scalars['Float'];
  avg__temperature_c: Scalars['Float'];
  avg__temperature_derating_loss_w_bi: Scalars['Float'];
  avg__temperature_derating_loss_w_mono: Scalars['Float'];
  avg__temperature_derating_loss_wh_bi: Scalars['Float'];
  avg__temperature_derating_loss_wh_mono: Scalars['Float'];
  avg__total_degradation_loss_w_bi: Scalars['Float'];
  avg__total_degradation_loss_w_mono: Scalars['Float'];
  avg__total_degradation_loss_wh_bi: Scalars['Float'];
  avg__total_degradation_loss_wh_mono: Scalars['Float'];
  avg__total_inverter_loss_w_bi: Scalars['Float'];
  avg__total_inverter_loss_w_mono: Scalars['Float'];
  avg__total_inverter_loss_wh_bi: Scalars['Float'];
  avg__total_inverter_loss_wh_mono: Scalars['Float'];
  avg__transformer_copper_loss_w_bi: Scalars['Float'];
  avg__transformer_copper_loss_w_mono: Scalars['Float'];
  avg__transformer_copper_loss_wh_bi: Scalars['Float'];
  avg__transformer_copper_loss_wh_mono: Scalars['Float'];
  avg__transformer_energy_loss_wh_bi: Scalars['Float'];
  avg__transformer_energy_loss_wh_mono: Scalars['Float'];
  avg__transformer_input_energy_wh_bi: Scalars['Float'];
  avg__transformer_input_energy_wh_mono: Scalars['Float'];
  avg__transformer_input_power_w_bi: Scalars['Float'];
  avg__transformer_input_power_w_mono: Scalars['Float'];
  avg__transformer_iron_core_loss_w_bi: Scalars['Float'];
  avg__transformer_iron_core_loss_w_mono: Scalars['Float'];
  avg__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  avg__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  avg__transformer_output_energy_wh_bi: Scalars['Float'];
  avg__transformer_output_energy_wh_mono: Scalars['Float'];
  avg__transformer_output_power_w_bi: Scalars['Float'];
  avg__transformer_output_power_w_mono: Scalars['Float'];
  avg__transformer_power_loss_w_bi: Scalars['Float'];
  avg__transformer_power_loss_w_mono: Scalars['Float'];
  avg__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  avg__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  avg__transmission_line_power_loss_w_bi: Scalars['Float'];
  avg__transmission_line_power_loss_w_mono: Scalars['Float'];
  avg__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  avg__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  avg__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  avg__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  avg__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  avg__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  avg__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  avg__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  count__above_max_temperature_loss_w_bi: Scalars['Float'];
  count__above_max_temperature_loss_w_mono: Scalars['Float'];
  count__above_max_temperature_loss_wh_bi: Scalars['Float'];
  count__above_max_temperature_loss_wh_mono: Scalars['Float'];
  count__ac_power_clipping_loss_w_bi: Scalars['Float'];
  count__ac_power_clipping_loss_w_mono: Scalars['Float'];
  count__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  count__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  count__air_mass: Scalars['Float'];
  count__albedo?: Maybe<Scalars['Float']>;
  count__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  count__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  count__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  count__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  count__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  count__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  count__array_string_energy_bi?: Maybe<Scalars['Float']>;
  count__array_string_energy_mono?: Maybe<Scalars['Float']>;
  count__available_energy_wh_bi: Scalars['Float'];
  count__available_energy_wh_mono: Scalars['Float'];
  count__available_power_w_bi: Scalars['Float'];
  count__available_power_w_mono: Scalars['Float'];
  count__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  count__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  count__below_min_temperature_loss_w_bi: Scalars['Float'];
  count__below_min_temperature_loss_w_mono: Scalars['Float'];
  count__below_min_temperature_loss_wh_bi: Scalars['Float'];
  count__below_min_temperature_loss_wh_mono: Scalars['Float'];
  count__bifaciality_current_ratio: Scalars['Float'];
  count__center_module_inclined_irradiance: Scalars['Float'];
  count__center_module_rear_inclined_irradiance: Scalars['Float'];
  count__degradation_loss_first_year_w_bi: Scalars['Float'];
  count__degradation_loss_first_year_w_mono: Scalars['Float'];
  count__degradation_loss_first_year_wh_bi: Scalars['Float'];
  count__degradation_loss_first_year_wh_mono: Scalars['Float'];
  count__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  count__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  count__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  count__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  count__dhi_whm2: Scalars['Float'];
  count__dhi_wm2: Scalars['Float'];
  count__dni_whm2: Scalars['Float'];
  count__dni_wm2: Scalars['Float'];
  count__energy_bi: Scalars['Float'];
  count__energy_mono: Scalars['Float'];
  count__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  count__ghi_whm2: Scalars['Float'];
  count__ghi_wm2: Scalars['Float'];
  count__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  count__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  count__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  count__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  count__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  count__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  count__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  count__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  count__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  count__inverter_night_tare_loss_w_bi: Scalars['Float'];
  count__inverter_night_tare_loss_w_mono: Scalars['Float'];
  count__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  count__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  count__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  count__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  count__inverter_output_energy_wh_bi: Scalars['Float'];
  count__inverter_output_energy_wh_mono: Scalars['Float'];
  count__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  count__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  count__inverter_output_power_w_bi: Scalars['Float'];
  count__inverter_output_power_w_mono: Scalars['Float'];
  count__line_energy_loss_wh_bi: Scalars['Float'];
  count__line_energy_loss_wh_mono: Scalars['Float'];
  count__line_power_loss_w_bi: Scalars['Float'];
  count__line_power_loss_w_mono: Scalars['Float'];
  count__line_receiving_end_energy_wh_bi: Scalars['Float'];
  count__line_receiving_end_energy_wh_mono: Scalars['Float'];
  count__line_receiving_end_power_w_bi: Scalars['Float'];
  count__line_receiving_end_power_w_mono: Scalars['Float'];
  count__line_sending_end_energy_wh_bi: Scalars['Float'];
  count__line_sending_end_energy_wh_mono: Scalars['Float'];
  count__line_sending_end_power_w_bi: Scalars['Float'];
  count__line_sending_end_power_w_mono: Scalars['Float'];
  count__num_panels_in_array: Scalars['Float'];
  count__performance_ratio_bi: Scalars['Float'];
  count__performance_ratio_mono: Scalars['Float'];
  count__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  count__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  count__pv_power_no_degradation_w_bi: Scalars['Float'];
  count__pv_power_no_degradation_w_mono: Scalars['Float'];
  count__pv_power_no_degradation_wh_bi: Scalars['Float'];
  count__pv_power_no_degradation_wh_mono: Scalars['Float'];
  count__pv_power_no_soiling_w_bi: Scalars['Float'];
  count__pv_power_no_soiling_w_mono: Scalars['Float'];
  count__pv_power_no_soiling_wh_bi: Scalars['Float'];
  count__pv_power_no_soiling_wh_mono: Scalars['Float'];
  count__pv_power_with_degradation_w_bi: Scalars['Float'];
  count__pv_power_with_degradation_w_mono: Scalars['Float'];
  count__pv_power_with_degradation_wh_bi: Scalars['Float'];
  count__pv_power_with_degradation_wh_mono: Scalars['Float'];
  count__pv_power_with_soiling_w_bi: Scalars['Float'];
  count__pv_power_with_soiling_w_mono: Scalars['Float'];
  count__pv_power_with_soiling_wh_bi: Scalars['Float'];
  count__pv_power_with_soiling_wh_mono: Scalars['Float'];
  count__self_consumption_loss_w_bi: Scalars['Float'];
  count__self_consumption_loss_w_mono: Scalars['Float'];
  count__self_consumption_loss_wh_bi: Scalars['Float'];
  count__self_consumption_loss_wh_mono: Scalars['Float'];
  count__soiling_loss_w_bi: Scalars['Float'];
  count__soiling_loss_w_mono: Scalars['Float'];
  count__soiling_loss_wh_bi: Scalars['Float'];
  count__soiling_loss_wh_mono: Scalars['Float'];
  count__stc_pv_power: Scalars['Float'];
  count__sun_azimuth_deg: Scalars['Float'];
  count__sun_zenith_deg: Scalars['Float'];
  count__temperature_c: Scalars['Float'];
  count__temperature_derating_loss_w_bi: Scalars['Float'];
  count__temperature_derating_loss_w_mono: Scalars['Float'];
  count__temperature_derating_loss_wh_bi: Scalars['Float'];
  count__temperature_derating_loss_wh_mono: Scalars['Float'];
  count__total_degradation_loss_w_bi: Scalars['Float'];
  count__total_degradation_loss_w_mono: Scalars['Float'];
  count__total_degradation_loss_wh_bi: Scalars['Float'];
  count__total_degradation_loss_wh_mono: Scalars['Float'];
  count__total_inverter_loss_w_bi: Scalars['Float'];
  count__total_inverter_loss_w_mono: Scalars['Float'];
  count__total_inverter_loss_wh_bi: Scalars['Float'];
  count__total_inverter_loss_wh_mono: Scalars['Float'];
  count__transformer_copper_loss_w_bi: Scalars['Float'];
  count__transformer_copper_loss_w_mono: Scalars['Float'];
  count__transformer_copper_loss_wh_bi: Scalars['Float'];
  count__transformer_copper_loss_wh_mono: Scalars['Float'];
  count__transformer_energy_loss_wh_bi: Scalars['Float'];
  count__transformer_energy_loss_wh_mono: Scalars['Float'];
  count__transformer_input_energy_wh_bi: Scalars['Float'];
  count__transformer_input_energy_wh_mono: Scalars['Float'];
  count__transformer_input_power_w_bi: Scalars['Float'];
  count__transformer_input_power_w_mono: Scalars['Float'];
  count__transformer_iron_core_loss_w_bi: Scalars['Float'];
  count__transformer_iron_core_loss_w_mono: Scalars['Float'];
  count__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  count__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  count__transformer_output_energy_wh_bi: Scalars['Float'];
  count__transformer_output_energy_wh_mono: Scalars['Float'];
  count__transformer_output_power_w_bi: Scalars['Float'];
  count__transformer_output_power_w_mono: Scalars['Float'];
  count__transformer_power_loss_w_bi: Scalars['Float'];
  count__transformer_power_loss_w_mono: Scalars['Float'];
  count__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  count__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  count__transmission_line_power_loss_w_bi: Scalars['Float'];
  count__transmission_line_power_loss_w_mono: Scalars['Float'];
  count__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  count__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  count__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  count__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  count__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  count__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  count__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  count__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  dt_timestamp: Scalars['DateTime'];
  duet_job_input_id?: Maybe<Scalars['String']>;
  max__above_max_temperature_loss_w_bi: Scalars['Float'];
  max__above_max_temperature_loss_w_mono: Scalars['Float'];
  max__above_max_temperature_loss_wh_bi: Scalars['Float'];
  max__above_max_temperature_loss_wh_mono: Scalars['Float'];
  max__ac_power_clipping_loss_w_bi: Scalars['Float'];
  max__ac_power_clipping_loss_w_mono: Scalars['Float'];
  max__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  max__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  max__air_mass: Scalars['Float'];
  max__albedo?: Maybe<Scalars['Float']>;
  max__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  max__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  max__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  max__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  max__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  max__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  max__array_string_energy_bi?: Maybe<Scalars['Float']>;
  max__array_string_energy_mono?: Maybe<Scalars['Float']>;
  max__available_energy_wh_bi: Scalars['Float'];
  max__available_energy_wh_mono: Scalars['Float'];
  max__available_power_w_bi: Scalars['Float'];
  max__available_power_w_mono: Scalars['Float'];
  max__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  max__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  max__below_min_temperature_loss_w_bi: Scalars['Float'];
  max__below_min_temperature_loss_w_mono: Scalars['Float'];
  max__below_min_temperature_loss_wh_bi: Scalars['Float'];
  max__below_min_temperature_loss_wh_mono: Scalars['Float'];
  max__bifaciality_current_ratio: Scalars['Float'];
  max__center_module_inclined_irradiance: Scalars['Float'];
  max__center_module_rear_inclined_irradiance: Scalars['Float'];
  max__degradation_loss_first_year_w_bi: Scalars['Float'];
  max__degradation_loss_first_year_w_mono: Scalars['Float'];
  max__degradation_loss_first_year_wh_bi: Scalars['Float'];
  max__degradation_loss_first_year_wh_mono: Scalars['Float'];
  max__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  max__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  max__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  max__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  max__dhi_whm2: Scalars['Float'];
  max__dhi_wm2: Scalars['Float'];
  max__dni_whm2: Scalars['Float'];
  max__dni_wm2: Scalars['Float'];
  max__energy_bi: Scalars['Float'];
  max__energy_mono: Scalars['Float'];
  max__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  max__ghi_whm2: Scalars['Float'];
  max__ghi_wm2: Scalars['Float'];
  max__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  max__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  max__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  max__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  max__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  max__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  max__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  max__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  max__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  max__inverter_night_tare_loss_w_bi: Scalars['Float'];
  max__inverter_night_tare_loss_w_mono: Scalars['Float'];
  max__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  max__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  max__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  max__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  max__inverter_output_energy_wh_bi: Scalars['Float'];
  max__inverter_output_energy_wh_mono: Scalars['Float'];
  max__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  max__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  max__inverter_output_power_w_bi: Scalars['Float'];
  max__inverter_output_power_w_mono: Scalars['Float'];
  max__line_energy_loss_wh_bi: Scalars['Float'];
  max__line_energy_loss_wh_mono: Scalars['Float'];
  max__line_power_loss_w_bi: Scalars['Float'];
  max__line_power_loss_w_mono: Scalars['Float'];
  max__line_receiving_end_energy_wh_bi: Scalars['Float'];
  max__line_receiving_end_energy_wh_mono: Scalars['Float'];
  max__line_receiving_end_power_w_bi: Scalars['Float'];
  max__line_receiving_end_power_w_mono: Scalars['Float'];
  max__line_sending_end_energy_wh_bi: Scalars['Float'];
  max__line_sending_end_energy_wh_mono: Scalars['Float'];
  max__line_sending_end_power_w_bi: Scalars['Float'];
  max__line_sending_end_power_w_mono: Scalars['Float'];
  max__num_panels_in_array: Scalars['Float'];
  max__performance_ratio_bi: Scalars['Float'];
  max__performance_ratio_mono: Scalars['Float'];
  max__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  max__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  max__pv_power_no_degradation_w_bi: Scalars['Float'];
  max__pv_power_no_degradation_w_mono: Scalars['Float'];
  max__pv_power_no_degradation_wh_bi: Scalars['Float'];
  max__pv_power_no_degradation_wh_mono: Scalars['Float'];
  max__pv_power_no_soiling_w_bi: Scalars['Float'];
  max__pv_power_no_soiling_w_mono: Scalars['Float'];
  max__pv_power_no_soiling_wh_bi: Scalars['Float'];
  max__pv_power_no_soiling_wh_mono: Scalars['Float'];
  max__pv_power_with_degradation_w_bi: Scalars['Float'];
  max__pv_power_with_degradation_w_mono: Scalars['Float'];
  max__pv_power_with_degradation_wh_bi: Scalars['Float'];
  max__pv_power_with_degradation_wh_mono: Scalars['Float'];
  max__pv_power_with_soiling_w_bi: Scalars['Float'];
  max__pv_power_with_soiling_w_mono: Scalars['Float'];
  max__pv_power_with_soiling_wh_bi: Scalars['Float'];
  max__pv_power_with_soiling_wh_mono: Scalars['Float'];
  max__self_consumption_loss_w_bi: Scalars['Float'];
  max__self_consumption_loss_w_mono: Scalars['Float'];
  max__self_consumption_loss_wh_bi: Scalars['Float'];
  max__self_consumption_loss_wh_mono: Scalars['Float'];
  max__soiling_loss_w_bi: Scalars['Float'];
  max__soiling_loss_w_mono: Scalars['Float'];
  max__soiling_loss_wh_bi: Scalars['Float'];
  max__soiling_loss_wh_mono: Scalars['Float'];
  max__stc_pv_power: Scalars['Float'];
  max__sun_azimuth_deg: Scalars['Float'];
  max__sun_zenith_deg: Scalars['Float'];
  max__temperature_c: Scalars['Float'];
  max__temperature_derating_loss_w_bi: Scalars['Float'];
  max__temperature_derating_loss_w_mono: Scalars['Float'];
  max__temperature_derating_loss_wh_bi: Scalars['Float'];
  max__temperature_derating_loss_wh_mono: Scalars['Float'];
  max__total_degradation_loss_w_bi: Scalars['Float'];
  max__total_degradation_loss_w_mono: Scalars['Float'];
  max__total_degradation_loss_wh_bi: Scalars['Float'];
  max__total_degradation_loss_wh_mono: Scalars['Float'];
  max__total_inverter_loss_w_bi: Scalars['Float'];
  max__total_inverter_loss_w_mono: Scalars['Float'];
  max__total_inverter_loss_wh_bi: Scalars['Float'];
  max__total_inverter_loss_wh_mono: Scalars['Float'];
  max__transformer_copper_loss_w_bi: Scalars['Float'];
  max__transformer_copper_loss_w_mono: Scalars['Float'];
  max__transformer_copper_loss_wh_bi: Scalars['Float'];
  max__transformer_copper_loss_wh_mono: Scalars['Float'];
  max__transformer_energy_loss_wh_bi: Scalars['Float'];
  max__transformer_energy_loss_wh_mono: Scalars['Float'];
  max__transformer_input_energy_wh_bi: Scalars['Float'];
  max__transformer_input_energy_wh_mono: Scalars['Float'];
  max__transformer_input_power_w_bi: Scalars['Float'];
  max__transformer_input_power_w_mono: Scalars['Float'];
  max__transformer_iron_core_loss_w_bi: Scalars['Float'];
  max__transformer_iron_core_loss_w_mono: Scalars['Float'];
  max__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  max__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  max__transformer_output_energy_wh_bi: Scalars['Float'];
  max__transformer_output_energy_wh_mono: Scalars['Float'];
  max__transformer_output_power_w_bi: Scalars['Float'];
  max__transformer_output_power_w_mono: Scalars['Float'];
  max__transformer_power_loss_w_bi: Scalars['Float'];
  max__transformer_power_loss_w_mono: Scalars['Float'];
  max__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  max__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  max__transmission_line_power_loss_w_bi: Scalars['Float'];
  max__transmission_line_power_loss_w_mono: Scalars['Float'];
  max__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  max__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  max__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  max__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  max__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  max__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  max__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  max__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  min__above_max_temperature_loss_w_bi: Scalars['Float'];
  min__above_max_temperature_loss_w_mono: Scalars['Float'];
  min__above_max_temperature_loss_wh_bi: Scalars['Float'];
  min__above_max_temperature_loss_wh_mono: Scalars['Float'];
  min__ac_power_clipping_loss_w_bi: Scalars['Float'];
  min__ac_power_clipping_loss_w_mono: Scalars['Float'];
  min__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  min__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  min__air_mass: Scalars['Float'];
  min__albedo?: Maybe<Scalars['Float']>;
  min__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  min__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  min__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  min__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  min__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  min__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  min__array_string_energy_bi?: Maybe<Scalars['Float']>;
  min__array_string_energy_mono?: Maybe<Scalars['Float']>;
  min__available_energy_wh_bi: Scalars['Float'];
  min__available_energy_wh_mono: Scalars['Float'];
  min__available_power_w_bi: Scalars['Float'];
  min__available_power_w_mono: Scalars['Float'];
  min__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  min__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  min__below_min_temperature_loss_w_bi: Scalars['Float'];
  min__below_min_temperature_loss_w_mono: Scalars['Float'];
  min__below_min_temperature_loss_wh_bi: Scalars['Float'];
  min__below_min_temperature_loss_wh_mono: Scalars['Float'];
  min__bifaciality_current_ratio: Scalars['Float'];
  min__center_module_inclined_irradiance: Scalars['Float'];
  min__center_module_rear_inclined_irradiance: Scalars['Float'];
  min__degradation_loss_first_year_w_bi: Scalars['Float'];
  min__degradation_loss_first_year_w_mono: Scalars['Float'];
  min__degradation_loss_first_year_wh_bi: Scalars['Float'];
  min__degradation_loss_first_year_wh_mono: Scalars['Float'];
  min__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  min__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  min__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  min__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  min__dhi_whm2: Scalars['Float'];
  min__dhi_wm2: Scalars['Float'];
  min__dni_whm2: Scalars['Float'];
  min__dni_wm2: Scalars['Float'];
  min__energy_bi: Scalars['Float'];
  min__energy_mono: Scalars['Float'];
  min__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  min__ghi_whm2: Scalars['Float'];
  min__ghi_wm2: Scalars['Float'];
  min__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  min__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  min__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  min__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  min__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  min__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  min__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  min__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  min__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  min__inverter_night_tare_loss_w_bi: Scalars['Float'];
  min__inverter_night_tare_loss_w_mono: Scalars['Float'];
  min__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  min__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  min__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  min__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  min__inverter_output_energy_wh_bi: Scalars['Float'];
  min__inverter_output_energy_wh_mono: Scalars['Float'];
  min__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  min__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  min__inverter_output_power_w_bi: Scalars['Float'];
  min__inverter_output_power_w_mono: Scalars['Float'];
  min__line_energy_loss_wh_bi: Scalars['Float'];
  min__line_energy_loss_wh_mono: Scalars['Float'];
  min__line_power_loss_w_bi: Scalars['Float'];
  min__line_power_loss_w_mono: Scalars['Float'];
  min__line_receiving_end_energy_wh_bi: Scalars['Float'];
  min__line_receiving_end_energy_wh_mono: Scalars['Float'];
  min__line_receiving_end_power_w_bi: Scalars['Float'];
  min__line_receiving_end_power_w_mono: Scalars['Float'];
  min__line_sending_end_energy_wh_bi: Scalars['Float'];
  min__line_sending_end_energy_wh_mono: Scalars['Float'];
  min__line_sending_end_power_w_bi: Scalars['Float'];
  min__line_sending_end_power_w_mono: Scalars['Float'];
  min__num_panels_in_array: Scalars['Float'];
  min__performance_ratio_bi: Scalars['Float'];
  min__performance_ratio_mono: Scalars['Float'];
  min__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  min__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  min__pv_power_no_degradation_w_bi: Scalars['Float'];
  min__pv_power_no_degradation_w_mono: Scalars['Float'];
  min__pv_power_no_degradation_wh_bi: Scalars['Float'];
  min__pv_power_no_degradation_wh_mono: Scalars['Float'];
  min__pv_power_no_soiling_w_bi: Scalars['Float'];
  min__pv_power_no_soiling_w_mono: Scalars['Float'];
  min__pv_power_no_soiling_wh_bi: Scalars['Float'];
  min__pv_power_no_soiling_wh_mono: Scalars['Float'];
  min__pv_power_with_degradation_w_bi: Scalars['Float'];
  min__pv_power_with_degradation_w_mono: Scalars['Float'];
  min__pv_power_with_degradation_wh_bi: Scalars['Float'];
  min__pv_power_with_degradation_wh_mono: Scalars['Float'];
  min__pv_power_with_soiling_w_bi: Scalars['Float'];
  min__pv_power_with_soiling_w_mono: Scalars['Float'];
  min__pv_power_with_soiling_wh_bi: Scalars['Float'];
  min__pv_power_with_soiling_wh_mono: Scalars['Float'];
  min__self_consumption_loss_w_bi: Scalars['Float'];
  min__self_consumption_loss_w_mono: Scalars['Float'];
  min__self_consumption_loss_wh_bi: Scalars['Float'];
  min__self_consumption_loss_wh_mono: Scalars['Float'];
  min__soiling_loss_w_bi: Scalars['Float'];
  min__soiling_loss_w_mono: Scalars['Float'];
  min__soiling_loss_wh_bi: Scalars['Float'];
  min__soiling_loss_wh_mono: Scalars['Float'];
  min__stc_pv_power: Scalars['Float'];
  min__sun_azimuth_deg: Scalars['Float'];
  min__sun_zenith_deg: Scalars['Float'];
  min__temperature_c: Scalars['Float'];
  min__temperature_derating_loss_w_bi: Scalars['Float'];
  min__temperature_derating_loss_w_mono: Scalars['Float'];
  min__temperature_derating_loss_wh_bi: Scalars['Float'];
  min__temperature_derating_loss_wh_mono: Scalars['Float'];
  min__total_degradation_loss_w_bi: Scalars['Float'];
  min__total_degradation_loss_w_mono: Scalars['Float'];
  min__total_degradation_loss_wh_bi: Scalars['Float'];
  min__total_degradation_loss_wh_mono: Scalars['Float'];
  min__total_inverter_loss_w_bi: Scalars['Float'];
  min__total_inverter_loss_w_mono: Scalars['Float'];
  min__total_inverter_loss_wh_bi: Scalars['Float'];
  min__total_inverter_loss_wh_mono: Scalars['Float'];
  min__transformer_copper_loss_w_bi: Scalars['Float'];
  min__transformer_copper_loss_w_mono: Scalars['Float'];
  min__transformer_copper_loss_wh_bi: Scalars['Float'];
  min__transformer_copper_loss_wh_mono: Scalars['Float'];
  min__transformer_energy_loss_wh_bi: Scalars['Float'];
  min__transformer_energy_loss_wh_mono: Scalars['Float'];
  min__transformer_input_energy_wh_bi: Scalars['Float'];
  min__transformer_input_energy_wh_mono: Scalars['Float'];
  min__transformer_input_power_w_bi: Scalars['Float'];
  min__transformer_input_power_w_mono: Scalars['Float'];
  min__transformer_iron_core_loss_w_bi: Scalars['Float'];
  min__transformer_iron_core_loss_w_mono: Scalars['Float'];
  min__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  min__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  min__transformer_output_energy_wh_bi: Scalars['Float'];
  min__transformer_output_energy_wh_mono: Scalars['Float'];
  min__transformer_output_power_w_bi: Scalars['Float'];
  min__transformer_output_power_w_mono: Scalars['Float'];
  min__transformer_power_loss_w_bi: Scalars['Float'];
  min__transformer_power_loss_w_mono: Scalars['Float'];
  min__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  min__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  min__transmission_line_power_loss_w_bi: Scalars['Float'];
  min__transmission_line_power_loss_w_mono: Scalars['Float'];
  min__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  min__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  min__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  min__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  min__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  min__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  min__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  min__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p10__above_max_temperature_loss_w_bi: Scalars['Float'];
  p10__above_max_temperature_loss_w_mono: Scalars['Float'];
  p10__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p10__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p10__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p10__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p10__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p10__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p10__air_mass: Scalars['Float'];
  p10__albedo?: Maybe<Scalars['Float']>;
  p10__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p10__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p10__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p10__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p10__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p10__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p10__available_energy_wh_bi: Scalars['Float'];
  p10__available_energy_wh_mono: Scalars['Float'];
  p10__available_power_w_bi: Scalars['Float'];
  p10__available_power_w_mono: Scalars['Float'];
  p10__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p10__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p10__below_min_temperature_loss_w_bi: Scalars['Float'];
  p10__below_min_temperature_loss_w_mono: Scalars['Float'];
  p10__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p10__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p10__bifaciality_current_ratio: Scalars['Float'];
  p10__center_module_inclined_irradiance: Scalars['Float'];
  p10__center_module_rear_inclined_irradiance: Scalars['Float'];
  p10__degradation_loss_first_year_w_bi: Scalars['Float'];
  p10__degradation_loss_first_year_w_mono: Scalars['Float'];
  p10__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p10__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p10__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p10__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p10__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p10__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p10__dhi_whm2: Scalars['Float'];
  p10__dhi_wm2: Scalars['Float'];
  p10__dni_whm2: Scalars['Float'];
  p10__dni_wm2: Scalars['Float'];
  p10__energy_bi: Scalars['Float'];
  p10__energy_mono: Scalars['Float'];
  p10__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p10__ghi_whm2: Scalars['Float'];
  p10__ghi_wm2: Scalars['Float'];
  p10__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p10__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p10__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p10__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p10__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p10__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p10__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p10__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p10__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p10__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p10__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p10__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p10__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p10__inverter_output_energy_wh_bi: Scalars['Float'];
  p10__inverter_output_energy_wh_mono: Scalars['Float'];
  p10__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p10__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p10__inverter_output_power_w_bi: Scalars['Float'];
  p10__inverter_output_power_w_mono: Scalars['Float'];
  p10__line_energy_loss_wh_bi: Scalars['Float'];
  p10__line_energy_loss_wh_mono: Scalars['Float'];
  p10__line_power_loss_w_bi: Scalars['Float'];
  p10__line_power_loss_w_mono: Scalars['Float'];
  p10__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p10__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p10__line_receiving_end_power_w_bi: Scalars['Float'];
  p10__line_receiving_end_power_w_mono: Scalars['Float'];
  p10__line_sending_end_energy_wh_bi: Scalars['Float'];
  p10__line_sending_end_energy_wh_mono: Scalars['Float'];
  p10__line_sending_end_power_w_bi: Scalars['Float'];
  p10__line_sending_end_power_w_mono: Scalars['Float'];
  p10__num_panels_in_array: Scalars['Float'];
  p10__performance_ratio_bi: Scalars['Float'];
  p10__performance_ratio_mono: Scalars['Float'];
  p10__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p10__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p10__pv_power_no_degradation_w_bi: Scalars['Float'];
  p10__pv_power_no_degradation_w_mono: Scalars['Float'];
  p10__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p10__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p10__pv_power_no_soiling_w_bi: Scalars['Float'];
  p10__pv_power_no_soiling_w_mono: Scalars['Float'];
  p10__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p10__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p10__pv_power_with_degradation_w_bi: Scalars['Float'];
  p10__pv_power_with_degradation_w_mono: Scalars['Float'];
  p10__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p10__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p10__pv_power_with_soiling_w_bi: Scalars['Float'];
  p10__pv_power_with_soiling_w_mono: Scalars['Float'];
  p10__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p10__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p10__self_consumption_loss_w_bi: Scalars['Float'];
  p10__self_consumption_loss_w_mono: Scalars['Float'];
  p10__self_consumption_loss_wh_bi: Scalars['Float'];
  p10__self_consumption_loss_wh_mono: Scalars['Float'];
  p10__soiling_loss_w_bi: Scalars['Float'];
  p10__soiling_loss_w_mono: Scalars['Float'];
  p10__soiling_loss_wh_bi: Scalars['Float'];
  p10__soiling_loss_wh_mono: Scalars['Float'];
  p10__stc_pv_power: Scalars['Float'];
  p10__sun_azimuth_deg: Scalars['Float'];
  p10__sun_zenith_deg: Scalars['Float'];
  p10__temperature_c: Scalars['Float'];
  p10__temperature_derating_loss_w_bi: Scalars['Float'];
  p10__temperature_derating_loss_w_mono: Scalars['Float'];
  p10__temperature_derating_loss_wh_bi: Scalars['Float'];
  p10__temperature_derating_loss_wh_mono: Scalars['Float'];
  p10__total_degradation_loss_w_bi: Scalars['Float'];
  p10__total_degradation_loss_w_mono: Scalars['Float'];
  p10__total_degradation_loss_wh_bi: Scalars['Float'];
  p10__total_degradation_loss_wh_mono: Scalars['Float'];
  p10__total_inverter_loss_w_bi: Scalars['Float'];
  p10__total_inverter_loss_w_mono: Scalars['Float'];
  p10__total_inverter_loss_wh_bi: Scalars['Float'];
  p10__total_inverter_loss_wh_mono: Scalars['Float'];
  p10__transformer_copper_loss_w_bi: Scalars['Float'];
  p10__transformer_copper_loss_w_mono: Scalars['Float'];
  p10__transformer_copper_loss_wh_bi: Scalars['Float'];
  p10__transformer_copper_loss_wh_mono: Scalars['Float'];
  p10__transformer_energy_loss_wh_bi: Scalars['Float'];
  p10__transformer_energy_loss_wh_mono: Scalars['Float'];
  p10__transformer_input_energy_wh_bi: Scalars['Float'];
  p10__transformer_input_energy_wh_mono: Scalars['Float'];
  p10__transformer_input_power_w_bi: Scalars['Float'];
  p10__transformer_input_power_w_mono: Scalars['Float'];
  p10__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p10__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p10__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p10__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p10__transformer_output_energy_wh_bi: Scalars['Float'];
  p10__transformer_output_energy_wh_mono: Scalars['Float'];
  p10__transformer_output_power_w_bi: Scalars['Float'];
  p10__transformer_output_power_w_mono: Scalars['Float'];
  p10__transformer_power_loss_w_bi: Scalars['Float'];
  p10__transformer_power_loss_w_mono: Scalars['Float'];
  p10__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p10__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p10__transmission_line_power_loss_w_bi: Scalars['Float'];
  p10__transmission_line_power_loss_w_mono: Scalars['Float'];
  p10__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p10__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p10__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p10__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p10__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p10__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p10__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p10__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p25__above_max_temperature_loss_w_bi: Scalars['Float'];
  p25__above_max_temperature_loss_w_mono: Scalars['Float'];
  p25__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p25__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p25__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p25__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p25__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p25__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p25__air_mass: Scalars['Float'];
  p25__albedo?: Maybe<Scalars['Float']>;
  p25__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p25__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p25__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p25__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p25__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p25__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p25__available_energy_wh_bi: Scalars['Float'];
  p25__available_energy_wh_mono: Scalars['Float'];
  p25__available_power_w_bi: Scalars['Float'];
  p25__available_power_w_mono: Scalars['Float'];
  p25__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p25__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p25__below_min_temperature_loss_w_bi: Scalars['Float'];
  p25__below_min_temperature_loss_w_mono: Scalars['Float'];
  p25__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p25__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p25__bifaciality_current_ratio: Scalars['Float'];
  p25__center_module_inclined_irradiance: Scalars['Float'];
  p25__center_module_rear_inclined_irradiance: Scalars['Float'];
  p25__degradation_loss_first_year_w_bi: Scalars['Float'];
  p25__degradation_loss_first_year_w_mono: Scalars['Float'];
  p25__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p25__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p25__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p25__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p25__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p25__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p25__dhi_whm2: Scalars['Float'];
  p25__dhi_wm2: Scalars['Float'];
  p25__dni_whm2: Scalars['Float'];
  p25__dni_wm2: Scalars['Float'];
  p25__energy_bi: Scalars['Float'];
  p25__energy_mono: Scalars['Float'];
  p25__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p25__ghi_whm2: Scalars['Float'];
  p25__ghi_wm2: Scalars['Float'];
  p25__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p25__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p25__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p25__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p25__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p25__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p25__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p25__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p25__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p25__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p25__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p25__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p25__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p25__inverter_output_energy_wh_bi: Scalars['Float'];
  p25__inverter_output_energy_wh_mono: Scalars['Float'];
  p25__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p25__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p25__inverter_output_power_w_bi: Scalars['Float'];
  p25__inverter_output_power_w_mono: Scalars['Float'];
  p25__line_energy_loss_wh_bi: Scalars['Float'];
  p25__line_energy_loss_wh_mono: Scalars['Float'];
  p25__line_power_loss_w_bi: Scalars['Float'];
  p25__line_power_loss_w_mono: Scalars['Float'];
  p25__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p25__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p25__line_receiving_end_power_w_bi: Scalars['Float'];
  p25__line_receiving_end_power_w_mono: Scalars['Float'];
  p25__line_sending_end_energy_wh_bi: Scalars['Float'];
  p25__line_sending_end_energy_wh_mono: Scalars['Float'];
  p25__line_sending_end_power_w_bi: Scalars['Float'];
  p25__line_sending_end_power_w_mono: Scalars['Float'];
  p25__num_panels_in_array: Scalars['Float'];
  p25__performance_ratio_bi: Scalars['Float'];
  p25__performance_ratio_mono: Scalars['Float'];
  p25__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p25__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p25__pv_power_no_degradation_w_bi: Scalars['Float'];
  p25__pv_power_no_degradation_w_mono: Scalars['Float'];
  p25__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p25__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p25__pv_power_no_soiling_w_bi: Scalars['Float'];
  p25__pv_power_no_soiling_w_mono: Scalars['Float'];
  p25__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p25__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p25__pv_power_with_degradation_w_bi: Scalars['Float'];
  p25__pv_power_with_degradation_w_mono: Scalars['Float'];
  p25__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p25__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p25__pv_power_with_soiling_w_bi: Scalars['Float'];
  p25__pv_power_with_soiling_w_mono: Scalars['Float'];
  p25__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p25__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p25__self_consumption_loss_w_bi: Scalars['Float'];
  p25__self_consumption_loss_w_mono: Scalars['Float'];
  p25__self_consumption_loss_wh_bi: Scalars['Float'];
  p25__self_consumption_loss_wh_mono: Scalars['Float'];
  p25__soiling_loss_w_bi: Scalars['Float'];
  p25__soiling_loss_w_mono: Scalars['Float'];
  p25__soiling_loss_wh_bi: Scalars['Float'];
  p25__soiling_loss_wh_mono: Scalars['Float'];
  p25__stc_pv_power: Scalars['Float'];
  p25__sun_azimuth_deg: Scalars['Float'];
  p25__sun_zenith_deg: Scalars['Float'];
  p25__temperature_c: Scalars['Float'];
  p25__temperature_derating_loss_w_bi: Scalars['Float'];
  p25__temperature_derating_loss_w_mono: Scalars['Float'];
  p25__temperature_derating_loss_wh_bi: Scalars['Float'];
  p25__temperature_derating_loss_wh_mono: Scalars['Float'];
  p25__total_degradation_loss_w_bi: Scalars['Float'];
  p25__total_degradation_loss_w_mono: Scalars['Float'];
  p25__total_degradation_loss_wh_bi: Scalars['Float'];
  p25__total_degradation_loss_wh_mono: Scalars['Float'];
  p25__total_inverter_loss_w_bi: Scalars['Float'];
  p25__total_inverter_loss_w_mono: Scalars['Float'];
  p25__total_inverter_loss_wh_bi: Scalars['Float'];
  p25__total_inverter_loss_wh_mono: Scalars['Float'];
  p25__transformer_copper_loss_w_bi: Scalars['Float'];
  p25__transformer_copper_loss_w_mono: Scalars['Float'];
  p25__transformer_copper_loss_wh_bi: Scalars['Float'];
  p25__transformer_copper_loss_wh_mono: Scalars['Float'];
  p25__transformer_energy_loss_wh_bi: Scalars['Float'];
  p25__transformer_energy_loss_wh_mono: Scalars['Float'];
  p25__transformer_input_energy_wh_bi: Scalars['Float'];
  p25__transformer_input_energy_wh_mono: Scalars['Float'];
  p25__transformer_input_power_w_bi: Scalars['Float'];
  p25__transformer_input_power_w_mono: Scalars['Float'];
  p25__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p25__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p25__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p25__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p25__transformer_output_energy_wh_bi: Scalars['Float'];
  p25__transformer_output_energy_wh_mono: Scalars['Float'];
  p25__transformer_output_power_w_bi: Scalars['Float'];
  p25__transformer_output_power_w_mono: Scalars['Float'];
  p25__transformer_power_loss_w_bi: Scalars['Float'];
  p25__transformer_power_loss_w_mono: Scalars['Float'];
  p25__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p25__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p25__transmission_line_power_loss_w_bi: Scalars['Float'];
  p25__transmission_line_power_loss_w_mono: Scalars['Float'];
  p25__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p25__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p25__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p25__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p25__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p25__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p25__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p25__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p50__above_max_temperature_loss_w_bi: Scalars['Float'];
  p50__above_max_temperature_loss_w_mono: Scalars['Float'];
  p50__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p50__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p50__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p50__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p50__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p50__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p50__air_mass: Scalars['Float'];
  p50__albedo?: Maybe<Scalars['Float']>;
  p50__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p50__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p50__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p50__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p50__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p50__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p50__available_energy_wh_bi: Scalars['Float'];
  p50__available_energy_wh_mono: Scalars['Float'];
  p50__available_power_w_bi: Scalars['Float'];
  p50__available_power_w_mono: Scalars['Float'];
  p50__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p50__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p50__below_min_temperature_loss_w_bi: Scalars['Float'];
  p50__below_min_temperature_loss_w_mono: Scalars['Float'];
  p50__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p50__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p50__bifaciality_current_ratio: Scalars['Float'];
  p50__center_module_inclined_irradiance: Scalars['Float'];
  p50__center_module_rear_inclined_irradiance: Scalars['Float'];
  p50__degradation_loss_first_year_w_bi: Scalars['Float'];
  p50__degradation_loss_first_year_w_mono: Scalars['Float'];
  p50__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p50__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p50__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p50__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p50__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p50__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p50__dhi_whm2: Scalars['Float'];
  p50__dhi_wm2: Scalars['Float'];
  p50__dni_whm2: Scalars['Float'];
  p50__dni_wm2: Scalars['Float'];
  p50__energy_bi: Scalars['Float'];
  p50__energy_mono: Scalars['Float'];
  p50__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p50__ghi_whm2: Scalars['Float'];
  p50__ghi_wm2: Scalars['Float'];
  p50__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p50__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p50__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p50__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p50__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p50__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p50__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p50__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p50__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p50__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p50__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p50__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p50__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p50__inverter_output_energy_wh_bi: Scalars['Float'];
  p50__inverter_output_energy_wh_mono: Scalars['Float'];
  p50__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p50__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p50__inverter_output_power_w_bi: Scalars['Float'];
  p50__inverter_output_power_w_mono: Scalars['Float'];
  p50__line_energy_loss_wh_bi: Scalars['Float'];
  p50__line_energy_loss_wh_mono: Scalars['Float'];
  p50__line_power_loss_w_bi: Scalars['Float'];
  p50__line_power_loss_w_mono: Scalars['Float'];
  p50__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p50__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p50__line_receiving_end_power_w_bi: Scalars['Float'];
  p50__line_receiving_end_power_w_mono: Scalars['Float'];
  p50__line_sending_end_energy_wh_bi: Scalars['Float'];
  p50__line_sending_end_energy_wh_mono: Scalars['Float'];
  p50__line_sending_end_power_w_bi: Scalars['Float'];
  p50__line_sending_end_power_w_mono: Scalars['Float'];
  p50__num_panels_in_array: Scalars['Float'];
  p50__performance_ratio_bi: Scalars['Float'];
  p50__performance_ratio_mono: Scalars['Float'];
  p50__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p50__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p50__pv_power_no_degradation_w_bi: Scalars['Float'];
  p50__pv_power_no_degradation_w_mono: Scalars['Float'];
  p50__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p50__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p50__pv_power_no_soiling_w_bi: Scalars['Float'];
  p50__pv_power_no_soiling_w_mono: Scalars['Float'];
  p50__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p50__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p50__pv_power_with_degradation_w_bi: Scalars['Float'];
  p50__pv_power_with_degradation_w_mono: Scalars['Float'];
  p50__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p50__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p50__pv_power_with_soiling_w_bi: Scalars['Float'];
  p50__pv_power_with_soiling_w_mono: Scalars['Float'];
  p50__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p50__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p50__self_consumption_loss_w_bi: Scalars['Float'];
  p50__self_consumption_loss_w_mono: Scalars['Float'];
  p50__self_consumption_loss_wh_bi: Scalars['Float'];
  p50__self_consumption_loss_wh_mono: Scalars['Float'];
  p50__soiling_loss_w_bi: Scalars['Float'];
  p50__soiling_loss_w_mono: Scalars['Float'];
  p50__soiling_loss_wh_bi: Scalars['Float'];
  p50__soiling_loss_wh_mono: Scalars['Float'];
  p50__stc_pv_power: Scalars['Float'];
  p50__sun_azimuth_deg: Scalars['Float'];
  p50__sun_zenith_deg: Scalars['Float'];
  p50__temperature_c: Scalars['Float'];
  p50__temperature_derating_loss_w_bi: Scalars['Float'];
  p50__temperature_derating_loss_w_mono: Scalars['Float'];
  p50__temperature_derating_loss_wh_bi: Scalars['Float'];
  p50__temperature_derating_loss_wh_mono: Scalars['Float'];
  p50__total_degradation_loss_w_bi: Scalars['Float'];
  p50__total_degradation_loss_w_mono: Scalars['Float'];
  p50__total_degradation_loss_wh_bi: Scalars['Float'];
  p50__total_degradation_loss_wh_mono: Scalars['Float'];
  p50__total_inverter_loss_w_bi: Scalars['Float'];
  p50__total_inverter_loss_w_mono: Scalars['Float'];
  p50__total_inverter_loss_wh_bi: Scalars['Float'];
  p50__total_inverter_loss_wh_mono: Scalars['Float'];
  p50__transformer_copper_loss_w_bi: Scalars['Float'];
  p50__transformer_copper_loss_w_mono: Scalars['Float'];
  p50__transformer_copper_loss_wh_bi: Scalars['Float'];
  p50__transformer_copper_loss_wh_mono: Scalars['Float'];
  p50__transformer_energy_loss_wh_bi: Scalars['Float'];
  p50__transformer_energy_loss_wh_mono: Scalars['Float'];
  p50__transformer_input_energy_wh_bi: Scalars['Float'];
  p50__transformer_input_energy_wh_mono: Scalars['Float'];
  p50__transformer_input_power_w_bi: Scalars['Float'];
  p50__transformer_input_power_w_mono: Scalars['Float'];
  p50__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p50__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p50__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p50__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p50__transformer_output_energy_wh_bi: Scalars['Float'];
  p50__transformer_output_energy_wh_mono: Scalars['Float'];
  p50__transformer_output_power_w_bi: Scalars['Float'];
  p50__transformer_output_power_w_mono: Scalars['Float'];
  p50__transformer_power_loss_w_bi: Scalars['Float'];
  p50__transformer_power_loss_w_mono: Scalars['Float'];
  p50__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p50__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p50__transmission_line_power_loss_w_bi: Scalars['Float'];
  p50__transmission_line_power_loss_w_mono: Scalars['Float'];
  p50__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p50__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p50__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p50__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p50__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p50__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p50__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p50__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p75__above_max_temperature_loss_w_bi: Scalars['Float'];
  p75__above_max_temperature_loss_w_mono: Scalars['Float'];
  p75__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p75__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p75__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p75__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p75__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p75__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p75__air_mass: Scalars['Float'];
  p75__albedo?: Maybe<Scalars['Float']>;
  p75__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p75__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p75__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p75__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p75__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p75__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p75__available_energy_wh_bi: Scalars['Float'];
  p75__available_energy_wh_mono: Scalars['Float'];
  p75__available_power_w_bi: Scalars['Float'];
  p75__available_power_w_mono: Scalars['Float'];
  p75__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p75__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p75__below_min_temperature_loss_w_bi: Scalars['Float'];
  p75__below_min_temperature_loss_w_mono: Scalars['Float'];
  p75__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p75__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p75__bifaciality_current_ratio: Scalars['Float'];
  p75__center_module_inclined_irradiance: Scalars['Float'];
  p75__center_module_rear_inclined_irradiance: Scalars['Float'];
  p75__degradation_loss_first_year_w_bi: Scalars['Float'];
  p75__degradation_loss_first_year_w_mono: Scalars['Float'];
  p75__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p75__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p75__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p75__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p75__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p75__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p75__dhi_whm2: Scalars['Float'];
  p75__dhi_wm2: Scalars['Float'];
  p75__dni_whm2: Scalars['Float'];
  p75__dni_wm2: Scalars['Float'];
  p75__energy_bi: Scalars['Float'];
  p75__energy_mono: Scalars['Float'];
  p75__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p75__ghi_whm2: Scalars['Float'];
  p75__ghi_wm2: Scalars['Float'];
  p75__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p75__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p75__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p75__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p75__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p75__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p75__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p75__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p75__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p75__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p75__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p75__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p75__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p75__inverter_output_energy_wh_bi: Scalars['Float'];
  p75__inverter_output_energy_wh_mono: Scalars['Float'];
  p75__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p75__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p75__inverter_output_power_w_bi: Scalars['Float'];
  p75__inverter_output_power_w_mono: Scalars['Float'];
  p75__line_energy_loss_wh_bi: Scalars['Float'];
  p75__line_energy_loss_wh_mono: Scalars['Float'];
  p75__line_power_loss_w_bi: Scalars['Float'];
  p75__line_power_loss_w_mono: Scalars['Float'];
  p75__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p75__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p75__line_receiving_end_power_w_bi: Scalars['Float'];
  p75__line_receiving_end_power_w_mono: Scalars['Float'];
  p75__line_sending_end_energy_wh_bi: Scalars['Float'];
  p75__line_sending_end_energy_wh_mono: Scalars['Float'];
  p75__line_sending_end_power_w_bi: Scalars['Float'];
  p75__line_sending_end_power_w_mono: Scalars['Float'];
  p75__num_panels_in_array: Scalars['Float'];
  p75__performance_ratio_bi: Scalars['Float'];
  p75__performance_ratio_mono: Scalars['Float'];
  p75__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p75__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p75__pv_power_no_degradation_w_bi: Scalars['Float'];
  p75__pv_power_no_degradation_w_mono: Scalars['Float'];
  p75__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p75__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p75__pv_power_no_soiling_w_bi: Scalars['Float'];
  p75__pv_power_no_soiling_w_mono: Scalars['Float'];
  p75__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p75__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p75__pv_power_with_degradation_w_bi: Scalars['Float'];
  p75__pv_power_with_degradation_w_mono: Scalars['Float'];
  p75__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p75__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p75__pv_power_with_soiling_w_bi: Scalars['Float'];
  p75__pv_power_with_soiling_w_mono: Scalars['Float'];
  p75__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p75__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p75__self_consumption_loss_w_bi: Scalars['Float'];
  p75__self_consumption_loss_w_mono: Scalars['Float'];
  p75__self_consumption_loss_wh_bi: Scalars['Float'];
  p75__self_consumption_loss_wh_mono: Scalars['Float'];
  p75__soiling_loss_w_bi: Scalars['Float'];
  p75__soiling_loss_w_mono: Scalars['Float'];
  p75__soiling_loss_wh_bi: Scalars['Float'];
  p75__soiling_loss_wh_mono: Scalars['Float'];
  p75__stc_pv_power: Scalars['Float'];
  p75__sun_azimuth_deg: Scalars['Float'];
  p75__sun_zenith_deg: Scalars['Float'];
  p75__temperature_c: Scalars['Float'];
  p75__temperature_derating_loss_w_bi: Scalars['Float'];
  p75__temperature_derating_loss_w_mono: Scalars['Float'];
  p75__temperature_derating_loss_wh_bi: Scalars['Float'];
  p75__temperature_derating_loss_wh_mono: Scalars['Float'];
  p75__total_degradation_loss_w_bi: Scalars['Float'];
  p75__total_degradation_loss_w_mono: Scalars['Float'];
  p75__total_degradation_loss_wh_bi: Scalars['Float'];
  p75__total_degradation_loss_wh_mono: Scalars['Float'];
  p75__total_inverter_loss_w_bi: Scalars['Float'];
  p75__total_inverter_loss_w_mono: Scalars['Float'];
  p75__total_inverter_loss_wh_bi: Scalars['Float'];
  p75__total_inverter_loss_wh_mono: Scalars['Float'];
  p75__transformer_copper_loss_w_bi: Scalars['Float'];
  p75__transformer_copper_loss_w_mono: Scalars['Float'];
  p75__transformer_copper_loss_wh_bi: Scalars['Float'];
  p75__transformer_copper_loss_wh_mono: Scalars['Float'];
  p75__transformer_energy_loss_wh_bi: Scalars['Float'];
  p75__transformer_energy_loss_wh_mono: Scalars['Float'];
  p75__transformer_input_energy_wh_bi: Scalars['Float'];
  p75__transformer_input_energy_wh_mono: Scalars['Float'];
  p75__transformer_input_power_w_bi: Scalars['Float'];
  p75__transformer_input_power_w_mono: Scalars['Float'];
  p75__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p75__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p75__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p75__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p75__transformer_output_energy_wh_bi: Scalars['Float'];
  p75__transformer_output_energy_wh_mono: Scalars['Float'];
  p75__transformer_output_power_w_bi: Scalars['Float'];
  p75__transformer_output_power_w_mono: Scalars['Float'];
  p75__transformer_power_loss_w_bi: Scalars['Float'];
  p75__transformer_power_loss_w_mono: Scalars['Float'];
  p75__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p75__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p75__transmission_line_power_loss_w_bi: Scalars['Float'];
  p75__transmission_line_power_loss_w_mono: Scalars['Float'];
  p75__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p75__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p75__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p75__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p75__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p75__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p75__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p75__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  p90__above_max_temperature_loss_w_bi: Scalars['Float'];
  p90__above_max_temperature_loss_w_mono: Scalars['Float'];
  p90__above_max_temperature_loss_wh_bi: Scalars['Float'];
  p90__above_max_temperature_loss_wh_mono: Scalars['Float'];
  p90__ac_power_clipping_loss_w_bi: Scalars['Float'];
  p90__ac_power_clipping_loss_w_mono: Scalars['Float'];
  p90__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  p90__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  p90__air_mass: Scalars['Float'];
  p90__albedo?: Maybe<Scalars['Float']>;
  p90__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  p90__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  p90__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  p90__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  p90__array_string_energy_bi?: Maybe<Scalars['Float']>;
  p90__array_string_energy_mono?: Maybe<Scalars['Float']>;
  p90__available_energy_wh_bi: Scalars['Float'];
  p90__available_energy_wh_mono: Scalars['Float'];
  p90__available_power_w_bi: Scalars['Float'];
  p90__available_power_w_mono: Scalars['Float'];
  p90__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  p90__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  p90__below_min_temperature_loss_w_bi: Scalars['Float'];
  p90__below_min_temperature_loss_w_mono: Scalars['Float'];
  p90__below_min_temperature_loss_wh_bi: Scalars['Float'];
  p90__below_min_temperature_loss_wh_mono: Scalars['Float'];
  p90__bifaciality_current_ratio: Scalars['Float'];
  p90__center_module_inclined_irradiance: Scalars['Float'];
  p90__center_module_rear_inclined_irradiance: Scalars['Float'];
  p90__degradation_loss_first_year_w_bi: Scalars['Float'];
  p90__degradation_loss_first_year_w_mono: Scalars['Float'];
  p90__degradation_loss_first_year_wh_bi: Scalars['Float'];
  p90__degradation_loss_first_year_wh_mono: Scalars['Float'];
  p90__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  p90__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  p90__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  p90__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  p90__dhi_whm2: Scalars['Float'];
  p90__dhi_wm2: Scalars['Float'];
  p90__dni_whm2: Scalars['Float'];
  p90__dni_wm2: Scalars['Float'];
  p90__energy_bi: Scalars['Float'];
  p90__energy_mono: Scalars['Float'];
  p90__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p90__ghi_whm2: Scalars['Float'];
  p90__ghi_wm2: Scalars['Float'];
  p90__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  p90__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  p90__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  p90__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  p90__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  p90__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  p90__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  p90__inverter_night_tare_loss_w_bi: Scalars['Float'];
  p90__inverter_night_tare_loss_w_mono: Scalars['Float'];
  p90__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  p90__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  p90__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  p90__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  p90__inverter_output_energy_wh_bi: Scalars['Float'];
  p90__inverter_output_energy_wh_mono: Scalars['Float'];
  p90__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  p90__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  p90__inverter_output_power_w_bi: Scalars['Float'];
  p90__inverter_output_power_w_mono: Scalars['Float'];
  p90__line_energy_loss_wh_bi: Scalars['Float'];
  p90__line_energy_loss_wh_mono: Scalars['Float'];
  p90__line_power_loss_w_bi: Scalars['Float'];
  p90__line_power_loss_w_mono: Scalars['Float'];
  p90__line_receiving_end_energy_wh_bi: Scalars['Float'];
  p90__line_receiving_end_energy_wh_mono: Scalars['Float'];
  p90__line_receiving_end_power_w_bi: Scalars['Float'];
  p90__line_receiving_end_power_w_mono: Scalars['Float'];
  p90__line_sending_end_energy_wh_bi: Scalars['Float'];
  p90__line_sending_end_energy_wh_mono: Scalars['Float'];
  p90__line_sending_end_power_w_bi: Scalars['Float'];
  p90__line_sending_end_power_w_mono: Scalars['Float'];
  p90__num_panels_in_array: Scalars['Float'];
  p90__performance_ratio_bi: Scalars['Float'];
  p90__performance_ratio_mono: Scalars['Float'];
  p90__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  p90__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  p90__pv_power_no_degradation_w_bi: Scalars['Float'];
  p90__pv_power_no_degradation_w_mono: Scalars['Float'];
  p90__pv_power_no_degradation_wh_bi: Scalars['Float'];
  p90__pv_power_no_degradation_wh_mono: Scalars['Float'];
  p90__pv_power_no_soiling_w_bi: Scalars['Float'];
  p90__pv_power_no_soiling_w_mono: Scalars['Float'];
  p90__pv_power_no_soiling_wh_bi: Scalars['Float'];
  p90__pv_power_no_soiling_wh_mono: Scalars['Float'];
  p90__pv_power_with_degradation_w_bi: Scalars['Float'];
  p90__pv_power_with_degradation_w_mono: Scalars['Float'];
  p90__pv_power_with_degradation_wh_bi: Scalars['Float'];
  p90__pv_power_with_degradation_wh_mono: Scalars['Float'];
  p90__pv_power_with_soiling_w_bi: Scalars['Float'];
  p90__pv_power_with_soiling_w_mono: Scalars['Float'];
  p90__pv_power_with_soiling_wh_bi: Scalars['Float'];
  p90__pv_power_with_soiling_wh_mono: Scalars['Float'];
  p90__self_consumption_loss_w_bi: Scalars['Float'];
  p90__self_consumption_loss_w_mono: Scalars['Float'];
  p90__self_consumption_loss_wh_bi: Scalars['Float'];
  p90__self_consumption_loss_wh_mono: Scalars['Float'];
  p90__soiling_loss_w_bi: Scalars['Float'];
  p90__soiling_loss_w_mono: Scalars['Float'];
  p90__soiling_loss_wh_bi: Scalars['Float'];
  p90__soiling_loss_wh_mono: Scalars['Float'];
  p90__stc_pv_power: Scalars['Float'];
  p90__sun_azimuth_deg: Scalars['Float'];
  p90__sun_zenith_deg: Scalars['Float'];
  p90__temperature_c: Scalars['Float'];
  p90__temperature_derating_loss_w_bi: Scalars['Float'];
  p90__temperature_derating_loss_w_mono: Scalars['Float'];
  p90__temperature_derating_loss_wh_bi: Scalars['Float'];
  p90__temperature_derating_loss_wh_mono: Scalars['Float'];
  p90__total_degradation_loss_w_bi: Scalars['Float'];
  p90__total_degradation_loss_w_mono: Scalars['Float'];
  p90__total_degradation_loss_wh_bi: Scalars['Float'];
  p90__total_degradation_loss_wh_mono: Scalars['Float'];
  p90__total_inverter_loss_w_bi: Scalars['Float'];
  p90__total_inverter_loss_w_mono: Scalars['Float'];
  p90__total_inverter_loss_wh_bi: Scalars['Float'];
  p90__total_inverter_loss_wh_mono: Scalars['Float'];
  p90__transformer_copper_loss_w_bi: Scalars['Float'];
  p90__transformer_copper_loss_w_mono: Scalars['Float'];
  p90__transformer_copper_loss_wh_bi: Scalars['Float'];
  p90__transformer_copper_loss_wh_mono: Scalars['Float'];
  p90__transformer_energy_loss_wh_bi: Scalars['Float'];
  p90__transformer_energy_loss_wh_mono: Scalars['Float'];
  p90__transformer_input_energy_wh_bi: Scalars['Float'];
  p90__transformer_input_energy_wh_mono: Scalars['Float'];
  p90__transformer_input_power_w_bi: Scalars['Float'];
  p90__transformer_input_power_w_mono: Scalars['Float'];
  p90__transformer_iron_core_loss_w_bi: Scalars['Float'];
  p90__transformer_iron_core_loss_w_mono: Scalars['Float'];
  p90__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  p90__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  p90__transformer_output_energy_wh_bi: Scalars['Float'];
  p90__transformer_output_energy_wh_mono: Scalars['Float'];
  p90__transformer_output_power_w_bi: Scalars['Float'];
  p90__transformer_output_power_w_mono: Scalars['Float'];
  p90__transformer_power_loss_w_bi: Scalars['Float'];
  p90__transformer_power_loss_w_mono: Scalars['Float'];
  p90__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  p90__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  p90__transmission_line_power_loss_w_bi: Scalars['Float'];
  p90__transmission_line_power_loss_w_mono: Scalars['Float'];
  p90__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  p90__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  p90__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  p90__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  p90__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  p90__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  p90__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  p90__transmission_line_sending_end_power_w_mono: Scalars['Float'];
  sum__above_max_temperature_loss_w_bi: Scalars['Float'];
  sum__above_max_temperature_loss_w_mono: Scalars['Float'];
  sum__above_max_temperature_loss_wh_bi: Scalars['Float'];
  sum__above_max_temperature_loss_wh_mono: Scalars['Float'];
  sum__ac_power_clipping_loss_w_bi: Scalars['Float'];
  sum__ac_power_clipping_loss_w_mono: Scalars['Float'];
  sum__ac_power_clipping_loss_wh_bi: Scalars['Float'];
  sum__ac_power_clipping_loss_wh_mono: Scalars['Float'];
  sum__air_mass: Scalars['Float'];
  sum__albedo?: Maybe<Scalars['Float']>;
  sum__array_cell_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_cell_energy_mono?: Maybe<Scalars['Float']>;
  sum__array_cell_max_energy_t_stc_bi?: Maybe<Scalars['Float']>;
  sum__array_cell_max_energy_t_stc_mono?: Maybe<Scalars['Float']>;
  sum__array_center_panel_cell_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_center_panel_cell_energy_mono?: Maybe<Scalars['Float']>;
  sum__array_string_energy_bi?: Maybe<Scalars['Float']>;
  sum__array_string_energy_mono?: Maybe<Scalars['Float']>;
  sum__available_energy_wh_bi: Scalars['Float'];
  sum__available_energy_wh_mono: Scalars['Float'];
  sum__available_power_w_bi: Scalars['Float'];
  sum__available_power_w_mono: Scalars['Float'];
  sum__ave_bi_cell_temp_c?: Maybe<Scalars['Float']>;
  sum__ave_mono_cell_temp_c?: Maybe<Scalars['Float']>;
  sum__below_min_temperature_loss_w_bi: Scalars['Float'];
  sum__below_min_temperature_loss_w_mono: Scalars['Float'];
  sum__below_min_temperature_loss_wh_bi: Scalars['Float'];
  sum__below_min_temperature_loss_wh_mono: Scalars['Float'];
  sum__bifaciality_current_ratio: Scalars['Float'];
  sum__center_module_inclined_irradiance: Scalars['Float'];
  sum__center_module_rear_inclined_irradiance: Scalars['Float'];
  sum__degradation_loss_first_year_w_bi: Scalars['Float'];
  sum__degradation_loss_first_year_w_mono: Scalars['Float'];
  sum__degradation_loss_first_year_wh_bi: Scalars['Float'];
  sum__degradation_loss_first_year_wh_mono: Scalars['Float'];
  sum__degradation_loss_remaining_years_w_bi: Scalars['Float'];
  sum__degradation_loss_remaining_years_w_mono: Scalars['Float'];
  sum__degradation_loss_remaining_years_wh_bi: Scalars['Float'];
  sum__degradation_loss_remaining_years_wh_mono: Scalars['Float'];
  sum__dhi_whm2: Scalars['Float'];
  sum__dhi_wm2: Scalars['Float'];
  sum__dni_whm2: Scalars['Float'];
  sum__dni_wm2: Scalars['Float'];
  sum__energy_bi: Scalars['Float'];
  sum__energy_mono: Scalars['Float'];
  sum__ghi_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  sum__ghi_whm2: Scalars['Float'];
  sum__ghi_wm2: Scalars['Float'];
  sum__grid_injection_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__grid_injection_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__grid_injection_power_w_bi?: Maybe<Scalars['Float']>;
  sum__grid_injection_power_w_mono?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_no_loss_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_far_shading_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_iam_whm2?: Maybe<Scalars['Float']>;
  sum__gti_f_pvsyst_with_near_shading_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_ground_reflected_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_diffuse_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_direct_whm2?: Maybe<Scalars['Float']>;
  sum__gti_r_pvsyst_with_structure_whm2?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_copper_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_efficiency_percentage_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_efficiency_percentage_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_input_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_iron_core_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_output_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transformer_power_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transformer_power_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_energy_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_energy_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_power_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_power_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_receiving_end_power_w_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_energy_wh_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_energy_wh_mono?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_power_w_bi?: Maybe<Scalars['Float']>;
  sum__hv_transmission_line_sending_end_power_w_mono?: Maybe<Scalars['Float']>;
  sum__inverter_dc_overcurrent_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overcurrent_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_overpower_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overpower_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overpower_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overpower_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_overvoltage_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_underpower_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_underpower_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_underpower_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_underpower_loss_wh_mono: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_w_bi: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_w_mono: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_wh_bi: Scalars['Float'];
  sum__inverter_dc_undervoltage_loss_wh_mono: Scalars['Float'];
  sum__inverter_night_tare_loss_w_bi: Scalars['Float'];
  sum__inverter_night_tare_loss_w_mono: Scalars['Float'];
  sum__inverter_night_tare_loss_wh_bi: Scalars['Float'];
  sum__inverter_night_tare_loss_wh_mono: Scalars['Float'];
  sum__inverter_output_energy_stc_wh_bi?: Maybe<Scalars['Float']>;
  sum__inverter_output_energy_stc_wh_mono?: Maybe<Scalars['Float']>;
  sum__inverter_output_energy_wh_bi: Scalars['Float'];
  sum__inverter_output_energy_wh_mono: Scalars['Float'];
  sum__inverter_output_power_stc_w_bi?: Maybe<Scalars['Float']>;
  sum__inverter_output_power_stc_w_mono?: Maybe<Scalars['Float']>;
  sum__inverter_output_power_w_bi: Scalars['Float'];
  sum__inverter_output_power_w_mono: Scalars['Float'];
  sum__line_energy_loss_wh_bi: Scalars['Float'];
  sum__line_energy_loss_wh_mono: Scalars['Float'];
  sum__line_power_loss_w_bi: Scalars['Float'];
  sum__line_power_loss_w_mono: Scalars['Float'];
  sum__line_receiving_end_energy_wh_bi: Scalars['Float'];
  sum__line_receiving_end_energy_wh_mono: Scalars['Float'];
  sum__line_receiving_end_power_w_bi: Scalars['Float'];
  sum__line_receiving_end_power_w_mono: Scalars['Float'];
  sum__line_sending_end_energy_wh_bi: Scalars['Float'];
  sum__line_sending_end_energy_wh_mono: Scalars['Float'];
  sum__line_sending_end_power_w_bi: Scalars['Float'];
  sum__line_sending_end_power_w_mono: Scalars['Float'];
  sum__num_panels_in_array: Scalars['Float'];
  sum__performance_ratio_bi: Scalars['Float'];
  sum__performance_ratio_mono: Scalars['Float'];
  sum__power_factor_derate_loss_w_bi?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_w_mono?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_wh_bi?: Maybe<Scalars['Float']>;
  sum__power_factor_derate_loss_wh_mono?: Maybe<Scalars['Float']>;
  sum__pv_power_no_degradation_w_bi: Scalars['Float'];
  sum__pv_power_no_degradation_w_mono: Scalars['Float'];
  sum__pv_power_no_degradation_wh_bi: Scalars['Float'];
  sum__pv_power_no_degradation_wh_mono: Scalars['Float'];
  sum__pv_power_no_soiling_w_bi: Scalars['Float'];
  sum__pv_power_no_soiling_w_mono: Scalars['Float'];
  sum__pv_power_no_soiling_wh_bi: Scalars['Float'];
  sum__pv_power_no_soiling_wh_mono: Scalars['Float'];
  sum__pv_power_with_degradation_w_bi: Scalars['Float'];
  sum__pv_power_with_degradation_w_mono: Scalars['Float'];
  sum__pv_power_with_degradation_wh_bi: Scalars['Float'];
  sum__pv_power_with_degradation_wh_mono: Scalars['Float'];
  sum__pv_power_with_soiling_w_bi: Scalars['Float'];
  sum__pv_power_with_soiling_w_mono: Scalars['Float'];
  sum__pv_power_with_soiling_wh_bi: Scalars['Float'];
  sum__pv_power_with_soiling_wh_mono: Scalars['Float'];
  sum__self_consumption_loss_w_bi: Scalars['Float'];
  sum__self_consumption_loss_w_mono: Scalars['Float'];
  sum__self_consumption_loss_wh_bi: Scalars['Float'];
  sum__self_consumption_loss_wh_mono: Scalars['Float'];
  sum__soiling_loss_w_bi: Scalars['Float'];
  sum__soiling_loss_w_mono: Scalars['Float'];
  sum__soiling_loss_wh_bi: Scalars['Float'];
  sum__soiling_loss_wh_mono: Scalars['Float'];
  sum__stc_pv_power: Scalars['Float'];
  sum__sun_azimuth_deg: Scalars['Float'];
  sum__sun_zenith_deg: Scalars['Float'];
  sum__temperature_c: Scalars['Float'];
  sum__temperature_derating_loss_w_bi: Scalars['Float'];
  sum__temperature_derating_loss_w_mono: Scalars['Float'];
  sum__temperature_derating_loss_wh_bi: Scalars['Float'];
  sum__temperature_derating_loss_wh_mono: Scalars['Float'];
  sum__total_degradation_loss_w_bi: Scalars['Float'];
  sum__total_degradation_loss_w_mono: Scalars['Float'];
  sum__total_degradation_loss_wh_bi: Scalars['Float'];
  sum__total_degradation_loss_wh_mono: Scalars['Float'];
  sum__total_inverter_loss_w_bi: Scalars['Float'];
  sum__total_inverter_loss_w_mono: Scalars['Float'];
  sum__total_inverter_loss_wh_bi: Scalars['Float'];
  sum__total_inverter_loss_wh_mono: Scalars['Float'];
  sum__transformer_copper_loss_w_bi: Scalars['Float'];
  sum__transformer_copper_loss_w_mono: Scalars['Float'];
  sum__transformer_copper_loss_wh_bi: Scalars['Float'];
  sum__transformer_copper_loss_wh_mono: Scalars['Float'];
  sum__transformer_energy_loss_wh_bi: Scalars['Float'];
  sum__transformer_energy_loss_wh_mono: Scalars['Float'];
  sum__transformer_input_energy_wh_bi: Scalars['Float'];
  sum__transformer_input_energy_wh_mono: Scalars['Float'];
  sum__transformer_input_power_w_bi: Scalars['Float'];
  sum__transformer_input_power_w_mono: Scalars['Float'];
  sum__transformer_iron_core_loss_w_bi: Scalars['Float'];
  sum__transformer_iron_core_loss_w_mono: Scalars['Float'];
  sum__transformer_iron_core_loss_wh_bi: Scalars['Float'];
  sum__transformer_iron_core_loss_wh_mono: Scalars['Float'];
  sum__transformer_output_energy_wh_bi: Scalars['Float'];
  sum__transformer_output_energy_wh_mono: Scalars['Float'];
  sum__transformer_output_power_w_bi: Scalars['Float'];
  sum__transformer_output_power_w_mono: Scalars['Float'];
  sum__transformer_power_loss_w_bi: Scalars['Float'];
  sum__transformer_power_loss_w_mono: Scalars['Float'];
  sum__transmission_line_energy_loss_wh_bi: Scalars['Float'];
  sum__transmission_line_energy_loss_wh_mono: Scalars['Float'];
  sum__transmission_line_power_loss_w_bi: Scalars['Float'];
  sum__transmission_line_power_loss_w_mono: Scalars['Float'];
  sum__transmission_line_receiving_end_energy_wh_bi: Scalars['Float'];
  sum__transmission_line_receiving_end_energy_wh_mono: Scalars['Float'];
  sum__transmission_line_receiving_end_power_w_bi: Scalars['Float'];
  sum__transmission_line_receiving_end_power_w_mono: Scalars['Float'];
  sum__transmission_line_sending_end_energy_wh_bi: Scalars['Float'];
  sum__transmission_line_sending_end_energy_wh_mono: Scalars['Float'];
  sum__transmission_line_sending_end_power_w_bi: Scalars['Float'];
  sum__transmission_line_sending_end_power_w_mono: Scalars['Float'];
};

export type SimulationTimestamp = {
  __typename?: 'SimulationTimestamp';
  dt_timestamp: Scalars['DateTime'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type StorageFile = {
  __typename?: 'StorageFile';
  is_dir: Scalars['Boolean'];
  name: Scalars['String'];
  path: Scalars['String'];
  size: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type SunRiseSet = {
  __typename?: 'SunRiseSet';
  dt_timestamp: Scalars['String'];
  sunrise: Scalars['String'];
  sunset: Scalars['String'];
};

export type SystemParameters = {
  __typename?: 'SystemParameters';
  bandgap_temperature_coefficient?: Maybe<Scalars['Float']>;
  cell_material_bandgap?: Maybe<Scalars['Float']>;
  cell_temperature_model?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  desoto_panel_technology?: Maybe<Scalars['String']>;
  faiman_u0?: Maybe<Scalars['Float']>;
  faiman_u1?: Maybe<Scalars['Float']>;
  grid_injection_limit?: Maybe<Scalars['Float']>;
  grid_injection_limit_enabled: Scalars['Boolean'];
  hv_stage_enabled: Scalars['Boolean'];
  id: Scalars['String'];
  project_id: Scalars['String'];
  pv_hv_ac_wire?: Maybe<PvAcWire>;
  pv_hv_ac_wire_id?: Maybe<Scalars['String']>;
  pv_hv_transformer?: Maybe<PvTransformer>;
  pv_hv_transformer_id?: Maybe<Scalars['String']>;
  pvsyst_alpha?: Maybe<Scalars['Float']>;
  pvsyst_mounting_type?: Maybe<Scalars['String']>;
  pvsyst_uc?: Maybe<Scalars['Float']>;
  pvsyst_uv?: Maybe<Scalars['Float']>;
  sandia_a?: Maybe<Scalars['Float']>;
  sandia_b?: Maybe<Scalars['Float']>;
  sandia_delta_t?: Maybe<Scalars['Float']>;
  sandia_e0?: Maybe<Scalars['Float']>;
  sandia_panel_type?: Maybe<Scalars['String']>;
  terrain_dem_enabled: Scalars['Boolean'];
  updated_at: Scalars['DateTime'];
  voct_model?: Maybe<Scalars['String']>;
};

export type SystemParametersInput = {
  bandgap_temperature_coefficient?: InputMaybe<Scalars['Float']>;
  cell_material_bandgap?: InputMaybe<Scalars['Float']>;
  cell_temperature_model?: InputMaybe<Scalars['String']>;
  desoto_panel_technology?: InputMaybe<Scalars['String']>;
  faiman_u0?: InputMaybe<Scalars['Float']>;
  faiman_u1?: InputMaybe<Scalars['Float']>;
  grid_injection_limit?: InputMaybe<Scalars['Float']>;
  grid_injection_limit_enabled?: InputMaybe<Scalars['Boolean']>;
  hv_stage_enabled?: InputMaybe<Scalars['Boolean']>;
  project_id: Scalars['String'];
  pv_hv_ac_wire_id?: InputMaybe<Scalars['String']>;
  pv_hv_transformer_id?: InputMaybe<Scalars['String']>;
  pvsyst_alpha?: InputMaybe<Scalars['Float']>;
  pvsyst_mounting_type?: InputMaybe<Scalars['String']>;
  pvsyst_uc?: InputMaybe<Scalars['Float']>;
  pvsyst_uv?: InputMaybe<Scalars['Float']>;
  sandia_a?: InputMaybe<Scalars['Float']>;
  sandia_b?: InputMaybe<Scalars['Float']>;
  sandia_delta_t?: InputMaybe<Scalars['Float']>;
  sandia_e0?: InputMaybe<Scalars['Float']>;
  sandia_panel_type?: InputMaybe<Scalars['String']>;
  terrain_dem_enabled?: InputMaybe<Scalars['Boolean']>;
  voct_model?: InputMaybe<Scalars['String']>;
};

export enum TerrainType {
  Flat = 'flat',
  Slope = 'slope'
}

export type TimeRange = {
  __typename?: 'TimeRange';
  end: DateTimeObject;
  start: DateTimeObject;
};

export type TimeRangeInput = {
  end: DateTimeObjectInput;
  start: DateTimeObjectInput;
};

export type TimeSelectionRangeInput = {
  end?: InputMaybe<TimeSelectionRangeInterval>;
  start?: InputMaybe<TimeSelectionRangeInterval>;
};

export type TimeSelectionRangeInterval = {
  day?: InputMaybe<Scalars['Int']>;
  hour?: InputMaybe<Scalars['Int']>;
  minute?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

export enum TimestampInterval {
  FifteenMinutes = 'FifteenMinutes',
  FiveMinutes = 'FiveMinutes',
  OneDay = 'OneDay',
  OneHour = 'OneHour',
  OneMinute = 'OneMinute',
  OneMonth = 'OneMonth',
  OneWeek = 'OneWeek',
  OneYear = 'OneYear',
  TenMinutes = 'TenMinutes',
  ThirtyMinutes = 'ThirtyMinutes'
}

export type Timestamps = {
  __typename?: 'Timestamps';
  timestamps: Array<Scalars['String']>;
};

export type TokenPayload = {
  __typename?: 'TokenPayload';
  token: Scalars['String'];
};

export enum TransformerPowerLossDataSource {
  Datasheet = 'Datasheet',
  Generic = 'Generic'
}

export type UpdateCompareWorkbookInput = {
  data?: InputMaybe<Scalars['JSON']>;
  dataset_a?: InputMaybe<CompareWorkbookDatasetInput>;
  dataset_b?: InputMaybe<CompareWorkbookDatasetInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateEnviroDatasetInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  type: EnviroDatasetType;
};

export type UpdateOrganizationInput = {
  allowed_domains?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationResult = {
  __typename?: 'UpdateOrganizationResult';
  errors: Array<FieldError>;
  organization: Organization;
};

export type UpdateRasterLayerInput = {
  name?: InputMaybe<Scalars['String']>;
  opacity?: InputMaybe<Scalars['Float']>;
  origin?: InputMaybe<Scalars['JSON']>;
  pixel_ratio?: InputMaybe<Scalars['Float']>;
};

export type User = {
  __typename?: 'User';
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  has_lead_intake_form: Scalars['Boolean'];
  id: Scalars['ID'];
  last_name?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  user_identity: Array<UserIdentity>;
  user_lead_intake_form?: Maybe<UserLeadIntakeForm>;
  user_organization: Array<UserOrganization>;
};

export type UserApiToken = {
  __typename?: 'UserApiToken';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  token: Scalars['String'];
};

export type UserIdentity = {
  __typename?: 'UserIdentity';
  created_at: Scalars['DateTime'];
  email_verified: Scalars['Boolean'];
  id: Scalars['ID'];
  provider: Scalars['String'];
  provider_id: Scalars['String'];
  provider_payload: Scalars['JSON'];
  updated_at: Scalars['DateTime'];
  user: User;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  accepted_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  expires_at: Scalars['DateTime'];
  id: Scalars['ID'];
  updated_at: Scalars['DateTime'];
};

export type UserLeadIntakeForm = {
  __typename?: 'UserLeadIntakeForm';
  company_name?: Maybe<Scalars['String']>;
  company_type?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  features: Scalars['JSON'];
  id: Scalars['ID'];
  is_complete: Scalars['Boolean'];
  position?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  use_cases: Scalars['JSON'];
  user: User;
};

export type UserLeadIntakeFormInput = {
  company_name?: InputMaybe<Scalars['String']>;
  company_type?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Scalars['JSON']>;
  first_name?: InputMaybe<Scalars['String']>;
  is_complete?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  use_cases?: InputMaybe<Scalars['JSON']>;
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  organization: Organization;
  role: Role;
  role_id: Scalars['String'];
  updated_at: Scalars['DateTime'];
  user: User;
};

export type UserRequest = {
  __typename?: 'UserRequest';
  approved_at?: Maybe<Scalars['DateTime']>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  organization_id: Scalars['String'];
  rejected_at?: Maybe<Scalars['DateTime']>;
  reviewed_by?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  user: User;
  user_id: Scalars['String'];
};

export type InviteUserMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser: { __typename?: 'UserInvite', id: string, email: string, created_at: any, updated_at: any, expires_at: any } };

export type InviteOrganizationUserMutationVariables = Exact<{
  email: Scalars['String'];
  organization_id: Scalars['String'];
}>;


export type InviteOrganizationUserMutation = { __typename?: 'Mutation', inviteOrganizationUser: { __typename?: 'UserInvite', id: string, email: string, created_at: any, updated_at: any, expires_at: any } };

export type ImpersonateUserMutationVariables = Exact<{
  email: Scalars['String'];
  reason: Scalars['String'];
  remarks?: InputMaybe<Scalars['String']>;
}>;


export type ImpersonateUserMutation = { __typename?: 'Mutation', impersonateUser: { __typename?: 'TokenPayload', token: string } };

export type EndImpersonateUserMutationVariables = Exact<{ [key: string]: never; }>;


export type EndImpersonateUserMutation = { __typename?: 'Mutation', endImpersonate: any };

export type AdminUsersQueryVariables = Exact<{
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['String']>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', usersCount: number, users: Array<{ __typename?: 'User', id: string, created_at: any, email: string, first_name?: string | null, last_name?: string | null, user_organization: Array<{ __typename?: 'UserOrganization', organization: { __typename?: 'Organization', id: string, name: string } }> }> };

export type UserInvitesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  accepted?: InputMaybe<Scalars['Boolean']>;
  organization_id?: InputMaybe<Scalars['String']>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
}>;


export type UserInvitesQuery = { __typename?: 'Query', userInvites?: Array<{ __typename?: 'UserInvite', id: string, email: string, created_at: any, expires_at: any, updated_at: any }> | null };

export type AcceptUserInviteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type AcceptUserInviteMutation = { __typename?: 'Mutation', acceptUserInvite?: { __typename?: 'ExpandedUserInvite', id: string, organization_slug?: string | null } | null };

export type DeleteUserInviteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserInviteMutation = { __typename?: 'Mutation', deleteUserInvite: { __typename?: 'UserInvite', id: string } };

export type UploadInverterDatasetMutationVariables = Exact<{
  data: Array<CreateCecInverterInput> | CreateCecInverterInput;
}>;


export type UploadInverterDatasetMutation = { __typename?: 'Mutation', upsertCecInverters: number };

export type AdminUserMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminUserMeQuery = { __typename?: 'Query', adminMe: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, created_at: any, updated_at: any, has_lead_intake_form: boolean, user_identity: Array<{ __typename?: 'UserIdentity', id: string, provider: string, email_verified: boolean, provider_payload: any }>, user_organization: Array<{ __typename?: 'UserOrganization', organization: { __typename?: 'Organization', id: string, name: string, slug: string } }> } };

export type AdminCopyProjectToSelfMutationVariables = Exact<{
  copyProjectName: Scalars['String'];
  sourceProjectId: Scalars['String'];
}>;


export type AdminCopyProjectToSelfMutation = { __typename?: 'Mutation', adminCopyProjectToSelf: { __typename?: 'Project', id: string } };

export type AdminFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminFeatureFlagsQuery = { __typename?: 'Query', allFeatureFlags: Array<{ __typename?: 'AdminFeatureFlag', id: string, enabled: boolean, constraints: Array<{ __typename?: 'AdminFeatureFlagConstraint', key: string, value: Array<string>, enabled: boolean }> }> };

export type AdminUpdateFeatureFlagMutationVariables = Exact<{
  flag_input: AdminFeatureFlagInput;
}>;


export type AdminUpdateFeatureFlagMutation = { __typename?: 'Mutation', updateFeatureFlag: boolean };

export type AdminProjectExportQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type AdminProjectExportQuery = { __typename?: 'Query', adminProjectExport: any };

export type PendingUserRequestsQueryVariables = Exact<{
  organization_id: Scalars['String'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
}>;


export type PendingUserRequestsQuery = { __typename?: 'Query', userRequests?: Array<{ __typename?: 'UserRequest', id: string, created_at: any, updated_at: any, user: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } }> | null };

export type ApproveUserRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ApproveUserRequestMutation = { __typename?: 'Mutation', approveUserRequest: { __typename?: 'UserRequest', id: string } };

export type RejectUserRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RejectUserRequestMutation = { __typename?: 'Mutation', rejectUserRequest: { __typename?: 'UserRequest', id: string } };

export type DeleteUserRequestMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserRequestMutation = { __typename?: 'Mutation', deleteUserRequest: { __typename?: 'UserRequest', id: string } };

export type CreateUserRequestMutationVariables = Exact<{
  organization_id: Scalars['String'];
}>;


export type CreateUserRequestMutation = { __typename?: 'Mutation', createUserRequest: { __typename?: 'UserRequest', id: string } };

export type AdminGetOrgIntegrationServersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['String']>;
}>;


export type AdminGetOrgIntegrationServersQuery = { __typename?: 'Query', adminOrganizationIntegrationServers: Array<{ __typename?: 'OrganizationIntegrationServer', id: string, organization_id: string, url: string, ping: boolean, bearer_token: string, organization: { __typename?: 'Organization', slug: string, name: string } }> };

export type AdminGetOrgIntegrationServerApiSpecQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type AdminGetOrgIntegrationServerApiSpecQuery = { __typename?: 'Query', adminOrganizationIntegrationServers: Array<{ __typename?: 'OrganizationIntegrationServer', api_spec?: any | null }> };

export type AdminUpsertOrgIntegrationServerMutationVariables = Exact<{
  orgIntegrationServerInput: OrganizationIntegrationServerInput;
  skipTokenGeneration?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminUpsertOrgIntegrationServerMutation = { __typename?: 'Mutation', adminUpsertOrganizationIntegrationServer: string };

export type AdminAddOrgIntegrationTryFetchQueryVariables = Exact<{
  url: Scalars['String'];
  bearer_token: Scalars['String'];
}>;


export type AdminAddOrgIntegrationTryFetchQuery = { __typename?: 'Query', adminUpsertOrganizationIntegrationServerTryFetch: any };

export type AdminDeleteOrgIntegrationServerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminDeleteOrgIntegrationServerMutation = { __typename?: 'Mutation', adminDeleteOrganizationIntegrationServer: boolean };

export type AdminOrgIntegrationSchedulesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AdminOrgIntegrationSchedulesQuery = { __typename?: 'Query', adminOrganizationIntegrationServers: Array<{ __typename?: 'OrganizationIntegrationServer', registered_schedulers?: any | null }>, adminOrganizationIntegrationServerSchedules: Array<{ __typename?: 'OrganizationIntegrationServerSchedule', project_id?: string | null, schedule_id: string, job_name: string, job_type: string, job_data: any, crontab: string, created_at: any, updated_at: any, project?: { __typename?: 'Project', name: string } | null }> };

export type AdminUpsertOrgIntegrationScheduleMutationVariables = Exact<{
  organizationIntegrationServerScheduleInput: OrganizationIntegrationServerScheduleInput;
}>;


export type AdminUpsertOrgIntegrationScheduleMutation = { __typename?: 'Mutation', adminUpsertOrganizationIntegrationServerSchedule: { __typename?: 'OrganizationIntegrationServerSchedule', job_name: string, job_type: string, schedule_id: string } };

export type AdminDeleteOrgIntegrationScheduleMutationVariables = Exact<{
  integration_server_id: Scalars['String'];
  schedule_id: Scalars['String'];
}>;


export type AdminDeleteOrgIntegrationScheduleMutation = { __typename?: 'Mutation', adminDeleteOrganizationIntegrationServerSchedule: { __typename?: 'OrganizationIntegrationServerSchedule', schedule_id: string } };

export type AdminMakeOrgIntegrationRequestMutationVariables = Exact<{
  id: Scalars['String'];
  endpoint: Scalars['String'];
  method: Scalars['String'];
  body?: InputMaybe<Scalars['JSON']>;
}>;


export type AdminMakeOrgIntegrationRequestMutation = { __typename?: 'Mutation', adminMakeOrganizationIntegrationServerRequest: any };

export type AdminGetOrgIntegrationServerJobEventsQueryVariables = Exact<{
  integration_server_id?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type AdminGetOrgIntegrationServerJobEventsQuery = { __typename?: 'Query', adminOrganizationIntegrationServerJobEvents: Array<{ __typename?: 'OrganizationIntegrationServerJob', id: string, parent_job_id?: string | null, status: string, job_name: string, created_at: any, updated_at: any, integration_server: { __typename?: 'OrganizationIntegrationServer', id: string, organization: { __typename?: 'Organization', name: string, slug: string } }, job_events: Array<{ __typename?: 'OrganizationIntegrationServerJobEvent', event_type: string, event_data: any, job_data: any, created_at: any, updated_at: any }> }> };

export type LocalLoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LocalLoginMutation = { __typename?: 'Mutation', localLogin: { __typename: 'AuthError', code: AuthErrorCode, message: string } | { __typename: 'TokenPayload', token: string } };

export type RefreshTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type RefreshTokenQuery = { __typename?: 'Query', refreshToken: { __typename: 'AuthError', code: AuthErrorCode, message: string } | { __typename: 'TokenPayload', token: string } };

export type InvitationTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type InvitationTokenQuery = { __typename?: 'Query', invitation?: { __typename?: 'ExpandedUserInvite', id: string, email: string, user_registered: boolean, organization_slug?: string | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename: 'AuthError', code: AuthErrorCode, message: string } | { __typename: 'TokenPayload', token: string } };

export type FirebaseAppLoginMutationVariables = Exact<{
  token: Scalars['String'];
  credential: Scalars['JSON'];
  invite_id?: InputMaybe<Scalars['String']>;
}>;


export type FirebaseAppLoginMutation = { __typename?: 'Mutation', firebaseLogin: { __typename: 'AuthError', code: AuthErrorCode, message: string } | { __typename: 'TokenPayload', token: string } };

export type FirebaseAppRegisterMutationVariables = Exact<{
  token: Scalars['String'];
  credential: Scalars['JSON'];
  invite_id?: InputMaybe<Scalars['String']>;
}>;


export type FirebaseAppRegisterMutation = { __typename?: 'Mutation', firebaseRegister: { __typename: 'AuthError', code: AuthErrorCode, message: string } | { __typename: 'TokenPayload', token: string } };

export type FirebaseResendEmailVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type FirebaseResendEmailVerificationMutation = { __typename?: 'Mutation', firebaseSendEmailVerification: { __typename: 'AuthError' } | { __typename: 'MutationFirebaseSendEmailVerificationSuccess' } };

export type FirebaseEmailVerificationSuccessMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type FirebaseEmailVerificationSuccessMutation = { __typename?: 'Mutation', firebaseEmailVerificationSuccess: { __typename: 'AuthError' } | { __typename: 'MutationFirebaseEmailVerificationSuccessSuccess' } };

export type FirebaseSyncUserIdentityMutationVariables = Exact<{ [key: string]: never; }>;


export type FirebaseSyncUserIdentityMutation = { __typename?: 'Mutation', firebaseSyncUserIdentity: { __typename: 'AuthError' } | { __typename: 'MutationFirebaseSyncUserIdentitySuccess' } };

export type LocalEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalEmailQuery = { __typename?: 'Query', localEmails: Array<{ __typename?: 'LocalEmail', id: string, to: string, subject: string, html: string }> };

export type FeatureFlagsQueryVariables = Exact<{
  project_id?: InputMaybe<Scalars['String']>;
}>;


export type FeatureFlagsQuery = { __typename?: 'Query', featureFlags: Array<{ __typename?: 'FeatureFlag', id: string, constraint?: { __typename?: 'FeatureFlagConstraint', key: string, value: string } | null }> };

export type GetAvailableMeteoDatasetsQueryVariables = Exact<{
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  sources: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetAvailableMeteoDatasetsQuery = { __typename?: 'Query', searchMeteoDatasets: Array<{ __typename?: 'AvailableThirdPartyDataset', source: string, dataset_name: string, display_name: string, available_intervals: Array<number>, available_years: any }> };

export type AddAvailableMeteoDatasetMutationVariables = Exact<{
  project_id: Scalars['String'];
  display_name?: InputMaybe<Scalars['String']>;
  dataset_name: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  source: Scalars['String'];
  intervals: Array<Scalars['Int']> | Scalars['Int'];
  nsrdb_tmy_years?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  years?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AddAvailableMeteoDatasetMutation = { __typename?: 'Mutation', addMeteoDataset: boolean };

export type LabelledEventsQueryVariables = Exact<{
  project_id: Scalars['String'];
  date_range: DateRangeArgs;
  interval: TimestampInterval;
  sentinel_tag?: InputMaybe<Scalars['String']>;
}>;


export type LabelledEventsQuery = { __typename?: 'Query', labelledEvents: Array<{ __typename?: 'LabelledEvent', ts: string, duet_block_id?: string | null, hierarchy_id?: string | null, component: string, event_type: string, sensor_value?: number | null, model_value?: number | null, measurable?: number | null, delta?: number | null }> };

export type SensorDataModelledHierarchyQueryVariables = Exact<{
  project_id: Scalars['String'];
  hierarchy_id?: InputMaybe<Scalars['String']>;
  block_id?: InputMaybe<Scalars['String']>;
  component: SensorHierarchyComponent;
  component_measure: SensorHierarchyComponentMeasure;
  date_range: DateRangeArgs;
  interval: TimestampInterval;
  sentinel_tag?: InputMaybe<Scalars['String']>;
  power_to_energy?: InputMaybe<Scalars['Boolean']>;
}>;


export type SensorDataModelledHierarchyQuery = { __typename?: 'Query', sensorDataModelled: Array<{ __typename?: 'SensorDataModelled', ts: string, duet_block_id?: string | null, hierarchy_id?: string | null, sensor_value?: number | null, model_value: number, performance_index?: number | null }> };

export type SensorDataModelledQueryVariables = Exact<{
  project_id: Scalars['String'];
  hierarchy_id?: InputMaybe<Scalars['String']>;
  block_id?: InputMaybe<Scalars['String']>;
  component: SensorHierarchyComponent;
  component_measure: SensorHierarchyComponentMeasure;
  date_range: DateRangeArgs;
  interval: TimestampInterval;
  sentinel_tag?: InputMaybe<Scalars['String']>;
  power_to_energy?: InputMaybe<Scalars['Boolean']>;
}>;


export type SensorDataModelledQuery = { __typename?: 'Query', sensorDataModelled: Array<{ __typename?: 'SensorDataModelled', ts: string, duet_block_id?: string | null, sensor_value?: number | null, model_value: number, performance_index?: number | null }> };

export type SensorDataModelledSystemQueryVariables = Exact<{
  project_id: Scalars['String'];
  component: SensorHierarchyComponent;
  component_measure: SensorHierarchyComponentMeasure;
  date_range: DateRangeArgs;
  interval: TimestampInterval;
  sentinel_tag?: InputMaybe<Scalars['String']>;
  power_to_energy?: InputMaybe<Scalars['Boolean']>;
}>;


export type SensorDataModelledSystemQuery = { __typename?: 'Query', sensorDataModelledSystem: Array<{ __typename?: 'SensorDataModelled', ts: string, duet_block_id?: string | null, sensor_value?: number | null, model_value: number, performance_index?: number | null }> };

export type SentinelDeploymentQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type SentinelDeploymentQuery = { __typename?: 'Query', blocks: Array<{ __typename?: 'Block', id: string, name: string }>, blockLayers: Array<{ __typename?: 'BlockLayer', block_id?: string | null, type: string, geojson: any }>, sentinelDeployment: { __typename?: 'SentinelDeployment', id: string, time_interval: number }, sensorDataHierarchy: Array<{ __typename?: 'SensorDataHierarchy', id: string, parent_id?: string | null, name: string, duet_block_id?: string | null, sensor_tag: string, component: string, component_measure?: string | null, duet_measure?: string | null, inverter_dc_capacity?: number | null, sentinel_tag?: string | null, sensor_time_interval?: number | null }>, modelledMonths: { __typename?: 'Timestamps', timestamps: Array<string> }, dailyTimestamps: { __typename?: 'Timestamps', timestamps: Array<string> } };

export type SentinelPortfoliosQueryVariables = Exact<{
  organization_id: Scalars['String'];
}>;


export type SentinelPortfoliosQuery = { __typename?: 'Query', sentinelPortfolios: Array<string> };

export type SentinelIssueSummaryQueryVariables = Exact<{
  project_id: Scalars['String'];
  date_range: DateRangeArgs;
  block_id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<TimestampInterval>;
  hierarchy_component?: InputMaybe<SensorHierarchyComponent>;
  status?: InputMaybe<Scalars['String']>;
}>;


export type SentinelIssueSummaryQuery = { __typename?: 'Query', sentinelIssueSummary: Array<{ __typename?: 'IssueSummary', duet_block_id?: string | null, hierarchy_ids: Array<string>, hierarchy_component: string, source: string, type: string, status: string, dt_timestamp: string, loss: number, count: number }> };

export type SentinelMeteoSummaryQueryVariables = Exact<{
  project_id: Scalars['String'];
  date_range: DateRangeArgs;
  interval: DateBinInterval;
}>;


export type SentinelMeteoSummaryQuery = { __typename?: 'Query', dailyData: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, avg__ghi_wm2: number, min__ghi_wm2: number, p10__ghi_wm2: number, p25__ghi_wm2: number, p50__ghi_wm2: number, p75__ghi_wm2: number, p90__ghi_wm2: number, max__ghi_wm2: number, avg__dhi_wm2: number, min__dhi_wm2: number, p10__dhi_wm2: number, p25__dhi_wm2: number, p50__dhi_wm2: number, p75__dhi_wm2: number, p90__dhi_wm2: number, max__dhi_wm2: number, avg__dni_wm2: number, min__dni_wm2: number, p10__dni_wm2: number, p25__dni_wm2: number, p50__dni_wm2: number, p75__dni_wm2: number, p90__dni_wm2: number, max__dni_wm2: number, avg__temperature_c: number, min__temperature_c: number, p10__temperature_c: number, p25__temperature_c: number, p50__temperature_c: number, p75__temperature_c: number, p90__temperature_c: number, max__temperature_c: number }>, hourlyData: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, avg__ghi_wm2: number, avg__dhi_wm2: number, avg__dni_wm2: number, avg__temperature_c: number }> };

export type SentinelSystemLossSummaryQueryVariables = Exact<{
  project_id: Scalars['String'];
  date_range: DateRangeArgs;
}>;


export type SentinelSystemLossSummaryQuery = { __typename?: 'Query', sentinelSimulationSummary: Array<{ __typename?: 'SimulationSummary', sum__array_cell_max_energy_t_stc_mono?: number | null, sum__array_cell_energy_mono?: number | null, sum__energy_mono: number, sum__transformer_input_energy_wh_mono: number, sum__transformer_output_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__pv_power_with_soiling_wh_mono: number, sum__soiling_loss_wh_mono: number, sum__pv_power_no_degradation_wh_mono: number, sum__pv_power_with_degradation_wh_mono: number, sum__total_degradation_loss_wh_mono: number, sum__degradation_loss_first_year_wh_mono: number, sum__degradation_loss_remaining_years_wh_mono: number, sum__line_sending_end_energy_wh_mono: number, sum__line_receiving_end_energy_wh_mono: number, sum__line_energy_loss_wh_mono: number, sum__transmission_line_sending_end_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__transmission_line_energy_loss_wh_mono: number, sum__transformer_energy_loss_wh_mono: number, sum__transformer_iron_core_loss_wh_mono: number, sum__transformer_copper_loss_wh_mono: number, sum__self_consumption_loss_wh_mono: number, sum__ac_power_clipping_loss_wh_mono: number, sum__inverter_night_tare_loss_wh_mono: number, sum__inverter_dc_undervoltage_loss_wh_mono: number, sum__inverter_dc_overvoltage_loss_wh_mono: number, sum__inverter_dc_underpower_loss_wh_mono: number, sum__inverter_dc_overpower_loss_wh_mono: number, sum__inverter_dc_overcurrent_loss_wh_mono: number, sum__power_factor_derate_loss_wh_mono?: number | null, sum__below_min_temperature_loss_wh_mono: number, sum__above_max_temperature_loss_wh_mono: number, sum__temperature_derating_loss_wh_mono: number, sum__total_inverter_loss_wh_mono: number, sum__inverter_output_energy_stc_wh_mono?: number | null, sum__ghi_whm2: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_far_shading_whm2?: number | null, sum__gti_f_pvsyst_with_near_shading_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null, sum__hv_transformer_input_energy_wh_mono?: number | null, sum__hv_transformer_iron_core_loss_wh_mono?: number | null, sum__hv_transformer_copper_loss_wh_mono?: number | null, sum__hv_transformer_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_sending_end_energy_wh_mono?: number | null, sum__array_cell_max_energy_t_stc_bi?: number | null, sum__array_cell_energy_bi?: number | null, sum__energy_bi: number, sum__transformer_input_energy_wh_bi: number, sum__transformer_output_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__pv_power_with_soiling_wh_bi: number, sum__soiling_loss_wh_bi: number, sum__pv_power_no_degradation_wh_bi: number, sum__pv_power_with_degradation_wh_bi: number, sum__total_degradation_loss_wh_bi: number, sum__degradation_loss_first_year_wh_bi: number, sum__degradation_loss_remaining_years_wh_bi: number, sum__line_sending_end_energy_wh_bi: number, sum__line_receiving_end_energy_wh_bi: number, sum__line_energy_loss_wh_bi: number, sum__transmission_line_sending_end_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__transmission_line_energy_loss_wh_bi: number, sum__transformer_energy_loss_wh_bi: number, sum__transformer_iron_core_loss_wh_bi: number, sum__transformer_copper_loss_wh_bi: number, sum__self_consumption_loss_wh_bi: number, sum__ac_power_clipping_loss_wh_bi: number, sum__inverter_night_tare_loss_wh_bi: number, sum__inverter_dc_undervoltage_loss_wh_bi: number, sum__inverter_dc_overvoltage_loss_wh_bi: number, sum__inverter_dc_underpower_loss_wh_bi: number, sum__inverter_dc_overpower_loss_wh_bi: number, sum__inverter_dc_overcurrent_loss_wh_bi: number, sum__power_factor_derate_loss_wh_bi?: number | null, sum__below_min_temperature_loss_wh_bi: number, sum__above_max_temperature_loss_wh_bi: number, sum__temperature_derating_loss_wh_bi: number, sum__total_inverter_loss_wh_bi: number, sum__inverter_output_energy_stc_wh_bi?: number | null, sum__ghi_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_with_diffuse_whm2?: number | null, sum__gti_r_pvsyst_with_direct_whm2?: number | null, sum__gti_r_pvsyst_with_structure_whm2?: number | null, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__hv_transformer_input_energy_wh_bi?: number | null, sum__hv_transformer_iron_core_loss_wh_bi?: number | null, sum__hv_transformer_copper_loss_wh_bi?: number | null, sum__hv_transformer_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_sending_end_energy_wh_bi?: number | null }>, blocks: Array<{ __typename?: 'Block', id: string, created_at: any, updated_at: any, name: string, enviro_dataset_id?: string | null, pv_system_start_date?: string | null, cleaning_interval_days?: number | null, soiling_rate?: number | null, power_factor?: number | null, date_of_most_recent_cleaning?: string | null, pv_soiling_algorithm?: string | null, soiling_rates_percentage?: any | null, num_inverters?: number | null, slope_azimuth?: number | null, slope_tilt?: number | null, follow_slope?: boolean | null, slope_aware_tracking?: boolean | null, terrain_type: TerrainType, pv_table_id?: string | null, pv_panel_id?: string | null, pv_inverter_id?: string | null, pv_transformer_id?: string | null, pv_dc_wire_id?: string | null, pv_ac_wire_id?: string | null, pv_panel?: { __typename?: 'PvPanel', panel_edge_lr?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, cell_length?: number | null, cell_width?: number | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, cells?: Array<number | null> | null, ideality_factor?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, series_resistance?: number | null, shunt_resistance?: number | null, cell_type?: string | null, panel_type?: string | null, bifaciality_current_ratio?: number | null, parallel_string_per_diode?: Array<number | null> | null } | null, pv_table?: { __typename?: 'PvTable', num_cols?: any | null, num_tiers?: number | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, column_gap?: number | null, azimuth?: number | null, orientation_str?: string | null } | null }>, blockLayers: Array<{ __typename?: 'BlockLayer', id: string, block_id?: string | null, project_id: string, name: string, type: string, geojson: any, source_type?: string | null, source_filename?: string | null, source_url?: string | null, created_at: any, updated_at: any }> };

export type SentinelAvailableEnergySummaryQueryVariables = Exact<{
  project_id: Scalars['String'];
  block_id?: InputMaybe<Scalars['String']>;
  date_range: DateRangeArgs;
}>;


export type SentinelAvailableEnergySummaryQuery = { __typename?: 'Query', sentinelSimulationSummary: Array<{ __typename?: 'SimulationSummary', sum__available_energy_wh_bi: number }> };

export type SentinelSimulationTimeseriesQueryVariables = Exact<{
  project_id: Scalars['String'];
  date_args: DateArgsInput;
  sentinel_tag?: InputMaybe<Scalars['String']>;
}>;


export type SentinelSimulationTimeseriesQuery = { __typename?: 'Query', sentinelSimulationTimeSeriesSummary: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, avg__ghi_wm2: number, avg__dhi_wm2: number, avg__dni_wm2: number, avg__temperature_c: number }> };

export type UserOnboardingIntakeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOnboardingIntakeQuery = { __typename?: 'Query', me: { __typename?: 'User', first_name?: string | null, last_name?: string | null, user_lead_intake_form?: { __typename?: 'UserLeadIntakeForm', company_name?: string | null, company_type?: string | null, position?: string | null, use_cases: any, features: any, is_complete: boolean } | null } };

export type UpdateUserOnboardingIntakeMutationVariables = Exact<{
  input: UserLeadIntakeFormInput;
}>;


export type UpdateUserOnboardingIntakeMutation = { __typename?: 'Mutation', updateUserIntakeForm: { __typename?: 'UserLeadIntakeForm', id: string } };

export type OrganizationFragmentFragment = { __typename?: 'Organization', id: string, name: string, slug: string, allowed_domains: Array<string>, user_organization: Array<{ __typename?: 'UserOrganization', id: string, role_id: string, user: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } }> };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, name: string, slug: string, allowed_domains: Array<string>, user_organization: Array<{ __typename?: 'UserOrganization', id: string, role_id: string, user: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } }> } };

export type GetOrganizationsQueryVariables = Exact<{
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string, slug: string, allowed_domains: Array<string>, user_organization: Array<{ __typename?: 'UserOrganization', id: string, role_id: string, user: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } }> }> };

export type GetDomainMatchingOrganizationsQueryVariables = Exact<{
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
}>;


export type GetDomainMatchingOrganizationsQuery = { __typename?: 'Query', domainMatchingOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, slug: string, allowed_domains: Array<string>, user_request: Array<{ __typename?: 'UserRequest', id: string, approved_at?: any | null, rejected_at?: any | null, user: { __typename?: 'User', id: string } }>, user_organization: Array<{ __typename?: 'UserOrganization', id: string, role_id: string, user: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } }> }> };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, slug: string, allowed_domains: Array<string>, user_organization: Array<{ __typename?: 'UserOrganization', id: string, role_id: string, user: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } }> } };

export type UpdateOrganizationMutationVariables = Exact<{
  data: UpdateOrganizationInput;
  id: Scalars['String'];
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationResult', organization: { __typename?: 'Organization', id: string, name: string, slug: string, allowed_domains: Array<string>, user_organization: Array<{ __typename?: 'UserOrganization', id: string, role_id: string, user: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } }> }, errors: Array<{ __typename?: 'FieldError', message: string, field: string }> } };

export type UpdateOrganizationUserRoleMutationVariables = Exact<{
  user_id: Scalars['String'];
  role_id: Scalars['String'];
}>;


export type UpdateOrganizationUserRoleMutation = { __typename?: 'Mutation', upsertOrganizationUser: { __typename?: 'UserOrganization', role_id: string } };

export type DeleteOrganizationUserMutationVariables = Exact<{
  user_id: Scalars['String'];
}>;


export type DeleteOrganizationUserMutation = { __typename?: 'Mutation', deleteOrganizationUser: boolean };

export type OrganizationProjectsQueryVariables = Exact<{
  organization_id: Scalars['String'];
}>;


export type OrganizationProjectsQuery = { __typename?: 'Query', organizationProjects: Array<{ __typename?: 'Project', id: string, name: string, org_general_access: boolean, pvsyst_import_in_progress?: boolean | null, created_at: any, last_activity_at: any, organization_id: string, project_users: Array<{ __typename?: 'ProjectUser', id: string, role_id: string, user: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } }> }> };

export type PlantPlaybackIndexQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type PlantPlaybackIndexQuery = { __typename?: 'Query', projectFileStorage: Array<{ __typename?: 'StorageFile', is_dir: boolean, path: string, name: string, url?: string | null }> };

export type PlantPlaybackQueryVariables = Exact<{
  project_id: Scalars['String'];
  plant_playback_id: Scalars['String'];
}>;


export type PlantPlaybackQuery = { __typename?: 'Query', plantPlayback: { __typename?: 'PlantPlaybackData', rows: Array<any>, columns: Array<string> } };

export type PlantPlaybackGeoJsonQueryVariables = Exact<{
  project_id: Scalars['String'];
  plant_playback_id: Scalars['String'];
}>;


export type PlantPlaybackGeoJsonQuery = { __typename?: 'Query', plantPlaybackGeoJson: any };

export type AssignProjectRoleMutationVariables = Exact<{
  project_id: Scalars['String'];
  role_id: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type AssignProjectRoleMutation = { __typename?: 'Mutation', assignProjectRole: { __typename?: 'ProjectUser', id: string } };

export type ListCompareDatasetsQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type ListCompareDatasetsQuery = { __typename?: 'Query', projectFileStorage: Array<{ __typename?: 'StorageFile', path: string, name: string, size: string, is_dir: boolean, url?: string | null }>, projectDuetSim: Array<{ __typename?: 'DuetSimulation', id: string, name: string, duet_job_id: string, created_at: any }> };

export type GetCompareWorkbooksQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  project_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompareWorkbooksQuery = { __typename?: 'Query', compareWorkbooks: Array<{ __typename?: 'CompareWorkbook', id: string, created_at: any, updated_at: any, name: string, data: any, dataset_a?: { __typename?: 'CompareWorkbookDataset', id: string, label: string, source: string } | null, dataset_b?: { __typename?: 'CompareWorkbookDataset', id: string, label: string, source: string } | null }> };

export type CreateCompareWorkbookMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
}>;


export type CreateCompareWorkbookMutation = { __typename?: 'Mutation', createCompareWorkbook: { __typename?: 'CompareWorkbook', id: string } };

export type UpdateCompareWorkbookMutationVariables = Exact<{
  id: Scalars['String'];
  project_id: Scalars['String'];
  data: UpdateCompareWorkbookInput;
}>;


export type UpdateCompareWorkbookMutation = { __typename?: 'Mutation', updateCompareWorkbook: { __typename?: 'CompareWorkbook', id: string } };

export type DeleteCompareWorkbookMutationVariables = Exact<{
  id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type DeleteCompareWorkbookMutation = { __typename?: 'Mutation', deleteCompareWorkbook: { __typename?: 'CompareWorkbook', id: string } };

export type BlockLayerFragment = { __typename?: 'BlockLayer', id: string, block_id?: string | null, project_id: string, name: string, type: string, geojson: any, source_type?: string | null, source_filename?: string | null, source_url?: string | null, created_at: any, updated_at: any };

export type BlockFragment = { __typename?: 'Block', id: string, created_at: any, updated_at: any, name: string, enviro_dataset_id?: string | null, pv_system_start_date?: string | null, cleaning_interval_days?: number | null, soiling_rate?: number | null, power_factor?: number | null, date_of_most_recent_cleaning?: string | null, pv_soiling_algorithm?: string | null, soiling_rates_percentage?: any | null, num_inverters?: number | null, slope_azimuth?: number | null, slope_tilt?: number | null, follow_slope?: boolean | null, slope_aware_tracking?: boolean | null, terrain_type: TerrainType, pv_table_id?: string | null, pv_panel_id?: string | null, pv_inverter_id?: string | null, pv_transformer_id?: string | null, pv_dc_wire_id?: string | null, pv_ac_wire_id?: string | null, pv_panel?: { __typename?: 'PvPanel', panel_edge_lr?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, cell_length?: number | null, cell_width?: number | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, cells?: Array<number | null> | null, ideality_factor?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, series_resistance?: number | null, shunt_resistance?: number | null, cell_type?: string | null, panel_type?: string | null, bifaciality_current_ratio?: number | null, parallel_string_per_diode?: Array<number | null> | null } | null, pv_table?: { __typename?: 'PvTable', num_cols?: any | null, num_tiers?: number | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, column_gap?: number | null, azimuth?: number | null, orientation_str?: string | null } | null };

export type GetProjectBlocksQueryVariables = Exact<{
  project_id: Scalars['String'];
  updated_after?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetProjectBlocksQuery = { __typename?: 'Query', blockIds: Array<{ __typename?: 'Block', id: string }>, blocks: Array<{ __typename?: 'Block', id: string, created_at: any, updated_at: any, name: string, enviro_dataset_id?: string | null, pv_system_start_date?: string | null, cleaning_interval_days?: number | null, soiling_rate?: number | null, power_factor?: number | null, date_of_most_recent_cleaning?: string | null, pv_soiling_algorithm?: string | null, soiling_rates_percentage?: any | null, num_inverters?: number | null, slope_azimuth?: number | null, slope_tilt?: number | null, follow_slope?: boolean | null, slope_aware_tracking?: boolean | null, terrain_type: TerrainType, pv_table_id?: string | null, pv_panel_id?: string | null, pv_inverter_id?: string | null, pv_transformer_id?: string | null, pv_dc_wire_id?: string | null, pv_ac_wire_id?: string | null, pv_panel?: { __typename?: 'PvPanel', panel_edge_lr?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, cell_length?: number | null, cell_width?: number | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, cells?: Array<number | null> | null, ideality_factor?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, series_resistance?: number | null, shunt_resistance?: number | null, cell_type?: string | null, panel_type?: string | null, bifaciality_current_ratio?: number | null, parallel_string_per_diode?: Array<number | null> | null } | null, pv_table?: { __typename?: 'PvTable', num_cols?: any | null, num_tiers?: number | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, column_gap?: number | null, azimuth?: number | null, orientation_str?: string | null } | null }>, blockLayerIds: Array<{ __typename?: 'BlockLayer', id: string, block_id?: string | null }>, blockLayers: Array<{ __typename?: 'BlockLayer', id: string, block_id?: string | null, project_id: string, name: string, type: string, geojson: any, source_type?: string | null, source_filename?: string | null, source_url?: string | null, created_at: any, updated_at: any }> };

export type UpsertBlocksMutationVariables = Exact<{
  project_id: Scalars['String'];
  blocks?: InputMaybe<Array<BlockInput> | BlockInput>;
}>;


export type UpsertBlocksMutation = { __typename?: 'Mutation', upsertBlocks: Array<{ __typename?: 'Block', id: string, created_at: any, updated_at: any, name: string, enviro_dataset_id?: string | null, pv_system_start_date?: string | null, cleaning_interval_days?: number | null, soiling_rate?: number | null, power_factor?: number | null, date_of_most_recent_cleaning?: string | null, pv_soiling_algorithm?: string | null, soiling_rates_percentage?: any | null, num_inverters?: number | null, slope_azimuth?: number | null, slope_tilt?: number | null, follow_slope?: boolean | null, slope_aware_tracking?: boolean | null, terrain_type: TerrainType, pv_table_id?: string | null, pv_panel_id?: string | null, pv_inverter_id?: string | null, pv_transformer_id?: string | null, pv_dc_wire_id?: string | null, pv_ac_wire_id?: string | null, pv_panel?: { __typename?: 'PvPanel', panel_edge_lr?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, cell_length?: number | null, cell_width?: number | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, cells?: Array<number | null> | null, ideality_factor?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, series_resistance?: number | null, shunt_resistance?: number | null, cell_type?: string | null, panel_type?: string | null, bifaciality_current_ratio?: number | null, parallel_string_per_diode?: Array<number | null> | null } | null, pv_table?: { __typename?: 'PvTable', num_cols?: any | null, num_tiers?: number | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, column_gap?: number | null, azimuth?: number | null, orientation_str?: string | null } | null }> };

export type UpsertBlockLayersMutationVariables = Exact<{
  project_id: Scalars['String'];
  block_layers?: InputMaybe<Array<BlockLayerInput> | BlockLayerInput>;
}>;


export type UpsertBlockLayersMutation = { __typename?: 'Mutation', upsertBlockLayers: Array<{ __typename?: 'BlockLayer', id: string, block_id?: string | null, project_id: string, name: string, type: string, geojson: any, source_type?: string | null, source_filename?: string | null, source_url?: string | null, created_at: any, updated_at: any }> };

export type DeleteBlocksMutationVariables = Exact<{
  project_id: Scalars['String'];
  block_ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DeleteBlocksMutation = { __typename?: 'Mutation', deleteBlocks: boolean };

export type DeleteBlockLayersMutationVariables = Exact<{
  project_id: Scalars['String'];
  block_layer_ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DeleteBlockLayersMutation = { __typename?: 'Mutation', deleteBlockLayers: boolean };

export type RasterLayerFragment = { __typename?: 'RasterLayer', id: string, name: string, opacity: number, origin: any, pixel_ratio: number, createdAt: any, storage_url: string, url?: string | null, project_id: string };

export type CreateRasterLayerMutationVariables = Exact<{
  project_id: Scalars['String'];
  raster_layer: RasterLayerInput;
}>;


export type CreateRasterLayerMutation = { __typename?: 'Mutation', createRasterLayer: { __typename?: 'RasterLayer', id: string, name: string, opacity: number, origin: any, pixel_ratio: number, createdAt: any, storage_url: string, url?: string | null, project_id: string } };

export type GetRasterLayersQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type GetRasterLayersQuery = { __typename?: 'Query', rasterLayers: Array<{ __typename?: 'RasterLayer', id: string, name: string, opacity: number, origin: any, pixel_ratio: number, createdAt: any, storage_url: string, url?: string | null, project_id: string }> };

export type UpdateRasterLayerMutationVariables = Exact<{
  project_id: Scalars['String'];
  raster_layer: UpdateRasterLayerInput;
  raster_layer_id: Scalars['String'];
}>;


export type UpdateRasterLayerMutation = { __typename?: 'Mutation', updateRasterLayer: { __typename?: 'RasterLayer', id: string, name: string, opacity: number, origin: any, pixel_ratio: number, createdAt: any, storage_url: string, url?: string | null, project_id: string } };

export type DeleteRasterLayerMutationVariables = Exact<{
  project_id: Scalars['String'];
  raster_layer_id: Scalars['String'];
}>;


export type DeleteRasterLayerMutation = { __typename?: 'Mutation', deleteRasterLayer: string };

export type CecInverterFragment = { __typename?: 'CecInverter', id: string, manufacturer: string, model: string, output_ac_voltage: number, self_consumption_power: number, rated_output_ac_power: number, reference_dc_power: number, reference_dc_voltage: number, sandia_model_c0: number, sandia_model_c1: number, sandia_model_c2: number, sandia_model_c3: number, night_tare_power: number, maximum_dc_current: number, minimum_dc_voltage: number, maximum_dc_voltage: number };

export type GetCecInverterQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCecInverterQuery = { __typename?: 'Query', cecInverter: { __typename?: 'CecInverter', id: string, manufacturer: string, model: string, output_ac_voltage: number, self_consumption_power: number, rated_output_ac_power: number, reference_dc_power: number, reference_dc_voltage: number, sandia_model_c0: number, sandia_model_c1: number, sandia_model_c2: number, sandia_model_c3: number, night_tare_power: number, maximum_dc_current: number, minimum_dc_voltage: number, maximum_dc_voltage: number } };

export type CecInvertersSearchQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  filter: CecInverterFilter;
  sort?: InputMaybe<CecInverterSort>;
  withCount?: InputMaybe<Scalars['Boolean']>;
}>;


export type CecInvertersSearchQuery = { __typename?: 'Query', cecInvertersCount?: number, cecInverters: Array<{ __typename?: 'CecInverter', id: string, manufacturer: string, model: string, output_ac_voltage: number, self_consumption_power: number, rated_output_ac_power: number, reference_dc_power: number, reference_dc_voltage: number, sandia_model_c0: number, sandia_model_c1: number, sandia_model_c2: number, sandia_model_c3: number, night_tare_power: number, maximum_dc_current: number, minimum_dc_voltage: number, maximum_dc_voltage: number }> };

export type GetCecInverterFilterParamsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCecInverterFilterParamsQuery = { __typename?: 'Query', cecInverterFilterParams: { __typename?: 'CecInverterFilterOptions', manufacturers: Array<string>, output_ac_voltage: { __typename?: 'MinMax', min: number, max: number }, maximum_dc_voltage: { __typename?: 'MinMax', min: number, max: number }, maximum_dc_current: { __typename?: 'MinMax', min: number, max: number } } };

export type EnviroDatasetFragment = { __typename?: 'EnviroDataset', id: string, created_at: any, name: string, local_time_zone: number, type: string, time_interval?: number | null, interval_alignment: string, dst_shifts: any, start_time: any, end_time: any, source?: string | null, latitude?: number | null, longitude?: number | null };

export type EnviroDataFragment = { __typename?: 'EnviroData', year: number, month: number, day: number, hour: number, minute: number, temp_c: number, rh?: number | null, ghi_wm2: number, dni_wm2: number, dhi_wm2: number, albedo: number, windspeed?: number | null, tracker_angle?: number | null };

export type UpdateEnviroDatasetMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateEnviroDatasetInput;
}>;


export type UpdateEnviroDatasetMutation = { __typename?: 'Mutation', updateProjectEnviroDataset: { __typename: 'EnviroDatasetOwner', id: string, created_at: any, project_id?: string | null, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string }, enviro_dataset: { __typename?: 'EnviroDataset', id: string, created_at: any, name: string, local_time_zone: number, type: string, time_interval?: number | null, interval_alignment: string, dst_shifts: any, start_time: any, end_time: any, source?: string | null, latitude?: number | null, longitude?: number | null } } };

export type CreateProjectEnviroDatasetFromCsvFileMutationVariables = Exact<{
  project_id: Scalars['String'];
  enviro_dataset: CreateEnviroDatasetFromCsvFileInput;
  decomposition_parameters?: InputMaybe<DecompositionParametersInput>;
}>;


export type CreateProjectEnviroDatasetFromCsvFileMutation = { __typename?: 'Mutation', createProjectEnviroDatasetFromCsvFile: { __typename: 'EnviroDatasetOwner', id: string, created_at: any, project_id?: string | null, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string }, enviro_dataset: { __typename?: 'EnviroDataset', id: string, created_at: any, name: string, local_time_zone: number, type: string, time_interval?: number | null, interval_alignment: string, dst_shifts: any, start_time: any, end_time: any, source?: string | null, latitude?: number | null, longitude?: number | null } } };

export type CreateEnviroDatasetFromMetFileMutationVariables = Exact<{
  project_id: Scalars['String'];
  enviro_dataset: CreateEnviroDatasetFromMetFileInput;
}>;


export type CreateEnviroDatasetFromMetFileMutation = { __typename?: 'Mutation', createProjectEnviroDatasetFromMetFile: { __typename: 'EnviroDatasetOwner', id: string, created_at: any, project_id?: string | null, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string }, enviro_dataset: { __typename?: 'EnviroDataset', id: string, created_at: any, name: string, local_time_zone: number, type: string, time_interval?: number | null, interval_alignment: string, dst_shifts: any, start_time: any, end_time: any, source?: string | null, latitude?: number | null, longitude?: number | null } } };

export type GetProjectEnviroDatasetsQueryVariables = Exact<{
  project_id: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetProjectEnviroDatasetsQuery = { __typename?: 'Query', projectEnviroDatasets: Array<{ __typename: 'EnviroDatasetOwner', id: string, created_at: any, project_id?: string | null, name?: string | null, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string }, enviro_dataset: { __typename?: 'EnviroDataset', id: string, created_at: any, name: string, local_time_zone: number, type: string, time_interval?: number | null, interval_alignment: string, dst_shifts: any, start_time: any, end_time: any, source?: string | null, latitude?: number | null, longitude?: number | null } }> };

export type GetEnviroDataQueryVariables = Exact<{
  enviro_dataset_owner_id: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  time_range?: InputMaybe<TimeRangeInput>;
  withCount?: InputMaybe<Scalars['Boolean']>;
  restore_interval_alignment?: InputMaybe<Scalars['Boolean']>;
  restore_dst_shifts?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetEnviroDataQuery = { __typename?: 'Query', enviroDataCount?: number, enviroData: Array<{ __typename?: 'EnviroData', year: number, month: number, day: number, hour: number, minute: number, temp_c: number, rh?: number | null, ghi_wm2: number, dni_wm2: number, dhi_wm2: number, albedo: number, windspeed?: number | null, tracker_angle?: number | null }> };

export type EnviroDataRollupQueryVariables = Exact<{
  enviro_dataset_owner_id: Scalars['String'];
  date_args: DateArgsInput;
}>;


export type EnviroDataRollupQuery = { __typename?: 'Query', enviroDataRollup: Array<{ __typename?: 'EnviroDataRollup', dt_timestamp: any, avg__ghi_wm2: number, min__ghi_wm2: number, p10__ghi_wm2: number, p25__ghi_wm2: number, p50__ghi_wm2: number, p75__ghi_wm2: number, p90__ghi_wm2: number, max__ghi_wm2: number, avg__dhi_wm2: number, min__dhi_wm2: number, p10__dhi_wm2: number, p25__dhi_wm2: number, p50__dhi_wm2: number, p75__dhi_wm2: number, p90__dhi_wm2: number, max__dhi_wm2: number, avg__dni_wm2: number, min__dni_wm2: number, p10__dni_wm2: number, p25__dni_wm2: number, p50__dni_wm2: number, p75__dni_wm2: number, p90__dni_wm2: number, max__dni_wm2: number }> };

export type DailySparkLineQueryVariables = Exact<{
  enviro_dataset_owner_id: Scalars['String'];
}>;


export type DailySparkLineQuery = { __typename?: 'Query', enviroDataRollup: Array<{ __typename?: 'EnviroDataRollup', dt_timestamp: any, avg__dni_wm2: number }> };

export type HourlyMeteoByMonthQueryVariables = Exact<{
  enviro_dataset_owner_id: Scalars['String'];
}>;


export type HourlyMeteoByMonthQuery = { __typename?: 'Query', enviroDataRollup: Array<{ __typename?: 'EnviroDataRollup', dt_timestamp: any, avg__ghi_wm2: number, avg__dhi_wm2: number, avg__dni_wm2: number, avg__temp_c: number }> };

export type DailyAlbedoQueryVariables = Exact<{
  enviro_dataset_owner_id: Scalars['String'];
}>;


export type DailyAlbedoQuery = { __typename?: 'Query', enviroDataRollup: Array<{ __typename?: 'EnviroDataRollup', dt_timestamp: any, avg__albedo: number }> };

export type DeleteProjectEnviroDatasetMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectEnviroDatasetMutation = { __typename?: 'Mutation', deleteProjectEnviroDataset: { __typename?: 'EnviroDatasetOwner', id: string } };

export type GetNumDaylightTimestampsQueryVariables = Exact<{
  enviro_dataset_owner_id: Scalars['String'];
  selectedTimeRange: TimeRangeInput;
}>;


export type GetNumDaylightTimestampsQuery = { __typename?: 'Query', numDaylightTimestamps?: number | null };

export type GetAcWireQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAcWireQuery = { __typename?: 'Query', acWire: { __typename: 'PvAcWire', id: string, name: string, created_at: any, updated_at: any, default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null } };

export type DeleteAcWireMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAcWireMutation = { __typename?: 'Mutation', deleteAcWire: { __typename?: 'PvAcWire', id: string } };

export type CreateAcWireMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  data?: InputMaybe<PvAcWireUpdateInput>;
}>;


export type CreateAcWireMutation = { __typename?: 'Mutation', createAcWire: { __typename: 'PvAcWire', id: string, name: string, updated_at: any, created_at: any, default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null } };

export type UpdateAcWireNameMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateAcWireNameMutation = { __typename?: 'Mutation', updateAcWireName: { __typename: 'PvAcWire', id: string, name: string, default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null } };

export type UpdateAcWireMutationVariables = Exact<{
  id: Scalars['String'];
  data: PvAcWireUpdateInput;
}>;


export type UpdateAcWireMutation = { __typename?: 'Mutation', updateAcWire: { __typename: 'PvAcWire', id: string, name: string, default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null } };

export type PvAcWireParametersFragment = { __typename: 'PvAcWire', default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null };

export type GetComponentsQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type GetComponentsQuery = { __typename?: 'Query', panels: Array<{ __typename: 'PvPanel', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null }>, tables: Array<{ __typename: 'PvTable', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null }>, inverters: Array<{ __typename: 'PvInverter', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null }>, transformers: Array<{ __typename: 'PvTransformer', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null }>, dcWires: Array<{ __typename: 'PvDcWire', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null }>, acWires: Array<{ __typename: 'PvAcWire', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null }> };

export type GetDcWireQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDcWireQuery = { __typename?: 'Query', dcWire: { __typename: 'PvDcWire', id: string, name: string, created_at: any, updated_at: any, default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null } };

export type DeleteDcWireMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDcWireMutation = { __typename?: 'Mutation', deleteDcWire: { __typename?: 'PvDcWire', id: string } };

export type CreateDcWireMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  data?: InputMaybe<PvDcWireUpdateInput>;
}>;


export type CreateDcWireMutation = { __typename?: 'Mutation', createDcWire: { __typename: 'PvDcWire', id: string, name: string, updated_at: any, created_at: any, default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null } };

export type UpdateDcWireNameMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateDcWireNameMutation = { __typename?: 'Mutation', updateDcWireName: { __typename: 'PvDcWire', id: string, name: string, default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null } };

export type UpdateDcWireMutationVariables = Exact<{
  id: Scalars['String'];
  data: PvDcWireUpdateInput;
}>;


export type UpdateDcWireMutation = { __typename?: 'Mutation', updateDcWire: { __typename: 'PvDcWire', id: string, name: string, default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null } };

export type PvDcWireParametersFragment = { __typename: 'PvDcWire', default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null };

export type GetInverterQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInverterQuery = { __typename?: 'Query', inverter: { __typename: 'PvInverter', id: string, name: string, created_at: any, updated_at: any, default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null } };

export type DeleteInverterMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteInverterMutation = { __typename?: 'Mutation', deleteInverter: { __typename?: 'PvInverter', id: string } };

export type CreateInverterMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  data?: InputMaybe<PvInverterUpdateInput>;
}>;


export type CreateInverterMutation = { __typename?: 'Mutation', createInverter: { __typename: 'PvInverter', id: string, name: string, updated_at: any, created_at: any, default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null } };

export type UpdateInverterNameMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateInverterNameMutation = { __typename?: 'Mutation', updateInverterName: { __typename: 'PvInverter', id: string, name: string, default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null } };

export type UpdateInverterMutationVariables = Exact<{
  id: Scalars['String'];
  data: PvInverterUpdateInput;
}>;


export type UpdateInverterMutation = { __typename?: 'Mutation', updateInverter: { __typename: 'PvInverter', id: string, name: string, default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null } };

export type PvInverterParametersFragment = { __typename: 'PvInverter', default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null };

export type GetPanelQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPanelQuery = { __typename?: 'Query', panel: { __typename: 'PvPanel', id: string, name: string, created_at: any, updated_at: any, default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null } };

export type DeletePanelMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePanelMutation = { __typename?: 'Mutation', deletePanel: { __typename?: 'PvPanel', id: string } };

export type CreatePanelMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  data?: InputMaybe<PvPanelUpdateInput>;
}>;


export type CreatePanelMutation = { __typename?: 'Mutation', createPanel: { __typename: 'PvPanel', id: string, name: string, updated_at: any, created_at: any, default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null } };

export type UpdatePanelNameMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdatePanelNameMutation = { __typename?: 'Mutation', updatePanelName: { __typename: 'PvPanel', id: string, name: string, default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null } };

export type UpdatePanelMutationVariables = Exact<{
  id: Scalars['String'];
  data: PvPanelUpdateInput;
}>;


export type UpdatePanelMutation = { __typename?: 'Mutation', updatePanel: { __typename: 'PvPanel', id: string, name: string, default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null } };

export type PvPanelParametersFragment = { __typename: 'PvPanel', default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null };

export type GetTableQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTableQuery = { __typename?: 'Query', table: { __typename: 'PvTable', id: string, name: string, created_at: any, updated_at: any, default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null } };

export type DeleteTableMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTableMutation = { __typename?: 'Mutation', deleteTable: { __typename?: 'PvTable', id: string } };

export type CreateTableMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  data?: InputMaybe<PvTableUpdateInput>;
}>;


export type CreateTableMutation = { __typename?: 'Mutation', createTable: { __typename: 'PvTable', id: string, name: string, updated_at: any, created_at: any, default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null } };

export type UpdateTableMutationVariables = Exact<{
  id: Scalars['String'];
  data: PvTableUpdateInput;
}>;


export type UpdateTableMutation = { __typename?: 'Mutation', updateTable: { __typename: 'PvTable', id: string, name: string, default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null } };

export type UpdateTableNameMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateTableNameMutation = { __typename?: 'Mutation', updateTableName: { __typename: 'PvTable', id: string, name: string, default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null } };

export type PvTableParametersFragment = { __typename: 'PvTable', default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null };

export type GetTransformerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTransformerQuery = { __typename?: 'Query', transformer: { __typename: 'PvTransformer', id: string, name: string, created_at: any, updated_at: any, default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null } };

export type DeleteTransformerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTransformerMutation = { __typename?: 'Mutation', deleteTransformer: { __typename?: 'PvTransformer', id: string } };

export type CreateMvTransformerMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  data?: InputMaybe<PvTransformerUpdateInput>;
}>;


export type CreateMvTransformerMutation = { __typename?: 'Mutation', createTransformer: { __typename: 'PvTransformer', id: string, name: string, updated_at: any, created_at: any, default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null } };

export type CreateHvTransformerMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  data?: InputMaybe<PvTransformerUpdateInput>;
}>;


export type CreateHvTransformerMutation = { __typename?: 'Mutation', createTransformer: { __typename: 'PvTransformer', id: string, name: string, updated_at: any, created_at: any, default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null } };

export type UpdateTransformerNameMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type UpdateTransformerNameMutation = { __typename?: 'Mutation', updateTransformerName: { __typename: 'PvTransformer', id: string, name: string, default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null } };

export type UpdateTransformerMutationVariables = Exact<{
  id: Scalars['String'];
  data: PvTransformerUpdateInput;
}>;


export type UpdateTransformerMutation = { __typename?: 'Mutation', updateTransformer: { __typename: 'PvTransformer', id: string, name: string, default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null } };

export type PvTransformerParametersFragment = { __typename: 'PvTransformer', default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null };

export type GetPvSystImportFilesQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type GetPvSystImportFilesQuery = { __typename?: 'Query', projectFileStorage: Array<{ __typename?: 'StorageFile', path: string, name: string, size: string, is_dir: boolean, url?: string | null }> };

export type GetPvSystImportDataQueryVariables = Exact<{
  project_id: Scalars['String'];
  files: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetPvSystImportDataQuery = { __typename?: 'Query', pvSystImportData: Array<{ __typename?: 'PvSystImportData', name: string, data?: any | null }> };

export type PvSystImportPreviewQueryVariables = Exact<{
  project_id: Scalars['String'];
  variant_file_name: Scalars['String'];
}>;


export type PvSystImportPreviewQuery = { __typename?: 'Query', pvSystImportPreview: { __typename?: 'PvSystImportPreview', panels: Array<{ __typename?: 'ComponentSummary', id: string, name: string }>, tables: Array<{ __typename?: 'ComponentSummary', id: string, name: string }>, inverters: Array<{ __typename?: 'ComponentSummary', id: string, name: string }>, transformers: Array<{ __typename?: 'ComponentSummary', id: string, name: string }>, dcWires: Array<{ __typename?: 'ComponentSummary', id: string, name: string }>, acWires: Array<{ __typename?: 'ComponentSummary', id: string, name: string }>, blocks: Array<{ __typename?: 'PvSystImportBlock', id: string, name: string, pv_panel_id?: string | null, pv_table_id?: string | null, pv_inverter_id?: string | null, pv_transformer_id?: string | null, pv_dc_wire_id?: string | null, pv_ac_wire_id?: string | null }>, enviro_dataset?: { __typename?: 'PvSystImportEnviroDataset', id: string, name: string, local_time_zone: number, type: string, time_interval: number, time_range?: { __typename?: 'TimeRange', start: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null }, end: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null } } | null } | null } };

export type ExecutePvSystImportMutationVariables = Exact<{
  project_id: Scalars['String'];
  variant_file_name: Scalars['String'];
  apply_starter_defaults?: InputMaybe<Scalars['Boolean']>;
}>;


export type ExecutePvSystImportMutation = { __typename?: 'Mutation', executePvSystImport: { __typename?: 'PvSystImportResult', panels: Array<{ __typename: 'PvPanel', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null }>, tables: Array<{ __typename: 'PvTable', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null }>, inverters: Array<{ __typename: 'PvInverter', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null }>, transformers: Array<{ __typename: 'PvTransformer', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null }>, dcWires: Array<{ __typename: 'PvDcWire', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null }>, acWires: Array<{ __typename: 'PvAcWire', id: string, created_at: any, updated_at: any, name: string, default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null }>, blocks: Array<{ __typename?: 'Block', id: string, created_at: any, updated_at: any, name: string, enviro_dataset_id?: string | null, pv_system_start_date?: string | null, cleaning_interval_days?: number | null, soiling_rate?: number | null, power_factor?: number | null, date_of_most_recent_cleaning?: string | null, pv_soiling_algorithm?: string | null, soiling_rates_percentage?: any | null, num_inverters?: number | null, slope_azimuth?: number | null, slope_tilt?: number | null, follow_slope?: boolean | null, slope_aware_tracking?: boolean | null, terrain_type: TerrainType, pv_table_id?: string | null, pv_panel_id?: string | null, pv_inverter_id?: string | null, pv_transformer_id?: string | null, pv_dc_wire_id?: string | null, pv_ac_wire_id?: string | null, pv_panel?: { __typename?: 'PvPanel', panel_edge_lr?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, cell_length?: number | null, cell_width?: number | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, cells?: Array<number | null> | null, ideality_factor?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, series_resistance?: number | null, shunt_resistance?: number | null, cell_type?: string | null, panel_type?: string | null, bifaciality_current_ratio?: number | null, parallel_string_per_diode?: Array<number | null> | null } | null, pv_table?: { __typename?: 'PvTable', num_cols?: any | null, num_tiers?: number | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, column_gap?: number | null, azimuth?: number | null, orientation_str?: string | null } | null }>, enviro_dataset?: { __typename?: 'EnviroDataset', id: string, created_at: any, name: string, local_time_zone: number, type: string, time_interval?: number | null, interval_alignment: string, dst_shifts: any, start_time: any, end_time: any, source?: string | null, latitude?: number | null, longitude?: number | null } | null } };

export type GetCustomDatasetsQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type GetCustomDatasetsQuery = { __typename?: 'Query', projectFileStorage: Array<{ __typename?: 'StorageFile', path: string, name: string, size: string, is_dir: boolean }> };

export type DescribeAllCustomDatasetQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type DescribeAllCustomDatasetQuery = { __typename?: 'Query', customDatasetDescribe: Array<{ __typename?: 'DescribeRow', file_name: string, name: string, type?: string | null }> };

export type DescribeCustomDatasetQueryVariables = Exact<{
  project_id: Scalars['String'];
  path: Scalars['String'];
}>;


export type DescribeCustomDatasetQuery = { __typename?: 'Query', customDatasetDescribe: Array<{ __typename?: 'DescribeRow', file_name: string, name: string, type?: string | null }> };

export type GetCustomDatasetDataSeriesQueryVariables = Exact<{
  project_id: Scalars['String'];
  path: Scalars['String'];
  date_args: DateArgsInput;
  measures: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetCustomDatasetDataSeriesQuery = { __typename?: 'Query', customDatasetQuery: any };

export type SimDataExportMutationVariables = Exact<{
  simulation_id: Scalars['String'];
  scope: DataExportScope;
  format: DataExportFormat;
}>;


export type SimDataExportMutation = { __typename?: 'Mutation', simDataExport: boolean };

export type DataExportsQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  scope?: InputMaybe<DataExportScope>;
  format?: InputMaybe<DataExportFormat>;
}>;


export type DataExportsQuery = { __typename?: 'Query', dataExports: Array<{ __typename?: 'SimDataExport', scope: DataExportScope, format: DataExportFormat, createdOn?: any | null, inProgress: boolean, urls: Array<{ __typename?: 'SimDataExportUrl', url: string, filename: string }> }> };

export type GetDataExportUrlsQueryVariables = Exact<{
  simulation_id: Scalars['String'];
}>;


export type GetDataExportUrlsQuery = { __typename?: 'Query', getDataExportUrls: Array<{ __typename?: 'SimDataUrlPayload', full_sim_detail_url: string, system_sim_detail_url: string, expires_at: number }> };

export type SimulationPdfExportBlockDataFragment = { __typename?: 'SimulationPdfExportBlockData', block_id: string, block_name: string, nominal_dc_power?: number | null, single_panel_dc_power?: number | null, num_total_panels?: number | null, num_strings?: number | null, num_panels_per_string?: number | null, num_inverters?: number | null, inverter_ac_power?: number | null, inverter_night_tare_power?: number | null, inverter_maximum_voltage?: number | null, inverter_minimum_voltage?: number | null, inverter_manufacturer?: string | null, inverter_model?: string | null, monthly_soiling_pct_ghi_weighted?: Array<number | null> | null, global_array_resistance?: number | null, dc_wiring_loss_fraction?: number | null, collector_width?: number | null, stc_efficiency?: number | null };

export type DuetSimulationBlockFragment = { __typename?: 'DuetSimulationBlock', block_id: string, duet_job_input_id: string, name: string, num_inverters?: number | null, terrain_type?: string | null, slope_azimuth?: number | null, slope_tilt?: number | null, slope_aware_tracking?: boolean | null, pv_soiling_algorithm?: string | null, soiling_rate?: number | null, soiling_rates_percentage?: Array<number | null> | null, num_total_tables?: number | null, pv_system_start_date?: string | null, cleaning_interval_days?: number | null, date_of_most_recent_cleaning?: string | null, power_factor?: number | null, time_range: { __typename?: 'TimeRange', start: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null }, end: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null } }, panel_parameters: { __typename: 'PvPanel', default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null }, table_parameters: { __typename: 'PvTable', default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null }, inverter_parameters: { __typename: 'PvInverter', default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null }, transformer_parameters: { __typename: 'PvTransformer', default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null }, ac_wire_parameters: { __typename: 'PvAcWire', default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null }, dc_wire_parameters: { __typename: 'PvDcWire', default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null } };

export type GetSimPdfExportDataQueryVariables = Exact<{
  project_id: Scalars['String'];
  simulation_id: Scalars['String'];
}>;


export type GetSimPdfExportDataQuery = { __typename?: 'Query', simPdfExportData: { __typename?: 'SimulationPdfExportData', monthly_albedo: Array<number | null>, monthly_albedo_ghi_weighted: Array<number | null>, albedo?: number | null, albedo_ghi_weighted?: number | null, windspeed_available: boolean, has_hv_stage: boolean, system_nominal_dc_power?: number | null, num_total_panels?: number | null, num_total_strings?: number | null, system_inverter_ac_power?: number | null, system_collector_width?: number | null, system_tracker_spacing?: number | null, system_stc_efficiency?: number | null, block_data: Array<{ __typename?: 'SimulationPdfExportBlockData', block_id: string, block_name: string, nominal_dc_power?: number | null, single_panel_dc_power?: number | null, num_total_panels?: number | null, num_strings?: number | null, num_panels_per_string?: number | null, num_inverters?: number | null, inverter_ac_power?: number | null, inverter_night_tare_power?: number | null, inverter_maximum_voltage?: number | null, inverter_minimum_voltage?: number | null, inverter_manufacturer?: string | null, inverter_model?: string | null, monthly_soiling_pct_ghi_weighted?: Array<number | null> | null, global_array_resistance?: number | null, dc_wiring_loss_fraction?: number | null, collector_width?: number | null, stc_efficiency?: number | null }>, author?: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } | null }, simulationDailySunRiseSet: Array<{ __typename?: 'SunRiseSet', dt_timestamp: string, sunrise: string, sunset: string }>, minutelySimulationTimestamps: Array<{ __typename?: 'SimulationTimestamp', dt_timestamp: any }>, systemSimOutput: Array<{ __typename?: 'SimulationSummary', sum__performance_ratio_bi: number, sum__performance_ratio_mono: number, avg__hv_transformer_copper_loss_w_bi?: number | null, avg__hv_transformer_copper_loss_w_mono?: number | null, sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null, sum__array_cell_max_energy_t_stc_bi?: number | null, sum__array_cell_energy_bi?: number | null, sum__energy_bi: number, sum__transformer_input_energy_wh_bi: number, sum__transformer_output_energy_wh_bi: number, sum__pv_power_with_soiling_wh_bi: number, sum__soiling_loss_wh_bi: number, sum__pv_power_no_degradation_wh_bi: number, sum__pv_power_with_degradation_wh_bi: number, sum__total_degradation_loss_wh_bi: number, sum__degradation_loss_first_year_wh_bi: number, sum__degradation_loss_remaining_years_wh_bi: number, sum__line_sending_end_energy_wh_bi: number, sum__line_energy_loss_wh_bi: number, sum__transmission_line_sending_end_energy_wh_bi: number, sum__transmission_line_energy_loss_wh_bi: number, sum__transformer_energy_loss_wh_bi: number, sum__transformer_iron_core_loss_wh_bi: number, sum__transformer_copper_loss_wh_bi: number, sum__self_consumption_loss_wh_bi: number, sum__ac_power_clipping_loss_wh_bi: number, sum__inverter_night_tare_loss_wh_bi: number, sum__inverter_dc_undervoltage_loss_wh_bi: number, sum__inverter_dc_overvoltage_loss_wh_bi: number, sum__inverter_dc_underpower_loss_wh_bi: number, sum__inverter_dc_overpower_loss_wh_bi: number, sum__inverter_dc_overcurrent_loss_wh_bi: number, sum__power_factor_derate_loss_wh_bi?: number | null, sum__below_min_temperature_loss_wh_bi: number, sum__above_max_temperature_loss_wh_bi: number, sum__temperature_derating_loss_wh_bi: number, sum__total_inverter_loss_wh_bi: number, sum__inverter_output_energy_stc_wh_bi?: number | null, sum__ghi_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_with_diffuse_whm2?: number | null, sum__gti_r_pvsyst_with_direct_whm2?: number | null, sum__gti_r_pvsyst_with_structure_whm2?: number | null, sum__array_cell_max_energy_t_stc_mono?: number | null, sum__array_cell_energy_mono?: number | null, sum__energy_mono: number, sum__transformer_input_energy_wh_mono: number, sum__transformer_output_energy_wh_mono: number, sum__pv_power_with_soiling_wh_mono: number, sum__soiling_loss_wh_mono: number, sum__pv_power_no_degradation_wh_mono: number, sum__pv_power_with_degradation_wh_mono: number, sum__total_degradation_loss_wh_mono: number, sum__degradation_loss_first_year_wh_mono: number, sum__degradation_loss_remaining_years_wh_mono: number, sum__line_sending_end_energy_wh_mono: number, sum__line_energy_loss_wh_mono: number, sum__transmission_line_sending_end_energy_wh_mono: number, sum__transmission_line_energy_loss_wh_mono: number, sum__transformer_energy_loss_wh_mono: number, sum__transformer_iron_core_loss_wh_mono: number, sum__transformer_copper_loss_wh_mono: number, sum__self_consumption_loss_wh_mono: number, sum__ac_power_clipping_loss_wh_mono: number, sum__inverter_night_tare_loss_wh_mono: number, sum__inverter_dc_undervoltage_loss_wh_mono: number, sum__inverter_dc_overvoltage_loss_wh_mono: number, sum__inverter_dc_underpower_loss_wh_mono: number, sum__inverter_dc_overpower_loss_wh_mono: number, sum__inverter_dc_overcurrent_loss_wh_mono: number, sum__power_factor_derate_loss_wh_mono?: number | null, sum__below_min_temperature_loss_wh_mono: number, sum__above_max_temperature_loss_wh_mono: number, sum__temperature_derating_loss_wh_mono: number, sum__total_inverter_loss_wh_mono: number, sum__inverter_output_energy_stc_wh_mono?: number | null, sum__ghi_whm2: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_far_shading_whm2?: number | null, sum__gti_f_pvsyst_with_near_shading_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null, sum__hv_transformer_input_energy_wh_mono?: number | null, sum__hv_transformer_iron_core_loss_wh_mono?: number | null, sum__hv_transformer_copper_loss_wh_mono?: number | null, sum__hv_transformer_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_sending_end_energy_wh_mono?: number | null, sum__hv_transformer_input_energy_wh_bi?: number | null, sum__hv_transformer_iron_core_loss_wh_bi?: number | null, sum__hv_transformer_copper_loss_wh_bi?: number | null, sum__hv_transformer_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_sending_end_energy_wh_bi?: number | null }>, blockSimOutput: Array<{ __typename?: 'SimulationSummary', duet_job_input_id?: string | null, avg__line_power_loss_w_bi: number, avg__line_power_loss_w_mono: number, avg__transformer_copper_loss_w_bi: number, avg__transformer_copper_loss_w_mono: number, sum__array_cell_max_energy_t_stc_bi?: number | null, sum__array_cell_energy_bi?: number | null, sum__energy_bi: number, sum__transformer_input_energy_wh_bi: number, sum__transformer_output_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__pv_power_with_soiling_wh_bi: number, sum__soiling_loss_wh_bi: number, sum__pv_power_no_degradation_wh_bi: number, sum__pv_power_with_degradation_wh_bi: number, sum__total_degradation_loss_wh_bi: number, sum__degradation_loss_first_year_wh_bi: number, sum__degradation_loss_remaining_years_wh_bi: number, sum__line_sending_end_energy_wh_bi: number, sum__line_receiving_end_energy_wh_bi: number, sum__line_energy_loss_wh_bi: number, sum__transmission_line_sending_end_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__transmission_line_energy_loss_wh_bi: number, sum__transformer_energy_loss_wh_bi: number, sum__transformer_iron_core_loss_wh_bi: number, sum__transformer_copper_loss_wh_bi: number, sum__self_consumption_loss_wh_bi: number, sum__ac_power_clipping_loss_wh_bi: number, sum__inverter_night_tare_loss_wh_bi: number, sum__inverter_dc_undervoltage_loss_wh_bi: number, sum__inverter_dc_overvoltage_loss_wh_bi: number, sum__inverter_dc_underpower_loss_wh_bi: number, sum__inverter_dc_overpower_loss_wh_bi: number, sum__inverter_dc_overcurrent_loss_wh_bi: number, sum__power_factor_derate_loss_wh_bi?: number | null, sum__below_min_temperature_loss_wh_bi: number, sum__above_max_temperature_loss_wh_bi: number, sum__temperature_derating_loss_wh_bi: number, sum__total_inverter_loss_wh_bi: number, sum__inverter_output_energy_stc_wh_bi?: number | null, sum__ghi_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_with_diffuse_whm2?: number | null, sum__gti_r_pvsyst_with_direct_whm2?: number | null, sum__gti_r_pvsyst_with_structure_whm2?: number | null, sum__array_cell_max_energy_t_stc_mono?: number | null, sum__array_cell_energy_mono?: number | null, sum__energy_mono: number, sum__transformer_input_energy_wh_mono: number, sum__transformer_output_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__pv_power_with_soiling_wh_mono: number, sum__soiling_loss_wh_mono: number, sum__pv_power_no_degradation_wh_mono: number, sum__pv_power_with_degradation_wh_mono: number, sum__total_degradation_loss_wh_mono: number, sum__degradation_loss_first_year_wh_mono: number, sum__degradation_loss_remaining_years_wh_mono: number, sum__line_sending_end_energy_wh_mono: number, sum__line_receiving_end_energy_wh_mono: number, sum__line_energy_loss_wh_mono: number, sum__transmission_line_sending_end_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__transmission_line_energy_loss_wh_mono: number, sum__transformer_energy_loss_wh_mono: number, sum__transformer_iron_core_loss_wh_mono: number, sum__transformer_copper_loss_wh_mono: number, sum__self_consumption_loss_wh_mono: number, sum__ac_power_clipping_loss_wh_mono: number, sum__inverter_night_tare_loss_wh_mono: number, sum__inverter_dc_undervoltage_loss_wh_mono: number, sum__inverter_dc_overvoltage_loss_wh_mono: number, sum__inverter_dc_underpower_loss_wh_mono: number, sum__inverter_dc_overpower_loss_wh_mono: number, sum__inverter_dc_overcurrent_loss_wh_mono: number, sum__power_factor_derate_loss_wh_mono?: number | null, sum__below_min_temperature_loss_wh_mono: number, sum__above_max_temperature_loss_wh_mono: number, sum__temperature_derating_loss_wh_mono: number, sum__total_inverter_loss_wh_mono: number, sum__inverter_output_energy_stc_wh_mono?: number | null, sum__ghi_whm2: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_far_shading_whm2?: number | null, sum__gti_f_pvsyst_with_near_shading_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null }>, simInput: { __typename?: 'DuetSimulation', enviro_dataset_type: string, created_at: any, latitude?: number | null, longitude?: number | null, local_time_zone?: number | null, enviro_dataset_name?: string | null, hv_transformer_parameters: { __typename?: 'PvTransformer', nominal_high_side_voltage?: number | null }, hv_ac_wire_parameters: { __typename?: 'PvAcWire', ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null }, duet_simulation_blocks: Array<{ __typename?: 'DuetSimulationBlock', block_id: string, duet_job_input_id: string, name: string, num_inverters?: number | null, terrain_type?: string | null, slope_azimuth?: number | null, slope_tilt?: number | null, slope_aware_tracking?: boolean | null, pv_soiling_algorithm?: string | null, soiling_rate?: number | null, soiling_rates_percentage?: Array<number | null> | null, num_total_tables?: number | null, pv_system_start_date?: string | null, cleaning_interval_days?: number | null, date_of_most_recent_cleaning?: string | null, power_factor?: number | null, time_range: { __typename?: 'TimeRange', start: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null }, end: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null } }, panel_parameters: { __typename: 'PvPanel', default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null }, table_parameters: { __typename: 'PvTable', default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null }, inverter_parameters: { __typename: 'PvInverter', default_state_fields?: any | null, ond_file_import?: any | null, inverter_data_source?: string | null, inverter_id?: string | null, output_ac_voltage?: number | null, rated_output_ac_power?: number | null, maximum_ac_power?: number | null, maximum_dc_power?: number | null, reference_dc_power?: number | null, reference_dc_voltage?: number | null, night_tare_power?: number | null, self_consumption_power?: number | null, maximum_dc_current?: number | null, minimum_dc_voltage?: number | null, maximum_dc_voltage?: number | null, minimum_operating_temperature?: number | null, maximum_operating_temperature?: number | null, cec_efficiency_curves?: any | null, temp_derate_curves?: any | null }, transformer_parameters: { __typename: 'PvTransformer', default_state_fields?: any | null, type: string, night_disconnect?: boolean | null, nominal_low_side_voltage?: number | null, nominal_high_side_voltage?: number | null, iron_power_loss_data_source?: string | null, iron_power_loss_percentage?: number | null, iron_power_loss?: number | null, copper_power_loss_data_source?: string | null, copper_power_loss_percentage?: number | null, low_voltage_winding_resistance?: number | null, high_voltage_winding_resistance?: number | null }, ac_wire_parameters: { __typename: 'PvAcWire', default_state_fields?: any | null, ac_line_metal_type?: string | null, ac_line_cross_section?: number | null, ac_line_length?: number | null, ac_per_km_resistance?: number | null, total_ac_resistance_override?: number | null, ac_line_loss_percentage?: number | null, ac_line_calculation_method?: string | null }, dc_wire_parameters: { __typename: 'PvDcWire', default_state_fields?: any | null, dc_line_metal_type?: string | null, dc_line_cross_section?: number | null, dc_line_length?: number | null, dc_per_km_resistance?: number | null, total_dc_resistance_override?: number | null, dc_line_loss_percentage?: number | null, dc_line_calculation_method?: string | null } }> }, systemSimOutputByYear: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__performance_ratio_bi: number, sum__performance_ratio_mono: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null, sum__ghi_whm2: number, sum__dhi_whm2: number, avg__temperature_c: number, sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }>, systemSimOutputByMonth: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__performance_ratio_bi: number, sum__performance_ratio_mono: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null, sum__pv_power_no_soiling_wh_bi: number, sum__pv_power_no_soiling_wh_mono: number, sum__line_receiving_end_energy_wh_bi: number, sum__line_receiving_end_energy_wh_mono: number, sum__ghi_whm2: number, sum__dhi_whm2: number, avg__temperature_c: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }>, systemSimOutputByDay: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }>, systemSimOutputByHour: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }> };

export type GetPVsystExportDataQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type GetPVsystExportDataQuery = { __typename?: 'Query', simulationSummary: Array<{ __typename?: 'SimulationSummary', sum__gti_r_pvsyst_with_direct_whm2?: number | null, sum__gti_r_pvsyst_with_structure_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null, sum__energy_bi: number, sum__array_string_energy_bi?: number | null, sum__array_cell_energy_bi?: number | null, sum__array_center_panel_cell_energy_bi?: number | null, sum__energy_mono: number, sum__array_string_energy_mono?: number | null, sum__array_cell_energy_mono?: number | null, sum__array_center_panel_cell_energy_mono?: number | null }>, duetSimulation: { __typename?: 'DuetSimulation', duet_simulation_blocks: Array<{ __typename?: 'DuetSimulationBlock', block_id: string, panel_parameters: { __typename?: 'PvPanel', panel_type?: string | null, bifaciality_current_ratio?: number | null } }> }, simPdfExportData: { __typename?: 'SimulationPdfExportData', block_data: Array<{ __typename?: 'SimulationPdfExportBlockData', block_id: string, nominal_dc_power?: number | null }> } };

export type DuetSimMetaQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type DuetSimMetaQuery = { __typename?: 'Query', duetSimulation: { __typename?: 'DuetSimulation', created_at: any, name: string, enviro_dataset_type: string, enviro_dataset_name?: string | null, latitude?: number | null, longitude?: number | null, local_time_zone?: number | null, duet_job: { __typename?: 'DuetJob', time_interval?: number | null }, duet_simulation_blocks: Array<{ __typename?: 'DuetSimulationBlock', duet_job_input_id: string, name: string, panel_parameters: { __typename?: 'PvPanel', panel_type?: string | null } }>, project: { __typename?: 'Project', id: string, name: string }, time_range?: { __typename?: 'TimeRange', start: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null }, end: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null } } | null }, simulationTimestamps: Array<{ __typename?: 'SimulationTimestamp', dt_timestamp: any }>, simulationExtendedSummary: { __typename?: 'SimulationExtendedSummary', cellTemperatureSupported?: boolean | null } };

export type TimeRangeFragment = { __typename?: 'TimeRange', start: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null }, end: { __typename?: 'DateTimeObject', year?: number | null, month: number, day: number, hour: number, minute?: number | null } };

export type DailyYieldsQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type DailyYieldsQuery = { __typename?: 'Query', simulationTimeSeriesSummary: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }>, simulationSummary: Array<{ __typename?: 'SimulationSummary', sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }> };

export type PerformanceRatioQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type PerformanceRatioQuery = { __typename?: 'Query', simulationSummary: Array<{ __typename?: 'SimulationSummary', sum__performance_ratio_bi: number, sum__performance_ratio_mono: number }>, simulationTimeSeriesSummary: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__performance_ratio_bi: number, sum__performance_ratio_mono: number }> };

export type CapacityFactorQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type CapacityFactorQuery = { __typename?: 'Query', simulationSummary: Array<{ __typename?: 'SimulationSummary', sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }>, simulationTimeSeriesSummary: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }>, simulationTimestamps: Array<{ __typename?: 'SimulationTimestamp', dt_timestamp: any }>, simulationDailySunRiseSet: Array<{ __typename?: 'SunRiseSet', dt_timestamp: string, sunrise: string, sunset: string }>, simulationExtendedSummary: { __typename?: 'SimulationExtendedSummary', nominal_dc_power?: number | null, inverter_ac_power?: number | null } };

export type ZoneYieldsQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type ZoneYieldsQuery = { __typename?: 'Query', simulationSummary: Array<{ __typename?: 'SimulationSummary', duet_job_input_id?: string | null, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_bi: number }> };

export type HourlyYieldsQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type HourlyYieldsQuery = { __typename?: 'Query', simulationTimeSeriesSummary: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, avg__ghi_wm2: number, sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null }> };

type BifacialEnergyMeasures_SimulationSummary_Fragment = { __typename?: 'SimulationSummary', sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null };

type BifacialEnergyMeasures_SimulationTimeSeriesSummary_Fragment = { __typename?: 'SimulationTimeSeriesSummary', sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null };

export type BifacialEnergyMeasuresFragment = BifacialEnergyMeasures_SimulationSummary_Fragment | BifacialEnergyMeasures_SimulationTimeSeriesSummary_Fragment;

type MonofacialEnergyMeasures_SimulationSummary_Fragment = { __typename?: 'SimulationSummary', sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null };

type MonofacialEnergyMeasures_SimulationTimeSeriesSummary_Fragment = { __typename?: 'SimulationTimeSeriesSummary', sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null };

export type MonofacialEnergyMeasuresFragment = MonofacialEnergyMeasures_SimulationSummary_Fragment | MonofacialEnergyMeasures_SimulationTimeSeriesSummary_Fragment;

export type MeteoMeasuresFragment = { __typename?: 'SimulationTimeSeriesSummary', avg__ghi_wm2: number, min__ghi_wm2: number, p10__ghi_wm2: number, p25__ghi_wm2: number, p50__ghi_wm2: number, p75__ghi_wm2: number, p90__ghi_wm2: number, max__ghi_wm2: number, avg__dhi_wm2: number, min__dhi_wm2: number, p10__dhi_wm2: number, p25__dhi_wm2: number, p50__dhi_wm2: number, p75__dhi_wm2: number, p90__dhi_wm2: number, max__dhi_wm2: number, avg__dni_wm2: number, min__dni_wm2: number, p10__dni_wm2: number, p25__dni_wm2: number, p50__dni_wm2: number, p75__dni_wm2: number, p90__dni_wm2: number, max__dni_wm2: number, avg__temperature_c: number, min__temperature_c: number, p10__temperature_c: number, p25__temperature_c: number, p50__temperature_c: number, p75__temperature_c: number, p90__temperature_c: number, max__temperature_c: number };

export type TimeSeriesSummaryQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
  date_args: DateArgsInput;
  include_energy_bi?: InputMaybe<Scalars['Boolean']>;
  include_energy_mono?: InputMaybe<Scalars['Boolean']>;
  include_meteo?: InputMaybe<Scalars['Boolean']>;
}>;


export type TimeSeriesSummaryQuery = { __typename?: 'Query', simulationTimeSeriesSummary: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__line_receiving_end_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__line_receiving_end_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null, avg__ghi_wm2: number, min__ghi_wm2: number, p10__ghi_wm2: number, p25__ghi_wm2: number, p50__ghi_wm2: number, p75__ghi_wm2: number, p90__ghi_wm2: number, max__ghi_wm2: number, avg__dhi_wm2: number, min__dhi_wm2: number, p10__dhi_wm2: number, p25__dhi_wm2: number, p50__dhi_wm2: number, p75__dhi_wm2: number, p90__dhi_wm2: number, max__dhi_wm2: number, avg__dni_wm2: number, min__dni_wm2: number, p10__dni_wm2: number, p25__dni_wm2: number, p50__dni_wm2: number, p75__dni_wm2: number, p90__dni_wm2: number, max__dni_wm2: number, avg__temperature_c: number, min__temperature_c: number, p10__temperature_c: number, p25__temperature_c: number, p50__temperature_c: number, p75__temperature_c: number, p90__temperature_c: number, max__temperature_c: number }> };

export type DrillDownQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
  date_args: DateArgsInput;
  duet_job_input_id?: InputMaybe<Scalars['String']>;
  measure: Measure;
}>;


export type DrillDownQuery = { __typename?: 'Query', simulationTimeSeriesDrillDown: Array<{ __typename?: 'SimulationTimeSeriesDrillDown', dt_timestamp: any, sum: number, avg: number, min: number, max: number, p10: number, p25: number, p50: number, p75: number, p90: number }> };

type MonofacialLosses_SimulationSummary_Fragment = { __typename?: 'SimulationSummary', sum__array_cell_max_energy_t_stc_mono?: number | null, sum__array_cell_energy_mono?: number | null, sum__energy_mono: number, sum__transformer_input_energy_wh_mono: number, sum__transformer_output_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__pv_power_with_soiling_wh_mono: number, sum__soiling_loss_wh_mono: number, sum__pv_power_no_degradation_wh_mono: number, sum__pv_power_with_degradation_wh_mono: number, sum__total_degradation_loss_wh_mono: number, sum__degradation_loss_first_year_wh_mono: number, sum__degradation_loss_remaining_years_wh_mono: number, sum__line_sending_end_energy_wh_mono: number, sum__line_receiving_end_energy_wh_mono: number, sum__line_energy_loss_wh_mono: number, sum__transmission_line_sending_end_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__transmission_line_energy_loss_wh_mono: number, sum__transformer_energy_loss_wh_mono: number, sum__transformer_iron_core_loss_wh_mono: number, sum__transformer_copper_loss_wh_mono: number, sum__self_consumption_loss_wh_mono: number, sum__ac_power_clipping_loss_wh_mono: number, sum__inverter_night_tare_loss_wh_mono: number, sum__inverter_dc_undervoltage_loss_wh_mono: number, sum__inverter_dc_overvoltage_loss_wh_mono: number, sum__inverter_dc_underpower_loss_wh_mono: number, sum__inverter_dc_overpower_loss_wh_mono: number, sum__inverter_dc_overcurrent_loss_wh_mono: number, sum__power_factor_derate_loss_wh_mono?: number | null, sum__below_min_temperature_loss_wh_mono: number, sum__above_max_temperature_loss_wh_mono: number, sum__temperature_derating_loss_wh_mono: number, sum__total_inverter_loss_wh_mono: number, sum__inverter_output_energy_stc_wh_mono?: number | null, sum__ghi_whm2: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_far_shading_whm2?: number | null, sum__gti_f_pvsyst_with_near_shading_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null };

type MonofacialLosses_SimulationTimeSeriesSummary_Fragment = { __typename?: 'SimulationTimeSeriesSummary', sum__array_cell_max_energy_t_stc_mono?: number | null, sum__array_cell_energy_mono?: number | null, sum__energy_mono: number, sum__transformer_input_energy_wh_mono: number, sum__transformer_output_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__pv_power_with_soiling_wh_mono: number, sum__soiling_loss_wh_mono: number, sum__pv_power_no_degradation_wh_mono: number, sum__pv_power_with_degradation_wh_mono: number, sum__total_degradation_loss_wh_mono: number, sum__degradation_loss_first_year_wh_mono: number, sum__degradation_loss_remaining_years_wh_mono: number, sum__line_sending_end_energy_wh_mono: number, sum__line_receiving_end_energy_wh_mono: number, sum__line_energy_loss_wh_mono: number, sum__transmission_line_sending_end_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__transmission_line_energy_loss_wh_mono: number, sum__transformer_energy_loss_wh_mono: number, sum__transformer_iron_core_loss_wh_mono: number, sum__transformer_copper_loss_wh_mono: number, sum__self_consumption_loss_wh_mono: number, sum__ac_power_clipping_loss_wh_mono: number, sum__inverter_night_tare_loss_wh_mono: number, sum__inverter_dc_undervoltage_loss_wh_mono: number, sum__inverter_dc_overvoltage_loss_wh_mono: number, sum__inverter_dc_underpower_loss_wh_mono: number, sum__inverter_dc_overpower_loss_wh_mono: number, sum__inverter_dc_overcurrent_loss_wh_mono: number, sum__power_factor_derate_loss_wh_mono?: number | null, sum__below_min_temperature_loss_wh_mono: number, sum__above_max_temperature_loss_wh_mono: number, sum__temperature_derating_loss_wh_mono: number, sum__total_inverter_loss_wh_mono: number, sum__inverter_output_energy_stc_wh_mono?: number | null, sum__ghi_whm2: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_far_shading_whm2?: number | null, sum__gti_f_pvsyst_with_near_shading_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null };

export type MonofacialLossesFragment = MonofacialLosses_SimulationSummary_Fragment | MonofacialLosses_SimulationTimeSeriesSummary_Fragment;

type BifacialLosses_SimulationSummary_Fragment = { __typename?: 'SimulationSummary', sum__array_cell_max_energy_t_stc_bi?: number | null, sum__array_cell_energy_bi?: number | null, sum__energy_bi: number, sum__transformer_input_energy_wh_bi: number, sum__transformer_output_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__pv_power_with_soiling_wh_bi: number, sum__soiling_loss_wh_bi: number, sum__pv_power_no_degradation_wh_bi: number, sum__pv_power_with_degradation_wh_bi: number, sum__total_degradation_loss_wh_bi: number, sum__degradation_loss_first_year_wh_bi: number, sum__degradation_loss_remaining_years_wh_bi: number, sum__line_sending_end_energy_wh_bi: number, sum__line_receiving_end_energy_wh_bi: number, sum__line_energy_loss_wh_bi: number, sum__transmission_line_sending_end_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__transmission_line_energy_loss_wh_bi: number, sum__transformer_energy_loss_wh_bi: number, sum__transformer_iron_core_loss_wh_bi: number, sum__transformer_copper_loss_wh_bi: number, sum__self_consumption_loss_wh_bi: number, sum__ac_power_clipping_loss_wh_bi: number, sum__inverter_night_tare_loss_wh_bi: number, sum__inverter_dc_undervoltage_loss_wh_bi: number, sum__inverter_dc_overvoltage_loss_wh_bi: number, sum__inverter_dc_underpower_loss_wh_bi: number, sum__inverter_dc_overpower_loss_wh_bi: number, sum__inverter_dc_overcurrent_loss_wh_bi: number, sum__power_factor_derate_loss_wh_bi?: number | null, sum__below_min_temperature_loss_wh_bi: number, sum__above_max_temperature_loss_wh_bi: number, sum__temperature_derating_loss_wh_bi: number, sum__total_inverter_loss_wh_bi: number, sum__inverter_output_energy_stc_wh_bi?: number | null, sum__ghi_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_with_diffuse_whm2?: number | null, sum__gti_r_pvsyst_with_direct_whm2?: number | null, sum__gti_r_pvsyst_with_structure_whm2?: number | null };

type BifacialLosses_SimulationTimeSeriesSummary_Fragment = { __typename?: 'SimulationTimeSeriesSummary', sum__array_cell_max_energy_t_stc_bi?: number | null, sum__array_cell_energy_bi?: number | null, sum__energy_bi: number, sum__transformer_input_energy_wh_bi: number, sum__transformer_output_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__pv_power_with_soiling_wh_bi: number, sum__soiling_loss_wh_bi: number, sum__pv_power_no_degradation_wh_bi: number, sum__pv_power_with_degradation_wh_bi: number, sum__total_degradation_loss_wh_bi: number, sum__degradation_loss_first_year_wh_bi: number, sum__degradation_loss_remaining_years_wh_bi: number, sum__line_sending_end_energy_wh_bi: number, sum__line_receiving_end_energy_wh_bi: number, sum__line_energy_loss_wh_bi: number, sum__transmission_line_sending_end_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__transmission_line_energy_loss_wh_bi: number, sum__transformer_energy_loss_wh_bi: number, sum__transformer_iron_core_loss_wh_bi: number, sum__transformer_copper_loss_wh_bi: number, sum__self_consumption_loss_wh_bi: number, sum__ac_power_clipping_loss_wh_bi: number, sum__inverter_night_tare_loss_wh_bi: number, sum__inverter_dc_undervoltage_loss_wh_bi: number, sum__inverter_dc_overvoltage_loss_wh_bi: number, sum__inverter_dc_underpower_loss_wh_bi: number, sum__inverter_dc_overpower_loss_wh_bi: number, sum__inverter_dc_overcurrent_loss_wh_bi: number, sum__power_factor_derate_loss_wh_bi?: number | null, sum__below_min_temperature_loss_wh_bi: number, sum__above_max_temperature_loss_wh_bi: number, sum__temperature_derating_loss_wh_bi: number, sum__total_inverter_loss_wh_bi: number, sum__inverter_output_energy_stc_wh_bi?: number | null, sum__ghi_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_with_diffuse_whm2?: number | null, sum__gti_r_pvsyst_with_direct_whm2?: number | null, sum__gti_r_pvsyst_with_structure_whm2?: number | null };

export type BifacialLossesFragment = BifacialLosses_SimulationSummary_Fragment | BifacialLosses_SimulationTimeSeriesSummary_Fragment;

type MonofacialHvStageLosses_SimulationSummary_Fragment = { __typename?: 'SimulationSummary', sum__hv_transformer_input_energy_wh_mono?: number | null, sum__hv_transformer_iron_core_loss_wh_mono?: number | null, sum__hv_transformer_copper_loss_wh_mono?: number | null, sum__hv_transformer_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__hv_transmission_line_sending_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null };

type MonofacialHvStageLosses_SimulationTimeSeriesSummary_Fragment = { __typename?: 'SimulationTimeSeriesSummary', sum__hv_transformer_input_energy_wh_mono?: number | null, sum__hv_transformer_iron_core_loss_wh_mono?: number | null, sum__hv_transformer_copper_loss_wh_mono?: number | null, sum__hv_transformer_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__hv_transmission_line_sending_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null };

export type MonofacialHvStageLossesFragment = MonofacialHvStageLosses_SimulationSummary_Fragment | MonofacialHvStageLosses_SimulationTimeSeriesSummary_Fragment;

type BifacialHvStageLosses_SimulationSummary_Fragment = { __typename?: 'SimulationSummary', sum__hv_transformer_input_energy_wh_bi?: number | null, sum__hv_transformer_iron_core_loss_wh_bi?: number | null, sum__hv_transformer_copper_loss_wh_bi?: number | null, sum__hv_transformer_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__hv_transmission_line_sending_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null };

type BifacialHvStageLosses_SimulationTimeSeriesSummary_Fragment = { __typename?: 'SimulationTimeSeriesSummary', sum__hv_transformer_input_energy_wh_bi?: number | null, sum__hv_transformer_iron_core_loss_wh_bi?: number | null, sum__hv_transformer_copper_loss_wh_bi?: number | null, sum__hv_transformer_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__hv_transmission_line_sending_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null };

export type BifacialHvStageLossesFragment = BifacialHvStageLosses_SimulationSummary_Fragment | BifacialHvStageLosses_SimulationTimeSeriesSummary_Fragment;

export type SystemLossesQueryVariables = Exact<{
  simulation_id: Scalars['String'];
  project_id: Scalars['String'];
  is_bifacial: Scalars['Boolean'];
}>;


export type SystemLossesQuery = { __typename?: 'Query', simulationSummary: Array<{ __typename?: 'SimulationSummary', sum__array_cell_max_energy_t_stc_mono?: number | null, sum__array_cell_energy_mono?: number | null, sum__energy_mono: number, sum__transformer_input_energy_wh_mono: number, sum__transformer_output_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__pv_power_with_soiling_wh_mono: number, sum__soiling_loss_wh_mono: number, sum__pv_power_no_degradation_wh_mono: number, sum__pv_power_with_degradation_wh_mono: number, sum__total_degradation_loss_wh_mono: number, sum__degradation_loss_first_year_wh_mono: number, sum__degradation_loss_remaining_years_wh_mono: number, sum__line_sending_end_energy_wh_mono: number, sum__line_receiving_end_energy_wh_mono: number, sum__line_energy_loss_wh_mono: number, sum__transmission_line_sending_end_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__transmission_line_energy_loss_wh_mono: number, sum__transformer_energy_loss_wh_mono: number, sum__transformer_iron_core_loss_wh_mono: number, sum__transformer_copper_loss_wh_mono: number, sum__self_consumption_loss_wh_mono: number, sum__ac_power_clipping_loss_wh_mono: number, sum__inverter_night_tare_loss_wh_mono: number, sum__inverter_dc_undervoltage_loss_wh_mono: number, sum__inverter_dc_overvoltage_loss_wh_mono: number, sum__inverter_dc_underpower_loss_wh_mono: number, sum__inverter_dc_overpower_loss_wh_mono: number, sum__inverter_dc_overcurrent_loss_wh_mono: number, sum__power_factor_derate_loss_wh_mono?: number | null, sum__below_min_temperature_loss_wh_mono: number, sum__above_max_temperature_loss_wh_mono: number, sum__temperature_derating_loss_wh_mono: number, sum__total_inverter_loss_wh_mono: number, sum__inverter_output_energy_stc_wh_mono?: number | null, sum__ghi_whm2: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_far_shading_whm2?: number | null, sum__gti_f_pvsyst_with_near_shading_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null, sum__hv_transformer_input_energy_wh_mono?: number | null, sum__hv_transformer_iron_core_loss_wh_mono?: number | null, sum__hv_transformer_copper_loss_wh_mono?: number | null, sum__hv_transformer_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_sending_end_energy_wh_mono?: number | null, sum__array_cell_max_energy_t_stc_bi?: number | null, sum__array_cell_energy_bi?: number | null, sum__energy_bi: number, sum__transformer_input_energy_wh_bi: number, sum__transformer_output_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__pv_power_with_soiling_wh_bi: number, sum__soiling_loss_wh_bi: number, sum__pv_power_no_degradation_wh_bi: number, sum__pv_power_with_degradation_wh_bi: number, sum__total_degradation_loss_wh_bi: number, sum__degradation_loss_first_year_wh_bi: number, sum__degradation_loss_remaining_years_wh_bi: number, sum__line_sending_end_energy_wh_bi: number, sum__line_receiving_end_energy_wh_bi: number, sum__line_energy_loss_wh_bi: number, sum__transmission_line_sending_end_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__transmission_line_energy_loss_wh_bi: number, sum__transformer_energy_loss_wh_bi: number, sum__transformer_iron_core_loss_wh_bi: number, sum__transformer_copper_loss_wh_bi: number, sum__self_consumption_loss_wh_bi: number, sum__ac_power_clipping_loss_wh_bi: number, sum__inverter_night_tare_loss_wh_bi: number, sum__inverter_dc_undervoltage_loss_wh_bi: number, sum__inverter_dc_overvoltage_loss_wh_bi: number, sum__inverter_dc_underpower_loss_wh_bi: number, sum__inverter_dc_overpower_loss_wh_bi: number, sum__inverter_dc_overcurrent_loss_wh_bi: number, sum__power_factor_derate_loss_wh_bi?: number | null, sum__below_min_temperature_loss_wh_bi: number, sum__above_max_temperature_loss_wh_bi: number, sum__temperature_derating_loss_wh_bi: number, sum__total_inverter_loss_wh_bi: number, sum__inverter_output_energy_stc_wh_bi?: number | null, sum__ghi_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_with_diffuse_whm2?: number | null, sum__gti_r_pvsyst_with_direct_whm2?: number | null, sum__gti_r_pvsyst_with_structure_whm2?: number | null, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__hv_transformer_input_energy_wh_bi?: number | null, sum__hv_transformer_iron_core_loss_wh_bi?: number | null, sum__hv_transformer_copper_loss_wh_bi?: number | null, sum__hv_transformer_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_sending_end_energy_wh_bi?: number | null }>, simulationTimeSeriesSummary: Array<{ __typename?: 'SimulationTimeSeriesSummary', dt_timestamp: any, sum__array_cell_max_energy_t_stc_mono?: number | null, sum__array_cell_energy_mono?: number | null, sum__energy_mono: number, sum__transformer_input_energy_wh_mono: number, sum__transformer_output_energy_wh_mono: number, sum__inverter_output_energy_wh_mono: number, sum__pv_power_with_soiling_wh_mono: number, sum__soiling_loss_wh_mono: number, sum__pv_power_no_degradation_wh_mono: number, sum__pv_power_with_degradation_wh_mono: number, sum__total_degradation_loss_wh_mono: number, sum__degradation_loss_first_year_wh_mono: number, sum__degradation_loss_remaining_years_wh_mono: number, sum__line_sending_end_energy_wh_mono: number, sum__line_receiving_end_energy_wh_mono: number, sum__line_energy_loss_wh_mono: number, sum__transmission_line_sending_end_energy_wh_mono: number, sum__transmission_line_receiving_end_energy_wh_mono: number, sum__transmission_line_energy_loss_wh_mono: number, sum__transformer_energy_loss_wh_mono: number, sum__transformer_iron_core_loss_wh_mono: number, sum__transformer_copper_loss_wh_mono: number, sum__self_consumption_loss_wh_mono: number, sum__ac_power_clipping_loss_wh_mono: number, sum__inverter_night_tare_loss_wh_mono: number, sum__inverter_dc_undervoltage_loss_wh_mono: number, sum__inverter_dc_overvoltage_loss_wh_mono: number, sum__inverter_dc_underpower_loss_wh_mono: number, sum__inverter_dc_overpower_loss_wh_mono: number, sum__inverter_dc_overcurrent_loss_wh_mono: number, sum__power_factor_derate_loss_wh_mono?: number | null, sum__below_min_temperature_loss_wh_mono: number, sum__above_max_temperature_loss_wh_mono: number, sum__temperature_derating_loss_wh_mono: number, sum__total_inverter_loss_wh_mono: number, sum__inverter_output_energy_stc_wh_mono?: number | null, sum__ghi_whm2: number, sum__gti_f_pvsyst_no_loss_whm2?: number | null, sum__gti_f_pvsyst_with_far_shading_whm2?: number | null, sum__gti_f_pvsyst_with_near_shading_whm2?: number | null, sum__gti_f_pvsyst_with_iam_whm2?: number | null, sum__hv_transformer_output_energy_wh_mono?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_mono?: number | null, sum__grid_injection_energy_wh_mono?: number | null, avg__ave_mono_cell_temp_c?: number | null, sum__hv_transformer_input_energy_wh_mono?: number | null, sum__hv_transformer_iron_core_loss_wh_mono?: number | null, sum__hv_transformer_copper_loss_wh_mono?: number | null, sum__hv_transformer_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_energy_loss_wh_mono?: number | null, sum__hv_transmission_line_sending_end_energy_wh_mono?: number | null, sum__array_cell_max_energy_t_stc_bi?: number | null, sum__array_cell_energy_bi?: number | null, sum__energy_bi: number, sum__transformer_input_energy_wh_bi: number, sum__transformer_output_energy_wh_bi: number, sum__inverter_output_energy_wh_bi: number, sum__pv_power_with_soiling_wh_bi: number, sum__soiling_loss_wh_bi: number, sum__pv_power_no_degradation_wh_bi: number, sum__pv_power_with_degradation_wh_bi: number, sum__total_degradation_loss_wh_bi: number, sum__degradation_loss_first_year_wh_bi: number, sum__degradation_loss_remaining_years_wh_bi: number, sum__line_sending_end_energy_wh_bi: number, sum__line_receiving_end_energy_wh_bi: number, sum__line_energy_loss_wh_bi: number, sum__transmission_line_sending_end_energy_wh_bi: number, sum__transmission_line_receiving_end_energy_wh_bi: number, sum__transmission_line_energy_loss_wh_bi: number, sum__transformer_energy_loss_wh_bi: number, sum__transformer_iron_core_loss_wh_bi: number, sum__transformer_copper_loss_wh_bi: number, sum__self_consumption_loss_wh_bi: number, sum__ac_power_clipping_loss_wh_bi: number, sum__inverter_night_tare_loss_wh_bi: number, sum__inverter_dc_undervoltage_loss_wh_bi: number, sum__inverter_dc_overvoltage_loss_wh_bi: number, sum__inverter_dc_underpower_loss_wh_bi: number, sum__inverter_dc_overpower_loss_wh_bi: number, sum__inverter_dc_overcurrent_loss_wh_bi: number, sum__power_factor_derate_loss_wh_bi?: number | null, sum__below_min_temperature_loss_wh_bi: number, sum__above_max_temperature_loss_wh_bi: number, sum__temperature_derating_loss_wh_bi: number, sum__total_inverter_loss_wh_bi: number, sum__inverter_output_energy_stc_wh_bi?: number | null, sum__ghi_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_ground_reflected_whm2?: number | null, sum__gti_r_pvsyst_with_diffuse_whm2?: number | null, sum__gti_r_pvsyst_with_direct_whm2?: number | null, sum__gti_r_pvsyst_with_structure_whm2?: number | null, sum__hv_transformer_output_energy_wh_bi?: number | null, sum__hv_transmission_line_receiving_end_energy_wh_bi?: number | null, sum__grid_injection_energy_wh_bi?: number | null, avg__ave_bi_cell_temp_c?: number | null, sum__hv_transformer_input_energy_wh_bi?: number | null, sum__hv_transformer_iron_core_loss_wh_bi?: number | null, sum__hv_transformer_copper_loss_wh_bi?: number | null, sum__hv_transformer_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_energy_loss_wh_bi?: number | null, sum__hv_transmission_line_sending_end_energy_wh_bi?: number | null }>, simPdfExportData: { __typename?: 'SimulationPdfExportData', system_stc_efficiency?: number | null, block_data: Array<{ __typename?: 'SimulationPdfExportBlockData', block_id: string, stc_efficiency?: number | null, num_total_panels?: number | null, nominal_dc_power?: number | null }> }, simulationExtendedSummary: { __typename?: 'SimulationExtendedSummary', inverterNightTarePower?: number | null }, simulationTimestamps: Array<{ __typename?: 'SimulationTimestamp', dt_timestamp: any }>, simulationDailySunRiseSet: Array<{ __typename?: 'SunRiseSet', dt_timestamp: string, sunrise: string, sunset: string }>, duetSimulation: { __typename?: 'DuetSimulation', duet_simulation_blocks: Array<{ __typename?: 'DuetSimulationBlock', block_id: string, panel_parameters: { __typename: 'PvPanel', default_state_fields?: any | null, panel_technology?: string | null, panel_type?: string | null, pan_file_import?: any | null, iam_profile?: any | null, cells?: Array<number | null> | null, cell_spacing_lr?: number | null, cell_spacing_tb?: number | null, half_cut_center_space?: number | null, panel_edge_b?: number | null, panel_edge_t?: number | null, panel_edge_lr?: number | null, frame?: boolean | null, frame_dimensions?: Array<number | null> | null, cell_length?: number | null, cell_width?: number | null, cell_type?: string | null, cell_shape?: string | null, corner_cut_off?: number | null, parallel_string_per_diode?: Array<number | null> | null, bypass_diodes?: Array<number | null> | null, bifaciality_current_ratio?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, temperature_coefficient_isc?: number | null, temperature_coefficient_voc?: number | null, shunt_resistance?: number | null, series_resistance?: number | null, ideality_factor?: number | null, bypass_diode_max_neg_v?: number | null, nominal_operating_cell_temp?: number | null, irradiance_coefficients_temp?: Array<number | null> | null, first_year_degradation_rate?: number | null, remaining_years_degradation_rate?: number | null }, table_parameters: { __typename: 'PvTable', default_state_fields?: any | null, azimuth?: number | null, column_gap?: number | null, ground_clearance?: number | null, num_cols?: any | null, num_post_cols?: number | null, num_post_tiers?: number | null, num_tiers?: number | null, orientation_str?: string | null, row_offset?: any | null, row_spacing?: number | null, table_gap?: any | null, tier_gap?: any | null, tilt?: number | null, backtracking_enabled?: boolean | null, stow_angle?: number | null, in_plane_racking_dimensions?: any | null, in_plane_racking_enabled?: boolean | null, in_plane_racking_shape?: string | null, rotation_radius?: number | null, torque_tube_enabled?: boolean | null, torque_tube_radius?: number | null, torque_tube_rect_dimensions?: any | null, torque_tube_shape?: string | null, track_angle_bounds?: Array<number | null> | null, tracking_type?: number | null, torque_tube_height?: number | null, vertical_post_shape?: string | null, vertical_post_enabled?: boolean | null, vertical_post_dimensions?: any | null, vertical_post_distance?: Array<number | null> | null, vertical_post_radius?: number | null } }> } };

export type TableModuleIrradianceProfilesQueryVariables = Exact<{
  simulation_id: Scalars['String'];
}>;


export type TableModuleIrradianceProfilesQuery = { __typename?: 'Query', simulationModuleIrradianceProfileTablesMeta: Array<{ __typename?: 'ModuleIrradianceProfileTableMeta', dt_timestamp: any, table_id: string, duet_job_input_id: string }> };

export type TableModuleIrradianceProfilesDataQueryVariables = Exact<{
  project_id: Scalars['String'];
  simulation_id: Scalars['String'];
  duet_job_input_id: Scalars['String'];
  dt_timestamp: Scalars['String'];
  table_id: Scalars['String'];
}>;


export type TableModuleIrradianceProfilesDataQuery = { __typename?: 'Query', simulationModuleIrradianceProfileTableData: Array<{ __typename?: 'ModuleIrradianceProfile', dt_timestamp: string, front_exterior: Array<Array<number>>, rear_exterior: Array<Array<number>>, pui_id: string }>, projectDuetSimBlock: Array<{ __typename?: 'DuetSimulationBlock', name: string, panel_parameters: { __typename?: 'PvPanel', panel_type?: string | null }, table_parameters: { __typename?: 'PvTable', azimuth?: number | null, orientation_str?: string | null } }> };

export type EditDuetSimulationMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
}>;


export type EditDuetSimulationMutation = { __typename?: 'Mutation', editDuetSimulation: { __typename?: 'DuetSimulation', id: string, created_at: any, name: string, duet_job_id: string, user_id?: string | null, duet_job: { __typename?: 'DuetJob', id: string, created_at: any, status: string }, user?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email: string } | null } };

export type RunProjectBlockSimulationMutationVariables = Exact<{
  project_id: Scalars['String'];
  name: Scalars['String'];
  enviro_dataset_id: Scalars['String'];
  time_range: TimeSelectionRangeInput;
  blocks: Array<BlockSimulationInput> | BlockSimulationInput;
  simulated_year_for_tmy?: InputMaybe<Scalars['Int']>;
}>;


export type RunProjectBlockSimulationMutation = { __typename?: 'Mutation', runProjectBlockSimulation: { __typename?: 'RunSimulationResult', success: boolean, duetSimulation?: { __typename?: 'DuetSimulation', id: string, created_at: any, name: string, duet_job: { __typename?: 'DuetJob', id: string, status: string, stage?: string | null, total_tasks?: number | null, completed_tasks?: number | null, created_at: any, submitted_at?: any | null, running_at?: any | null, completed_at?: any | null }, user?: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } | null, duet_simulation_blocks: Array<{ __typename?: 'DuetSimulationBlock', duet_job_input_id: string, name: string }> } | null, errors?: Array<{ __typename?: 'BlockSimulationErrors', block_id: string, messages: Array<string> }> | null } };

export type SimDuetJobFragment = { __typename?: 'DuetJob', id: string, status: string, stage?: string | null, total_tasks?: number | null, completed_tasks?: number | null, created_at: any, submitted_at?: any | null, running_at?: any | null, completed_at?: any | null };

export type ProjectSimFragment = { __typename?: 'DuetSimulation', id: string, created_at: any, name: string, duet_job: { __typename?: 'DuetJob', id: string, status: string, stage?: string | null, total_tasks?: number | null, completed_tasks?: number | null, created_at: any, submitted_at?: any | null, running_at?: any | null, completed_at?: any | null }, user?: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } | null, duet_simulation_blocks: Array<{ __typename?: 'DuetSimulationBlock', duet_job_input_id: string, name: string }> };

export type ProjectDuetSimQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  project_id: Scalars['String'];
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  not_status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type ProjectDuetSimQuery = { __typename?: 'Query', projectDuetSim: Array<{ __typename?: 'DuetSimulation', id: string, created_at: any, name: string, duet_job: { __typename?: 'DuetJob', id: string, status: string, stage?: string | null, total_tasks?: number | null, completed_tasks?: number | null, created_at: any, submitted_at?: any | null, running_at?: any | null, completed_at?: any | null }, user?: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null } | null, duet_simulation_blocks: Array<{ __typename?: 'DuetSimulationBlock', duet_job_input_id: string, name: string }> }> };

export type RunningProjectSimQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type RunningProjectSimQuery = { __typename?: 'Query', projectDuetSim: Array<{ __typename?: 'DuetSimulation', id: string, name: string, duet_job: { __typename?: 'DuetJob', id: string, status: string, stage?: string | null, total_tasks?: number | null, completed_tasks?: number | null, created_at: any, submitted_at?: any | null, running_at?: any | null, completed_at?: any | null } }> };

export type StopRunningSimulationMutationVariables = Exact<{
  project_id: Scalars['String'];
  id: Scalars['String'];
}>;


export type StopRunningSimulationMutation = { __typename?: 'Mutation', stopProjectSimulation: { __typename?: 'DuetSimulation', id: string, duet_job: { __typename?: 'DuetJob', status: string } } };

export type EditDuetJobStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: Scalars['String'];
}>;


export type EditDuetJobStatusMutation = { __typename?: 'Mutation', editDuetJobStatus: { __typename?: 'DuetJob', id: string, status: string } };

export type DeleteDuetSimulationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDuetSimulationMutation = { __typename?: 'Mutation', deleteDuetSimulation: { __typename?: 'DuetSimulation', id: string } };

export type ProjectUserFragment = { __typename?: 'ProjectUser', role_id: string, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string } };

export type AddProjectUsersMutationVariables = Exact<{
  project_id: Scalars['String'];
  user_ids: Array<Scalars['String']> | Scalars['String'];
  role_id: Scalars['String'];
}>;


export type AddProjectUsersMutation = { __typename?: 'Mutation', addProjectUsers: Array<{ __typename?: 'ProjectUser', role_id: string, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string } }> };

export type DeleteProjectUserMutationVariables = Exact<{
  project_id: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type DeleteProjectUserMutation = { __typename?: 'Mutation', deleteProjectUser: { __typename?: 'ProjectUser', user_id: string, role_id: string } };

export type ProjectsSearchQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['String']>;
  order_by?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  collection: Scalars['String'];
  portfolio?: InputMaybe<Scalars['String']>;
}>;


export type ProjectsSearchQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'Project', id: string, created_at: any, updated_at: any, name: string, pvsyst_import_in_progress?: boolean | null, org_general_access: boolean, organization_id: string, owner_id: string, blocks_bounding_box?: Array<number> | null, layers_mutated_at?: any | null, last_activity_at: any, organization: { __typename?: 'Organization', slug: string, name: string }, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string }, project_users: Array<{ __typename?: 'ProjectUser', role_id: string, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string } }>, recent_simulations: Array<{ __typename?: 'DuetSimulation', id: string, name: string, duet_job: { __typename?: 'DuetJob', id: string, status: string, stage?: string | null, total_tasks?: number | null, completed_tasks?: number | null, created_at: any, submitted_at?: any | null, running_at?: any | null, completed_at?: any | null } }>, sentinel_deployment?: { __typename?: 'SentinelDeployment', portfolio?: string | null } | null }> };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'Project', id: string } };

export type CreateProjectMutationVariables = Exact<{
  organization_id: Scalars['String'];
  name: Scalars['String'];
  blocks_bounding_box?: InputMaybe<Array<Scalars['Float']> | Scalars['Float']>;
  pvsyst_import_in_progress?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string, name: string, organization_id: string, updated_at: any, created_at: any, pvsyst_import_in_progress?: boolean | null, blocks_bounding_box?: Array<number> | null } };

export type CopyProjectMutationVariables = Exact<{
  sourceProjectId: Scalars['String'];
  copyProjectName: Scalars['String'];
}>;


export type CopyProjectMutation = { __typename?: 'Mutation', copyProject: { __typename?: 'Project', id: string, name: string, organization_id: string, updated_at: any, created_at: any } };

export type ProjectWithParametersFragment = { __typename?: 'Project', id: string, created_at: any, updated_at: any, name: string, organization_id: string, org_general_access: boolean, pvsyst_import_in_progress?: boolean | null, blocks_bounding_box?: Array<number> | null, owner_id: string, system_parameters: { __typename?: 'SystemParameters', project_id: string, terrain_dem_enabled: boolean, hv_stage_enabled: boolean, grid_injection_limit_enabled: boolean, grid_injection_limit?: number | null, pv_hv_transformer_id?: string | null, pv_hv_ac_wire_id?: string | null, cell_temperature_model?: string | null, sandia_panel_type?: string | null, sandia_a?: number | null, sandia_b?: number | null, sandia_delta_t?: number | null, sandia_e0?: number | null, faiman_u0?: number | null, faiman_u1?: number | null, pvsyst_mounting_type?: string | null, pvsyst_uc?: number | null, pvsyst_uv?: number | null, pvsyst_alpha?: number | null, voct_model?: string | null, desoto_panel_technology?: string | null, cell_material_bandgap?: number | null, bandgap_temperature_coefficient?: number | null }, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string }, project_users: Array<{ __typename?: 'ProjectUser', role_id: string, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string } }>, duet_simulations: Array<{ __typename?: 'DuetSimulation', user?: { __typename?: 'User', email: string, first_name?: string | null, last_name?: string | null } | null, duet_job: { __typename?: 'DuetJob', status: string, created_at: any, submitted_at?: any | null, running_at?: any | null, completed_at?: any | null } }>, sentinel_deployment?: { __typename?: 'SentinelDeployment', portfolio?: string | null } | null };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project: { __typename?: 'Project', id: string, created_at: any, updated_at: any, name: string, organization_id: string, org_general_access: boolean, pvsyst_import_in_progress?: boolean | null, blocks_bounding_box?: Array<number> | null, owner_id: string, system_parameters: { __typename?: 'SystemParameters', project_id: string, terrain_dem_enabled: boolean, hv_stage_enabled: boolean, grid_injection_limit_enabled: boolean, grid_injection_limit?: number | null, pv_hv_transformer_id?: string | null, pv_hv_ac_wire_id?: string | null, cell_temperature_model?: string | null, sandia_panel_type?: string | null, sandia_a?: number | null, sandia_b?: number | null, sandia_delta_t?: number | null, sandia_e0?: number | null, faiman_u0?: number | null, faiman_u1?: number | null, pvsyst_mounting_type?: string | null, pvsyst_uc?: number | null, pvsyst_uv?: number | null, pvsyst_alpha?: number | null, voct_model?: string | null, desoto_panel_technology?: string | null, cell_material_bandgap?: number | null, bandgap_temperature_coefficient?: number | null }, owner: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string }, project_users: Array<{ __typename?: 'ProjectUser', role_id: string, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string } }>, duet_simulations: Array<{ __typename?: 'DuetSimulation', user?: { __typename?: 'User', email: string, first_name?: string | null, last_name?: string | null } | null, duet_job: { __typename?: 'DuetJob', status: string, created_at: any, submitted_at?: any | null, running_at?: any | null, completed_at?: any | null } }>, sentinel_deployment?: { __typename?: 'SentinelDeployment', portfolio?: string | null } | null } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['String'];
  data: ProjectUpdateData;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, name: string } };

export type GetProjectFileStorageSignedUrlQueryVariables = Exact<{
  project_id: Scalars['String'];
  dir: Scalars['String'];
  filename: Scalars['String'];
  allowOverwrite?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetProjectFileStorageSignedUrlQuery = { __typename?: 'Query', projectFileStorageSignedUrl: { __typename?: 'GetFileStorageSignedUrlPayload', url: string, filename: string } };

export type GetPanelIvQueryVariables = Exact<{
  panels: Array<GetPanelIvInput> | GetPanelIvInput;
}>;


export type GetPanelIvQuery = { __typename?: 'Query', getPanelIv: Array<{ __typename?: 'GetPanelIvPayload', panel_id: string, iv_params_invalid: boolean, ideality_factor?: number | null, short_circuit_current?: number | null, open_circuit_voltage?: number | null, series_resistance?: number | null, shunt_resistance?: number | null, saturation_current?: number | null, maximum_dc_power?: number | null, maximum_power_voltage?: number | null, maximum_power_current?: number | null, cell_iv_curve?: Array<{ __typename?: 'IVCurvePoint', current: number, voltage: number }> | null, module_iv_curve?: Array<{ __typename?: 'IVCurvePoint', current: number, voltage: number }> | null }> };

export type SystemParametersFragment = { __typename?: 'SystemParameters', project_id: string, terrain_dem_enabled: boolean, hv_stage_enabled: boolean, grid_injection_limit_enabled: boolean, grid_injection_limit?: number | null, pv_hv_transformer_id?: string | null, pv_hv_ac_wire_id?: string | null, cell_temperature_model?: string | null, sandia_panel_type?: string | null, sandia_a?: number | null, sandia_b?: number | null, sandia_delta_t?: number | null, sandia_e0?: number | null, faiman_u0?: number | null, faiman_u1?: number | null, pvsyst_mounting_type?: string | null, pvsyst_uc?: number | null, pvsyst_uv?: number | null, pvsyst_alpha?: number | null, voct_model?: string | null, desoto_panel_technology?: string | null, cell_material_bandgap?: number | null, bandgap_temperature_coefficient?: number | null };

export type GetSystemParametersQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type GetSystemParametersQuery = { __typename?: 'Query', systemParameters: { __typename?: 'SystemParameters', project_id: string, terrain_dem_enabled: boolean, hv_stage_enabled: boolean, grid_injection_limit_enabled: boolean, grid_injection_limit?: number | null, pv_hv_transformer_id?: string | null, pv_hv_ac_wire_id?: string | null, cell_temperature_model?: string | null, sandia_panel_type?: string | null, sandia_a?: number | null, sandia_b?: number | null, sandia_delta_t?: number | null, sandia_e0?: number | null, faiman_u0?: number | null, faiman_u1?: number | null, pvsyst_mounting_type?: string | null, pvsyst_uc?: number | null, pvsyst_uv?: number | null, pvsyst_alpha?: number | null, voct_model?: string | null, desoto_panel_technology?: string | null, cell_material_bandgap?: number | null, bandgap_temperature_coefficient?: number | null } };

export type UpdateSystemParametersMutationVariables = Exact<{
  system_parameters: SystemParametersInput;
}>;


export type UpdateSystemParametersMutation = { __typename?: 'Mutation', updateSystemParameters: { __typename?: 'SystemParameters', project_id: string, terrain_dem_enabled: boolean, hv_stage_enabled: boolean, grid_injection_limit_enabled: boolean, grid_injection_limit?: number | null, pv_hv_transformer_id?: string | null, pv_hv_ac_wire_id?: string | null, cell_temperature_model?: string | null, sandia_panel_type?: string | null, sandia_a?: number | null, sandia_b?: number | null, sandia_delta_t?: number | null, sandia_e0?: number | null, faiman_u0?: number | null, faiman_u1?: number | null, pvsyst_mounting_type?: string | null, pvsyst_uc?: number | null, pvsyst_uv?: number | null, pvsyst_alpha?: number | null, voct_model?: string | null, desoto_panel_technology?: string | null, cell_material_bandgap?: number | null, bandgap_temperature_coefficient?: number | null } };

export type UserFragmentFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, created_at: any, updated_at: any, has_lead_intake_form: boolean, user_identity: Array<{ __typename?: 'UserIdentity', id: string, provider: string, email_verified: boolean, provider_payload: any }>, user_organization: Array<{ __typename?: 'UserOrganization', organization: { __typename?: 'Organization', id: string, name: string, slug: string } }> };

export type UserMeQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, created_at: any, updated_at: any, has_lead_intake_form: boolean, user_identity: Array<{ __typename?: 'UserIdentity', id: string, provider: string, email_verified: boolean, provider_payload: any }>, user_organization: Array<{ __typename?: 'UserOrganization', organization: { __typename?: 'Organization', id: string, name: string, slug: string } }> } };

export type UserSearchQueryVariables = Exact<{
  search: Scalars['String'];
  organization_id?: InputMaybe<Scalars['String']>;
}>;


export type UserSearchQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, created_at: any, updated_at: any, has_lead_intake_form: boolean, user_identity: Array<{ __typename?: 'UserIdentity', id: string, provider: string, email_verified: boolean, provider_payload: any }>, user_organization: Array<{ __typename?: 'UserOrganization', organization: { __typename?: 'Organization', id: string, name: string, slug: string } }> }> };

export type UpdateUserMutationVariables = Exact<{
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email: string, created_at: any, updated_at: any, has_lead_intake_form: boolean, user_identity: Array<{ __typename?: 'UserIdentity', id: string, provider: string, email_verified: boolean, provider_payload: any }>, user_organization: Array<{ __typename?: 'UserOrganization', organization: { __typename?: 'Organization', id: string, name: string, slug: string } }> } };

export type UserDataPrivacyRequestMutationVariables = Exact<{
  request_type: Scalars['String'];
}>;


export type UserDataPrivacyRequestMutation = { __typename?: 'Mutation', userDataPrivacyRequest: boolean };

export const OrganizationFragmentFragmentDoc = `
    fragment organizationFragment on Organization {
  id
  name
  slug
  allowed_domains
  user_organization {
    id
    user {
      id
      email
      first_name
      last_name
    }
    role_id
  }
}
    `;
export const BlockLayerFragmentDoc = `
    fragment BlockLayer on BlockLayer {
  id
  block_id
  project_id
  name
  type
  geojson
  source_type
  source_filename
  source_url
  created_at
  updated_at
}
    `;
export const BlockFragmentDoc = `
    fragment Block on Block {
  id
  created_at
  updated_at
  name
  enviro_dataset_id
  pv_system_start_date
  cleaning_interval_days
  soiling_rate
  power_factor
  date_of_most_recent_cleaning
  pv_soiling_algorithm
  soiling_rates_percentage
  num_inverters
  slope_azimuth
  slope_tilt
  follow_slope
  slope_aware_tracking
  terrain_type
  pv_table_id
  pv_panel_id
  pv_inverter_id
  pv_transformer_id
  pv_dc_wire_id
  pv_ac_wire_id
  pv_panel {
    panel_edge_lr
    panel_edge_b
    panel_edge_t
    cell_length
    cell_width
    cell_spacing_lr
    cell_spacing_tb
    half_cut_center_space
    cells
    ideality_factor
    short_circuit_current
    open_circuit_voltage
    series_resistance
    shunt_resistance
    cell_type
    panel_type
    bifaciality_current_ratio
    parallel_string_per_diode
  }
  pv_table {
    num_cols
    num_tiers
    row_offset
    row_spacing
    table_gap
    tier_gap
    column_gap
    azimuth
    orientation_str
  }
}
    `;
export const RasterLayerFragmentDoc = `
    fragment RasterLayer on RasterLayer {
  id
  name
  opacity
  origin
  pixel_ratio
  createdAt
  storage_url
  url
  project_id
}
    `;
export const CecInverterFragmentDoc = `
    fragment cecInverter on CecInverter {
  id
  manufacturer
  model
  output_ac_voltage
  self_consumption_power
  rated_output_ac_power
  reference_dc_power
  reference_dc_voltage
  sandia_model_c0
  sandia_model_c1
  sandia_model_c2
  sandia_model_c3
  night_tare_power
  maximum_dc_current
  minimum_dc_voltage
  maximum_dc_voltage
}
    `;
export const EnviroDatasetFragmentDoc = `
    fragment EnviroDataset on EnviroDataset {
  id
  created_at
  name
  local_time_zone
  type
  time_interval
  interval_alignment
  dst_shifts
  start_time
  end_time
  source
  latitude
  longitude
}
    `;
export const EnviroDataFragmentDoc = `
    fragment EnviroData on EnviroData {
  year
  month
  day
  hour
  minute
  temp_c
  rh
  ghi_wm2
  dni_wm2
  dhi_wm2
  albedo
  windspeed
  tracker_angle
}
    `;
export const SimulationPdfExportBlockDataFragmentDoc = `
    fragment SimulationPdfExportBlockData on SimulationPdfExportBlockData {
  block_id
  block_name
  nominal_dc_power
  single_panel_dc_power
  num_total_panels
  num_strings
  num_panels_per_string
  num_inverters
  inverter_ac_power
  inverter_night_tare_power
  inverter_maximum_voltage
  inverter_minimum_voltage
  inverter_manufacturer
  inverter_model
  monthly_soiling_pct_ghi_weighted
  global_array_resistance
  dc_wiring_loss_fraction
  collector_width
  stc_efficiency
}
    `;
export const PvPanelParametersFragmentDoc = `
    fragment PvPanelParameters on PvPanel {
  __typename
  default_state_fields
  panel_technology
  panel_type
  pan_file_import
  iam_profile
  cells
  cell_spacing_lr
  cell_spacing_tb
  half_cut_center_space
  panel_edge_b
  panel_edge_t
  panel_edge_lr
  frame
  frame_dimensions
  cell_length
  cell_width
  cell_type
  cell_shape
  corner_cut_off
  parallel_string_per_diode
  bypass_diodes
  bifaciality_current_ratio
  short_circuit_current
  open_circuit_voltage
  temperature_coefficient_isc
  temperature_coefficient_voc
  shunt_resistance
  series_resistance
  ideality_factor
  bypass_diode_max_neg_v
  nominal_operating_cell_temp
  irradiance_coefficients_temp
  first_year_degradation_rate
  remaining_years_degradation_rate
}
    `;
export const PvTableParametersFragmentDoc = `
    fragment PvTableParameters on PvTable {
  __typename
  default_state_fields
  azimuth
  column_gap
  ground_clearance
  num_cols
  num_post_cols
  num_post_tiers
  num_tiers
  orientation_str
  row_offset
  row_spacing
  table_gap
  tier_gap
  tilt
  backtracking_enabled
  stow_angle
  in_plane_racking_dimensions
  in_plane_racking_enabled
  in_plane_racking_shape
  rotation_radius
  torque_tube_enabled
  torque_tube_radius
  torque_tube_rect_dimensions
  torque_tube_shape
  track_angle_bounds
  tracking_type
  torque_tube_height
  vertical_post_shape
  vertical_post_enabled
  vertical_post_dimensions
  vertical_post_distance
  vertical_post_radius
}
    `;
export const PvInverterParametersFragmentDoc = `
    fragment PvInverterParameters on PvInverter {
  __typename
  default_state_fields
  ond_file_import
  inverter_data_source
  inverter_id
  output_ac_voltage
  rated_output_ac_power
  maximum_ac_power
  maximum_dc_power
  reference_dc_power
  reference_dc_voltage
  night_tare_power
  self_consumption_power
  maximum_dc_current
  minimum_dc_voltage
  maximum_dc_voltage
  minimum_operating_temperature
  maximum_operating_temperature
  cec_efficiency_curves
  temp_derate_curves
}
    `;
export const PvTransformerParametersFragmentDoc = `
    fragment PvTransformerParameters on PvTransformer {
  __typename
  default_state_fields
  type
  night_disconnect
  nominal_low_side_voltage
  nominal_high_side_voltage
  iron_power_loss_data_source
  iron_power_loss_percentage
  iron_power_loss
  copper_power_loss_data_source
  copper_power_loss_percentage
  low_voltage_winding_resistance
  high_voltage_winding_resistance
}
    `;
export const PvAcWireParametersFragmentDoc = `
    fragment PvAcWireParameters on PvAcWire {
  __typename
  default_state_fields
  ac_line_metal_type
  ac_line_cross_section
  ac_line_length
  ac_per_km_resistance
  total_ac_resistance_override
  ac_line_loss_percentage
  ac_line_calculation_method
}
    `;
export const PvDcWireParametersFragmentDoc = `
    fragment PvDcWireParameters on PvDcWire {
  __typename
  default_state_fields
  dc_line_metal_type
  dc_line_cross_section
  dc_line_length
  dc_per_km_resistance
  total_dc_resistance_override
  dc_line_loss_percentage
  dc_line_calculation_method
}
    `;
export const DuetSimulationBlockFragmentDoc = `
    fragment DuetSimulationBlock on DuetSimulationBlock {
  block_id
  duet_job_input_id
  name
  time_range {
    start {
      year
      month
      day
      hour
      minute
    }
    end {
      year
      month
      day
      hour
      minute
    }
  }
  num_inverters
  panel_parameters {
    ...PvPanelParameters
  }
  table_parameters {
    ...PvTableParameters
  }
  inverter_parameters {
    ...PvInverterParameters
  }
  transformer_parameters {
    ...PvTransformerParameters
  }
  ac_wire_parameters {
    ...PvAcWireParameters
  }
  dc_wire_parameters {
    ...PvDcWireParameters
  }
  terrain_type
  slope_azimuth
  slope_tilt
  slope_aware_tracking
  pv_soiling_algorithm
  soiling_rate
  soiling_rates_percentage
  num_total_tables
  pv_system_start_date
  cleaning_interval_days
  date_of_most_recent_cleaning
  power_factor
}
    ${PvPanelParametersFragmentDoc}
${PvTableParametersFragmentDoc}
${PvInverterParametersFragmentDoc}
${PvTransformerParametersFragmentDoc}
${PvAcWireParametersFragmentDoc}
${PvDcWireParametersFragmentDoc}`;
export const TimeRangeFragmentDoc = `
    fragment TimeRange on TimeRange {
  start {
    year
    month
    day
    hour
    minute
  }
  end {
    year
    month
    day
    hour
    minute
  }
}
    `;
export const BifacialEnergyMeasuresFragmentDoc = `
    fragment BifacialEnergyMeasures on SimulationAggregatedMeasures {
  sum__line_receiving_end_energy_wh_bi
  sum__inverter_output_energy_wh_bi
  sum__transmission_line_receiving_end_energy_wh_bi
  sum__hv_transformer_output_energy_wh_bi
  sum__hv_transmission_line_receiving_end_energy_wh_bi
  sum__grid_injection_energy_wh_bi
  avg__ave_bi_cell_temp_c
}
    `;
export const MonofacialEnergyMeasuresFragmentDoc = `
    fragment MonofacialEnergyMeasures on SimulationAggregatedMeasures {
  sum__line_receiving_end_energy_wh_mono
  sum__inverter_output_energy_wh_mono
  sum__transmission_line_receiving_end_energy_wh_mono
  sum__hv_transformer_output_energy_wh_mono
  sum__hv_transmission_line_receiving_end_energy_wh_mono
  sum__grid_injection_energy_wh_mono
  avg__ave_mono_cell_temp_c
}
    `;
export const MeteoMeasuresFragmentDoc = `
    fragment MeteoMeasures on SimulationTimeSeriesSummary {
  avg__ghi_wm2
  min__ghi_wm2
  p10__ghi_wm2
  p25__ghi_wm2
  p50__ghi_wm2
  p75__ghi_wm2
  p90__ghi_wm2
  max__ghi_wm2
  avg__dhi_wm2
  min__dhi_wm2
  p10__dhi_wm2
  p25__dhi_wm2
  p50__dhi_wm2
  p75__dhi_wm2
  p90__dhi_wm2
  max__dhi_wm2
  avg__dni_wm2
  min__dni_wm2
  p10__dni_wm2
  p25__dni_wm2
  p50__dni_wm2
  p75__dni_wm2
  p90__dni_wm2
  max__dni_wm2
  avg__temperature_c
  min__temperature_c
  p10__temperature_c
  p25__temperature_c
  p50__temperature_c
  p75__temperature_c
  p90__temperature_c
  max__temperature_c
}
    `;
export const MonofacialLossesFragmentDoc = `
    fragment MonofacialLosses on SimulationAggregatedMeasures {
  sum__array_cell_max_energy_t_stc_mono
  sum__array_cell_energy_mono
  sum__energy_mono
  sum__transformer_input_energy_wh_mono
  sum__transformer_output_energy_wh_mono
  sum__inverter_output_energy_wh_mono
  sum__pv_power_with_soiling_wh_mono
  sum__soiling_loss_wh_mono
  sum__pv_power_no_degradation_wh_mono
  sum__pv_power_with_degradation_wh_mono
  sum__total_degradation_loss_wh_mono
  sum__degradation_loss_first_year_wh_mono
  sum__degradation_loss_remaining_years_wh_mono
  sum__line_sending_end_energy_wh_mono
  sum__line_receiving_end_energy_wh_mono
  sum__line_energy_loss_wh_mono
  sum__transmission_line_sending_end_energy_wh_mono
  sum__transmission_line_receiving_end_energy_wh_mono
  sum__transmission_line_energy_loss_wh_mono
  sum__transformer_energy_loss_wh_mono
  sum__transformer_iron_core_loss_wh_mono
  sum__transformer_copper_loss_wh_mono
  sum__self_consumption_loss_wh_mono
  sum__ac_power_clipping_loss_wh_mono
  sum__inverter_night_tare_loss_wh_mono
  sum__inverter_dc_undervoltage_loss_wh_mono
  sum__inverter_dc_overvoltage_loss_wh_mono
  sum__inverter_dc_underpower_loss_wh_mono
  sum__inverter_dc_overpower_loss_wh_mono
  sum__inverter_dc_overcurrent_loss_wh_mono
  sum__power_factor_derate_loss_wh_mono
  sum__below_min_temperature_loss_wh_mono
  sum__above_max_temperature_loss_wh_mono
  sum__temperature_derating_loss_wh_mono
  sum__inverter_output_energy_wh_mono
  sum__total_inverter_loss_wh_mono
  sum__inverter_output_energy_stc_wh_mono
  sum__ghi_whm2
  sum__gti_f_pvsyst_no_loss_whm2
  sum__gti_f_pvsyst_with_far_shading_whm2
  sum__gti_f_pvsyst_with_near_shading_whm2
  sum__gti_f_pvsyst_with_iam_whm2
}
    `;
export const BifacialLossesFragmentDoc = `
    fragment BifacialLosses on SimulationAggregatedMeasures {
  sum__array_cell_max_energy_t_stc_bi
  sum__array_cell_energy_bi
  sum__energy_bi
  sum__transformer_input_energy_wh_bi
  sum__transformer_output_energy_wh_bi
  sum__inverter_output_energy_wh_bi
  sum__pv_power_with_soiling_wh_bi
  sum__soiling_loss_wh_bi
  sum__pv_power_no_degradation_wh_bi
  sum__pv_power_with_degradation_wh_bi
  sum__total_degradation_loss_wh_bi
  sum__degradation_loss_first_year_wh_bi
  sum__degradation_loss_remaining_years_wh_bi
  sum__line_sending_end_energy_wh_bi
  sum__line_receiving_end_energy_wh_bi
  sum__line_energy_loss_wh_bi
  sum__transmission_line_sending_end_energy_wh_bi
  sum__transmission_line_receiving_end_energy_wh_bi
  sum__transmission_line_energy_loss_wh_bi
  sum__transformer_energy_loss_wh_bi
  sum__transformer_iron_core_loss_wh_bi
  sum__transformer_copper_loss_wh_bi
  sum__self_consumption_loss_wh_bi
  sum__ac_power_clipping_loss_wh_bi
  sum__inverter_night_tare_loss_wh_bi
  sum__inverter_dc_undervoltage_loss_wh_bi
  sum__inverter_dc_overvoltage_loss_wh_bi
  sum__inverter_dc_underpower_loss_wh_bi
  sum__inverter_dc_overpower_loss_wh_bi
  sum__inverter_dc_overcurrent_loss_wh_bi
  sum__power_factor_derate_loss_wh_bi
  sum__below_min_temperature_loss_wh_bi
  sum__above_max_temperature_loss_wh_bi
  sum__temperature_derating_loss_wh_bi
  sum__inverter_output_energy_wh_bi
  sum__total_inverter_loss_wh_bi
  sum__inverter_output_energy_stc_wh_bi
  sum__ghi_ground_reflected_whm2
  sum__gti_r_pvsyst_ground_reflected_whm2
  sum__gti_r_pvsyst_with_diffuse_whm2
  sum__gti_r_pvsyst_with_direct_whm2
  sum__gti_r_pvsyst_with_structure_whm2
}
    `;
export const MonofacialHvStageLossesFragmentDoc = `
    fragment MonofacialHvStageLosses on SimulationAggregatedMeasures {
  sum__hv_transformer_input_energy_wh_mono
  sum__hv_transformer_iron_core_loss_wh_mono
  sum__hv_transformer_copper_loss_wh_mono
  sum__hv_transformer_energy_loss_wh_mono
  sum__hv_transmission_line_energy_loss_wh_mono
  sum__hv_transmission_line_receiving_end_energy_wh_mono
  sum__hv_transmission_line_sending_end_energy_wh_mono
  sum__grid_injection_energy_wh_mono
}
    `;
export const BifacialHvStageLossesFragmentDoc = `
    fragment BifacialHvStageLosses on SimulationAggregatedMeasures {
  sum__hv_transformer_input_energy_wh_bi
  sum__hv_transformer_iron_core_loss_wh_bi
  sum__hv_transformer_copper_loss_wh_bi
  sum__hv_transformer_energy_loss_wh_bi
  sum__hv_transmission_line_energy_loss_wh_bi
  sum__hv_transmission_line_receiving_end_energy_wh_bi
  sum__hv_transmission_line_sending_end_energy_wh_bi
  sum__grid_injection_energy_wh_bi
}
    `;
export const SimDuetJobFragmentDoc = `
    fragment SimDuetJob on DuetJob {
  id
  status
  stage
  total_tasks
  completed_tasks
  created_at
  submitted_at
  running_at
  completed_at
}
    `;
export const ProjectSimFragmentDoc = `
    fragment ProjectSim on DuetSimulation {
  id
  created_at
  name
  duet_job {
    ...SimDuetJob
  }
  user {
    id
    email
    first_name
    last_name
  }
  duet_simulation_blocks {
    duet_job_input_id
    name
  }
}
    ${SimDuetJobFragmentDoc}`;
export const SystemParametersFragmentDoc = `
    fragment SystemParameters on SystemParameters {
  project_id
  terrain_dem_enabled
  hv_stage_enabled
  grid_injection_limit_enabled
  grid_injection_limit
  pv_hv_transformer_id
  pv_hv_ac_wire_id
  cell_temperature_model
  sandia_panel_type
  sandia_a
  sandia_b
  sandia_delta_t
  sandia_e0
  faiman_u0
  faiman_u1
  pvsyst_mounting_type
  pvsyst_uc
  pvsyst_uv
  pvsyst_alpha
  voct_model
  desoto_panel_technology
  cell_material_bandgap
  bandgap_temperature_coefficient
}
    `;
export const ProjectUserFragmentDoc = `
    fragment projectUser on ProjectUser {
  user {
    id
    first_name
    last_name
    email
  }
  role_id
}
    `;
export const ProjectWithParametersFragmentDoc = `
    fragment ProjectWithParameters on Project {
  id
  created_at
  updated_at
  name
  organization_id
  org_general_access
  pvsyst_import_in_progress
  blocks_bounding_box
  system_parameters {
    ...SystemParameters
  }
  owner_id
  owner {
    id
    first_name
    last_name
    email
  }
  project_users {
    ...projectUser
  }
  duet_simulations {
    user {
      email
      first_name
      last_name
    }
    duet_job {
      status
      created_at
      submitted_at
      running_at
      completed_at
    }
  }
  sentinel_deployment {
    portfolio
  }
}
    ${SystemParametersFragmentDoc}
${ProjectUserFragmentDoc}`;
export const UserFragmentFragmentDoc = `
    fragment userFragment on User {
  id
  first_name
  last_name
  email
  created_at
  updated_at
  user_identity {
    id
    provider
    email_verified
    provider_payload
  }
  has_lead_intake_form
  user_organization {
    organization {
      id
      name
      slug
    }
  }
}
    `;
export const InviteUserDocument = `
    mutation InviteUser($email: String!) {
  inviteUser(email: $email) {
    id
    email
    created_at
    updated_at
    expires_at
  }
}
    `;
export const InviteOrganizationUserDocument = `
    mutation InviteOrganizationUser($email: String!, $organization_id: String!) {
  inviteOrganizationUser(email: $email, organization_id: $organization_id) {
    id
    email
    created_at
    updated_at
    expires_at
  }
}
    `;
export const ImpersonateUserDocument = `
    mutation ImpersonateUser($email: String!, $reason: String!, $remarks: String) {
  impersonateUser(email: $email, reason: $reason, remarks: $remarks) {
    token
  }
}
    `;
export const EndImpersonateUserDocument = `
    mutation EndImpersonateUser {
  endImpersonate
}
    `;
export const AdminUsersDocument = `
    query AdminUsers($skip: Int! = 0, $take: Int! = 500, $search: String, $organization_id: String) {
  users(
    skip: $skip
    take: $take
    search: $search
    organization_id: $organization_id
  ) {
    id
    created_at
    email
    first_name
    last_name
    user_organization {
      organization {
        id
        name
      }
    }
  }
  usersCount(search: $search, organization_id: $organization_id)
}
    `;
export const UserInvitesDocument = `
    query UserInvites($id: String, $accepted: Boolean = false, $organization_id: String, $skip: Int! = 0, $take: Int! = 500) {
  userInvites(
    accepted: $accepted
    skip: $skip
    take: $take
    id: $id
    organization_id: $organization_id
  ) {
    id
    email
    created_at
    expires_at
    updated_at
  }
}
    `;
export const AcceptUserInviteDocument = `
    mutation AcceptUserInvite($id: String!) {
  acceptUserInvite(id: $id) {
    id
    organization_slug
  }
}
    `;
export const DeleteUserInviteDocument = `
    mutation DeleteUserInvite($id: String!) {
  deleteUserInvite(id: $id) {
    id
  }
}
    `;
export const UploadInverterDatasetDocument = `
    mutation UploadInverterDataset($data: [CreateCecInverterInput!]!) {
  upsertCecInverters(data: $data)
}
    `;
export const AdminUserMeDocument = `
    query AdminUserMe {
  adminMe {
    ...userFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const AdminCopyProjectToSelfDocument = `
    mutation AdminCopyProjectToSelf($copyProjectName: String!, $sourceProjectId: String!) {
  adminCopyProjectToSelf(
    copyProjectName: $copyProjectName
    sourceProjectId: $sourceProjectId
  ) {
    id
  }
}
    `;
export const AdminFeatureFlagsDocument = `
    query AdminFeatureFlags {
  allFeatureFlags {
    id
    enabled
    constraints {
      key
      value
      enabled
    }
  }
}
    `;
export const AdminUpdateFeatureFlagDocument = `
    mutation AdminUpdateFeatureFlag($flag_input: AdminFeatureFlagInput!) {
  updateFeatureFlag(flag_input: $flag_input)
}
    `;
export const AdminProjectExportDocument = `
    query AdminProjectExport($projectId: String!) {
  adminProjectExport(projectId: $projectId)
}
    `;
export const PendingUserRequestsDocument = `
    query PendingUserRequests($organization_id: String!, $skip: Int! = 0, $take: Int! = 500) {
  userRequests(
    organization_id: $organization_id
    skip: $skip
    take: $take
    approved: false
    rejected: false
  ) {
    id
    created_at
    updated_at
    user {
      id
      email
      first_name
      last_name
    }
  }
}
    `;
export const ApproveUserRequestDocument = `
    mutation ApproveUserRequest($id: String!) {
  approveUserRequest(id: $id) {
    id
  }
}
    `;
export const RejectUserRequestDocument = `
    mutation RejectUserRequest($id: String!) {
  rejectUserRequest(id: $id) {
    id
  }
}
    `;
export const DeleteUserRequestDocument = `
    mutation DeleteUserRequest($id: String!) {
  deleteUserRequest(id: $id) {
    id
  }
}
    `;
export const CreateUserRequestDocument = `
    mutation CreateUserRequest($organization_id: String!) {
  createUserRequest(organization_id: $organization_id) {
    id
  }
}
    `;
export const AdminGetOrgIntegrationServersDocument = `
    query AdminGetOrgIntegrationServers($id: String, $organization_id: String) {
  adminOrganizationIntegrationServers(id: $id, organization_id: $organization_id) {
    id
    organization_id
    organization {
      slug
      name
    }
    url
    ping
    bearer_token
  }
}
    `;
export const AdminGetOrgIntegrationServerApiSpecDocument = `
    query AdminGetOrgIntegrationServerApiSpec($id: String) {
  adminOrganizationIntegrationServers(id: $id) {
    api_spec
  }
}
    `;
export const AdminUpsertOrgIntegrationServerDocument = `
    mutation AdminUpsertOrgIntegrationServer($orgIntegrationServerInput: OrganizationIntegrationServerInput!, $skipTokenGeneration: Boolean = false) {
  adminUpsertOrganizationIntegrationServer(
    organizationIntegrationServerInput: $orgIntegrationServerInput
    skipTokenGeneration: $skipTokenGeneration
  )
}
    `;
export const AdminAddOrgIntegrationTryFetchDocument = `
    query AdminAddOrgIntegrationTryFetch($url: String!, $bearer_token: String!) {
  adminUpsertOrganizationIntegrationServerTryFetch(
    url: $url
    bearer_token: $bearer_token
  )
}
    `;
export const AdminDeleteOrgIntegrationServerDocument = `
    mutation AdminDeleteOrgIntegrationServer($id: String!) {
  adminDeleteOrganizationIntegrationServer(id: $id)
}
    `;
export const AdminOrgIntegrationSchedulesDocument = `
    query AdminOrgIntegrationSchedules($id: String!) {
  adminOrganizationIntegrationServers(id: $id) {
    registered_schedulers
  }
  adminOrganizationIntegrationServerSchedules(integration_server_id: $id) {
    project_id
    project {
      name
    }
    schedule_id
    job_name
    job_type
    job_data
    crontab
    created_at
    updated_at
  }
}
    `;
export const AdminUpsertOrgIntegrationScheduleDocument = `
    mutation AdminUpsertOrgIntegrationSchedule($organizationIntegrationServerScheduleInput: OrganizationIntegrationServerScheduleInput!) {
  adminUpsertOrganizationIntegrationServerSchedule(
    organizationIntegrationServerScheduleInput: $organizationIntegrationServerScheduleInput
  ) {
    job_name
    job_type
    schedule_id
  }
}
    `;
export const AdminDeleteOrgIntegrationScheduleDocument = `
    mutation AdminDeleteOrgIntegrationSchedule($integration_server_id: String!, $schedule_id: String!) {
  adminDeleteOrganizationIntegrationServerSchedule(
    integration_server_id: $integration_server_id
    schedule_id: $schedule_id
  ) {
    schedule_id
  }
}
    `;
export const AdminMakeOrgIntegrationRequestDocument = `
    mutation AdminMakeOrgIntegrationRequest($id: String!, $endpoint: String!, $method: String!, $body: JSON) {
  adminMakeOrganizationIntegrationServerRequest(
    id: $id
    endpoint: $endpoint
    method: $method
    body: $body
  )
}
    `;
export const AdminGetOrgIntegrationServerJobEventsDocument = `
    query AdminGetOrgIntegrationServerJobEvents($integration_server_id: String, $skip: Int, $take: Int) {
  adminOrganizationIntegrationServerJobEvents(
    integration_server_id: $integration_server_id
    skip: $skip
    take: $take
  ) {
    integration_server {
      id
      organization {
        name
        slug
      }
    }
    id
    parent_job_id
    status
    job_name
    job_events {
      event_type
      event_data
      job_data
      created_at
      updated_at
    }
    created_at
    updated_at
  }
}
    `;
export const LocalLoginDocument = `
    mutation LocalLogin($username: String!, $password: String!) {
  localLogin(input: {username: $username, password: $password}) {
    ... on AuthError {
      __typename
      code
      message
    }
    ... on TokenPayload {
      __typename
      token
    }
  }
}
    `;
export const RefreshTokenDocument = `
    query RefreshToken {
  refreshToken {
    ... on AuthError {
      __typename
      code
      message
    }
    ... on TokenPayload {
      __typename
      token
    }
  }
}
    `;
export const InvitationTokenDocument = `
    query InvitationToken($token: String!) {
  invitation(token: $token) {
    id
    email
    user_registered
    organization_slug
  }
}
    `;
export const ChangePasswordDocument = `
    mutation ChangePassword($newPassword: String!, $oldPassword: String!) {
  changePassword(newPassword: $newPassword, oldPassword: $oldPassword) {
    ... on AuthError {
      __typename
      code
      message
    }
    ... on TokenPayload {
      __typename
      token
    }
  }
}
    `;
export const FirebaseAppLoginDocument = `
    mutation FirebaseAppLogin($token: String!, $credential: JSON!, $invite_id: String) {
  firebaseLogin(token: $token, credential: $credential, invite_id: $invite_id) {
    ... on AuthError {
      __typename
      code
      message
    }
    ... on TokenPayload {
      __typename
      token
    }
  }
}
    `;
export const FirebaseAppRegisterDocument = `
    mutation FirebaseAppRegister($token: String!, $credential: JSON!, $invite_id: String) {
  firebaseRegister(token: $token, credential: $credential, invite_id: $invite_id) {
    ... on AuthError {
      __typename
      code
      message
    }
    ... on TokenPayload {
      __typename
      token
    }
  }
}
    `;
export const FirebaseResendEmailVerificationDocument = `
    mutation FirebaseResendEmailVerification {
  firebaseSendEmailVerification {
    __typename
  }
}
    `;
export const FirebaseEmailVerificationSuccessDocument = `
    mutation FirebaseEmailVerificationSuccess($token: String!) {
  firebaseEmailVerificationSuccess(token: $token) {
    __typename
  }
}
    `;
export const FirebaseSyncUserIdentityDocument = `
    mutation firebaseSyncUserIdentity {
  firebaseSyncUserIdentity {
    __typename
  }
}
    `;
export const LocalEmailDocument = `
    query LocalEmail {
  localEmails {
    id
    to
    subject
    html
  }
}
    `;
export const FeatureFlagsDocument = `
    query FeatureFlags($project_id: String) {
  featureFlags(project_id: $project_id) {
    id
    constraint {
      key
      value
    }
  }
}
    `;
export const GetAvailableMeteoDatasetsDocument = `
    query GetAvailableMeteoDatasets($latitude: Float!, $longitude: Float!, $sources: [String!]!) {
  searchMeteoDatasets(
    latitude: $latitude
    longitude: $longitude
    sources: $sources
  ) {
    source
    dataset_name
    display_name
    available_intervals
    available_years
  }
}
    `;
export const AddAvailableMeteoDatasetDocument = `
    mutation AddAvailableMeteoDataset($project_id: String!, $display_name: String, $dataset_name: String!, $latitude: Float!, $longitude: Float!, $source: String!, $intervals: [Int!]!, $nsrdb_tmy_years: [String!], $years: [Int!]) {
  addMeteoDataset(
    project_id: $project_id
    display_name: $display_name
    dataset_name: $dataset_name
    latitude: $latitude
    longitude: $longitude
    source: $source
    years: $years
    intervals: $intervals
    nsrdb_tmy_years: $nsrdb_tmy_years
  )
}
    `;
export const LabelledEventsDocument = `
    query LabelledEvents($project_id: String!, $date_range: DateRangeArgs!, $interval: TimestampInterval!, $sentinel_tag: String = "default") {
  labelledEvents(
    project_id: $project_id
    date_range: $date_range
    interval: $interval
    sentinel_tag: $sentinel_tag
  ) {
    ts
    duet_block_id
    hierarchy_id
    component
    event_type
    sensor_value
    model_value
    measurable
    delta
  }
}
    `;
export const SensorDataModelledHierarchyDocument = `
    query SensorDataModelledHierarchy($project_id: String!, $hierarchy_id: String, $block_id: String, $component: SensorHierarchyComponent!, $component_measure: SensorHierarchyComponentMeasure!, $date_range: DateRangeArgs!, $interval: TimestampInterval!, $sentinel_tag: String = "default", $power_to_energy: Boolean = false) {
  sensorDataModelled(
    project_id: $project_id
    hierarchy_id: $hierarchy_id
    block_id: $block_id
    component: $component
    component_measure: $component_measure
    date_range: $date_range
    interval: $interval
    sentinel_tag: $sentinel_tag
    power_to_energy: $power_to_energy
  ) {
    ts
    duet_block_id
    hierarchy_id
    sensor_value
    model_value
    performance_index
  }
}
    `;
export const SensorDataModelledDocument = `
    query SensorDataModelled($project_id: String!, $hierarchy_id: String, $block_id: String, $component: SensorHierarchyComponent!, $component_measure: SensorHierarchyComponentMeasure!, $date_range: DateRangeArgs!, $interval: TimestampInterval!, $sentinel_tag: String = "default", $power_to_energy: Boolean = false) {
  sensorDataModelled(
    project_id: $project_id
    hierarchy_id: $hierarchy_id
    block_id: $block_id
    component: $component
    component_measure: $component_measure
    date_range: $date_range
    interval: $interval
    sentinel_tag: $sentinel_tag
    power_to_energy: $power_to_energy
  ) {
    ts
    duet_block_id
    sensor_value
    model_value
    performance_index
  }
}
    `;
export const SensorDataModelledSystemDocument = `
    query SensorDataModelledSystem($project_id: String!, $component: SensorHierarchyComponent!, $component_measure: SensorHierarchyComponentMeasure!, $date_range: DateRangeArgs!, $interval: TimestampInterval!, $sentinel_tag: String = "default", $power_to_energy: Boolean = false) {
  sensorDataModelledSystem(
    project_id: $project_id
    component: $component
    component_measure: $component_measure
    date_range: $date_range
    interval: $interval
    sentinel_tag: $sentinel_tag
    power_to_energy: $power_to_energy
  ) {
    ts
    duet_block_id
    sensor_value
    model_value
    performance_index
  }
}
    `;
export const SentinelDeploymentDocument = `
    query SentinelDeployment($project_id: String!) {
  blocks(project_id: $project_id) {
    id
    name
  }
  blockLayers(project_id: $project_id) {
    block_id
    type
    geojson
  }
  sentinelDeployment(project_id: $project_id) {
    id
    time_interval
  }
  sensorDataHierarchy(project_id: $project_id) {
    id
    parent_id
    name
    duet_block_id
    sensor_tag
    component
    component
    component_measure
    duet_measure
    inverter_dc_capacity
    sentinel_tag
    sensor_time_interval
  }
  modelledMonths: sentinelTimestamps(interval: OneMonth, project_id: $project_id) {
    timestamps
  }
  dailyTimestamps: sentinelTimestamps(interval: OneDay, project_id: $project_id) {
    timestamps
  }
}
    `;
export const SentinelPortfoliosDocument = `
    query SentinelPortfolios($organization_id: String!) {
  sentinelPortfolios(org_id: $organization_id)
}
    `;
export const SentinelIssueSummaryDocument = `
    query SentinelIssueSummary($project_id: String!, $date_range: DateRangeArgs!, $block_id: String, $interval: TimestampInterval, $hierarchy_component: SensorHierarchyComponent, $status: String) {
  sentinelIssueSummary(
    project_id: $project_id
    date_range: $date_range
    block_id: $block_id
    interval: $interval
    hierarchy_component: $hierarchy_component
    status: $status
  ) {
    duet_block_id
    hierarchy_ids
    hierarchy_component
    source
    type
    status
    dt_timestamp
    loss
    count
  }
}
    `;
export const SentinelMeteoSummaryDocument = `
    query SentinelMeteoSummary($project_id: String!, $date_range: DateRangeArgs!, $interval: DateBinInterval!) {
  dailyData: sentinelSimulationTimeSeriesSummary(
    project_id: $project_id
    date_args: {range: $date_range, interval: $interval}
  ) {
    dt_timestamp
    ...MeteoMeasures
  }
  hourlyData: sentinelSimulationTimeSeriesSummary(
    project_id: $project_id
    date_args: {interval: OneHour}
  ) {
    dt_timestamp
    avg__ghi_wm2
    avg__dhi_wm2
    avg__dni_wm2
    avg__temperature_c
  }
}
    ${MeteoMeasuresFragmentDoc}`;
export const SentinelSystemLossSummaryDocument = `
    query SentinelSystemLossSummary($project_id: String!, $date_range: DateRangeArgs!) {
  sentinelSimulationSummary(project_id: $project_id, date_range: $date_range) {
    ...MonofacialLosses
    ...MonofacialEnergyMeasures
    ...MonofacialHvStageLosses
    ...BifacialLosses
    ...BifacialEnergyMeasures
    ...BifacialHvStageLosses
  }
  blocks(project_id: $project_id) {
    ...Block
  }
  blockLayers(project_id: $project_id) {
    ...BlockLayer
  }
}
    ${MonofacialLossesFragmentDoc}
${MonofacialEnergyMeasuresFragmentDoc}
${MonofacialHvStageLossesFragmentDoc}
${BifacialLossesFragmentDoc}
${BifacialEnergyMeasuresFragmentDoc}
${BifacialHvStageLossesFragmentDoc}
${BlockFragmentDoc}
${BlockLayerFragmentDoc}`;
export const SentinelAvailableEnergySummaryDocument = `
    query SentinelAvailableEnergySummary($project_id: String!, $block_id: String, $date_range: DateRangeArgs!) {
  sentinelSimulationSummary(
    project_id: $project_id
    block_id: $block_id
    date_range: $date_range
  ) {
    sum__available_energy_wh_bi
  }
}
    `;
export const SentinelSimulationTimeseriesDocument = `
    query SentinelSimulationTimeseries($project_id: String!, $date_args: DateArgsInput!, $sentinel_tag: String = "default") {
  sentinelSimulationTimeSeriesSummary(
    project_id: $project_id
    date_args: $date_args
    sentinel_tag: $sentinel_tag
  ) {
    dt_timestamp
    avg__ghi_wm2
    avg__dhi_wm2
    avg__dni_wm2
    avg__temperature_c
  }
}
    `;
export const UserOnboardingIntakeDocument = `
    query UserOnboardingIntake {
  me {
    first_name
    last_name
    user_lead_intake_form {
      company_name
      company_type
      position
      use_cases
      features
      is_complete
    }
  }
}
    `;
export const UpdateUserOnboardingIntakeDocument = `
    mutation UpdateUserOnboardingIntake($input: UserLeadIntakeFormInput!) {
  updateUserIntakeForm(input: $input) {
    id
  }
}
    `;
export const GetOrganizationDocument = `
    query GetOrganization($id: String!) {
  organization(id: $id) {
    ...organizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export const GetOrganizationsDocument = `
    query GetOrganizations($skip: Int! = 0, $take: Int! = 500, $search: String) {
  organizations(skip: $skip, take: $take, search: $search) {
    ...organizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export const GetDomainMatchingOrganizationsDocument = `
    query GetDomainMatchingOrganizations($skip: Int! = 0, $take: Int! = 500) {
  domainMatchingOrganizations(skip: $skip, take: $take) {
    ...organizationFragment
    user_request {
      id
      user {
        id
      }
      approved_at
      rejected_at
    }
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export const CreateOrganizationDocument = `
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    ...organizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export const UpdateOrganizationDocument = `
    mutation UpdateOrganization($data: UpdateOrganizationInput!, $id: String!) {
  updateOrganization(data: $data, id: $id) {
    organization {
      ...organizationFragment
    }
    errors {
      message
      field
    }
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export const UpdateOrganizationUserRoleDocument = `
    mutation UpdateOrganizationUserRole($user_id: String!, $role_id: String!) {
  upsertOrganizationUser(user_id: $user_id, role_id: $role_id) {
    role_id
  }
}
    `;
export const DeleteOrganizationUserDocument = `
    mutation DeleteOrganizationUser($user_id: String!) {
  deleteOrganizationUser(user_id: $user_id)
}
    `;
export const OrganizationProjectsDocument = `
    query OrganizationProjects($organization_id: String!) {
  organizationProjects(organization_id: $organization_id) {
    id
    name
    org_general_access
    pvsyst_import_in_progress
    created_at
    last_activity_at
    organization_id
    project_users {
      id
      user {
        id
        email
        first_name
        last_name
      }
      role_id
    }
  }
}
    `;
export const PlantPlaybackIndexDocument = `
    query PlantPlaybackIndex($project_id: String!) {
  projectFileStorage(
    project_id: $project_id
    prefix: "/plant-playback"
    includes: "geojson.json"
  ) {
    is_dir
    path
    name
    url
  }
}
    `;
export const PlantPlaybackDocument = `
    query PlantPlayback($project_id: String!, $plant_playback_id: String!) {
  plantPlayback(project_id: $project_id, plant_playback_id: $plant_playback_id) {
    rows
    columns
  }
}
    `;
export const PlantPlaybackGeoJsonDocument = `
    query PlantPlaybackGeoJson($project_id: String!, $plant_playback_id: String!) {
  plantPlaybackGeoJson(
    project_id: $project_id
    plant_playback_id: $plant_playback_id
  )
}
    `;
export const AssignProjectRoleDocument = `
    mutation AssignProjectRole($project_id: String!, $role_id: String!, $user_id: String!) {
  assignProjectRole(project_id: $project_id, role_id: $role_id, user_id: $user_id) {
    id
  }
}
    `;
export const ListCompareDatasetsDocument = `
    query ListCompareDatasets($project_id: String!) {
  projectFileStorage(project_id: $project_id, prefix: "/custom-datasets") {
    path
    name
    size
    is_dir
    url
  }
  projectDuetSim(project_id: $project_id, status: ["completed"]) {
    id
    name
    duet_job_id
    created_at
  }
}
    `;
export const GetCompareWorkbooksDocument = `
    query GetCompareWorkbooks($id: String, $project_id: String!, $skip: Int = 0, $take: Int = 250) {
  compareWorkbooks(id: $id, project_id: $project_id, skip: $skip, take: $take) {
    id
    created_at
    updated_at
    name
    data
    dataset_a {
      id
      label
      source
    }
    dataset_b {
      id
      label
      source
    }
  }
}
    `;
export const CreateCompareWorkbookDocument = `
    mutation CreateCompareWorkbook($project_id: String!, $name: String!) {
  createCompareWorkbook(project_id: $project_id, name: $name) {
    id
  }
}
    `;
export const UpdateCompareWorkbookDocument = `
    mutation UpdateCompareWorkbook($id: String!, $project_id: String!, $data: UpdateCompareWorkbookInput!) {
  updateCompareWorkbook(id: $id, project_id: $project_id, data: $data) {
    id
  }
}
    `;
export const DeleteCompareWorkbookDocument = `
    mutation DeleteCompareWorkbook($id: String!, $project_id: String!) {
  deleteCompareWorkbook(id: $id, project_id: $project_id) {
    id
  }
}
    `;
export const GetProjectBlocksDocument = `
    query GetProjectBlocks($project_id: String!, $updated_after: DateTime) {
  blockIds: blocks(project_id: $project_id) {
    id
  }
  blocks(project_id: $project_id, updated_after: $updated_after) {
    ...Block
  }
  blockLayerIds: blockLayers(project_id: $project_id) {
    id
    block_id
  }
  blockLayers(project_id: $project_id, updated_after: $updated_after) {
    ...BlockLayer
  }
}
    ${BlockFragmentDoc}
${BlockLayerFragmentDoc}`;
export const UpsertBlocksDocument = `
    mutation UpsertBlocks($project_id: String!, $blocks: [BlockInput!]) {
  upsertBlocks(project_id: $project_id, blocks: $blocks) {
    ...Block
  }
}
    ${BlockFragmentDoc}`;
export const UpsertBlockLayersDocument = `
    mutation UpsertBlockLayers($project_id: String!, $block_layers: [BlockLayerInput!]) {
  upsertBlockLayers(project_id: $project_id, block_layers: $block_layers) {
    ...BlockLayer
  }
}
    ${BlockLayerFragmentDoc}`;
export const DeleteBlocksDocument = `
    mutation DeleteBlocks($project_id: String!, $block_ids: [String!]) {
  deleteBlocks(project_id: $project_id, block_ids: $block_ids)
}
    `;
export const DeleteBlockLayersDocument = `
    mutation DeleteBlockLayers($project_id: String!, $block_layer_ids: [String!]) {
  deleteBlockLayers(project_id: $project_id, block_layer_ids: $block_layer_ids)
}
    `;
export const CreateRasterLayerDocument = `
    mutation CreateRasterLayer($project_id: String!, $raster_layer: RasterLayerInput!) {
  createRasterLayer(project_id: $project_id, raster_layer: $raster_layer) {
    ...RasterLayer
  }
}
    ${RasterLayerFragmentDoc}`;
export const GetRasterLayersDocument = `
    query GetRasterLayers($project_id: String!) {
  rasterLayers(project_id: $project_id) {
    ...RasterLayer
  }
}
    ${RasterLayerFragmentDoc}`;
export const UpdateRasterLayerDocument = `
    mutation UpdateRasterLayer($project_id: String!, $raster_layer: UpdateRasterLayerInput!, $raster_layer_id: String!) {
  updateRasterLayer(
    project_id: $project_id
    raster_layer_id: $raster_layer_id
    raster_layer: $raster_layer
  ) {
    ...RasterLayer
  }
}
    ${RasterLayerFragmentDoc}`;
export const DeleteRasterLayerDocument = `
    mutation DeleteRasterLayer($project_id: String!, $raster_layer_id: String!) {
  deleteRasterLayer(project_id: $project_id, raster_layer_id: $raster_layer_id)
}
    `;
export const GetCecInverterDocument = `
    query GetCecInverter($id: String!) {
  cecInverter(id: $id) {
    ...cecInverter
  }
}
    ${CecInverterFragmentDoc}`;
export const CecInvertersSearchDocument = `
    query CecInvertersSearch($skip: Int = 0, $take: Int = 20, $filter: CecInverterFilter!, $sort: CecInverterSort, $withCount: Boolean = false) {
  cecInverters(take: $take, skip: $skip, filter: $filter, sort: $sort) {
    ...cecInverter
  }
  cecInvertersCount(filter: $filter) @include(if: $withCount)
}
    ${CecInverterFragmentDoc}`;
export const GetCecInverterFilterParamsDocument = `
    query GetCecInverterFilterParams {
  cecInverterFilterParams {
    manufacturers
    output_ac_voltage {
      min
      max
    }
    maximum_dc_voltage {
      min
      max
    }
    maximum_dc_current {
      min
      max
    }
  }
}
    `;
export const UpdateEnviroDatasetDocument = `
    mutation UpdateEnviroDataset($id: String!, $data: UpdateEnviroDatasetInput!) {
  updateProjectEnviroDataset(id: $id, data: $data) {
    id
    created_at
    project_id
    user {
      id
      first_name
      last_name
      email
    }
    enviro_dataset {
      ...EnviroDataset
    }
    __typename
  }
}
    ${EnviroDatasetFragmentDoc}`;
export const CreateProjectEnviroDatasetFromCsvFileDocument = `
    mutation CreateProjectEnviroDatasetFromCsvFile($project_id: String!, $enviro_dataset: CreateEnviroDatasetFromCsvFileInput!, $decomposition_parameters: DecompositionParametersInput) {
  createProjectEnviroDatasetFromCsvFile(
    project_id: $project_id
    enviro_dataset: $enviro_dataset
    decomposition_parameters: $decomposition_parameters
  ) {
    id
    created_at
    project_id
    user {
      id
      first_name
      last_name
      email
    }
    enviro_dataset {
      ...EnviroDataset
    }
    __typename
  }
}
    ${EnviroDatasetFragmentDoc}`;
export const CreateEnviroDatasetFromMetFileDocument = `
    mutation CreateEnviroDatasetFromMetFile($project_id: String!, $enviro_dataset: CreateEnviroDatasetFromMetFileInput!) {
  createProjectEnviroDatasetFromMetFile(
    project_id: $project_id
    enviro_dataset: $enviro_dataset
  ) {
    id
    created_at
    project_id
    user {
      id
      first_name
      last_name
      email
    }
    enviro_dataset {
      ...EnviroDataset
    }
    __typename
  }
}
    ${EnviroDatasetFragmentDoc}`;
export const GetProjectEnviroDatasetsDocument = `
    query GetProjectEnviroDatasets($project_id: String!, $id: String, $skip: Int = 0, $take: Int = 50, $not: [String!]) {
  projectEnviroDatasets(
    project_id: $project_id
    id: $id
    skip: $skip
    take: $take
    not: $not
  ) {
    id
    created_at
    project_id
    name
    user {
      id
      first_name
      last_name
      email
    }
    enviro_dataset {
      ...EnviroDataset
    }
    __typename
  }
}
    ${EnviroDatasetFragmentDoc}`;
export const GetEnviroDataDocument = `
    query GetEnviroData($enviro_dataset_owner_id: String!, $skip: Int, $take: Int, $time_range: TimeRangeInput, $withCount: Boolean = false, $restore_interval_alignment: Boolean = false, $restore_dst_shifts: Boolean = false) {
  enviroData(
    enviro_dataset_owner_id: $enviro_dataset_owner_id
    skip: $skip
    take: $take
    time_range: $time_range
    restore_interval_alignment: $restore_interval_alignment
    restore_dst_shifts: $restore_dst_shifts
  ) {
    ...EnviroData
  }
  enviroDataCount(
    enviro_dataset_owner_id: $enviro_dataset_owner_id
    time_range: $time_range
  ) @include(if: $withCount)
}
    ${EnviroDataFragmentDoc}`;
export const EnviroDataRollupDocument = `
    query EnviroDataRollup($enviro_dataset_owner_id: String!, $date_args: DateArgsInput!) {
  enviroDataRollup(
    enviro_dataset_owner_id: $enviro_dataset_owner_id
    date_args: $date_args
  ) {
    dt_timestamp
    avg__ghi_wm2
    min__ghi_wm2
    p10__ghi_wm2
    p25__ghi_wm2
    p50__ghi_wm2
    p75__ghi_wm2
    p90__ghi_wm2
    max__ghi_wm2
    avg__dhi_wm2
    min__dhi_wm2
    p10__dhi_wm2
    p25__dhi_wm2
    p50__dhi_wm2
    p75__dhi_wm2
    p90__dhi_wm2
    max__dhi_wm2
    avg__dni_wm2
    min__dni_wm2
    p10__dni_wm2
    p25__dni_wm2
    p50__dni_wm2
    p75__dni_wm2
    p90__dni_wm2
    max__dni_wm2
  }
}
    `;
export const DailySparkLineDocument = `
    query DailySparkLine($enviro_dataset_owner_id: String!) {
  enviroDataRollup(
    enviro_dataset_owner_id: $enviro_dataset_owner_id
    date_args: {interval: OneDay}
  ) {
    dt_timestamp
    avg__dni_wm2
  }
}
    `;
export const HourlyMeteoByMonthDocument = `
    query HourlyMeteoByMonth($enviro_dataset_owner_id: String!) {
  enviroDataRollup(
    enviro_dataset_owner_id: $enviro_dataset_owner_id
    date_args: {interval: OneHour, trunc: {part: month, withTime: true}}
  ) {
    dt_timestamp
    avg__ghi_wm2
    avg__dhi_wm2
    avg__dni_wm2
    avg__temp_c
  }
}
    `;
export const DailyAlbedoDocument = `
    query DailyAlbedo($enviro_dataset_owner_id: String!) {
  enviroDataRollup(
    enviro_dataset_owner_id: $enviro_dataset_owner_id
    date_args: {interval: OneDay}
  ) {
    dt_timestamp
    avg__albedo
  }
}
    `;
export const DeleteProjectEnviroDatasetDocument = `
    mutation DeleteProjectEnviroDataset($id: String!) {
  deleteProjectEnviroDataset(id: $id) {
    id
  }
}
    `;
export const GetNumDaylightTimestampsDocument = `
    query GetNumDaylightTimestamps($enviro_dataset_owner_id: String!, $selectedTimeRange: TimeRangeInput!) {
  numDaylightTimestamps(
    enviro_dataset_owner_id: $enviro_dataset_owner_id
    selectedTimeRange: $selectedTimeRange
  )
}
    `;
export const GetAcWireDocument = `
    query GetAcWire($id: String!) {
  acWire(id: $id) {
    id
    name
    created_at
    updated_at
    ...PvAcWireParameters
  }
}
    ${PvAcWireParametersFragmentDoc}`;
export const DeleteAcWireDocument = `
    mutation DeleteAcWire($id: String!) {
  deleteAcWire(id: $id) {
    id
  }
}
    `;
export const CreateAcWireDocument = `
    mutation CreateAcWire($project_id: String!, $name: String!, $data: PvAcWireUpdateInput) {
  createAcWire(project_id: $project_id, name: $name, data: $data) {
    id
    name
    updated_at
    created_at
    ...PvAcWireParameters
  }
}
    ${PvAcWireParametersFragmentDoc}`;
export const UpdateAcWireNameDocument = `
    mutation UpdateAcWireName($id: String!, $name: String!) {
  updateAcWireName(id: $id, name: $name) {
    id
    name
    ...PvAcWireParameters
  }
}
    ${PvAcWireParametersFragmentDoc}`;
export const UpdateAcWireDocument = `
    mutation UpdateAcWire($id: String!, $data: PvAcWireUpdateInput!) {
  updateAcWire(id: $id, data: $data) {
    id
    name
    ...PvAcWireParameters
  }
}
    ${PvAcWireParametersFragmentDoc}`;
export const GetComponentsDocument = `
    query GetComponents($project_id: String!) {
  panels(project_id: $project_id) {
    id
    created_at
    updated_at
    name
    ...PvPanelParameters
  }
  tables(project_id: $project_id) {
    id
    created_at
    updated_at
    name
    ...PvTableParameters
  }
  inverters(project_id: $project_id) {
    id
    created_at
    updated_at
    name
    ...PvInverterParameters
  }
  transformers(project_id: $project_id) {
    id
    created_at
    updated_at
    name
    ...PvTransformerParameters
  }
  dcWires(project_id: $project_id) {
    id
    created_at
    updated_at
    name
    ...PvDcWireParameters
  }
  acWires(project_id: $project_id) {
    id
    created_at
    updated_at
    name
    ...PvAcWireParameters
  }
}
    ${PvPanelParametersFragmentDoc}
${PvTableParametersFragmentDoc}
${PvInverterParametersFragmentDoc}
${PvTransformerParametersFragmentDoc}
${PvDcWireParametersFragmentDoc}
${PvAcWireParametersFragmentDoc}`;
export const GetDcWireDocument = `
    query GetDcWire($id: String!) {
  dcWire(id: $id) {
    id
    name
    created_at
    updated_at
    ...PvDcWireParameters
  }
}
    ${PvDcWireParametersFragmentDoc}`;
export const DeleteDcWireDocument = `
    mutation DeleteDcWire($id: String!) {
  deleteDcWire(id: $id) {
    id
  }
}
    `;
export const CreateDcWireDocument = `
    mutation CreateDcWire($project_id: String!, $name: String!, $data: PvDcWireUpdateInput) {
  createDcWire(project_id: $project_id, name: $name, data: $data) {
    id
    name
    updated_at
    created_at
    ...PvDcWireParameters
  }
}
    ${PvDcWireParametersFragmentDoc}`;
export const UpdateDcWireNameDocument = `
    mutation UpdateDcWireName($id: String!, $name: String!) {
  updateDcWireName(id: $id, name: $name) {
    id
    name
    ...PvDcWireParameters
  }
}
    ${PvDcWireParametersFragmentDoc}`;
export const UpdateDcWireDocument = `
    mutation UpdateDcWire($id: String!, $data: PvDcWireUpdateInput!) {
  updateDcWire(id: $id, data: $data) {
    id
    name
    ...PvDcWireParameters
  }
}
    ${PvDcWireParametersFragmentDoc}`;
export const GetInverterDocument = `
    query GetInverter($id: String!) {
  inverter(id: $id) {
    id
    name
    created_at
    updated_at
    ...PvInverterParameters
  }
}
    ${PvInverterParametersFragmentDoc}`;
export const DeleteInverterDocument = `
    mutation DeleteInverter($id: String!) {
  deleteInverter(id: $id) {
    id
  }
}
    `;
export const CreateInverterDocument = `
    mutation CreateInverter($project_id: String!, $name: String!, $data: PvInverterUpdateInput) {
  createInverter(project_id: $project_id, name: $name, data: $data) {
    id
    name
    updated_at
    created_at
    ...PvInverterParameters
  }
}
    ${PvInverterParametersFragmentDoc}`;
export const UpdateInverterNameDocument = `
    mutation UpdateInverterName($id: String!, $name: String!) {
  updateInverterName(id: $id, name: $name) {
    id
    name
    ...PvInverterParameters
  }
}
    ${PvInverterParametersFragmentDoc}`;
export const UpdateInverterDocument = `
    mutation UpdateInverter($id: String!, $data: PvInverterUpdateInput!) {
  updateInverter(id: $id, data: $data) {
    id
    name
    ...PvInverterParameters
  }
}
    ${PvInverterParametersFragmentDoc}`;
export const GetPanelDocument = `
    query GetPanel($id: String!) {
  panel(id: $id) {
    id
    name
    created_at
    updated_at
    ...PvPanelParameters
  }
}
    ${PvPanelParametersFragmentDoc}`;
export const DeletePanelDocument = `
    mutation DeletePanel($id: String!) {
  deletePanel(id: $id) {
    id
  }
}
    `;
export const CreatePanelDocument = `
    mutation CreatePanel($project_id: String!, $name: String!, $data: PvPanelUpdateInput) {
  createPanel(project_id: $project_id, name: $name, data: $data) {
    id
    name
    updated_at
    created_at
    ...PvPanelParameters
  }
}
    ${PvPanelParametersFragmentDoc}`;
export const UpdatePanelNameDocument = `
    mutation UpdatePanelName($id: String!, $name: String!) {
  updatePanelName(id: $id, name: $name) {
    id
    name
    ...PvPanelParameters
  }
}
    ${PvPanelParametersFragmentDoc}`;
export const UpdatePanelDocument = `
    mutation UpdatePanel($id: String!, $data: PvPanelUpdateInput!) {
  updatePanel(id: $id, data: $data) {
    id
    name
    ...PvPanelParameters
  }
}
    ${PvPanelParametersFragmentDoc}`;
export const GetTableDocument = `
    query GetTable($id: String!) {
  table(id: $id) {
    id
    name
    created_at
    updated_at
    ...PvTableParameters
  }
}
    ${PvTableParametersFragmentDoc}`;
export const DeleteTableDocument = `
    mutation DeleteTable($id: String!) {
  deleteTable(id: $id) {
    id
  }
}
    `;
export const CreateTableDocument = `
    mutation CreateTable($project_id: String!, $name: String!, $data: PvTableUpdateInput) {
  createTable(project_id: $project_id, name: $name, data: $data) {
    id
    name
    updated_at
    created_at
    ...PvTableParameters
  }
}
    ${PvTableParametersFragmentDoc}`;
export const UpdateTableDocument = `
    mutation UpdateTable($id: String!, $data: PvTableUpdateInput!) {
  updateTable(id: $id, data: $data) {
    id
    name
    ...PvTableParameters
  }
}
    ${PvTableParametersFragmentDoc}`;
export const UpdateTableNameDocument = `
    mutation UpdateTableName($id: String!, $name: String!) {
  updateTableName(id: $id, name: $name) {
    id
    name
    ...PvTableParameters
  }
}
    ${PvTableParametersFragmentDoc}`;
export const GetTransformerDocument = `
    query GetTransformer($id: String!) {
  transformer(id: $id) {
    id
    name
    created_at
    updated_at
    ...PvTransformerParameters
  }
}
    ${PvTransformerParametersFragmentDoc}`;
export const DeleteTransformerDocument = `
    mutation DeleteTransformer($id: String!) {
  deleteTransformer(id: $id) {
    id
  }
}
    `;
export const CreateMvTransformerDocument = `
    mutation CreateMvTransformer($project_id: String!, $name: String!, $data: PvTransformerUpdateInput) {
  createTransformer(project_id: $project_id, name: $name, data: $data, type: "MV") {
    id
    name
    updated_at
    created_at
    ...PvTransformerParameters
  }
}
    ${PvTransformerParametersFragmentDoc}`;
export const CreateHvTransformerDocument = `
    mutation CreateHvTransformer($project_id: String!, $name: String!, $data: PvTransformerUpdateInput) {
  createTransformer(project_id: $project_id, name: $name, data: $data, type: "HV") {
    id
    name
    updated_at
    created_at
    ...PvTransformerParameters
  }
}
    ${PvTransformerParametersFragmentDoc}`;
export const UpdateTransformerNameDocument = `
    mutation UpdateTransformerName($id: String!, $name: String!) {
  updateTransformerName(id: $id, name: $name) {
    id
    name
    ...PvTransformerParameters
  }
}
    ${PvTransformerParametersFragmentDoc}`;
export const UpdateTransformerDocument = `
    mutation UpdateTransformer($id: String!, $data: PvTransformerUpdateInput!) {
  updateTransformer(id: $id, data: $data) {
    id
    name
    ...PvTransformerParameters
  }
}
    ${PvTransformerParametersFragmentDoc}`;
export const GetPvSystImportFilesDocument = `
    query GetPvSystImportFiles($project_id: String!) {
  projectFileStorage(project_id: $project_id, prefix: "/pvsyst-import/") {
    path
    name
    size
    is_dir
    url
  }
}
    `;
export const GetPvSystImportDataDocument = `
    query GetPvSystImportData($project_id: String!, $files: [String!]!) {
  pvSystImportData(project_id: $project_id, files: $files) {
    name
    data
  }
}
    `;
export const PvSystImportPreviewDocument = `
    query PvSystImportPreview($project_id: String!, $variant_file_name: String!) {
  pvSystImportPreview(
    project_id: $project_id
    variant_file_name: $variant_file_name
  ) {
    panels {
      id
      name
    }
    tables {
      id
      name
    }
    inverters {
      id
      name
    }
    transformers {
      id
      name
    }
    dcWires {
      id
      name
    }
    acWires {
      id
      name
    }
    blocks {
      id
      name
      pv_panel_id
      pv_table_id
      pv_inverter_id
      pv_transformer_id
      pv_dc_wire_id
      pv_ac_wire_id
    }
    enviro_dataset {
      id
      name
      local_time_zone
      type
      time_interval
      time_range {
        start {
          year
          month
          day
          hour
          minute
        }
        end {
          year
          month
          day
          hour
          minute
        }
      }
    }
  }
}
    `;
export const ExecutePvSystImportDocument = `
    mutation ExecutePvSystImport($project_id: String!, $variant_file_name: String!, $apply_starter_defaults: Boolean = false) {
  executePvSystImport(
    project_id: $project_id
    variant_file_name: $variant_file_name
    apply_starter_defaults: $apply_starter_defaults
  ) {
    panels {
      id
      created_at
      updated_at
      name
      ...PvPanelParameters
    }
    tables {
      id
      created_at
      updated_at
      name
      ...PvTableParameters
    }
    inverters {
      id
      created_at
      updated_at
      name
      ...PvInverterParameters
    }
    transformers {
      id
      created_at
      updated_at
      name
      ...PvTransformerParameters
    }
    dcWires {
      id
      created_at
      updated_at
      name
      ...PvDcWireParameters
    }
    acWires {
      id
      created_at
      updated_at
      name
      ...PvAcWireParameters
    }
    blocks {
      ...Block
    }
    enviro_dataset {
      ...EnviroDataset
    }
  }
}
    ${PvPanelParametersFragmentDoc}
${PvTableParametersFragmentDoc}
${PvInverterParametersFragmentDoc}
${PvTransformerParametersFragmentDoc}
${PvDcWireParametersFragmentDoc}
${PvAcWireParametersFragmentDoc}
${BlockFragmentDoc}
${EnviroDatasetFragmentDoc}`;
export const GetCustomDatasetsDocument = `
    query GetCustomDatasets($project_id: String!) {
  projectFileStorage(project_id: $project_id, prefix: "/custom-datasets") {
    path
    name
    size
    is_dir
  }
}
    `;
export const DescribeAllCustomDatasetDocument = `
    query DescribeAllCustomDataset($project_id: String!) {
  customDatasetDescribe(
    project_id: $project_id
    path: "custom-datasets/*.parquet"
  ) {
    file_name
    name
    type
  }
}
    `;
export const DescribeCustomDatasetDocument = `
    query DescribeCustomDataset($project_id: String!, $path: String!) {
  customDatasetDescribe(project_id: $project_id, path: $path) {
    file_name
    name
    type
  }
}
    `;
export const GetCustomDatasetDataSeriesDocument = `
    query GetCustomDatasetDataSeries($project_id: String!, $path: String!, $date_args: DateArgsInput!, $measures: [String!]!) {
  customDatasetQuery(
    project_id: $project_id
    path: $path
    date_args: $date_args
    measures: $measures
  )
}
    `;
export const SimDataExportDocument = `
    mutation SimDataExport($simulation_id: String!, $scope: DataExportScope!, $format: DataExportFormat!) {
  simDataExport(simulation_id: $simulation_id, scope: $scope, format: $format)
}
    `;
export const DataExportsDocument = `
    query DataExports($simulation_id: String!, $scope: DataExportScope, $format: DataExportFormat) {
  dataExports(simulation_id: $simulation_id, scope: $scope, format: $format) {
    scope
    format
    createdOn
    inProgress
    urls {
      url
      filename
    }
  }
}
    `;
export const GetDataExportUrlsDocument = `
    query GetDataExportUrls($simulation_id: String!) {
  getDataExportUrls(simulation_id: $simulation_id) {
    full_sim_detail_url
    system_sim_detail_url
    expires_at
  }
}
    `;
export const GetSimPdfExportDataDocument = `
    query GetSimPdfExportData($project_id: String!, $simulation_id: String!) {
  simPdfExportData(simulation_id: $simulation_id) {
    monthly_albedo
    monthly_albedo_ghi_weighted
    albedo
    albedo_ghi_weighted
    windspeed_available
    has_hv_stage
    system_nominal_dc_power
    num_total_panels
    num_total_strings
    system_inverter_ac_power
    system_collector_width
    system_tracker_spacing
    system_stc_efficiency
    block_data {
      ...SimulationPdfExportBlockData
    }
    author {
      id
      email
      first_name
      last_name
    }
  }
  simulationDailySunRiseSet(
    simulation_id: $simulation_id
    project_id: $project_id
  ) {
    dt_timestamp
    sunrise
    sunset
  }
  minutelySimulationTimestamps: simulationTimestamps(
    simulation_id: $simulation_id
    project_id: $project_id
    interval: OneMinute
  ) {
    dt_timestamp
  }
  systemSimOutput: simulationSummary(
    simulation_id: $simulation_id
    project_id: $project_id
  ) {
    sum__performance_ratio_bi
    sum__performance_ratio_mono
    avg__hv_transformer_copper_loss_w_bi
    avg__hv_transformer_copper_loss_w_mono
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
    ...BifacialLosses
    ...MonofacialLosses
    ...MonofacialHvStageLosses
    ...BifacialHvStageLosses
  }
  blockSimOutput: simulationSummary(
    simulation_id: $simulation_id
    project_id: $project_id
  ) {
    duet_job_input_id
    avg__line_power_loss_w_bi
    avg__line_power_loss_w_mono
    avg__transformer_copper_loss_w_bi
    avg__transformer_copper_loss_w_mono
    ...BifacialLosses
    ...MonofacialLosses
  }
  simInput: duetSimulation(id: $simulation_id) {
    enviro_dataset_type
    created_at
    latitude
    longitude
    local_time_zone
    enviro_dataset_name
    hv_transformer_parameters {
      nominal_high_side_voltage
    }
    hv_ac_wire_parameters {
      ac_line_metal_type
      ac_line_cross_section
      ac_line_length
    }
    duet_simulation_blocks {
      ...DuetSimulationBlock
    }
  }
  systemSimOutputByYear: simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneYear, sort: {direction: asc}}
  ) {
    dt_timestamp
    sum__performance_ratio_bi
    sum__performance_ratio_mono
    sum__gti_f_pvsyst_no_loss_whm2
    sum__gti_f_pvsyst_with_iam_whm2
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
    sum__ghi_whm2
    sum__dhi_whm2
    avg__temperature_c
  }
  systemSimOutputByMonth: simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneMonth, sort: {direction: asc}}
  ) {
    dt_timestamp
    sum__performance_ratio_bi
    sum__performance_ratio_mono
    sum__gti_f_pvsyst_no_loss_whm2
    sum__gti_f_pvsyst_with_iam_whm2
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
    sum__pv_power_no_soiling_wh_bi
    sum__pv_power_no_soiling_wh_mono
    sum__line_receiving_end_energy_wh_bi
    sum__line_receiving_end_energy_wh_mono
    sum__ghi_whm2
    sum__dhi_whm2
    avg__temperature_c
  }
  systemSimOutputByDay: simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneDay, sort: {direction: asc}}
  ) {
    dt_timestamp
    sum__gti_f_pvsyst_no_loss_whm2
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
  }
  systemSimOutputByHour: simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneHour, sort: {direction: asc}}
  ) {
    dt_timestamp
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
  }
}
    ${SimulationPdfExportBlockDataFragmentDoc}
${BifacialEnergyMeasuresFragmentDoc}
${MonofacialEnergyMeasuresFragmentDoc}
${BifacialLossesFragmentDoc}
${MonofacialLossesFragmentDoc}
${MonofacialHvStageLossesFragmentDoc}
${BifacialHvStageLossesFragmentDoc}
${DuetSimulationBlockFragmentDoc}`;
export const GetPVsystExportDataDocument = `
    query GetPVsystExportData($simulation_id: String!, $project_id: String!) {
  simulationSummary(simulation_id: $simulation_id, project_id: $project_id) {
    sum__gti_r_pvsyst_with_direct_whm2
    sum__gti_r_pvsyst_with_structure_whm2
    sum__gti_f_pvsyst_with_iam_whm2
    sum__energy_bi
    sum__array_string_energy_bi
    sum__array_cell_energy_bi
    sum__array_center_panel_cell_energy_bi
    sum__energy_mono
    sum__array_string_energy_mono
    sum__array_cell_energy_mono
    sum__array_center_panel_cell_energy_mono
  }
  duetSimulation(id: $simulation_id) {
    duet_simulation_blocks {
      block_id
      panel_parameters {
        panel_type
        bifaciality_current_ratio
      }
    }
  }
  simPdfExportData(simulation_id: $simulation_id) {
    block_data {
      block_id
      nominal_dc_power
    }
  }
}
    `;
export const DuetSimMetaDocument = `
    query DuetSimMeta($simulation_id: String!, $project_id: String!) {
  duetSimulation(id: $simulation_id) {
    created_at
    name
    enviro_dataset_type
    enviro_dataset_name
    latitude
    longitude
    local_time_zone
    duet_job {
      time_interval
    }
    duet_simulation_blocks {
      duet_job_input_id
      name
      panel_parameters {
        panel_type
      }
    }
    project {
      id
      name
    }
    time_range {
      ...TimeRange
    }
  }
  simulationTimestamps(
    simulation_id: $simulation_id
    project_id: $project_id
    interval: OneDay
  ) {
    dt_timestamp
  }
  simulationExtendedSummary(
    simulation_id: $simulation_id
    project_id: $project_id
  ) {
    cellTemperatureSupported
  }
}
    ${TimeRangeFragmentDoc}`;
export const DailyYieldsDocument = `
    query DailyYields($simulation_id: String!, $project_id: String!) {
  simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneDay, sort: {direction: asc}}
  ) {
    dt_timestamp
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
  }
  simulationSummary(project_id: $project_id, simulation_id: $simulation_id) {
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
  }
}
    ${BifacialEnergyMeasuresFragmentDoc}
${MonofacialEnergyMeasuresFragmentDoc}`;
export const PerformanceRatioDocument = `
    query PerformanceRatio($simulation_id: String!, $project_id: String!) {
  simulationSummary(simulation_id: $simulation_id, project_id: $project_id) {
    sum__performance_ratio_bi
    sum__performance_ratio_mono
  }
  simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneMonth, sort: {direction: asc}}
  ) {
    dt_timestamp
    sum__performance_ratio_bi
    sum__performance_ratio_mono
  }
}
    `;
export const CapacityFactorDocument = `
    query CapacityFactor($simulation_id: String!, $project_id: String!) {
  simulationSummary(project_id: $project_id, simulation_id: $simulation_id) {
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
  }
  simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneMonth, sort: {direction: asc}}
  ) {
    dt_timestamp
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
  }
  simulationTimestamps(
    simulation_id: $simulation_id
    project_id: $project_id
    interval: OneMinute
  ) {
    dt_timestamp
  }
  simulationDailySunRiseSet(
    simulation_id: $simulation_id
    project_id: $project_id
  ) {
    dt_timestamp
    sunrise
    sunset
  }
  simulationExtendedSummary(
    simulation_id: $simulation_id
    project_id: $project_id
  ) {
    nominal_dc_power
    inverter_ac_power
  }
}
    ${BifacialEnergyMeasuresFragmentDoc}
${MonofacialEnergyMeasuresFragmentDoc}`;
export const ZoneYieldsDocument = `
    query ZoneYields($simulation_id: String!, $project_id: String!) {
  simulationSummary(simulation_id: $simulation_id, project_id: $project_id) {
    duet_job_input_id
    sum__transmission_line_receiving_end_energy_wh_mono
    sum__transmission_line_receiving_end_energy_wh_bi
  }
}
    `;
export const HourlyYieldsDocument = `
    query HourlyYields($simulation_id: String!, $project_id: String!) {
  simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneHour, sort: {direction: asc}}
  ) {
    dt_timestamp
    ...BifacialEnergyMeasures
    ...MonofacialEnergyMeasures
    avg__ghi_wm2
  }
}
    ${BifacialEnergyMeasuresFragmentDoc}
${MonofacialEnergyMeasuresFragmentDoc}`;
export const TimeSeriesSummaryDocument = `
    query TimeSeriesSummary($simulation_id: String!, $project_id: String!, $date_args: DateArgsInput!, $include_energy_bi: Boolean = false, $include_energy_mono: Boolean = false, $include_meteo: Boolean = false) {
  simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: $date_args
  ) {
    dt_timestamp
    ...BifacialEnergyMeasures @include(if: $include_energy_bi)
    ...MonofacialEnergyMeasures @include(if: $include_energy_mono)
    ...MeteoMeasures @include(if: $include_meteo)
  }
}
    ${BifacialEnergyMeasuresFragmentDoc}
${MonofacialEnergyMeasuresFragmentDoc}
${MeteoMeasuresFragmentDoc}`;
export const DrillDownDocument = `
    query DrillDown($simulation_id: String!, $project_id: String!, $date_args: DateArgsInput!, $duet_job_input_id: String, $measure: Measure!) {
  simulationTimeSeriesDrillDown(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: $date_args
    duet_job_input_id: $duet_job_input_id
    measure: $measure
  ) {
    dt_timestamp
    sum
    avg
    min
    max
    p10
    p25
    p50
    p75
    p90
  }
}
    `;
export const SystemLossesDocument = `
    query SystemLosses($simulation_id: String!, $project_id: String!, $is_bifacial: Boolean!) {
  simulationSummary(simulation_id: $simulation_id, project_id: $project_id) {
    ...MonofacialLosses
    ...MonofacialEnergyMeasures
    ...MonofacialHvStageLosses
    ...BifacialLosses @include(if: $is_bifacial)
    ...BifacialEnergyMeasures @include(if: $is_bifacial)
    ...BifacialHvStageLosses @include(if: $is_bifacial)
  }
  simulationTimeSeriesSummary(
    simulation_id: $simulation_id
    project_id: $project_id
    date_args: {interval: OneMonth}
  ) {
    dt_timestamp
    ...MonofacialLosses
    ...MonofacialEnergyMeasures
    ...MonofacialHvStageLosses
    ...BifacialLosses @include(if: $is_bifacial)
    ...BifacialEnergyMeasures @include(if: $is_bifacial)
    ...BifacialHvStageLosses @include(if: $is_bifacial)
  }
  simPdfExportData(simulation_id: $simulation_id) {
    system_stc_efficiency
    block_data {
      block_id
      stc_efficiency
      num_total_panels
      nominal_dc_power
    }
  }
  simulationExtendedSummary(
    simulation_id: $simulation_id
    project_id: $project_id
  ) {
    inverterNightTarePower
  }
  simulationTimestamps(
    simulation_id: $simulation_id
    project_id: $project_id
    interval: OneMinute
  ) {
    dt_timestamp
  }
  simulationDailySunRiseSet(
    simulation_id: $simulation_id
    project_id: $project_id
  ) {
    dt_timestamp
    sunrise
    sunset
  }
  duetSimulation(id: $simulation_id) {
    duet_simulation_blocks {
      block_id
      panel_parameters {
        ...PvPanelParameters
      }
      table_parameters {
        ...PvTableParameters
      }
    }
  }
}
    ${MonofacialLossesFragmentDoc}
${MonofacialEnergyMeasuresFragmentDoc}
${MonofacialHvStageLossesFragmentDoc}
${BifacialLossesFragmentDoc}
${BifacialEnergyMeasuresFragmentDoc}
${BifacialHvStageLossesFragmentDoc}
${PvPanelParametersFragmentDoc}
${PvTableParametersFragmentDoc}`;
export const TableModuleIrradianceProfilesDocument = `
    query TableModuleIrradianceProfiles($simulation_id: String!) {
  simulationModuleIrradianceProfileTablesMeta(simulation_id: $simulation_id) {
    dt_timestamp
    table_id
    duet_job_input_id
  }
}
    `;
export const TableModuleIrradianceProfilesDataDocument = `
    query TableModuleIrradianceProfilesData($project_id: String!, $simulation_id: String!, $duet_job_input_id: String!, $dt_timestamp: String!, $table_id: String!) {
  simulationModuleIrradianceProfileTableData(
    simulation_id: $simulation_id
    duet_job_input_id: $duet_job_input_id
    dt_timestamp: $dt_timestamp
    table_id: $table_id
  ) {
    dt_timestamp
    front_exterior
    rear_exterior
    pui_id
  }
  projectDuetSimBlock(
    duet_job_input_id: [$duet_job_input_id]
    project_id: $project_id
  ) {
    name
    panel_parameters {
      panel_type
    }
    table_parameters {
      azimuth
      orientation_str
    }
  }
}
    `;
export const EditDuetSimulationDocument = `
    mutation EditDuetSimulation($id: String!, $name: String!) {
  editDuetSimulation(id: $id, name: $name) {
    id
    created_at
    name
    duet_job_id
    duet_job {
      id
      created_at
      status
    }
    user_id
    user {
      first_name
      last_name
      email
    }
  }
}
    `;
export const RunProjectBlockSimulationDocument = `
    mutation RunProjectBlockSimulation($project_id: String!, $name: String!, $enviro_dataset_id: String!, $time_range: TimeSelectionRangeInput!, $blocks: [BlockSimulationInput!]!, $simulated_year_for_tmy: Int) {
  runProjectBlockSimulation(
    project_id: $project_id
    name: $name
    enviro_dataset_id: $enviro_dataset_id
    time_range: $time_range
    blocks: $blocks
    simulated_year_for_tmy: $simulated_year_for_tmy
  ) {
    success
    duetSimulation {
      ...ProjectSim
    }
    errors {
      block_id
      messages
    }
  }
}
    ${ProjectSimFragmentDoc}`;
export const ProjectDuetSimDocument = `
    query ProjectDuetSim($id: [String!], $project_id: String!, $status: [String!], $not_status: [String!], $skip: Int, $take: Int) {
  projectDuetSim(
    id: $id
    project_id: $project_id
    status: $status
    not_status: $not_status
    skip: $skip
    take: $take
  ) {
    ...ProjectSim
  }
}
    ${ProjectSimFragmentDoc}`;
export const RunningProjectSimDocument = `
    query RunningProjectSim($project_id: String!) {
  projectDuetSim(
    project_id: $project_id
    take: 1
    status: ["submitting", "running"]
  ) {
    id
    name
    duet_job {
      ...SimDuetJob
    }
  }
}
    ${SimDuetJobFragmentDoc}`;
export const StopRunningSimulationDocument = `
    mutation StopRunningSimulation($project_id: String!, $id: String!) {
  stopProjectSimulation(project_id: $project_id, id: $id) {
    id
    duet_job {
      status
    }
  }
}
    `;
export const EditDuetJobStatusDocument = `
    mutation EditDuetJobStatus($id: String!, $status: String!) {
  editDuetJobStatus(id: $id, status: $status) {
    id
    status
  }
}
    `;
export const DeleteDuetSimulationDocument = `
    mutation DeleteDuetSimulation($id: String!) {
  deleteDuetSimulation(id: $id) {
    id
  }
}
    `;
export const AddProjectUsersDocument = `
    mutation AddProjectUsers($project_id: String!, $user_ids: [String!]!, $role_id: String!) {
  addProjectUsers(project_id: $project_id, user_ids: $user_ids, role_id: $role_id) {
    ...projectUser
  }
}
    ${ProjectUserFragmentDoc}`;
export const DeleteProjectUserDocument = `
    mutation DeleteProjectUser($project_id: String!, $user_id: String!) {
  deleteProjectUser(project_id: $project_id, user_id: $user_id) {
    user_id
    role_id
  }
}
    `;
export const ProjectsSearchDocument = `
    query ProjectsSearch($skip: Int = 0, $take: Int = 50, $search: String, $org_id: String, $order_by: [String!], $collection: String!, $portfolio: String) {
  projects(
    take: $take
    skip: $skip
    search: $search
    org_id: $org_id
    collection: $collection
    order_by: $order_by
    portfolio: $portfolio
  ) {
    id
    created_at
    updated_at
    name
    pvsyst_import_in_progress
    org_general_access
    organization_id
    organization {
      slug
      name
    }
    owner_id
    owner {
      id
      first_name
      last_name
      email
    }
    blocks_bounding_box
    layers_mutated_at
    last_activity_at
    project_users {
      ...projectUser
    }
    recent_simulations {
      id
      name
      duet_job {
        ...SimDuetJob
      }
    }
    sentinel_deployment {
      portfolio
    }
  }
}
    ${ProjectUserFragmentDoc}
${SimDuetJobFragmentDoc}`;
export const DeleteProjectDocument = `
    mutation DeleteProject($id: String!) {
  deleteProject(id: $id) {
    id
  }
}
    `;
export const CreateProjectDocument = `
    mutation CreateProject($organization_id: String!, $name: String!, $blocks_bounding_box: [Float!], $pvsyst_import_in_progress: Boolean) {
  createProject(
    organization_id: $organization_id
    name: $name
    blocks_bounding_box: $blocks_bounding_box
    pvsyst_import_in_progress: $pvsyst_import_in_progress
  ) {
    id
    name
    organization_id
    updated_at
    created_at
    pvsyst_import_in_progress
    blocks_bounding_box
  }
}
    `;
export const CopyProjectDocument = `
    mutation CopyProject($sourceProjectId: String!, $copyProjectName: String!) {
  copyProject(
    sourceProjectId: $sourceProjectId
    copyProjectName: $copyProjectName
  ) {
    id
    name
    organization_id
    updated_at
    created_at
  }
}
    `;
export const GetProjectDocument = `
    query GetProject($id: String!) {
  project(id: $id) {
    ...ProjectWithParameters
  }
}
    ${ProjectWithParametersFragmentDoc}`;
export const UpdateProjectDocument = `
    mutation UpdateProject($id: String!, $data: ProjectUpdateData!) {
  updateProject(id: $id, data: $data) {
    id
    name
  }
}
    `;
export const GetProjectFileStorageSignedUrlDocument = `
    query GetProjectFileStorageSignedUrl($project_id: String!, $dir: String!, $filename: String!, $allowOverwrite: Boolean = false) {
  projectFileStorageSignedUrl(
    project_id: $project_id
    dir: $dir
    filename: $filename
    allowOverwrite: $allowOverwrite
  ) {
    url
    filename
  }
}
    `;
export const GetPanelIvDocument = `
    query GetPanelIv($panels: [GetPanelIvInput!]!) {
  getPanelIv(panels: $panels) {
    panel_id
    iv_params_invalid
    cell_iv_curve {
      current
      voltage
    }
    module_iv_curve {
      current
      voltage
    }
    ideality_factor
    short_circuit_current
    open_circuit_voltage
    series_resistance
    shunt_resistance
    saturation_current
    maximum_dc_power
    maximum_power_voltage
    maximum_power_current
  }
}
    `;
export const GetSystemParametersDocument = `
    query GetSystemParameters($project_id: String!) {
  systemParameters(project_id: $project_id) {
    ...SystemParameters
  }
}
    ${SystemParametersFragmentDoc}`;
export const UpdateSystemParametersDocument = `
    mutation UpdateSystemParameters($system_parameters: SystemParametersInput!) {
  updateSystemParameters(system_parameters: $system_parameters) {
    ...SystemParameters
  }
}
    ${SystemParametersFragmentDoc}`;
export const UserMeDocument = `
    query UserMe {
  me {
    ...userFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const UserSearchDocument = `
    query UserSearch($search: String!, $organization_id: String) {
  users(search: $search, organization_id: $organization_id) {
    ...userFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const UpdateUserDocument = `
    mutation UpdateUser($first_name: String, $last_name: String) {
  updateUser(first_name: $first_name, last_name: $last_name) {
    ...userFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export const UserDataPrivacyRequestDocument = `
    mutation UserDataPrivacyRequest($request_type: String!) {
  userDataPrivacyRequest(request_type: $request_type)
}
    `;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: Boolean(import.meta.hot),
  endpoints: (build) => ({
    InviteUser: build.mutation<InviteUserMutation, InviteUserMutationVariables>({
      query: (variables) => ({ document: InviteUserDocument, variables })
    }),
    InviteOrganizationUser: build.mutation<InviteOrganizationUserMutation, InviteOrganizationUserMutationVariables>({
      query: (variables) => ({ document: InviteOrganizationUserDocument, variables })
    }),
    ImpersonateUser: build.mutation<ImpersonateUserMutation, ImpersonateUserMutationVariables>({
      query: (variables) => ({ document: ImpersonateUserDocument, variables })
    }),
    EndImpersonateUser: build.mutation<EndImpersonateUserMutation, EndImpersonateUserMutationVariables | void>({
      query: (variables) => ({ document: EndImpersonateUserDocument, variables })
    }),
    AdminUsers: build.query<AdminUsersQuery, AdminUsersQueryVariables | void>({
      query: (variables) => ({ document: AdminUsersDocument, variables })
    }),
    UserInvites: build.query<UserInvitesQuery, UserInvitesQueryVariables | void>({
      query: (variables) => ({ document: UserInvitesDocument, variables })
    }),
    AcceptUserInvite: build.mutation<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>({
      query: (variables) => ({ document: AcceptUserInviteDocument, variables })
    }),
    DeleteUserInvite: build.mutation<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>({
      query: (variables) => ({ document: DeleteUserInviteDocument, variables })
    }),
    UploadInverterDataset: build.mutation<UploadInverterDatasetMutation, UploadInverterDatasetMutationVariables>({
      query: (variables) => ({ document: UploadInverterDatasetDocument, variables })
    }),
    AdminUserMe: build.query<AdminUserMeQuery, AdminUserMeQueryVariables | void>({
      query: (variables) => ({ document: AdminUserMeDocument, variables })
    }),
    AdminCopyProjectToSelf: build.mutation<AdminCopyProjectToSelfMutation, AdminCopyProjectToSelfMutationVariables>({
      query: (variables) => ({ document: AdminCopyProjectToSelfDocument, variables })
    }),
    AdminFeatureFlags: build.query<AdminFeatureFlagsQuery, AdminFeatureFlagsQueryVariables | void>({
      query: (variables) => ({ document: AdminFeatureFlagsDocument, variables })
    }),
    AdminUpdateFeatureFlag: build.mutation<AdminUpdateFeatureFlagMutation, AdminUpdateFeatureFlagMutationVariables>({
      query: (variables) => ({ document: AdminUpdateFeatureFlagDocument, variables })
    }),
    AdminProjectExport: build.query<AdminProjectExportQuery, AdminProjectExportQueryVariables>({
      query: (variables) => ({ document: AdminProjectExportDocument, variables })
    }),
    PendingUserRequests: build.query<PendingUserRequestsQuery, PendingUserRequestsQueryVariables>({
      query: (variables) => ({ document: PendingUserRequestsDocument, variables })
    }),
    ApproveUserRequest: build.mutation<ApproveUserRequestMutation, ApproveUserRequestMutationVariables>({
      query: (variables) => ({ document: ApproveUserRequestDocument, variables })
    }),
    RejectUserRequest: build.mutation<RejectUserRequestMutation, RejectUserRequestMutationVariables>({
      query: (variables) => ({ document: RejectUserRequestDocument, variables })
    }),
    DeleteUserRequest: build.mutation<DeleteUserRequestMutation, DeleteUserRequestMutationVariables>({
      query: (variables) => ({ document: DeleteUserRequestDocument, variables })
    }),
    CreateUserRequest: build.mutation<CreateUserRequestMutation, CreateUserRequestMutationVariables>({
      query: (variables) => ({ document: CreateUserRequestDocument, variables })
    }),
    AdminGetOrgIntegrationServers: build.query<AdminGetOrgIntegrationServersQuery, AdminGetOrgIntegrationServersQueryVariables | void>({
      query: (variables) => ({ document: AdminGetOrgIntegrationServersDocument, variables })
    }),
    AdminGetOrgIntegrationServerApiSpec: build.query<AdminGetOrgIntegrationServerApiSpecQuery, AdminGetOrgIntegrationServerApiSpecQueryVariables | void>({
      query: (variables) => ({ document: AdminGetOrgIntegrationServerApiSpecDocument, variables })
    }),
    AdminUpsertOrgIntegrationServer: build.mutation<AdminUpsertOrgIntegrationServerMutation, AdminUpsertOrgIntegrationServerMutationVariables>({
      query: (variables) => ({ document: AdminUpsertOrgIntegrationServerDocument, variables })
    }),
    AdminAddOrgIntegrationTryFetch: build.query<AdminAddOrgIntegrationTryFetchQuery, AdminAddOrgIntegrationTryFetchQueryVariables>({
      query: (variables) => ({ document: AdminAddOrgIntegrationTryFetchDocument, variables })
    }),
    AdminDeleteOrgIntegrationServer: build.mutation<AdminDeleteOrgIntegrationServerMutation, AdminDeleteOrgIntegrationServerMutationVariables>({
      query: (variables) => ({ document: AdminDeleteOrgIntegrationServerDocument, variables })
    }),
    AdminOrgIntegrationSchedules: build.query<AdminOrgIntegrationSchedulesQuery, AdminOrgIntegrationSchedulesQueryVariables>({
      query: (variables) => ({ document: AdminOrgIntegrationSchedulesDocument, variables })
    }),
    AdminUpsertOrgIntegrationSchedule: build.mutation<AdminUpsertOrgIntegrationScheduleMutation, AdminUpsertOrgIntegrationScheduleMutationVariables>({
      query: (variables) => ({ document: AdminUpsertOrgIntegrationScheduleDocument, variables })
    }),
    AdminDeleteOrgIntegrationSchedule: build.mutation<AdminDeleteOrgIntegrationScheduleMutation, AdminDeleteOrgIntegrationScheduleMutationVariables>({
      query: (variables) => ({ document: AdminDeleteOrgIntegrationScheduleDocument, variables })
    }),
    AdminMakeOrgIntegrationRequest: build.mutation<AdminMakeOrgIntegrationRequestMutation, AdminMakeOrgIntegrationRequestMutationVariables>({
      query: (variables) => ({ document: AdminMakeOrgIntegrationRequestDocument, variables })
    }),
    AdminGetOrgIntegrationServerJobEvents: build.query<AdminGetOrgIntegrationServerJobEventsQuery, AdminGetOrgIntegrationServerJobEventsQueryVariables | void>({
      query: (variables) => ({ document: AdminGetOrgIntegrationServerJobEventsDocument, variables })
    }),
    LocalLogin: build.mutation<LocalLoginMutation, LocalLoginMutationVariables>({
      query: (variables) => ({ document: LocalLoginDocument, variables })
    }),
    RefreshToken: build.query<RefreshTokenQuery, RefreshTokenQueryVariables | void>({
      query: (variables) => ({ document: RefreshTokenDocument, variables })
    }),
    InvitationToken: build.query<InvitationTokenQuery, InvitationTokenQueryVariables>({
      query: (variables) => ({ document: InvitationTokenDocument, variables })
    }),
    ChangePassword: build.mutation<ChangePasswordMutation, ChangePasswordMutationVariables>({
      query: (variables) => ({ document: ChangePasswordDocument, variables })
    }),
    FirebaseAppLogin: build.mutation<FirebaseAppLoginMutation, FirebaseAppLoginMutationVariables>({
      query: (variables) => ({ document: FirebaseAppLoginDocument, variables })
    }),
    FirebaseAppRegister: build.mutation<FirebaseAppRegisterMutation, FirebaseAppRegisterMutationVariables>({
      query: (variables) => ({ document: FirebaseAppRegisterDocument, variables })
    }),
    FirebaseResendEmailVerification: build.mutation<FirebaseResendEmailVerificationMutation, FirebaseResendEmailVerificationMutationVariables | void>({
      query: (variables) => ({ document: FirebaseResendEmailVerificationDocument, variables })
    }),
    FirebaseEmailVerificationSuccess: build.mutation<FirebaseEmailVerificationSuccessMutation, FirebaseEmailVerificationSuccessMutationVariables>({
      query: (variables) => ({ document: FirebaseEmailVerificationSuccessDocument, variables })
    }),
    firebaseSyncUserIdentity: build.mutation<FirebaseSyncUserIdentityMutation, FirebaseSyncUserIdentityMutationVariables | void>({
      query: (variables) => ({ document: FirebaseSyncUserIdentityDocument, variables })
    }),
    LocalEmail: build.query<LocalEmailQuery, LocalEmailQueryVariables | void>({
      query: (variables) => ({ document: LocalEmailDocument, variables })
    }),
    FeatureFlags: build.query<FeatureFlagsQuery, FeatureFlagsQueryVariables | void>({
      query: (variables) => ({ document: FeatureFlagsDocument, variables })
    }),
    GetAvailableMeteoDatasets: build.query<GetAvailableMeteoDatasetsQuery, GetAvailableMeteoDatasetsQueryVariables>({
      query: (variables) => ({ document: GetAvailableMeteoDatasetsDocument, variables })
    }),
    AddAvailableMeteoDataset: build.mutation<AddAvailableMeteoDatasetMutation, AddAvailableMeteoDatasetMutationVariables>({
      query: (variables) => ({ document: AddAvailableMeteoDatasetDocument, variables })
    }),
    LabelledEvents: build.query<LabelledEventsQuery, LabelledEventsQueryVariables>({
      query: (variables) => ({ document: LabelledEventsDocument, variables })
    }),
    SensorDataModelledHierarchy: build.query<SensorDataModelledHierarchyQuery, SensorDataModelledHierarchyQueryVariables>({
      query: (variables) => ({ document: SensorDataModelledHierarchyDocument, variables })
    }),
    SensorDataModelled: build.query<SensorDataModelledQuery, SensorDataModelledQueryVariables>({
      query: (variables) => ({ document: SensorDataModelledDocument, variables })
    }),
    SensorDataModelledSystem: build.query<SensorDataModelledSystemQuery, SensorDataModelledSystemQueryVariables>({
      query: (variables) => ({ document: SensorDataModelledSystemDocument, variables })
    }),
    SentinelDeployment: build.query<SentinelDeploymentQuery, SentinelDeploymentQueryVariables>({
      query: (variables) => ({ document: SentinelDeploymentDocument, variables })
    }),
    SentinelPortfolios: build.query<SentinelPortfoliosQuery, SentinelPortfoliosQueryVariables>({
      query: (variables) => ({ document: SentinelPortfoliosDocument, variables })
    }),
    SentinelIssueSummary: build.query<SentinelIssueSummaryQuery, SentinelIssueSummaryQueryVariables>({
      query: (variables) => ({ document: SentinelIssueSummaryDocument, variables })
    }),
    SentinelMeteoSummary: build.query<SentinelMeteoSummaryQuery, SentinelMeteoSummaryQueryVariables>({
      query: (variables) => ({ document: SentinelMeteoSummaryDocument, variables })
    }),
    SentinelSystemLossSummary: build.query<SentinelSystemLossSummaryQuery, SentinelSystemLossSummaryQueryVariables>({
      query: (variables) => ({ document: SentinelSystemLossSummaryDocument, variables })
    }),
    SentinelAvailableEnergySummary: build.query<SentinelAvailableEnergySummaryQuery, SentinelAvailableEnergySummaryQueryVariables>({
      query: (variables) => ({ document: SentinelAvailableEnergySummaryDocument, variables })
    }),
    SentinelSimulationTimeseries: build.query<SentinelSimulationTimeseriesQuery, SentinelSimulationTimeseriesQueryVariables>({
      query: (variables) => ({ document: SentinelSimulationTimeseriesDocument, variables })
    }),
    UserOnboardingIntake: build.query<UserOnboardingIntakeQuery, UserOnboardingIntakeQueryVariables | void>({
      query: (variables) => ({ document: UserOnboardingIntakeDocument, variables })
    }),
    UpdateUserOnboardingIntake: build.mutation<UpdateUserOnboardingIntakeMutation, UpdateUserOnboardingIntakeMutationVariables>({
      query: (variables) => ({ document: UpdateUserOnboardingIntakeDocument, variables })
    }),
    GetOrganization: build.query<GetOrganizationQuery, GetOrganizationQueryVariables>({
      query: (variables) => ({ document: GetOrganizationDocument, variables })
    }),
    GetOrganizations: build.query<GetOrganizationsQuery, GetOrganizationsQueryVariables | void>({
      query: (variables) => ({ document: GetOrganizationsDocument, variables })
    }),
    GetDomainMatchingOrganizations: build.query<GetDomainMatchingOrganizationsQuery, GetDomainMatchingOrganizationsQueryVariables | void>({
      query: (variables) => ({ document: GetDomainMatchingOrganizationsDocument, variables })
    }),
    CreateOrganization: build.mutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>({
      query: (variables) => ({ document: CreateOrganizationDocument, variables })
    }),
    UpdateOrganization: build.mutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>({
      query: (variables) => ({ document: UpdateOrganizationDocument, variables })
    }),
    UpdateOrganizationUserRole: build.mutation<UpdateOrganizationUserRoleMutation, UpdateOrganizationUserRoleMutationVariables>({
      query: (variables) => ({ document: UpdateOrganizationUserRoleDocument, variables })
    }),
    DeleteOrganizationUser: build.mutation<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>({
      query: (variables) => ({ document: DeleteOrganizationUserDocument, variables })
    }),
    OrganizationProjects: build.query<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>({
      query: (variables) => ({ document: OrganizationProjectsDocument, variables })
    }),
    PlantPlaybackIndex: build.query<PlantPlaybackIndexQuery, PlantPlaybackIndexQueryVariables>({
      query: (variables) => ({ document: PlantPlaybackIndexDocument, variables })
    }),
    PlantPlayback: build.query<PlantPlaybackQuery, PlantPlaybackQueryVariables>({
      query: (variables) => ({ document: PlantPlaybackDocument, variables })
    }),
    PlantPlaybackGeoJson: build.query<PlantPlaybackGeoJsonQuery, PlantPlaybackGeoJsonQueryVariables>({
      query: (variables) => ({ document: PlantPlaybackGeoJsonDocument, variables })
    }),
    AssignProjectRole: build.mutation<AssignProjectRoleMutation, AssignProjectRoleMutationVariables>({
      query: (variables) => ({ document: AssignProjectRoleDocument, variables })
    }),
    ListCompareDatasets: build.query<ListCompareDatasetsQuery, ListCompareDatasetsQueryVariables>({
      query: (variables) => ({ document: ListCompareDatasetsDocument, variables })
    }),
    GetCompareWorkbooks: build.query<GetCompareWorkbooksQuery, GetCompareWorkbooksQueryVariables>({
      query: (variables) => ({ document: GetCompareWorkbooksDocument, variables })
    }),
    CreateCompareWorkbook: build.mutation<CreateCompareWorkbookMutation, CreateCompareWorkbookMutationVariables>({
      query: (variables) => ({ document: CreateCompareWorkbookDocument, variables })
    }),
    UpdateCompareWorkbook: build.mutation<UpdateCompareWorkbookMutation, UpdateCompareWorkbookMutationVariables>({
      query: (variables) => ({ document: UpdateCompareWorkbookDocument, variables })
    }),
    DeleteCompareWorkbook: build.mutation<DeleteCompareWorkbookMutation, DeleteCompareWorkbookMutationVariables>({
      query: (variables) => ({ document: DeleteCompareWorkbookDocument, variables })
    }),
    GetProjectBlocks: build.query<GetProjectBlocksQuery, GetProjectBlocksQueryVariables>({
      query: (variables) => ({ document: GetProjectBlocksDocument, variables })
    }),
    UpsertBlocks: build.mutation<UpsertBlocksMutation, UpsertBlocksMutationVariables>({
      query: (variables) => ({ document: UpsertBlocksDocument, variables })
    }),
    UpsertBlockLayers: build.mutation<UpsertBlockLayersMutation, UpsertBlockLayersMutationVariables>({
      query: (variables) => ({ document: UpsertBlockLayersDocument, variables })
    }),
    DeleteBlocks: build.mutation<DeleteBlocksMutation, DeleteBlocksMutationVariables>({
      query: (variables) => ({ document: DeleteBlocksDocument, variables })
    }),
    DeleteBlockLayers: build.mutation<DeleteBlockLayersMutation, DeleteBlockLayersMutationVariables>({
      query: (variables) => ({ document: DeleteBlockLayersDocument, variables })
    }),
    CreateRasterLayer: build.mutation<CreateRasterLayerMutation, CreateRasterLayerMutationVariables>({
      query: (variables) => ({ document: CreateRasterLayerDocument, variables })
    }),
    GetRasterLayers: build.query<GetRasterLayersQuery, GetRasterLayersQueryVariables>({
      query: (variables) => ({ document: GetRasterLayersDocument, variables })
    }),
    UpdateRasterLayer: build.mutation<UpdateRasterLayerMutation, UpdateRasterLayerMutationVariables>({
      query: (variables) => ({ document: UpdateRasterLayerDocument, variables })
    }),
    DeleteRasterLayer: build.mutation<DeleteRasterLayerMutation, DeleteRasterLayerMutationVariables>({
      query: (variables) => ({ document: DeleteRasterLayerDocument, variables })
    }),
    GetCecInverter: build.query<GetCecInverterQuery, GetCecInverterQueryVariables>({
      query: (variables) => ({ document: GetCecInverterDocument, variables })
    }),
    CecInvertersSearch: build.query<CecInvertersSearchQuery, CecInvertersSearchQueryVariables>({
      query: (variables) => ({ document: CecInvertersSearchDocument, variables })
    }),
    GetCecInverterFilterParams: build.query<GetCecInverterFilterParamsQuery, GetCecInverterFilterParamsQueryVariables | void>({
      query: (variables) => ({ document: GetCecInverterFilterParamsDocument, variables })
    }),
    UpdateEnviroDataset: build.mutation<UpdateEnviroDatasetMutation, UpdateEnviroDatasetMutationVariables>({
      query: (variables) => ({ document: UpdateEnviroDatasetDocument, variables })
    }),
    CreateProjectEnviroDatasetFromCsvFile: build.mutation<CreateProjectEnviroDatasetFromCsvFileMutation, CreateProjectEnviroDatasetFromCsvFileMutationVariables>({
      query: (variables) => ({ document: CreateProjectEnviroDatasetFromCsvFileDocument, variables })
    }),
    CreateEnviroDatasetFromMetFile: build.mutation<CreateEnviroDatasetFromMetFileMutation, CreateEnviroDatasetFromMetFileMutationVariables>({
      query: (variables) => ({ document: CreateEnviroDatasetFromMetFileDocument, variables })
    }),
    GetProjectEnviroDatasets: build.query<GetProjectEnviroDatasetsQuery, GetProjectEnviroDatasetsQueryVariables>({
      query: (variables) => ({ document: GetProjectEnviroDatasetsDocument, variables })
    }),
    GetEnviroData: build.query<GetEnviroDataQuery, GetEnviroDataQueryVariables>({
      query: (variables) => ({ document: GetEnviroDataDocument, variables })
    }),
    EnviroDataRollup: build.query<EnviroDataRollupQuery, EnviroDataRollupQueryVariables>({
      query: (variables) => ({ document: EnviroDataRollupDocument, variables })
    }),
    DailySparkLine: build.query<DailySparkLineQuery, DailySparkLineQueryVariables>({
      query: (variables) => ({ document: DailySparkLineDocument, variables })
    }),
    HourlyMeteoByMonth: build.query<HourlyMeteoByMonthQuery, HourlyMeteoByMonthQueryVariables>({
      query: (variables) => ({ document: HourlyMeteoByMonthDocument, variables })
    }),
    DailyAlbedo: build.query<DailyAlbedoQuery, DailyAlbedoQueryVariables>({
      query: (variables) => ({ document: DailyAlbedoDocument, variables })
    }),
    DeleteProjectEnviroDataset: build.mutation<DeleteProjectEnviroDatasetMutation, DeleteProjectEnviroDatasetMutationVariables>({
      query: (variables) => ({ document: DeleteProjectEnviroDatasetDocument, variables })
    }),
    GetNumDaylightTimestamps: build.query<GetNumDaylightTimestampsQuery, GetNumDaylightTimestampsQueryVariables>({
      query: (variables) => ({ document: GetNumDaylightTimestampsDocument, variables })
    }),
    GetAcWire: build.query<GetAcWireQuery, GetAcWireQueryVariables>({
      query: (variables) => ({ document: GetAcWireDocument, variables })
    }),
    DeleteAcWire: build.mutation<DeleteAcWireMutation, DeleteAcWireMutationVariables>({
      query: (variables) => ({ document: DeleteAcWireDocument, variables })
    }),
    CreateAcWire: build.mutation<CreateAcWireMutation, CreateAcWireMutationVariables>({
      query: (variables) => ({ document: CreateAcWireDocument, variables })
    }),
    UpdateAcWireName: build.mutation<UpdateAcWireNameMutation, UpdateAcWireNameMutationVariables>({
      query: (variables) => ({ document: UpdateAcWireNameDocument, variables })
    }),
    UpdateAcWire: build.mutation<UpdateAcWireMutation, UpdateAcWireMutationVariables>({
      query: (variables) => ({ document: UpdateAcWireDocument, variables })
    }),
    GetComponents: build.query<GetComponentsQuery, GetComponentsQueryVariables>({
      query: (variables) => ({ document: GetComponentsDocument, variables })
    }),
    GetDcWire: build.query<GetDcWireQuery, GetDcWireQueryVariables>({
      query: (variables) => ({ document: GetDcWireDocument, variables })
    }),
    DeleteDcWire: build.mutation<DeleteDcWireMutation, DeleteDcWireMutationVariables>({
      query: (variables) => ({ document: DeleteDcWireDocument, variables })
    }),
    CreateDcWire: build.mutation<CreateDcWireMutation, CreateDcWireMutationVariables>({
      query: (variables) => ({ document: CreateDcWireDocument, variables })
    }),
    UpdateDcWireName: build.mutation<UpdateDcWireNameMutation, UpdateDcWireNameMutationVariables>({
      query: (variables) => ({ document: UpdateDcWireNameDocument, variables })
    }),
    UpdateDcWire: build.mutation<UpdateDcWireMutation, UpdateDcWireMutationVariables>({
      query: (variables) => ({ document: UpdateDcWireDocument, variables })
    }),
    GetInverter: build.query<GetInverterQuery, GetInverterQueryVariables>({
      query: (variables) => ({ document: GetInverterDocument, variables })
    }),
    DeleteInverter: build.mutation<DeleteInverterMutation, DeleteInverterMutationVariables>({
      query: (variables) => ({ document: DeleteInverterDocument, variables })
    }),
    CreateInverter: build.mutation<CreateInverterMutation, CreateInverterMutationVariables>({
      query: (variables) => ({ document: CreateInverterDocument, variables })
    }),
    UpdateInverterName: build.mutation<UpdateInverterNameMutation, UpdateInverterNameMutationVariables>({
      query: (variables) => ({ document: UpdateInverterNameDocument, variables })
    }),
    UpdateInverter: build.mutation<UpdateInverterMutation, UpdateInverterMutationVariables>({
      query: (variables) => ({ document: UpdateInverterDocument, variables })
    }),
    GetPanel: build.query<GetPanelQuery, GetPanelQueryVariables>({
      query: (variables) => ({ document: GetPanelDocument, variables })
    }),
    DeletePanel: build.mutation<DeletePanelMutation, DeletePanelMutationVariables>({
      query: (variables) => ({ document: DeletePanelDocument, variables })
    }),
    CreatePanel: build.mutation<CreatePanelMutation, CreatePanelMutationVariables>({
      query: (variables) => ({ document: CreatePanelDocument, variables })
    }),
    UpdatePanelName: build.mutation<UpdatePanelNameMutation, UpdatePanelNameMutationVariables>({
      query: (variables) => ({ document: UpdatePanelNameDocument, variables })
    }),
    UpdatePanel: build.mutation<UpdatePanelMutation, UpdatePanelMutationVariables>({
      query: (variables) => ({ document: UpdatePanelDocument, variables })
    }),
    GetTable: build.query<GetTableQuery, GetTableQueryVariables>({
      query: (variables) => ({ document: GetTableDocument, variables })
    }),
    DeleteTable: build.mutation<DeleteTableMutation, DeleteTableMutationVariables>({
      query: (variables) => ({ document: DeleteTableDocument, variables })
    }),
    CreateTable: build.mutation<CreateTableMutation, CreateTableMutationVariables>({
      query: (variables) => ({ document: CreateTableDocument, variables })
    }),
    UpdateTable: build.mutation<UpdateTableMutation, UpdateTableMutationVariables>({
      query: (variables) => ({ document: UpdateTableDocument, variables })
    }),
    UpdateTableName: build.mutation<UpdateTableNameMutation, UpdateTableNameMutationVariables>({
      query: (variables) => ({ document: UpdateTableNameDocument, variables })
    }),
    GetTransformer: build.query<GetTransformerQuery, GetTransformerQueryVariables>({
      query: (variables) => ({ document: GetTransformerDocument, variables })
    }),
    DeleteTransformer: build.mutation<DeleteTransformerMutation, DeleteTransformerMutationVariables>({
      query: (variables) => ({ document: DeleteTransformerDocument, variables })
    }),
    CreateMvTransformer: build.mutation<CreateMvTransformerMutation, CreateMvTransformerMutationVariables>({
      query: (variables) => ({ document: CreateMvTransformerDocument, variables })
    }),
    CreateHvTransformer: build.mutation<CreateHvTransformerMutation, CreateHvTransformerMutationVariables>({
      query: (variables) => ({ document: CreateHvTransformerDocument, variables })
    }),
    UpdateTransformerName: build.mutation<UpdateTransformerNameMutation, UpdateTransformerNameMutationVariables>({
      query: (variables) => ({ document: UpdateTransformerNameDocument, variables })
    }),
    UpdateTransformer: build.mutation<UpdateTransformerMutation, UpdateTransformerMutationVariables>({
      query: (variables) => ({ document: UpdateTransformerDocument, variables })
    }),
    GetPvSystImportFiles: build.query<GetPvSystImportFilesQuery, GetPvSystImportFilesQueryVariables>({
      query: (variables) => ({ document: GetPvSystImportFilesDocument, variables })
    }),
    GetPvSystImportData: build.query<GetPvSystImportDataQuery, GetPvSystImportDataQueryVariables>({
      query: (variables) => ({ document: GetPvSystImportDataDocument, variables })
    }),
    PvSystImportPreview: build.query<PvSystImportPreviewQuery, PvSystImportPreviewQueryVariables>({
      query: (variables) => ({ document: PvSystImportPreviewDocument, variables })
    }),
    ExecutePvSystImport: build.mutation<ExecutePvSystImportMutation, ExecutePvSystImportMutationVariables>({
      query: (variables) => ({ document: ExecutePvSystImportDocument, variables })
    }),
    GetCustomDatasets: build.query<GetCustomDatasetsQuery, GetCustomDatasetsQueryVariables>({
      query: (variables) => ({ document: GetCustomDatasetsDocument, variables })
    }),
    DescribeAllCustomDataset: build.query<DescribeAllCustomDatasetQuery, DescribeAllCustomDatasetQueryVariables>({
      query: (variables) => ({ document: DescribeAllCustomDatasetDocument, variables })
    }),
    DescribeCustomDataset: build.query<DescribeCustomDatasetQuery, DescribeCustomDatasetQueryVariables>({
      query: (variables) => ({ document: DescribeCustomDatasetDocument, variables })
    }),
    GetCustomDatasetDataSeries: build.query<GetCustomDatasetDataSeriesQuery, GetCustomDatasetDataSeriesQueryVariables>({
      query: (variables) => ({ document: GetCustomDatasetDataSeriesDocument, variables })
    }),
    SimDataExport: build.mutation<SimDataExportMutation, SimDataExportMutationVariables>({
      query: (variables) => ({ document: SimDataExportDocument, variables })
    }),
    DataExports: build.query<DataExportsQuery, DataExportsQueryVariables>({
      query: (variables) => ({ document: DataExportsDocument, variables })
    }),
    GetDataExportUrls: build.query<GetDataExportUrlsQuery, GetDataExportUrlsQueryVariables>({
      query: (variables) => ({ document: GetDataExportUrlsDocument, variables })
    }),
    GetSimPdfExportData: build.query<GetSimPdfExportDataQuery, GetSimPdfExportDataQueryVariables>({
      query: (variables) => ({ document: GetSimPdfExportDataDocument, variables })
    }),
    GetPVsystExportData: build.query<GetPVsystExportDataQuery, GetPVsystExportDataQueryVariables>({
      query: (variables) => ({ document: GetPVsystExportDataDocument, variables })
    }),
    DuetSimMeta: build.query<DuetSimMetaQuery, DuetSimMetaQueryVariables>({
      query: (variables) => ({ document: DuetSimMetaDocument, variables })
    }),
    DailyYields: build.query<DailyYieldsQuery, DailyYieldsQueryVariables>({
      query: (variables) => ({ document: DailyYieldsDocument, variables })
    }),
    PerformanceRatio: build.query<PerformanceRatioQuery, PerformanceRatioQueryVariables>({
      query: (variables) => ({ document: PerformanceRatioDocument, variables })
    }),
    CapacityFactor: build.query<CapacityFactorQuery, CapacityFactorQueryVariables>({
      query: (variables) => ({ document: CapacityFactorDocument, variables })
    }),
    ZoneYields: build.query<ZoneYieldsQuery, ZoneYieldsQueryVariables>({
      query: (variables) => ({ document: ZoneYieldsDocument, variables })
    }),
    HourlyYields: build.query<HourlyYieldsQuery, HourlyYieldsQueryVariables>({
      query: (variables) => ({ document: HourlyYieldsDocument, variables })
    }),
    TimeSeriesSummary: build.query<TimeSeriesSummaryQuery, TimeSeriesSummaryQueryVariables>({
      query: (variables) => ({ document: TimeSeriesSummaryDocument, variables })
    }),
    DrillDown: build.query<DrillDownQuery, DrillDownQueryVariables>({
      query: (variables) => ({ document: DrillDownDocument, variables })
    }),
    SystemLosses: build.query<SystemLossesQuery, SystemLossesQueryVariables>({
      query: (variables) => ({ document: SystemLossesDocument, variables })
    }),
    TableModuleIrradianceProfiles: build.query<TableModuleIrradianceProfilesQuery, TableModuleIrradianceProfilesQueryVariables>({
      query: (variables) => ({ document: TableModuleIrradianceProfilesDocument, variables })
    }),
    TableModuleIrradianceProfilesData: build.query<TableModuleIrradianceProfilesDataQuery, TableModuleIrradianceProfilesDataQueryVariables>({
      query: (variables) => ({ document: TableModuleIrradianceProfilesDataDocument, variables })
    }),
    EditDuetSimulation: build.mutation<EditDuetSimulationMutation, EditDuetSimulationMutationVariables>({
      query: (variables) => ({ document: EditDuetSimulationDocument, variables })
    }),
    RunProjectBlockSimulation: build.mutation<RunProjectBlockSimulationMutation, RunProjectBlockSimulationMutationVariables>({
      query: (variables) => ({ document: RunProjectBlockSimulationDocument, variables })
    }),
    ProjectDuetSim: build.query<ProjectDuetSimQuery, ProjectDuetSimQueryVariables>({
      query: (variables) => ({ document: ProjectDuetSimDocument, variables })
    }),
    RunningProjectSim: build.query<RunningProjectSimQuery, RunningProjectSimQueryVariables>({
      query: (variables) => ({ document: RunningProjectSimDocument, variables })
    }),
    StopRunningSimulation: build.mutation<StopRunningSimulationMutation, StopRunningSimulationMutationVariables>({
      query: (variables) => ({ document: StopRunningSimulationDocument, variables })
    }),
    EditDuetJobStatus: build.mutation<EditDuetJobStatusMutation, EditDuetJobStatusMutationVariables>({
      query: (variables) => ({ document: EditDuetJobStatusDocument, variables })
    }),
    DeleteDuetSimulation: build.mutation<DeleteDuetSimulationMutation, DeleteDuetSimulationMutationVariables>({
      query: (variables) => ({ document: DeleteDuetSimulationDocument, variables })
    }),
    AddProjectUsers: build.mutation<AddProjectUsersMutation, AddProjectUsersMutationVariables>({
      query: (variables) => ({ document: AddProjectUsersDocument, variables })
    }),
    DeleteProjectUser: build.mutation<DeleteProjectUserMutation, DeleteProjectUserMutationVariables>({
      query: (variables) => ({ document: DeleteProjectUserDocument, variables })
    }),
    ProjectsSearch: build.query<ProjectsSearchQuery, ProjectsSearchQueryVariables>({
      query: (variables) => ({ document: ProjectsSearchDocument, variables })
    }),
    DeleteProject: build.mutation<DeleteProjectMutation, DeleteProjectMutationVariables>({
      query: (variables) => ({ document: DeleteProjectDocument, variables })
    }),
    CreateProject: build.mutation<CreateProjectMutation, CreateProjectMutationVariables>({
      query: (variables) => ({ document: CreateProjectDocument, variables })
    }),
    CopyProject: build.mutation<CopyProjectMutation, CopyProjectMutationVariables>({
      query: (variables) => ({ document: CopyProjectDocument, variables })
    }),
    GetProject: build.query<GetProjectQuery, GetProjectQueryVariables>({
      query: (variables) => ({ document: GetProjectDocument, variables })
    }),
    UpdateProject: build.mutation<UpdateProjectMutation, UpdateProjectMutationVariables>({
      query: (variables) => ({ document: UpdateProjectDocument, variables })
    }),
    GetProjectFileStorageSignedUrl: build.query<GetProjectFileStorageSignedUrlQuery, GetProjectFileStorageSignedUrlQueryVariables>({
      query: (variables) => ({ document: GetProjectFileStorageSignedUrlDocument, variables })
    }),
    GetPanelIv: build.query<GetPanelIvQuery, GetPanelIvQueryVariables>({
      query: (variables) => ({ document: GetPanelIvDocument, variables })
    }),
    GetSystemParameters: build.query<GetSystemParametersQuery, GetSystemParametersQueryVariables>({
      query: (variables) => ({ document: GetSystemParametersDocument, variables })
    }),
    UpdateSystemParameters: build.mutation<UpdateSystemParametersMutation, UpdateSystemParametersMutationVariables>({
      query: (variables) => ({ document: UpdateSystemParametersDocument, variables })
    }),
    UserMe: build.query<UserMeQuery, UserMeQueryVariables | void>({
      query: (variables) => ({ document: UserMeDocument, variables })
    }),
    UserSearch: build.query<UserSearchQuery, UserSearchQueryVariables>({
      query: (variables) => ({ document: UserSearchDocument, variables })
    }),
    UpdateUser: build.mutation<UpdateUserMutation, UpdateUserMutationVariables | void>({
      query: (variables) => ({ document: UpdateUserDocument, variables })
    }),
    UserDataPrivacyRequest: build.mutation<UserDataPrivacyRequestMutation, UserDataPrivacyRequestMutationVariables>({
      query: (variables) => ({ document: UserDataPrivacyRequestDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useInviteUserMutation, useInviteOrganizationUserMutation, useImpersonateUserMutation, useEndImpersonateUserMutation, useAdminUsersQuery, useLazyAdminUsersQuery, useUserInvitesQuery, useLazyUserInvitesQuery, useAcceptUserInviteMutation, useDeleteUserInviteMutation, useUploadInverterDatasetMutation, useAdminUserMeQuery, useLazyAdminUserMeQuery, useAdminCopyProjectToSelfMutation, useAdminFeatureFlagsQuery, useLazyAdminFeatureFlagsQuery, useAdminUpdateFeatureFlagMutation, useAdminProjectExportQuery, useLazyAdminProjectExportQuery, usePendingUserRequestsQuery, useLazyPendingUserRequestsQuery, useApproveUserRequestMutation, useRejectUserRequestMutation, useDeleteUserRequestMutation, useCreateUserRequestMutation, useAdminGetOrgIntegrationServersQuery, useLazyAdminGetOrgIntegrationServersQuery, useAdminGetOrgIntegrationServerApiSpecQuery, useLazyAdminGetOrgIntegrationServerApiSpecQuery, useAdminUpsertOrgIntegrationServerMutation, useAdminAddOrgIntegrationTryFetchQuery, useLazyAdminAddOrgIntegrationTryFetchQuery, useAdminDeleteOrgIntegrationServerMutation, useAdminOrgIntegrationSchedulesQuery, useLazyAdminOrgIntegrationSchedulesQuery, useAdminUpsertOrgIntegrationScheduleMutation, useAdminDeleteOrgIntegrationScheduleMutation, useAdminMakeOrgIntegrationRequestMutation, useAdminGetOrgIntegrationServerJobEventsQuery, useLazyAdminGetOrgIntegrationServerJobEventsQuery, useLocalLoginMutation, useRefreshTokenQuery, useLazyRefreshTokenQuery, useInvitationTokenQuery, useLazyInvitationTokenQuery, useChangePasswordMutation, useFirebaseAppLoginMutation, useFirebaseAppRegisterMutation, useFirebaseResendEmailVerificationMutation, useFirebaseEmailVerificationSuccessMutation, useFirebaseSyncUserIdentityMutation, useLocalEmailQuery, useLazyLocalEmailQuery, useFeatureFlagsQuery, useLazyFeatureFlagsQuery, useGetAvailableMeteoDatasetsQuery, useLazyGetAvailableMeteoDatasetsQuery, useAddAvailableMeteoDatasetMutation, useLabelledEventsQuery, useLazyLabelledEventsQuery, useSensorDataModelledHierarchyQuery, useLazySensorDataModelledHierarchyQuery, useSensorDataModelledQuery, useLazySensorDataModelledQuery, useSensorDataModelledSystemQuery, useLazySensorDataModelledSystemQuery, useSentinelDeploymentQuery, useLazySentinelDeploymentQuery, useSentinelPortfoliosQuery, useLazySentinelPortfoliosQuery, useSentinelIssueSummaryQuery, useLazySentinelIssueSummaryQuery, useSentinelMeteoSummaryQuery, useLazySentinelMeteoSummaryQuery, useSentinelSystemLossSummaryQuery, useLazySentinelSystemLossSummaryQuery, useSentinelAvailableEnergySummaryQuery, useLazySentinelAvailableEnergySummaryQuery, useSentinelSimulationTimeseriesQuery, useLazySentinelSimulationTimeseriesQuery, useUserOnboardingIntakeQuery, useLazyUserOnboardingIntakeQuery, useUpdateUserOnboardingIntakeMutation, useGetOrganizationQuery, useLazyGetOrganizationQuery, useGetOrganizationsQuery, useLazyGetOrganizationsQuery, useGetDomainMatchingOrganizationsQuery, useLazyGetDomainMatchingOrganizationsQuery, useCreateOrganizationMutation, useUpdateOrganizationMutation, useUpdateOrganizationUserRoleMutation, useDeleteOrganizationUserMutation, useOrganizationProjectsQuery, useLazyOrganizationProjectsQuery, usePlantPlaybackIndexQuery, useLazyPlantPlaybackIndexQuery, usePlantPlaybackQuery, useLazyPlantPlaybackQuery, usePlantPlaybackGeoJsonQuery, useLazyPlantPlaybackGeoJsonQuery, useAssignProjectRoleMutation, useListCompareDatasetsQuery, useLazyListCompareDatasetsQuery, useGetCompareWorkbooksQuery, useLazyGetCompareWorkbooksQuery, useCreateCompareWorkbookMutation, useUpdateCompareWorkbookMutation, useDeleteCompareWorkbookMutation, useGetProjectBlocksQuery, useLazyGetProjectBlocksQuery, useUpsertBlocksMutation, useUpsertBlockLayersMutation, useDeleteBlocksMutation, useDeleteBlockLayersMutation, useCreateRasterLayerMutation, useGetRasterLayersQuery, useLazyGetRasterLayersQuery, useUpdateRasterLayerMutation, useDeleteRasterLayerMutation, useGetCecInverterQuery, useLazyGetCecInverterQuery, useCecInvertersSearchQuery, useLazyCecInvertersSearchQuery, useGetCecInverterFilterParamsQuery, useLazyGetCecInverterFilterParamsQuery, useUpdateEnviroDatasetMutation, useCreateProjectEnviroDatasetFromCsvFileMutation, useCreateEnviroDatasetFromMetFileMutation, useGetProjectEnviroDatasetsQuery, useLazyGetProjectEnviroDatasetsQuery, useGetEnviroDataQuery, useLazyGetEnviroDataQuery, useEnviroDataRollupQuery, useLazyEnviroDataRollupQuery, useDailySparkLineQuery, useLazyDailySparkLineQuery, useHourlyMeteoByMonthQuery, useLazyHourlyMeteoByMonthQuery, useDailyAlbedoQuery, useLazyDailyAlbedoQuery, useDeleteProjectEnviroDatasetMutation, useGetNumDaylightTimestampsQuery, useLazyGetNumDaylightTimestampsQuery, useGetAcWireQuery, useLazyGetAcWireQuery, useDeleteAcWireMutation, useCreateAcWireMutation, useUpdateAcWireNameMutation, useUpdateAcWireMutation, useGetComponentsQuery, useLazyGetComponentsQuery, useGetDcWireQuery, useLazyGetDcWireQuery, useDeleteDcWireMutation, useCreateDcWireMutation, useUpdateDcWireNameMutation, useUpdateDcWireMutation, useGetInverterQuery, useLazyGetInverterQuery, useDeleteInverterMutation, useCreateInverterMutation, useUpdateInverterNameMutation, useUpdateInverterMutation, useGetPanelQuery, useLazyGetPanelQuery, useDeletePanelMutation, useCreatePanelMutation, useUpdatePanelNameMutation, useUpdatePanelMutation, useGetTableQuery, useLazyGetTableQuery, useDeleteTableMutation, useCreateTableMutation, useUpdateTableMutation, useUpdateTableNameMutation, useGetTransformerQuery, useLazyGetTransformerQuery, useDeleteTransformerMutation, useCreateMvTransformerMutation, useCreateHvTransformerMutation, useUpdateTransformerNameMutation, useUpdateTransformerMutation, useGetPvSystImportFilesQuery, useLazyGetPvSystImportFilesQuery, useGetPvSystImportDataQuery, useLazyGetPvSystImportDataQuery, usePvSystImportPreviewQuery, useLazyPvSystImportPreviewQuery, useExecutePvSystImportMutation, useGetCustomDatasetsQuery, useLazyGetCustomDatasetsQuery, useDescribeAllCustomDatasetQuery, useLazyDescribeAllCustomDatasetQuery, useDescribeCustomDatasetQuery, useLazyDescribeCustomDatasetQuery, useGetCustomDatasetDataSeriesQuery, useLazyGetCustomDatasetDataSeriesQuery, useSimDataExportMutation, useDataExportsQuery, useLazyDataExportsQuery, useGetDataExportUrlsQuery, useLazyGetDataExportUrlsQuery, useGetSimPdfExportDataQuery, useLazyGetSimPdfExportDataQuery, useGetPVsystExportDataQuery, useLazyGetPVsystExportDataQuery, useDuetSimMetaQuery, useLazyDuetSimMetaQuery, useDailyYieldsQuery, useLazyDailyYieldsQuery, usePerformanceRatioQuery, useLazyPerformanceRatioQuery, useCapacityFactorQuery, useLazyCapacityFactorQuery, useZoneYieldsQuery, useLazyZoneYieldsQuery, useHourlyYieldsQuery, useLazyHourlyYieldsQuery, useTimeSeriesSummaryQuery, useLazyTimeSeriesSummaryQuery, useDrillDownQuery, useLazyDrillDownQuery, useSystemLossesQuery, useLazySystemLossesQuery, useTableModuleIrradianceProfilesQuery, useLazyTableModuleIrradianceProfilesQuery, useTableModuleIrradianceProfilesDataQuery, useLazyTableModuleIrradianceProfilesDataQuery, useEditDuetSimulationMutation, useRunProjectBlockSimulationMutation, useProjectDuetSimQuery, useLazyProjectDuetSimQuery, useRunningProjectSimQuery, useLazyRunningProjectSimQuery, useStopRunningSimulationMutation, useEditDuetJobStatusMutation, useDeleteDuetSimulationMutation, useAddProjectUsersMutation, useDeleteProjectUserMutation, useProjectsSearchQuery, useLazyProjectsSearchQuery, useDeleteProjectMutation, useCreateProjectMutation, useCopyProjectMutation, useGetProjectQuery, useLazyGetProjectQuery, useUpdateProjectMutation, useGetProjectFileStorageSignedUrlQuery, useLazyGetProjectFileStorageSignedUrlQuery, useGetPanelIvQuery, useLazyGetPanelIvQuery, useGetSystemParametersQuery, useLazyGetSystemParametersQuery, useUpdateSystemParametersMutation, useUserMeQuery, useLazyUserMeQuery, useUserSearchQuery, useLazyUserSearchQuery, useUpdateUserMutation, useUserDataPrivacyRequestMutation } = injectedRtkApi;

